// This file was automatically generated from your CSV data on your_content_data.csv.
export const staticContent = [
  {
    "id": 62808,
    "iso3": "AEU",
    "langId": "1148",
    "languageEn": "Akeu",
    "langTh": "อาเคอะ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Genesis 1:1 In the beginning God created the heavens and the earth.",
    "verse_th": "ปฐมกาล 1:1 ใน​ปฐมกาล​นั้น เมื่อ​พระเจ้า​สร้าง​แผ่นดิน​และ​ท้องฟ้า",
    "streamUrl": "fivefish.org/T62808",
    "trackDownloadUrl": "fivefish.org/T62808-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62808.zip",
    "programId": "62808",
    "languageVideoUrl": "https://www.youtube.com/watch?v=tzCm1UPP2iI&list=PLXcynA24_lTMfK40uNECYzwFBmcvoXB2D",
    "shareUrl": "5fi.sh/T62808",
    "duration": "57:45",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Akeu.62808.mp3",
    "stableKey": "Akeu"
  },
  {
    "id": 6760,
    "iso3": "AHK",
    "langId": "529",
    "languageEn": "Akha",
    "langTh": "อาข่า",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Exodus 23:25 Worship the LORD your God, and His blessing will be on your food and water. I will take away sickness from among you.",
    "verse_th": "อพยพ 23:25 ถ้า​พวกเจ้า​รับใช้​พระยาห์เวห์​พระเจ้า​ของเจ้า พระองค์​จะ​อวยพร​อาหาร​และ​น้ำ​ของเจ้า และ​เรา​จะ​เอา​เชื้อโรค​ออก​ไป​จากเจ้า",
    "streamUrl": "fivefish.org/T6760",
    "trackDownloadUrl": "fivefish.org/T6760-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6760.zip",
    "programId": "6760",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XUuCFsvtuRE&list=PLbQkUFqMy6wpzUItlLMRHRdWq6NODqIbw",
    "shareUrl": "5fi.sh/T6760",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Akha.529.mp3",
    "stableKey": "Akha"
  },
  {
    "id": 6761,
    "iso3": "AHK",
    "langId": "529",
    "languageEn": "Akha",
    "langTh": "อาข่า",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Leviticus 19:11 Do not steal. Do not lie. Do not deceive on another.",
    "verse_th": "เลวีนิติ 19:11 เจ้า​ต้อง​ไม่​ขโมย ไม่​โกง​หรือ​โกหก​ซึ่งกัน​และกัน",
    "streamUrl": "fivefish.org/T6761",
    "trackDownloadUrl": "fivefish.org/T6761-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6761.zip",
    "programId": "6761",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jlYlwWJbAV4&list=PLbQkUFqMy6wpzUItlLMRHRdWq6NODqIbw",
    "shareUrl": "5fi.sh/T6761",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Akha.529.mp3",
    "stableKey": "Akha"
  },
  {
    "id": 74874,
    "iso3": "AHK",
    "langId": "3127",
    "languageEn": "Akha Thailand",
    "langTh": "อาข่า ประเทศไทย",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Numbers 23:19 God is not a man, that He should lie, nor a son of man, that He should change His mind. Does He speak and then not act? Does He promise and not fulfill?",
    "verse_th": "กันดารวิถี 23:19 พระเจ้า​ไม่​ใช่​มนุษย์​ที่​พูด​โกหก และ​ก็​ไม่​ใช่​มนุษย์​ที่​ชอบ​เปลี่ยนใจ มี​หรือ​ที่​พระองค์​พูด​แล้ว​ไม่​ทำ หรือ​สัญญา​แล้ว​ไม่​ทำ​ตาม​สัญญานั้น",
    "streamUrl": "fivefish.org/T74874",
    "trackDownloadUrl": "fivefish.org/T74874-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74874.zip",
    "programId": "74874",
    "languageVideoUrl": "https://www.youtube.com/watch?v=v3FMlmTjcUs&list=PLho9cJoXqQC_ER8aGJnmj6rDqQ7UqSXKd",
    "shareUrl": "5fi.sh/T74874",
    "duration": "42:03",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Akha.Thailand.74874.mp3",
    "stableKey": "Akha Thailand"
  },
  {
    "id": 6850,
    "iso3": "AHK",
    "langId": "3127",
    "languageEn": "Akha Thailand",
    "langTh": "อาข่า ประเทศไทย",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Deuteronomy 31:6 Be strong and courageous. Do not be afraid or terrified because of them, for the LORD your God goes with you; He will never leave you nor forsake you.",
    "verse_th": "เฉลยธรรมบัญญัติ 31:6 ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ ไม่​ต้อง​กลัว​หรือ​ตื่นตกใจ​เพราะ​พวกนั้น เพราะ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน​คือ​ผู้ที่​จะ​ไป​กับ​ท่าน พระองค์​จะ​ไม่​ละ​ท่าน​ไป​หรือ​ทอดทิ้ง​ท่าน​หรอก”",
    "streamUrl": "fivefish.org/T6850",
    "trackDownloadUrl": "fivefish.org/T6850-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6850.zip",
    "programId": "6850",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4OYpnyVM0W0&list=PLho9cJoXqQC_ER8aGJnmj6rDqQ7UqSXKd",
    "shareUrl": "5fi.sh/T6850",
    "duration": "13:41",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Akha.Thailand.3127.mp3",
    "stableKey": "Akha Thailand"
  },
  {
    "id": 62691,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Deuteronomy 6:16 Do not put the LORD your God to the test as you did at Massah.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:16 พวกท่าน​ต้อง​ไม่​ลองดี​กับ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน เหมือน​กับ​ที่​พวกท่าน​เคย​ลองดี​กับ​พระองค์​มา​แล้ว​ที่​มัสสาห์",
    "streamUrl": "fivefish.org/T62691",
    "trackDownloadUrl": "fivefish.org/T62691-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62691.zip",
    "programId": "62691",
    "languageVideoUrl": "https://www.youtube.com/watch?v=afMvmmhkkgU&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T62691",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 75171,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Deuteronomy 6:5 Love the LORD your God with all your heart and with all your soul and with all your strength.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:5 ท่าน​ต้อง​รัก​พระยาห์เวห์​พระเจ้า​ของ​ท่าน ด้วย​การ​ทุ่ม​สุดใจ สุด​ชีวิต และ​สุด​ตัว ของ​ท่าน​ให้​กับ​พระองค์",
    "streamUrl": "fivefish.org/T75171",
    "trackDownloadUrl": "fivefish.org/T75171-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/75171.zip",
    "programId": "75171",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nBbD4Vp6c00&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T75171",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 62692,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Deuteronomy 8:3 He humbled you, causing you to hunger and then feeding you with manna, which neither you nor your ancestors had known, to teach you that man does not live on bread alone but on every word that comes from the mouth of the LORD.",
    "verse_th": "เฉลยธรรมบัญญัติ 8:3 พระยาห์เวห์​ทำ​ให้​ท่าน​ต้อง​ทนทุกข์​จาก​ความหิว​แล้ว​พระองค์​ก็​เลี้ยง​พวกท่าน​ด้วย​มานา ที่​ทั้ง​ท่าน​และ​บรรพบุรุษ​ของ​ท่าน​ไม่​เคย​รู้จัก​มา​ก่อน เพื่อ​ที่​พระองค์​จะ​ได้​สอน​ท่าน​ว่า คน​เรา​ไม่​ได้​มี​ชีวิต​อยู่​ด้วย​อาหาร​เพียง​อย่าง​เดียว แต่​คน​เรา​จะ​มี​ชีวิต​อยู่​ได้​ด้วย​ทุกๆ​คำพูด​ที่​ออก​มา​จาก​ปาก​ของ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T62692",
    "trackDownloadUrl": "fivefish.org/T62692-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62692.zip",
    "programId": "62692",
    "languageVideoUrl": "https://www.youtube.com/watch?v=y4U2puXluG0&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T62692",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 62695,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Joshua 1:8 Do not let this Book of the Law depart from your mouth; meditate on it day and night, so that you may be careful to do everything written in it. Then you will be prosperous and successful.",
    "verse_th": "โยชูวา 1:8 เจ้า​ต้อง​ไม่หยุด​พูด​ถึง​กฎ​ใน​หนังสือ​เล่มนี้ และ​เจ้า​ต้อง​ไตร่ตรอง​มัน​ทั้งวัน​ทั้งคืน เพื่อ​เจ้า​จะได้​ทำ​ตาม​สิ่ง​ที่​ได้​เขียน​ไว้​ใน​กฎ​นั้น​อย่าง​เคร่งครัด แล้ว​เจ้า​จะได้​เจริญ​รุ่งเรือง​และ​ประสบ​ความ​สำเร็จ",
    "streamUrl": "fivefish.org/T62695",
    "trackDownloadUrl": "fivefish.org/T62695-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62695.zip",
    "programId": "62695",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wP5O5Wo1lX4&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T62695",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 62710,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Joshua 1:9 Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the LORD your God will be with you wherever you go.",
    "verse_th": "โยชูวา 1:9 อย่าลืม​ว่า​เรา​ได้​สั่ง​เจ้า​ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ อย่า​ได้​หวาดกลัว​หรือ​ท้อถอย เพราะ​เรา ยาห์เวห์ พระเจ้า​ของเจ้า จะ​อยู่​กับเจ้า​ใน​ทุกที่​ที่​เจ้าไป”",
    "streamUrl": "fivefish.org/T62710",
    "trackDownloadUrl": "fivefish.org/T62710-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62710.zip",
    "programId": "62710",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-6kN1lOhNqo&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T62710",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 62834,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "2 Chronicles 7:14 If My people, who are called by My name, will humble themselves and pray and seek My face and turn from their wicked ways, then I will hear from heaven, and I will forgive their sin and will heal their land.",
    "verse_th": "2 พงศาวดาร 7:14 ถ้า​ประชาชน​ของ​เรา​ผู้ที่​เรา​ได้​ประทับ​ชื่อ​เราไว้ ถ่อมตัว​ลง​และ​อธิษฐาน และ​เริ่ม​แสวงหา​ใบ​หน้า​ของเรา และ​หันเห​ออก​จาก​วิถีทาง​ชั่ว​ทั้งหลาย​ของ​พวกเขา เรา​ก็​จะ​รับฟัง​จาก​สวรรค์ และ​จะ​ยกโทษ​บาป​ของ​พวกเขา​และ​จะ​รักษา​แผ่นดิน​ของ​พวกเขา",
    "streamUrl": "fivefish.org/T62834",
    "trackDownloadUrl": "fivefish.org/T62834-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62834.zip",
    "programId": "62834",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FsGNmfkYbJU&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T62834",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 75170,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Job 31:1 I made a covenant with my eyes not to look lustfully at a young woman.",
    "verse_th": "โยบ 31:1 ข้า​ทำ​ข้อตกลง​กับ​ดวงตา​ของ​ข้า​ว่า ข้า​จะ​ไม่​มอง​หญิงสาว​ด้วย​ความใคร่",
    "streamUrl": "fivefish.org/T75170",
    "trackDownloadUrl": "fivefish.org/T75170-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/75170.zip",
    "programId": "75170",
    "languageVideoUrl": "https://www.youtube.com/watch?v=n4q4oA3d7Kg&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T75170",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 2760,
    "iso3": "CTG",
    "langId": "3259",
    "languageEn": "Bangla Chittagonian",
    "langTh": "บังกลา ชิตตาโกเนียน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 103:1 Praise the LORD, my soul; all my inmost being, praise His holy name.",
    "verse_th": "สดุดี 103:1 จิตใจ​ของ​ข้าพเจ้า​เอ๋ย สรรเสริญ​พระยาห์เวห์เถิด หัวใจ​ทั้งดวง​ของข้าพเจ้า​เอ๋ย สรรเสริญ​ชื่อ​อันศักดิ์สิทธิ์​ของ​พระองค์เถิด",
    "streamUrl": "fivefish.org/T2760",
    "trackDownloadUrl": "fivefish.org/T2760-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2760.zip",
    "programId": "2760",
    "languageVideoUrl": "https://www.youtube.com/watch?v=SpkdgEOeml4&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
    "shareUrl": "5fi.sh/T2760",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bangla.Chittagonian.3259.mp3",
    "stableKey": "Bangla Chittagonian"
  },
  {
    "id": 33761,
    "iso3": "BZI",
    "langId": "8185",
    "languageEn": "Bisu",
    "langTh": "บีซู",
    "title_en": "Bible Stories (Easy Reader)",
    "title_th": "เรื่องราวในพระคัมภีร์",
    "verse_en": "Psalms 111:10 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สดุดี 111:10 การยำเกรง​พระยาห์เวห์​คือ​จุดเริ่มต้น​แห่งสติปัญญา ทุกคน​ที่​เชื่อฟัง​พระองค์​ก็​จะเป็น​คนที่​มีสติรอบคอบ พระองค์​จะได้รับ​การสรรเสริญ​ตลอดไป",
    "streamUrl": "fivefish.org/T33761",
    "trackDownloadUrl": "fivefish.org/T33761-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33761.zip",
    "programId": "33761",
    "languageVideoUrl": "https://www.youtube.com/watch?v=t2SVhEdbjDE&list=PLXcynA24_lTO5FEbSsaGK8_YkkxEtc24v",
    "shareUrl": "5fi.sh/T33761",
    "duration": "24:13",
    "trackCount": "3.0",
    "sampleUrl": "/audio/Bisu.8185.mp3",
    "stableKey": "Bisu"
  },
  {
    "id": 29841,
    "iso3": "BLR",
    "langId": "6164",
    "languageEn": "Blang-Shan",
    "langTh": "บลางชาน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Psalms 119: 9,11 I lift up my eyes to the mountains— where does my help come from? My help comes from the LORD, the Maker of heaven and earth.",
    "verse_th": "สดุดี 119:9,11 คนหนุ่มๆ​จะ​รักษาชีวิต​ของตน​ให้​บริสุทธิ์​ได้อย่างไร ก็​ด้วย​การรักษา​คำบัญชา​ของพระอง 11ข้าพเจ้า​เก็บรักษา​คำ​สัญญา​ของพระองค์​ไว้ในใจ เพื่อ​ข้าพเจ้า​จะได้​ไม่ทำบาป​ต่อพระองค์",
    "streamUrl": "fivefish.org/T29841",
    "trackDownloadUrl": "fivefish.org/T29841-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29841.zip",
    "programId": "29841",
    "languageVideoUrl": "https://www.youtube.com/watch?v=J4pSPlGaZs8&list=PLXcynA24_lTM9OeC1on2LprYHWvDY3fWy",
    "shareUrl": "5fi.sh/T29841",
    "duration": "64:19",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Blang-Shan.29841.mp3",
    "stableKey": "Blang-Shan"
  },
  {
    "id": 63352,
    "iso3": "BLR",
    "langId": "6164",
    "languageEn": "Blang-Shan",
    "langTh": "บลางชาน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Psalms 121:1-2 How can a young man keep his way pure? By living according to Your Word. I have hidden Your Word in my heart that I might not sin against You.",
    "verse_th": "สดุดี 121:1-2 ข้าพเจ้า​แหงนหน้า​มอง​ขึ้นไป​ยัง​ภูเขาทั้งหลาย ความช่วยเหลือ​ของข้าพเจ้า​จะมา​จาก​ที่ไหนกัน ความช่วยเหลือ​ของข้าพเจ้า​มาจาก​พระยาห์เวห์ ผู้สร้าง​สวรรค์​และ​แผ่นดินโลก",
    "streamUrl": "fivefish.org/T63352",
    "trackDownloadUrl": "fivefish.org/T63352-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63352.zip",
    "programId": "63352",
    "languageVideoUrl": "https://www.youtube.com/watch?v=cpYq_PsOe2U&list=PLXcynA24_lTM9OeC1on2LprYHWvDY3fWy",
    "shareUrl": "5fi.sh/T63352",
    "duration": "52:35",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Blang.Shan.6164.mp3",
    "stableKey": "Blang-Shan"
  },
  {
    "id": 29770,
    "iso3": "BLR",
    "langId": "6164",
    "languageEn": "Blang-Shan",
    "langTh": "บลางชาน",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Psalms 139:13-14 For You created my inmost being; You knit me together in my mother’s womb. I praise You because I am fearfully and wonderfully made; Your works are wonderful, I know that full well.",
    "verse_th": "สดุดี 139:13-14 พระองค์​สร้าง​ทั้งจิต​และใจ​ของข้าพเจ้า พระองค์​ทอ​ข้าพเจ้า​เข้าด้วยกัน​ใน​ท้องแม่ ข้าพเจ้า​จึง​ขอบคุณ​พระองค์​เพราะ​งาน​ของพระองค์นั้น​ช่างน่าเกรง​ขาม​และน่าทึ่ง พระองค์​รู้จัก​ข้าพเจ้า​อย่าง​ทะลุปรุโปร่ง",
    "streamUrl": "fivefish.org/T29770",
    "trackDownloadUrl": "fivefish.org/T29770-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29770.zip",
    "programId": "29770",
    "languageVideoUrl": "https://www.youtube.com/watch?v=dCaNrJion6Y&list=PLXcynA24_lTM9OeC1on2LprYHWvDY3fWy",
    "shareUrl": "5fi.sh/T29770",
    "duration": "53:37",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Blang.Shan.6164.mp3",
    "stableKey": "Blang-Shan"
  },
  {
    "id": 29771,
    "iso3": "BLR",
    "langId": "6164",
    "languageEn": "Blang-Shan",
    "langTh": "บลางชาน",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Psalms 139:8 If I go up to the heavens, You are there; if I make my bed in the depths, You are there.",
    "verse_th": "สดุดี 139:8 ถ้า​ข้าพเจ้า​จะ​ขึ้นไป​บนสวรรค์​พระองค์​ก็อยู่ที่นั่น ถ้า​ข้าพเจ้า​นอนลง​ที่​แดน​คนตาย​พระองค์​ก็อยู่ที่นั่น",
    "streamUrl": "fivefish.org/T29771",
    "trackDownloadUrl": "fivefish.org/T29771-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29771.zip",
    "programId": "29771",
    "languageVideoUrl": "https://www.youtube.com/watch?v=72vunttcC44&list=PLXcynA24_lTM9OeC1on2LprYHWvDY3fWy",
    "shareUrl": "5fi.sh/T29771",
    "duration": "52:58",
    "trackCount": "7.0",
    "sampleUrl": "/audio/Blang.Shan.6164.mp3",
    "stableKey": "Blang-Shan"
  },
  {
    "id": 37411,
    "iso3": "BRU",
    "langId": "8378",
    "languageEn": "Bru Eastern Tri",
    "langTh": "บรู ตะวันออก ตรี",
    "title_en": "Genesis Stories 1",
    "title_th": "ปฐมกาลตอนเรื่องที่ 1",
    "verse_en": "Psalms 23:1 The Lord is my Shepherd, I lack nothing.",
    "verse_th": "สดุดี 23:1 พระยาห์เวห์​เลี้ยงดู​ข้าพเจ้า​เหมือน​เลี้ยงแกะ ดังนั้น ข้าพเจ้า​ไม่ขาด​อะไรเลย",
    "streamUrl": "fivefish.org/T37411",
    "trackDownloadUrl": "fivefish.org/T37411-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37411.zip",
    "programId": "37411",
    "languageVideoUrl": "https://www.youtube.com/watch?v=vdwnKSdHl_w&list=PLbVWnwtj_2QErqggfUlRNfjOHF_7zWCeO",
    "shareUrl": "5fi.sh/T37411",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Eastern.Tri.8378.mp3",
    "stableKey": "Bru Eastern Tri"
  },
  {
    "id": 37420,
    "iso3": "BRU",
    "langId": "8378",
    "languageEn": "Bru Eastern Tri",
    "langTh": "บรู ตะวันออก ตรี",
    "title_en": "Genesis Stories 2",
    "title_th": "ปฐมกาลตอนเรื่องที่ 2",
    "verse_en": "Psalms 27:14 Wait for the Lord; be strong and take heart and wait for the Lord.",
    "verse_th": "สดุดี 27:14 ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์ ให้​เข้มแข็ง​และ​กล้าหาญไว้ ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T37420",
    "trackDownloadUrl": "fivefish.org/T37420-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37420.zip",
    "programId": "37420",
    "shareUrl": "5fi.sh/T37420",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Eastern.Tri.8378.mp3",
    "stableKey": "Bru Eastern Tri"
  },
  {
    "id": 37421,
    "iso3": "BRU",
    "langId": "8378",
    "languageEn": "Bru Eastern Tri",
    "langTh": "บรู ตะวันออก ตรี",
    "title_en": "Genesis Stories 3",
    "title_th": "ปฐมกาลตอนเรื่องที่ 3",
    "verse_en": "Psalms 30:5 For His anger lasts only a moment, but His favor lasts a lifetime; weeping may stay for the night, but rejoicing comes in the morning.",
    "verse_th": "สดุดี 30:5 ความ​โกรธ​เกรี้ยว​ของ​พระองค์​อยู่​เพียง​ชั่วคราว แต่​ความปรานี​ของ​พระองค์​นำ​ชีวิต​มาให้ เรา​อาจจะ​ร้องไห้​ใน​ยามค่ำคืน แต่​ใน​วันรุ่งขึ้น เรา​จะ​ชื่นบาน",
    "streamUrl": "fivefish.org/T37421",
    "trackDownloadUrl": "fivefish.org/T37421-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37421.zip",
    "programId": "37421",
    "shareUrl": "5fi.sh/T37421",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Eastern.Tri.8378.mp3",
    "stableKey": "Bru Eastern Tri"
  },
  {
    "id": 37410,
    "iso3": "BRU",
    "langId": "8378",
    "languageEn": "Bru Eastern Tri",
    "langTh": "บรู ตะวันออก ตรี",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 32:5 Then I acknowledged my sin to You and did not cover up my iniquity. I said, I will confess my transgressions to the LORD. And You forgave the guilt of my sin.",
    "verse_th": "สดุดี 32:5 ดังนั้น พระยาห์เวห์ ข้าพเจ้า​ขอสารภาพ​ความบาป​ต่อพระองค์ โดย​ไม่ได้​ซ่อน​ความผิดบาป​อะไร​ไว้เลย ข้าพเจ้า​พูดว่า “ข้าพเจ้า​จะ​สารภาพ​ต่อ​พระยาห์เวห์​ถึง​การกบฏ​ทั้งหลาย​ที่ทำไป” แล้ว​พระองค์​ก็​ได้​ยกโทษ​ให้​กับ​ความผิดบาป​ของ​ข้าพเจ้า เซลาห์",
    "streamUrl": "fivefish.org/T37410",
    "trackDownloadUrl": "fivefish.org/T37410-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37410.zip",
    "programId": "37410",
    "languageVideoUrl": "https://www.youtube.com/watch?v=F9ofVYkB4ek&list=PLbVWnwtj_2QErqggfUlRNfjOHF_7zWCeO",
    "shareUrl": "5fi.sh/T37410",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Eastern.Tri.37410.mp3",
    "stableKey": "Bru Eastern Tri"
  },
  {
    "id": 37370,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 1",
    "title_th": "ปฐมกาลตอนเรื่องที่ 1",
    "verse_en": "Psalms 37:4 Take delight in the Lord, and He will give you the desires of your heart.",
    "verse_th": "สดุดี 37:4 ให้​มี​ความสุข​กับ​การรับใช้​พระยาห์เวห์ แล้ว​พระองค์​จะให้​สิ่งที่​ใจ​เจ้า​ต้องการ",
    "streamUrl": "fivefish.org/T37370",
    "trackDownloadUrl": "fivefish.org/T37370-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37370.zip",
    "programId": "37370",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TUJbaPCFtuE&list=PLho9cJoXqQC-EzbHOM1kvNfWnEoYnYrbi",
    "shareUrl": "5fi.sh/T37370",
    "duration": "408:32",
    "trackCount": "50.0",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.37370.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37371,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 2",
    "title_th": "ปฐมกาลตอนเรื่องที่ 2",
    "verse_en": "Psalms 4:3 Know that the LORD has set apart His faithful servant for Himself; the LORD hears when I call to Him.",
    "verse_th": "สดุดี 4:3 พวกเจ้า​ทั้งหลาย ให้​รู้​ไว้​เถอะ​ว่า พระยาห์เวห์​เอาใจใส่​คน​ที่​สัตย์ซื่อ​ต่อ​พระองค์​เป็นพิเศษ พระองค์​จะ​ฟัง​เสียง​ของเรา เมื่อ​เรา​ร้องขอ​ความช่วยเหลือ​จาก​พระองค์",
    "streamUrl": "fivefish.org/T37371",
    "trackDownloadUrl": "fivefish.org/T37371-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37371.zip",
    "programId": "37371",
    "shareUrl": "5fi.sh/T37371",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37380,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 3",
    "title_th": "ปฐมกาลตอนเรื่องที่ 3",
    "verse_en": "Psalms 4:8 In peace I will lie down and sleep, for You alone, LORD, make me dwell in safety.",
    "verse_th": "สดุดี 4:8 ดังนั้น ข้าพเจ้า​นอนลง​และ​หลับไป​อย่าง​สงบสุข​ยิ่งนัก เพราะ พระยาห์เวห์ พระองค์​แต่เพียงผู้เดียว​เป็น​ผู้ที่​ทำให้​ข้าพเจ้า​นอนลง​อย่างปลอดภัย",
    "streamUrl": "fivefish.org/T37380",
    "trackDownloadUrl": "fivefish.org/T37380-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37380.zip",
    "programId": "37380",
    "shareUrl": "5fi.sh/T37380",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37381,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 4",
    "title_th": "ปฐมกาลตอนเรื่องที่ 4",
    "verse_en": "Psalms 94:11 The LORD knows all human plans; He knows that they are futile.",
    "verse_th": "สดุดี 94:11 พระยาห์เวห์​รู้จัก​ความคิด​ของ​มนุษย์ และ​พระองค์​รู้ว่า​มัน​ไร้สาระ",
    "streamUrl": "fivefish.org/T37381",
    "trackDownloadUrl": "fivefish.org/T37381-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37381.zip",
    "programId": "37381",
    "shareUrl": "5fi.sh/T37381",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37390,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 5",
    "title_th": "ปฐมกาลตอนเรื่องที่ 5",
    "verse_en": "Proverbs 1:7 The fear of the LORD is the beginning of knowledge, but fools despise wisdom and instruction.",
    "verse_th": "สุภาษิต 1:7 การ​ยำเกรง​พระยาห์เวห์​คือ​จุด​เริ่มต้น​ของ​ความรู้ แต่​คน​โง่​เกลียดชัง​ปัญญา​และ​คำ​สั่งสอน",
    "streamUrl": "fivefish.org/T37390",
    "trackDownloadUrl": "fivefish.org/T37390-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37390.zip",
    "programId": "37390",
    "shareUrl": "5fi.sh/T37390",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37391,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 6",
    "title_th": "ปฐมกาลตอนเรื่องที่ 6",
    "verse_en": "Proverbs 1:8 Listen, my son, to your father's instruction and do not forsake your mother's teaching.",
    "verse_th": "สุภาษิต 1:8 ลูกเอ๋ย ให้​เชื่อฟัง​คำ​สั่งสอน​ของ​พ่อเจ้า และ​อย่า​ได้​ละทิ้ง​คำสอน​ของ​แม่เจ้า​ด้วย",
    "streamUrl": "fivefish.org/T37391",
    "trackDownloadUrl": "fivefish.org/T37391-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37391.zip",
    "programId": "37391",
    "shareUrl": "5fi.sh/T37391",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37526,
    "iso3": "BRV",
    "langId": "8379",
    "languageEn": "Bru Western Dong Luang",
    "langTh": "บรูตะวันตก ดงหลวง",
    "title_en": "Genesis Stories 7",
    "title_th": "ปฐมกาลตอนเรื่องที่ 7",
    "verse_en": "Proverbs 10:12 Hatred stirs up conflict, but love covers over all wrongs.",
    "verse_th": "สุภาษิต 10:12 ความ​เกลียดชัง​ย่อม​เร่งเร้า​ให้​เกิด​การ​ทะเลาะ​วิวาท แต่​ความรัก​ปกปิด​ความผิด​ทั้งปวง",
    "streamUrl": "fivefish.org/T37526",
    "trackDownloadUrl": "fivefish.org/T37526-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37526.zip",
    "programId": "37526",
    "shareUrl": "5fi.sh/T37526",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Bru.Western.Dong.Luang.8379.mp3",
    "stableKey": "Bru Western Dong Luang"
  },
  {
    "id": 37401,
    "iso3": "KHB",
    "langId": "20037",
    "languageEn": "Buguo",
    "langTh": "บูกูโอ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 10:4 Lazy hands make for poverty, but diligent hands bring wealth.",
    "verse_th": "สุภาษิต 10:4 มือ​ที่​เกียจคร้าน​ทำให้​ยากจน แต่​มือ​ที่​ขยัน​ทำ​ให้​ร่ำรวย",
    "streamUrl": "fivefish.org/T37401",
    "trackDownloadUrl": "fivefish.org/T37401-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37401.zip",
    "programId": "37401",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YgtI_Lj-K98&list=PLXcynA24_lTOSBkl9j5iegeG2-iTpOQ8y",
    "shareUrl": "5fi.sh/T37401",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Buguo.37401.mp3",
    "stableKey": "Buguo"
  },
  {
    "id": 80570,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Proverbs 10:9 Whoever walks in integrity walks securely, but whoever takes crooked paths will be found out.",
    "verse_th": "สุภาษิต 10:9 คน​ที่​ใช้​ชีวิต​อย่าง​ซื่อสัตย์​ไม่​ต้อง​ห่วง​อะไร แต่​คน​ที่​อยู่​ใน​ทาง​ไม่ซื่อสัตย์​ก็​จะ​ถูก​จับ​ได้",
    "streamUrl": "fivefish.org/T80570",
    "trackDownloadUrl": "fivefish.org/T80570-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80570.zip",
    "programId": "80570",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Tj2S5tNGe9g&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T80570",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.80570.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 74797,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Gospel Songs",
    "title_th": "เพลงนมัสการ",
    "verse_en": "Proverbs 16:3 Commit to the LORD whatever you do, and He will establish your plans.",
    "verse_th": "สุภาษิต 16:3 ให้​มอบ​การ​งาน​ของ​เจ้า​ให้​กับ​พระยาห์เวห์ แล้ว​แผนการ​ของ​เจ้า​จะ​สำเร็จ",
    "streamUrl": "fivefish.org/T74797",
    "trackDownloadUrl": "fivefish.org/T74797-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74797.zip",
    "programId": "74797",
    "languageVideoUrl": "https://www.youtube.com/watch?v=RVnR61uPHtI&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T74797",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 65957,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Jesus, the Refugee",
    "title_th": "พระเยซู ผู้ลี้ภัย",
    "verse_en": "Proverbs 16:4 The Lord works out everything to its proper end— even the wicked for a day of disaster.",
    "verse_th": "สุภาษิต 16:4 พระยาห์เวห์​สร้าง​ทุกสิ่ง​ขึ้น​มา​อย่าง​มี​จุด​มุ่งหมาย แม้แต่​คนชั่ว พระองค์​ก็​สร้าง​ขึ้น​มา​เพื่อ​วัน​แห่ง​ความ​พินาศ",
    "streamUrl": "fivefish.org/T65957",
    "trackDownloadUrl": "fivefish.org/T65957-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65957.zip",
    "programId": "65957",
    "languageVideoUrl": "https://www.youtube.com/watch?v=E2GQQNmgAac&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T65957",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62603,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Proverbs 17:17 A friend loves at all times, and a brother is born for a time of adversity.",
    "verse_th": "สุภาษิต 17:17 เพื่อน​แท้​ก็​รักกัน​อยู่​เสมอ ส่วน​พี่น้องนั้น​ก็​เกิด​มา​เพื่อ​ช่วยเหลือกัน​ใน​ยาม​ทุกข์ยาก",
    "streamUrl": "fivefish.org/T62603",
    "trackDownloadUrl": "fivefish.org/T62603-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62603.zip",
    "programId": "62603",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ALrDNCeU6nY&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62603",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62605,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Proverbs 17:9 Whoever would foster love covers over an offense, but whoever repeats the matter separates close friends.",
    "verse_th": "สุภาษิต 17:9 คน​ที่​ปกปิด​ความผิด​ของ​คน​อื่น​ไว้​รักษา​มิตรภาพ ส่วน​คน​ที่​เล่า​ความผิด​ของ​เพื่อน​ให้​คนอื่น​ฟัง​ก็​ทำลาย​มิตรภาพ",
    "streamUrl": "fivefish.org/T62605",
    "trackDownloadUrl": "fivefish.org/T62605-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62605.zip",
    "programId": "62605",
    "languageVideoUrl": "https://www.youtube.com/watch?v=_gKV-M1YQoM&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62605",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62604,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Proverbs 18:4 The words of the mouth are deep waters, but the fountain of wisdom is a rushing stream.",
    "verse_th": "สุภาษิต 18:4 คำพูด​จาก​ปาก เป็น​น้ำลึก​ที่​เกิน​กว่า​จะ​เข้าใจ​ได้ แต่​แหล่งน้ำ​แห่ง​ปัญญา​ทำ​ให้​สดชื่น​เสมอ เหมือน​กับ​ลำธาร​ที่​ไหล​เชี่ยว",
    "streamUrl": "fivefish.org/T62604",
    "trackDownloadUrl": "fivefish.org/T62604-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62604.zip",
    "programId": "62604",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lncNHje2S2M&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62604",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62606,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Proverbs 21:30 There is no wisdom, no insight, no plan that can succeed against the LORD.",
    "verse_th": "สุภาษิต 21:30 ถึง​จะ​มี​สติปัญญา ความเข้าใจ และ​คำปรึกษาดี​แค่ไหน​ก็ตาม ก็​ช่วย​ไม่​ได้​หรอก ถ้า​พระยาห์เวห์​ต่อต้าน​เจ้า",
    "streamUrl": "fivefish.org/T62606",
    "trackDownloadUrl": "fivefish.org/T62606-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62606.zip",
    "programId": "62606",
    "languageVideoUrl": "https://www.youtube.com/watch?v=b1MA64zc-XU&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62606",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62607,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Proverbs 25:28 Like a city whose walls are broken through is a person who lacks self-control.",
    "verse_th": "สุภาษิต 25:28 คน​ที่​ควบคุม​อารมณ์​ตัวเอง​ไม่​ได้ ก็​เหมือน​เมือง​ที่​ไม่​มี​กำแพง​ป้องกัน",
    "streamUrl": "fivefish.org/T62607",
    "trackDownloadUrl": "fivefish.org/T62607-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62607.zip",
    "programId": "62607",
    "languageVideoUrl": "https://www.youtube.com/watch?v=X4rHdRp1tw0&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62607",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62708,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Proverbs 27:17 As iron sharpens iron, so one person sharpens another.",
    "verse_th": "สุภาษิต 27:17 เหล็ก​ลับ​เหล็ก​ให้​คม​ได้ คน​ก็​ลับ​เพื่อน​ของ​เขา​ได้",
    "streamUrl": "fivefish.org/T62708",
    "trackDownloadUrl": "fivefish.org/T62708-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62708.zip",
    "programId": "62708",
    "languageVideoUrl": "https://www.youtube.com/watch?v=UE4fkwbgxhs&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62708",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62608,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Proverbs 3:13-14 Blessed are those who find wisdom, those who gain understanding,for she is more profitable than silver and yields better returns than gold.",
    "verse_th": "สุภาษิต 3:13-14 คน​ที่​ค้นพบ​สติปัญญา มี​เกียรติ​จริงๆ คน​ที่​มี​ความ​เข้าใจ​ก็​มี​เกียรติ​จริงๆ 14 กำไร​ที่​เกิด​จาก​สติปัญญานั้น มี​ค่า​ยิ่งกว่า​เงิน รายได้​ที่​เกิด​จาก​เธอ มี​ค่า​ยิ่งกว่า​ทองคำ",
    "streamUrl": "fivefish.org/T62608",
    "trackDownloadUrl": "fivefish.org/T62608-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62608.zip",
    "programId": "62608",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kny0p6EFtwU&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62608",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62609,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Proverbs 3:5-6 Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to Him, and He will make your paths straight.",
    "verse_th": "สุภาษิต 3:5-6 ให้​ไว้วางใจ​ใน​พระยาห์เวห์​ด้วย​สุดใจ​ของ​เจ้า และ​อย่า​ได้​พึ่ง​ความ​เข้าใจ​ของ​ตัว​เจ้า​เอง 6 ให้​เชื่อฟัง​พระองค์​ใน​ทุกหน​ทาง​ของ​เจ้า แล้ว​พระองค์​จะ​ทำ​ให้​เส้นทาง​ของ​เจ้า​ราบ​รื่น",
    "streamUrl": "fivefish.org/T62609",
    "trackDownloadUrl": "fivefish.org/T62609-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62609.zip",
    "programId": "62609",
    "languageVideoUrl": "https://www.youtube.com/watch?v=KkO8msATOfw&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62609",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 74799,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Temporal to Eternity Part 1",
    "title_th": "ชั่วคราวถึงนิรันดร์กาล ตอนที่ 1",
    "verse_en": "Proverbs 3:9-10 Honor the Lord with your wealth, with the first fruits of all your crops; then your barns will be filled to overflowing, and your vats will brim over with new wine.",
    "verse_th": "สุภาษิต 3:9-10 ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้ ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้แล้ว​ยุ้งฉาง​ของ​เจ้า​จะ​เต็มเปี่ยม​ไป​ด้วย​เมล็ดข้าว และ​ถัง​เหล้าองุ่น​ของ​เจ้า​ก็​จะ​เต็มล้น​ไปด้วย​เหล้าองุ่น​ใหม่",
    "streamUrl": "fivefish.org/T74799",
    "trackDownloadUrl": "fivefish.org/T74799-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74799.zip",
    "programId": "74799",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lAnVl6gLaRo&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T74799",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 74798,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Temporal to Eternity Part 2",
    "title_th": "ชั่วคราวถึงนิรันดร์กาล ตอนที่ 2",
    "verse_en": "Proverbs 4:23 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สุภาษิต 4:23 ยิ่งกว่า​สิ่งใด ให้​เฝ้าระวัง​ใจ เพราะ​ใจ​เป็น​แหล่ง​ชีวิต",
    "streamUrl": "fivefish.org/T74798",
    "trackDownloadUrl": "fivefish.org/T74798-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74798.zip",
    "programId": "74798",
    "shareUrl": "5fi.sh/T74798",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 80864,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "The Living Christ - Lessons 1 & 2",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 1 & 2",
    "verse_en": "Isaiah 26:3 You will keep in perfect peace him whose mind is steadfast, because he trusts in You.",
    "verse_th": "อิสยาห์ 26:3 พระยาห์เวห์​เจ้าข้า พระองค์​ประทาน​สันติสุข​แท้จริง​ให้​กับ​ใจ​ที่พึ่งพิง​ในพระองค์นั้น เพราะ​พวกเขา​ไว้วางใจ​ในพระองค์",
    "streamUrl": "fivefish.org/T80864",
    "trackDownloadUrl": "fivefish.org/T80864-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80864.zip",
    "programId": "80864",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-jiej8_zqM0&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T80864",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 62602,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "The Living Christ - Lessons 3 & 4",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 3 & 4",
    "verse_en": "Isaiah 40:31 But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.",
    "verse_th": "อิสยาห์ 40:31 แต่​คนเหล่านั้น​ที่​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์​จะ​มี​กำลัง​ขึ้นมาใหม่ และ​จะบิน​สูงขึ้นไป​เหมือน​ติดปีกนกอินทรี พวกเขา​จะ​วิ่ง​และ​จะ​ไม่หมดเรี่ยวแรง พวกเขา​จะ​เดิน​และ​จะ​ไม่เหนื่อย",
    "streamUrl": "fivefish.org/T62602",
    "trackDownloadUrl": "fivefish.org/T62602-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62602.zip",
    "programId": "62602",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FhkcSqpDlxQ&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T62602",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 80851,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "The Living Christ 1-63",
    "title_th": "ชีวิตของพระคริสต์ 1-63",
    "verse_en": "Isaiah 41:10 So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with My righteous hand.",
    "verse_th": "อิสยาห์ 41:10 ไม่ต้องกลัว เพราะ​เรา​อยู่​กับเจ้า อย่ากลัวเลย เพราะ​เรา​เป็น​พระเจ้า​ของเจ้า เรา​จะ​ทำให้​เจ้า​มีกำลัง ใช่แล้ว เรา​จะ​ช่วยเจ้า เรา​จะ​พยุงเจ้า​ด้วย​มือขวา​แห่ง​ชัยชนะ​ของเรา",
    "streamUrl": "fivefish.org/T80851",
    "trackDownloadUrl": "fivefish.org/T80851-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80851.zip",
    "programId": "80851",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-Iux8Q6G0Yg&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T80851",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 80852,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "The Living Christ 64 - 120",
    "title_th": "ชีวิตของพระคริสต์ 64 - 120",
    "verse_en": "Isaiah 53:6 We all, like sheep, have gone astray, each of us has turned to his own way; and the Lord has laid on Him the iniquity of us all.",
    "verse_th": "อิสยาห์ 53:6 พวกเรา​ทุกคน​ได้​หลงหายไป​เหมือนแกะ พวกเรา​แต่ละคน​ต่าง​หลงไป​คนละทิศ​ละทาง แต่​พระยาห์เวห์​ปล่อย​ให้​ความผิด​ของ​พวกเรา​ทุกคน​โจมตีเขา",
    "streamUrl": "fivefish.org/T80852",
    "trackDownloadUrl": "fivefish.org/T80852-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80852.zip",
    "programId": "80852",
    "shareUrl": "5fi.sh/T80852",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 3240,
    "iso3": "MYA",
    "langId": "195",
    "languageEn": "Burmese",
    "langTh": "พม่า",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Isaiah 6:8 Then I heard the voice of the Lord saying, Whom shall I send? And who will go for Us? And I said, Here am I. Send me!",
    "verse_th": "อิสยาห์ 6:8 และ​ผม​ก็​ได้ยิน​เสียง​ของ​องค์​เจ้า​ชีวิต​พูดว่า “เรา​จะ​ส่งใคร​ไปดี ใคร​จะไป​แทน​พวกเรา” แล้ว​ผม​ก็​ตอบว่า “ข้าพเจ้า​อยู่นี่ครับ ส่ง​ข้าพเจ้า​ไปเถิด”",
    "streamUrl": "fivefish.org/T3240",
    "trackDownloadUrl": "fivefish.org/T3240-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3240.zip",
    "programId": "3240",
    "languageVideoUrl": "https://www.youtube.com/watch?v=cwGyf8oKLho&list=PLbQkUFqMy6wrRWdGXBDeEaoRkQY8yq6j8",
    "shareUrl": "5fi.sh/T3240",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Burmese.195.mp3",
    "stableKey": "Burmese"
  },
  {
    "id": 14200,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Jeremiah 1:9 Then the LORD reached out His hand and touched my mouth and said to me, I have put My words in your mouth.",
    "verse_th": "เยเรมีย์ 1:9 แล้ว​พระยาห์เวห์​ก็​ยื่น​มือ​ออกมา​แตะ​ปาก​ของผม และ​พระองค์​พูด​กับ​ผม​ว่า “เรา​ได้​ใส่​คำพูด​ของเรา​เข้าไป​ใน​ปาก​ของเจ้า​แล้ว",
    "streamUrl": "fivefish.org/T14200",
    "trackDownloadUrl": "fivefish.org/T14200-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/14200.zip",
    "programId": "14200",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yb_tp0xGROg&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T14200",
    "duration": "37:30",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 70590,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Jeremiah 29:13 You will seek Me and find Me when you seek Me with all your heart.",
    "verse_th": "เยเรมีย์ 29:13 เจ้า​จะ​แสวงหา​เรา แล้ว​เจ้า​ก็​จะ​พบ​เรา เมื่อ​เจ้า​แสวงหา​เรา​ด้วย​สิ้นสุดใจ​ของ​เจ้า",
    "streamUrl": "fivefish.org/T70590",
    "trackDownloadUrl": "fivefish.org/T70590-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/70590.zip",
    "programId": "70590",
    "languageVideoUrl": "https://www.youtube.com/watch?v=d247Lvtourc&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T70590",
    "duration": "37:37",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Cantonese.70590.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 70600,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Lamentations 3:22-23 Because of the Lord’s great love, we are not consumed, for His compassions never fail. They are new every morning; great is Your faithfulness.",
    "verse_th": "บทเพลง​ร้องทุกข์ 3:22-23 แน่นอน ความรัก​ของ​พระยาห์เวห์​ไม่มี​วัน​สิ้นสุด แน่นอน ความเมตตา​ของ​พระองค์​ไม่มี​วัน​หมดสิ้น​ 23 ความรัก​และ​ความเมตตา​ของ​พระองค์​เริ่มต้นใหม่​ใน​ทุกๆ เช้า ความซื่อสัตย์​ของ​พระองค์​นั้น​ยิ่งใหญ่",
    "streamUrl": "fivefish.org/T70600",
    "trackDownloadUrl": "fivefish.org/T70600-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/70600.zip",
    "programId": "70600",
    "languageVideoUrl": "https://www.youtube.com/watch?v=tlkzVA5pGRk&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T70600",
    "duration": "38:05",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 80172,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Micah 6:8 He has shown you, O mortal, what is good. And what does the LORD require of you? To act justly and to love mercy and to walk humbly with your God.",
    "verse_th": "มีคาห์ 6:8 เจ้ามนุษย์ พระยาห์เวห์ บอก​เจ้า​แล้ว​ถึง​สิ่ง​ที่ดี และ​สิ่ง​ที่​พระองค์​ต้องการ​จาก​เจ้า คือ ให้​ทำ​สิ่ง​ที่​ยุติธรรม รัก​ความเมตตา และ​เดิน​กับ​พระเจ้า​ของ​เจ้า​ด้วย​ความถ่อมใจ",
    "streamUrl": "fivefish.org/T80172",
    "trackDownloadUrl": "fivefish.org/T80172-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80172.zip",
    "programId": "80172",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Wb-pgnud4wg&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T80172",
    "duration": "45:33",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 80245,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Zechariah 7:9-10 “This is what the LORD Almighty said: ‘Administer true justice; show mercy and compassion to one another. Do not oppress the widow or the fatherless, the foreigner or the poor. Do not plot evil against each other.’",
    "verse_th": "เศคาริยาห์ 7:9-10 “นี่​คือ​สิ่ง​ที่​พระยาห์เวห์​ผู้มีฤทธิ์ทั้งสิ้น​พูด ‘ให้​ตัดสิน​อย่าง​ยุติธรรม ให้​มี​น้ำใจ​ต่อกัน​และ​เห็นอก​เห็นใจ​กัน อย่า​กดขี่​ข่มเหง​แม่หม้าย เด็ก​กำพร้า คนต่างชาติ หรือ​คนจน อย่า​วางแผนชั่ว​ในใจ​ต่อกัน’",
    "streamUrl": "fivefish.org/T80245",
    "trackDownloadUrl": "fivefish.org/T80245-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80245.zip",
    "programId": "80245",
    "languageVideoUrl": "https://www.youtube.com/watch?v=E2TS-epmUyQ&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T80245",
    "duration": "38:41",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 62456,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Matthew 18:20 For where two or three come together in My name, there am I with them.",
    "verse_th": "มัทธิว 18:20 เพราะ​ที่​ไหน​ก็​ตาม ที่​มี​สอง​หรือ​สาม​คน​มา​อยู่​รวม​กัน​เพราะ​เป็น​ศิษย์​ของ​เรา เรา​ก็​จะ​อยู่​กับ​พวก​เขา​ที่​นั่น",
    "streamUrl": "fivefish.org/T62456",
    "trackDownloadUrl": "fivefish.org/T62456-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62456.zip",
    "programId": "62456",
    "languageVideoUrl": "https://www.youtube.com/watch?v=BXeiVfkTrcw&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T62456",
    "duration": "29:21",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 70610,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Matthew 19:26 Jesus looked at them and said, With man this is impossible, but with God all things are possible.",
    "verse_th": "มัทธิว 19:26 พระเยซู​มอง​พวก​ศิษย์​และ​พูด​ว่า “สำหรับ​มนุษย์ เป็น​ไป​ไม่​ได้​อยู่​แล้ว แต่​สำหรับ​พระเจ้า​ทุก​สิ่ง​ทุก​อย่าง​เป็น​ไป​ได้”",
    "streamUrl": "fivefish.org/T70610",
    "trackDownloadUrl": "fivefish.org/T70610-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/70610.zip",
    "programId": "70610",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IC3d3236WPQ&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T70610",
    "duration": "34:03",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 62457,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Matthew 28:19-20 Therefore, go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded you. And surely, I am with you always, to the very end of the age.",
    "verse_th": "มัทธิว 28:19-20 ดังนั้น​ให้​ออก​ไป​ทำ​ให้​คน​ทุก​ชาติ​มา​เป็น​ศิษย์​ของ​เรา ให้​เขา​เข้า​พิธี​จุ่มน้ำ เพื่อ​จะ​ได้​กลาย​เป็น​ของ​พระบิดา พระบุตร และ​พระวิญญาณ​บริสุทธิ์สอน​พวก​เขา​ให้​เชื่อฟัง​ทุก​สิ่ง​ที่​เรา​ได้​สั่ง​ไว้ จำ​ไว้​ว่า เรา​จะ​อยู่​กับ​พวก​คุณ​เสมอ จนกว่า​จะ​สิ้นยุค",
    "streamUrl": "fivefish.org/T62457",
    "trackDownloadUrl": "fivefish.org/T62457-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62457.zip",
    "programId": "62457",
    "languageVideoUrl": "https://www.youtube.com/watch?v=A4WxhM7KXZE&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T62457",
    "duration": "32:24",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 70620,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Matthew 4:19 “Come, follow Me,” Jesus said, “and I will make you fishers of men.”",
    "verse_th": "มัทธิว 4:19 พระองค์​พูด​กับ​เขา​ว่า “ตาม​เรา​มา​เถอะ เรา​จะ​สอน​ให้​จับ​คน​แทน​จับ​ปลา”",
    "streamUrl": "fivefish.org/T70620",
    "trackDownloadUrl": "fivefish.org/T70620-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/70620.zip",
    "programId": "70620",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Ik62riooj54&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T70620",
    "duration": "35:52",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 30011,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Portrait of Jesus",
    "title_th": "ชีวิตของพระเยซู",
    "verse_en": "Matthew 4:4 Jesus answered, It is written: 'Man shall not live on bread alone, but on every word that comes from the mouth of God.'",
    "verse_th": "มัทธิว 4:4 พระเยซู​ตอบ​ว่า “พระคัมภีร์ เขียน​ไว้​ว่า ‘ชีวิต​ที่​เที่ยงแท้​ไม่​ได้​ขึ้น​อยู่​กับ​ขนมปัง​เพียง​อย่าง​เดียว แต่​อยู่​ได้​ด้วย​คำพูด​ทุก​คำ​ที่​มา​จาก​พระเจ้า’”",
    "streamUrl": "fivefish.org/T30011",
    "trackDownloadUrl": "fivefish.org/T30011-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30011.zip",
    "programId": "30011",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OAZbEt94Mwg&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T30011",
    "duration": "76:02",
    "trackCount": "7.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 2890,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Matthew 5:16 In the same way, let your light shine before men, that they may see your good deeds and praise your Father in heaven.",
    "verse_th": "มัทธิว 5:16 พวก​คุณ​ก็​เหมือน​กัน ให้​ส่อง​สว่าง​ออก​ไป​เพื่อ​คน​จะ​ได้​เห็น​ความ​ดี​ที่​คุณ​ทำ และ​จะ​ได้​สรรเสริญ​พระบิดา​ของ​คุณ​ที่​อยู่​บน​สวรรค์",
    "streamUrl": "fivefish.org/T2890",
    "trackDownloadUrl": "fivefish.org/T2890-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2890.zip",
    "programId": "2890",
    "languageVideoUrl": "https://www.youtube.com/watch?v=RZh9Z1BIZ-I&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T2890",
    "duration": "57:50",
    "trackCount": "13.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 2891,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Matthew 5:9 Blessed are the peacemakers, for they will be called children of God.",
    "verse_th": "มัทธิว 5:9 คน​ที่​สร้าง​สันติ มี​เกียรติ​จริงๆ เพราะ​พระเจ้า​จะ​เรียก​เขา​ว่า​เป็น​ลูก",
    "streamUrl": "fivefish.org/T2891",
    "trackDownloadUrl": "fivefish.org/T2891-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2891.zip",
    "programId": "2891",
    "languageVideoUrl": "https://www.youtube.com/watch?v=zPf0WtZDvc8&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T2891",
    "duration": "53:30",
    "trackCount": "17.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 13250,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Words of Life 3",
    "title_th": "พระคำแห่งชีวิต 3",
    "verse_en": "Matthew 6:33 But seek first His kingdom and His righteousness, and all these things will be given to you as well.",
    "verse_th": "มัทธิว 6:33 แต่​ให้​ดิ้นรน​หา​อาณาจักร​ของ​พระเจ้า​และ​ชีวิต​ที่​ทำ​ตามใจ​พระองค์​ก่อน แล้ว​พระองค์​จะ​ให้​สิ่ง​ที่​จำเป็น​ทั้งหมดนี้​กับ​พวก​คุณ​เอง",
    "streamUrl": "fivefish.org/T13250",
    "trackDownloadUrl": "fivefish.org/T13250-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/13250.zip",
    "programId": "13250",
    "languageVideoUrl": "https://www.youtube.com/watch?v=0HxMgCDHM-U&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T13250",
    "duration": "55:51",
    "trackCount": "16.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 20340,
    "iso3": "YUE",
    "langId": "13",
    "languageEn": "Cantonese",
    "langTh": "จีนกวางตุ้ง",
    "title_en": "Words of Life for Children",
    "title_th": "พระคำแห่งชีวิตสำหรับเด็ก",
    "verse_en": "Mark 10:45 For even the Son of Man did not come to be served, but to serve, and to give His life as ransom for many.",
    "verse_th": "มาระโก 10:45 เพราะ​แม้แต่​บุตร​มนุษย์ ก็​ยัง​ไม่​ได้​มา​เพื่อ​จะ​ให้​คน​อื่น​รับใช้ แต่​มา​เพื่อ​จะ​รับใช้​คน​อื่น และ​ยอม​สละ​ชีวิต​เพื่อ​ปลดปล่อย​ให้​คน​มากมาย​เป็น​อิสระ",
    "streamUrl": "fivefish.org/T20340",
    "trackDownloadUrl": "fivefish.org/T20340-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/20340.zip",
    "programId": "20340",
    "languageVideoUrl": "https://www.youtube.com/watch?v=U-qjMJu2V9w&list=PLP0Y_cbvmX8psrLzRyjqhEFH9kPxs80yr",
    "shareUrl": "5fi.sh/T20340",
    "duration": "43:08",
    "trackCount": "9.0",
    "sampleUrl": "/audio/Cantonese.13.mp3",
    "stableKey": "Cantonese"
  },
  {
    "id": 3410,
    "iso3": "CJA",
    "langId": "1024",
    "languageEn": "Cham Cambodia",
    "langTh": "ชาม กัมพูชา",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Mark 9:29 He replied, This kind can come out only by prayer.",
    "verse_th": "มาระโก 9:29 พระองค์​บอก​ว่า “มี​ทาง​เดียว​ที่​จะ​ไล่​ผี​ชั่ว​ชนิดนี้​ออก​ได้ คือ​ต้อง​อธิษฐาน”",
    "streamUrl": "fivefish.org/T3410",
    "trackDownloadUrl": "fivefish.org/T3410-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3410.zip",
    "programId": "3410",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XAJNDFkDN80&list=PLd1Q7xMzP2jWLzsT4jIyrlIPhR6QbM8r0",
    "shareUrl": "5fi.sh/T3410",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Cham.Cambodia.1024.mp3",
    "stableKey": "Cham Cambodia"
  },
  {
    "id": 31891,
    "iso3": "CMN",
    "langId": "6238",
    "languageEn": "Chinese Huang Yuan",
    "langTh": "จีนหวงเยวียน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Luke 12:32 Do not be afraid, little flock, for your Father has been pleased to give you the kingdom.",
    "verse_th": "ลูกา 12:32 “ฝูง​แกะ​เล็กๆ​เอ๋ย ไม่​ต้อง​กลัว​นะ เพราะ​พระบิดา​ของ​คุณ​ยินดี​ที่​จะ​มอบ​อาณาจักร​ให้​กับ​คุณ",
    "streamUrl": "fivefish.org/T31891",
    "trackDownloadUrl": "fivefish.org/T31891-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31891.zip",
    "programId": "31891",
    "languageVideoUrl": "https://www.youtube.com/watch?v=e5M8IjxZWm8&list=PLXcynA24_lTPUvbp3hpgWnETyeG0V_8iX",
    "shareUrl": "5fi.sh/T31891",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Huang.Yuan.31891.mp3",
    "stableKey": "Chinese Huang Yuan"
  },
  {
    "id": 31111,
    "iso3": "CMN",
    "langId": "6276",
    "languageEn": "Chinese Hubei Chongyanghua",
    "langTh": "จีนเหอเป่ยฉงหยางหัว",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "Luke 5:16 But Jesus often withdrew to lonely places and prayed.",
    "verse_th": "ลูกา 5:16 แต่​บ่อย​ครั้ง​ที่​พระเยซู​หลบ​ไป​ที่​สงบเงียบ​เพื่อ​อธิษฐาน",
    "streamUrl": "fivefish.org/T31111",
    "trackDownloadUrl": "fivefish.org/T31111-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31111.zip",
    "programId": "31111",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ZSWfIhcytEg&list=PLXcynA24_lTN1S2ALVJRX-3aYgsZrmMCP",
    "shareUrl": "5fi.sh/T31111",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Hubei.Chongyanghua.6276.mp3",
    "stableKey": "Chinese Hubei Chongyanghua"
  },
  {
    "id": 30170,
    "iso3": "CMN",
    "langId": "6278",
    "languageEn": "Chinese Hubei Dangyanghua",
    "langTh": "จีนเหอเป่ยตังแย่งหัว",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "Luke 6:42 How can you say to your brother, 'Brother, let me take the speck out of your eye,' when you yourself fail to see the plank in your own eye? You hypocrite, first take the plank out of your eye, and then you will see clearly to remove the speck from your brother's eye.",
    "verse_th": "ลูกา 6:42 แล้ว​คุณ​พูด​กับ​พี่น้อง​ออก​มา​ได้​ยังไง​ว่า ‘เดี๋ยว​ผม​จะ​เขี่ย​ขี้ผง​ใน​ตา​ให้​นะ’ ทั้งๆที่​ซุง​ทั้ง​ท่อน​ใน​ตา​ตัวเอง​ก็​ยัง​มอง​ไม่​เห็น ไอ้​หน้าซื่อใจคด เอา​ท่อน​ซุง​ออก​จาก​ตา​ของ​ตัวเอง​ก่อน แล้ว​จะ​ได้​มอง​เห็น​ชัดๆ​ตอน​เขี่ย​ขี้ผง​ออก​จาก​ตา​ของ​พี่น้อง",
    "streamUrl": "fivefish.org/T30170",
    "trackDownloadUrl": "fivefish.org/T30170-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30170.zip",
    "programId": "30170",
    "languageVideoUrl": "https://www.youtube.com/watch?v=EPXdPiTlz-0&list=PLXcynA24_lTOp8wq6Qwt3s-RjqH5osSEJ",
    "shareUrl": "5fi.sh/T30170",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Hubei.Dangyanghua.30170.mp3",
    "stableKey": "Chinese Hubei Dangyanghua"
  },
  {
    "id": 30630,
    "iso3": "CMN",
    "langId": "6277",
    "languageEn": "Chinese Hubei Wuhandayehua",
    "langTh": "จีนเหอเป่ยวูฮั่นตาเยหัว",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "Luke 9:23 Then He said to them all, “If anyone would come after Me, he must deny himself and take up the cross daily and follow Me.”",
    "verse_th": "ลูกา 9:23 แล้ว​พระองค์​ก็​พูด​กับ​ทุก​คน​ว่า “ถ้า​ใคร​อยาก​จะ​ติดตาม​เรา ต้อง​เลิก​ตามใจ​ตัวเอง แล้ว​แบก​ไม้กางเขน​ของ​ตัวเอง​ตาม​เรา​ทุกๆ​วัน”",
    "streamUrl": "fivefish.org/T30630",
    "trackDownloadUrl": "fivefish.org/T30630-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30630.zip",
    "programId": "30630",
    "languageVideoUrl": "https://www.youtube.com/watch?v=LRprWBK-2i4&list=PLXcynA24_lTPEEEKTQ_Y6XavRh6_fmNwA",
    "shareUrl": "5fi.sh/T30630",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Hubei.Wuhandayehua.30630.mp3",
    "stableKey": "Chinese Hubei Wuhandayehua"
  },
  {
    "id": 29501,
    "iso3": "CMN",
    "langId": "6143",
    "languageEn": "Chinese Liansan",
    "langTh": "จีนเหลียนซาน",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "John 1:12 Yet to all who received Him to those who believed in His name, He gave the right to become children of God.",
    "verse_th": "ยอห์น 1:12 แต่​ส่วน​คน​ที่​ยอมรับ​และ​ไว้วางใจ​พระองค์ พระองค์​ให้​สิทธิ์​พวก​เขา​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T29501",
    "trackDownloadUrl": "fivefish.org/T29501-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29501.zip",
    "programId": "29501",
    "languageVideoUrl": "https://www.youtube.com/watch?v=aFZcX1diIww&list=PLXcynA24_lTPbWspcQUL00FNFjvnUT2R3",
    "shareUrl": "5fi.sh/T29501",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Liansan.29501.mp3",
    "stableKey": "Chinese Liansan"
  },
  {
    "id": 31900,
    "iso3": "CMN",
    "langId": "6239",
    "languageEn": "Chinese Min Zhou",
    "langTh": "จีนมินโจ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 10:14-15 I am the good shepherd; I know My sheep and My sheep know Me—just as the Father knows Me and I know the Father—and I lay down My life for the sheep.",
    "verse_th": "ยอห์น 10:14-15 เรา​เป็น​คน​เลี้ยง​แกะ​ที่​ดี เรา​รู้จัก​แกะ​ของ​เรา และ​แกะ​ก็​รู้จัก​เรา​ด้วย เหมือน​กับ​ที่​พระบิดา​รู้จัก​เรา​และ​เรา​ก็​รู้จัก​พระบิดา เรา​สละ​ชีวิต​ของ​เรา​เพื่อ​รักษา​แกะ​ของ​เรา​ให้​รอด",
    "streamUrl": "fivefish.org/T31900",
    "trackDownloadUrl": "fivefish.org/T31900-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31900.zip",
    "programId": "31900",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8TPTkZwlyBI&list=PLXcynA24_lTPkyoAOwirV4s8nQt7k2sMA",
    "shareUrl": "5fi.sh/T31900",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Min.Zhou.31900.mp3",
    "stableKey": "Chinese Min Zhou"
  },
  {
    "id": 25310,
    "iso3": "CMN",
    "langId": "4665",
    "languageEn": "Chinese Ningxia",
    "langTh": "จีนหนิงเซีย",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 10:27 My sheep listen to My voice; I know them, and they follow Me.",
    "verse_th": "ยอห์น 10:27 แกะ​ของ​เรา​จะ​ฟัง​เสียง​เรา และ​เรา​ก็​รู้จัก​แกะ​ของ​เรา และ​แกะ​ของ​เรา​จะ​ตาม​เรา​ไป",
    "streamUrl": "fivefish.org/T25310",
    "trackDownloadUrl": "fivefish.org/T25310-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/25310.zip",
    "programId": "25310",
    "languageVideoUrl": "https://www.youtube.com/watch?v=xOUCtY2035g&list=PLXcynA24_lTMmqAYtdEG7KQPB8m6XnS15",
    "shareUrl": "5fi.sh/T25310",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Ningxia.25310.mp3",
    "stableKey": "Chinese Ningxia"
  },
  {
    "id": 27500,
    "iso3": "CMN",
    "langId": "4837",
    "languageEn": "Chinese Sichuan",
    "langTh": "จีนซื่อชวน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 13:34 A new command I give you: Love one another. As I have loved you, so you must love one another.",
    "verse_th": "ยอห์น 13:34 เรา​จะ​ให้​คำสั่ง​ใหม่​กับ​พวก​คุณ คือ​ให้​รัก​ซึ่ง​กัน​และ​กัน พวก​คุณ​ต้อง​รัก​กัน​เหมือน​กับ​ที่​เรา​รัก​คุณ",
    "streamUrl": "fivefish.org/T27500",
    "trackDownloadUrl": "fivefish.org/T27500-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27500.zip",
    "programId": "27500",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4MlGsB4I9Kw&list=PLXcynA24_lTN1-RvQ4XXkkPBqDmu8ITMQ",
    "shareUrl": "5fi.sh/T27500",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Sichuan.27500.mp3",
    "stableKey": "Chinese Sichuan"
  },
  {
    "id": 31870,
    "iso3": "CMN",
    "langId": "6241",
    "languageEn": "Chinese Zang Ye",
    "langTh": "จีนจางเย",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 13:35 By this everyone will know that you are My disciples, if you love one another.",
    "verse_th": "ยอห์น 13:35 ถ้า​พวก​คุณ​รัก​กัน ทุก​คน​ก็​จะ​รู้​ว่า​คุณ​เป็น​ศิษย์​ของ​เรา",
    "streamUrl": "fivefish.org/T31870",
    "trackDownloadUrl": "fivefish.org/T31870-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31870.zip",
    "programId": "31870",
    "languageVideoUrl": "https://www.youtube.com/watch?v=dzIbMnmFo8s&list=PLXcynA24_lTMKmR8IA3yMTZjFemMO8BV7",
    "shareUrl": "5fi.sh/T31870",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Chinese.Zang.Ye.31870.mp3",
    "stableKey": "Chinese Zang Ye"
  },
  {
    "id": 64447,
    "iso3": "COG",
    "langId": "8901",
    "languageEn": "Chong",
    "langTh": "ชอง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "John 14:21 Whoever has My commands and obeys them, he is the one who loves Me. He who loves Me will be loved by My Father, and I too will love him and show Myself to him.",
    "verse_th": "ยอห์น 14:21 คน​ที่​รู้จัก​คำ​สั่งสอน​ของ​เรา​และ​ทำ​ตาม​ก็​เป็น​คน​ที่​รัก​เรา พระบิดา​จะ​รัก​คน​ที่​รัก​เรา​ด้วย เรา​ก็​จะ​รัก​พวก​เขา​และ​จะ​ปรากฏ​ตัว​ให้​พวก​เขา​เห็น",
    "streamUrl": "fivefish.org/T64447",
    "trackDownloadUrl": "fivefish.org/T64447-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64447.zip",
    "programId": "64447",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ddeRxc-miEM&list=PLd1Q7xMzP2jWtwrcL74n-woRprCUPkjwS",
    "shareUrl": "5fi.sh/T64447",
    "duration": "92:53",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Chong.64447.mp3",
    "stableKey": "Chong"
  },
  {
    "id": 31030,
    "iso3": "PCE",
    "langId": "6296",
    "languageEn": "Deang Hongfenglong",
    "langTh": "เดียง ฮองแฟงกลอง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "John 14:27 Peace I leave with you; My peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid.",
    "verse_th": "ยอห์น 14:27 เรา​ได้​ให้​สันติสุข​ไว้​กับ​คุณ สันติสุข​ที่​เรา​ให้​นี้​ไม่​เหมือน​กับ​ที่​โลก​ให้ ดังนั้น​คุณ​จึง​ไม่​ต้อง​ทุกข์ใจ หรือ​หวาดกลัว​เลย",
    "streamUrl": "fivefish.org/T31030",
    "trackDownloadUrl": "fivefish.org/T31030-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31030.zip",
    "programId": "31030",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FG0t88tGd24&list=PLXcynA24_lTPgiRxY15G9-b9VsM47sSoK",
    "shareUrl": "5fi.sh/T31030",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Deang.Hongfenglong.31030.mp3",
    "stableKey": "Deang Hongfenglong"
  },
  {
    "id": 31020,
    "iso3": "PCE",
    "langId": "6296",
    "languageEn": "Deang Hongfenglong",
    "langTh": "เดียง ฮองแฟงกลอง",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 14:6 Jesus answered, I am the way and the truth and the life. No one comes to the Father except through Me.",
    "verse_th": "ยอห์น 14:6 พระเยซู​บอก​ว่า เรา​เป็น​ทาง​นั้น เป็น​ความจริง​และ​เป็น​ชีวิต ไม่​มี​ใคร​ไป​ถึง​พระบิดา​ได้​นอก​จาก​มา​ทาง​เรา",
    "streamUrl": "fivefish.org/T31020",
    "trackDownloadUrl": "fivefish.org/T31020-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31020.zip",
    "programId": "31020",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4hX-3hJMzr8&list=PLXcynA24_lTPgiRxY15G9-b9VsM47sSoK",
    "shareUrl": "5fi.sh/T31020",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Deang.Hongfenglong.6296.mp3",
    "stableKey": "Deang Hongfenglong"
  },
  {
    "id": 29270,
    "iso3": "ENG",
    "langId": "4405",
    "languageEn": "English Australia",
    "langTh": "อังกฤษ ออสเตรเลีย",
    "title_en": "Faith by Hearing",
    "title_th": "ความเชื่อเกิดขึ้นเพราะการได้ยิน",
    "verse_en": "John 15:7 If you remain in Me and My Words remain in you, ask whatever you wish, and it will be given you.",
    "verse_th": "ยอห์น 15:7 ถ้า​พวก​คุณ​ติด​สนิท​กับ​เรา และ​คำ​สั่งสอน​ของ​เรา​ติด​สนิท​กับ​คุณ ไม่ว่า​คุณ​จะ​ขอ​อะไร​มัน​ก็​จะ​เป็น​อย่าง​นั้น",
    "streamUrl": "fivefish.org/T29270",
    "trackDownloadUrl": "fivefish.org/T29270-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29270.zip",
    "programId": "29270",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yzDgi8kv7UY&list=PL-Y0D9PLpdLAlV8MeGOk5xjfM0ZI0NsKK",
    "shareUrl": "5fi.sh/T29270",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.Australia.4405.mp3",
    "stableKey": "English Australia"
  },
  {
    "id": 64560,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "John 5:24 I tell you the truth, whoever hears My Word and believes Him who sent Me has eternal life and will not be condemned; he has crossed over from death to life.",
    "verse_th": "ยอห์น 5:24 เรา​จะ​บอก​ให้​รู้​ว่า คน​ที่​ฟัง​คำพูด​เรา​และ​ไว้วางใจ​พระองค์​ผู้​ส่ง​เรา​มา ก็​มี​ชีวิต​กับ​พระเจ้า​ตลอด​ไป และ​เขา​จะ​ไม่​ถูก​ตัดสินลงโทษ เขา​ได้​ผ่านพ้น​ความตาย​ไป​สู่​ชีวิต​แล้ว",
    "streamUrl": "fivefish.org/T64560",
    "trackDownloadUrl": "fivefish.org/T64560-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64560.zip",
    "programId": "64560",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Jtn7LqC_eaE&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T64560",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.64560.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65955,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "Jesus, the Refugee",
    "title_th": "พระเยซู ผู้ลี้ภัย",
    "verse_en": "Acts 1:8 But you will receive power when the Holy Spirit comes on you; and you will be My witnesses in Jerusalem, and in all Judea and Samaria, and to the ends of the earth.",
    "verse_th": "กิจการ 1:8 เมื่อ​พระวิญญาณ​บริสุทธิ์​มา​อยู่​กับ​พวกคุณ พวก​คุณ​ก็​จะ​ได้รับ​ฤทธิ์เดช และ​จะ​เป็น​พยาน​เล่า​เรื่อง​ของ​เรา​ให้​คน​ฟัง ทั่ว​เมือง​เยรูซาเล็ม ใน​แคว้น​ยูเดีย ใน​แคว้น​สะมาเรีย และ​ทุก​หน​แห่ง​ใน​โลกนี้",
    "streamUrl": "fivefish.org/T65955",
    "trackDownloadUrl": "fivefish.org/T65955-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65955.zip",
    "programId": "65955",
    "languageVideoUrl": "https://www.youtube.com/watch?v=sC3hKGrNlY4&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65955",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65688,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Acts 24:16 So I strive always to keep my conscience clear before God and man.",
    "verse_th": "กิจการ 24:16 ผม​จึง​พยายาม​ทำ​ดี​ที่สุด เพื่อ​จะ​ได้​มี​จิต​สำนึก​ที่​ถูกต้อง​ต่อหน้า​พระเจ้า​และ​มนุษย์​ทุก​คน",
    "streamUrl": "fivefish.org/T65688",
    "trackDownloadUrl": "fivefish.org/T65688-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65688.zip",
    "programId": "65688",
    "languageVideoUrl": "https://www.youtube.com/watch?v=dtOIGa2Yv70&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65688",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65689,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Acts 4:12 Salvation is found in no one else, for there is no other Name under heaven given to mankind by which we must be saved.",
    "verse_th": "กิจการ 4:12 นอกจาก​พระเยซู​แล้ว ไม่​มี​ใคร​ที่​จะ​ให้​ความ​รอด​กับ​เรา​ได้ ไม่​มี​ชื่อ​อื่น​ภายใต้​ฟ้านี้ ที่​จะ​ทำ​ให้​มนุษย์​รอด​ได้",
    "streamUrl": "fivefish.org/T65689",
    "trackDownloadUrl": "fivefish.org/T65689-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65689.zip",
    "programId": "65689",
    "languageVideoUrl": "https://www.youtube.com/watch?v=CYPW5dgxF84&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65689",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65761,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Acts 4:13 When they saw the courage of Peter and John and realized that they were unschooled, ordinary men, they were astonished and they took note that these men had been with Jesus.",
    "verse_th": "กิจการ 4:13 เมื่อ​พวก​ผู้นำ​ชาว​ยิว​เห็น​ถึง​ความ​กล้าหาญ​ของ​เปโตร​กับ​ยอห์น และ​เห็น​ว่า​ทั้ง​สอง​เป็น​แค่​คน​ธรรมดาๆ​ที่​ไม่​ได้รับ​การ​ศึกษา​หรือ​ฝึกฝน​อะไร​มา​เป็น​พิเศษ พวก​เขา​ก็​ยิ่ง​แปลกใจ พวก​เขา​ต่าง​ก็​นึก​ขึ้น​มา​ได้​ว่า เปโตร​และ​ยอห์น​เคย​อยู่​กับ​พระเยซู​มา​ก่อน",
    "streamUrl": "fivefish.org/T65761",
    "trackDownloadUrl": "fivefish.org/T65761-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65761.zip",
    "programId": "65761",
    "languageVideoUrl": "https://www.youtube.com/watch?v=bRMTsED7sjg&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65761",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65762,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Romans 1:16 I am not ashamed of the Gospel, because it is the power of God for the salvation of everyone who believes: first for the Jew, then for the Gentile.",
    "verse_th": "โรม 1:16 ผม​ไม่​ละอาย​เกี่ยวกับ​ข่าวดีนี้​หรอก เพราะ​ข่าวดีนี้​เป็น​ฤทธิ์เดช​ของ​พระเจ้า​ที่​จะ​ช่วย​ชีวิต​ทุก​คน​ที่​ไว้วางใจ​ให้​รอด ช่วย​พวกยิว​ก่อน แล้ว​ต่อมา​ก็​ช่วย​คน​ที่​ไม่​ใช่​ยิว​ด้วย",
    "streamUrl": "fivefish.org/T65762",
    "trackDownloadUrl": "fivefish.org/T65762-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65762.zip",
    "programId": "65762",
    "languageVideoUrl": "https://www.youtube.com/watch?v=iHUEmMPIgQA&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65762",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65763,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Romans 12:1 Therefore, I urge you brothers, in view of God’s mercy, to offer your bodies as living sacrifices, holy and pleasing to God-this is your spiritual act of worship.",
    "verse_th": "โรม 12:1 ดังนั้น​พี่น้อง​ครับ พระเจ้า​ได้​เมตตากรุณา​ต่อ​เรา ผม​ก็​เลย​ขอ​ร้อง​ให้​คุณ​มอบ​ร่างกาย​ของ​คุณ​เป็น​เครื่อง​บูชา​ที่​มี​ชีวิต​อยู่ เป็น​เครื่อง​บูชา​ที่​บริสุทธิ์ และ​เป็น​ที่​พอใจ​ของ​พระเจ้า การ​",
    "streamUrl": "fivefish.org/T65763",
    "trackDownloadUrl": "fivefish.org/T65763-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65763.zip",
    "programId": "65763",
    "languageVideoUrl": "https://www.youtube.com/watch?v=bxaB9VSgvXE&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65763",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65764,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Romans 12:2 Do not conform any longer to the pattern of this world but be transformed by the renewing of your mind. Then you will be able to test and approve what God’s will is - His good, pleasing and perfect will.",
    "verse_th": "โรม 12:2 อย่า​ทำ​ตาม​อย่าง​คน​ใน​โลกนี้ แต่​ขอ​ยอม​ให้​พระเจ้า​เปลี่ยน​แปลง​คุณ คือ​พระองค์​จะ​ให้​จิตใจ​ใหม่​กับ​คุณ​เพื่อ​จะ​ได้​รู้​ว่า​พระเจ้า​ต้อง​การ​อะไร สิ่ง​ไหน​ดี สิ่ง​ไหน​พระองค์​ชอบใจ และ​สิ่ง​ไหน​สมบูรณ์แบบ",
    "streamUrl": "fivefish.org/T65764",
    "trackDownloadUrl": "fivefish.org/T65764-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65764.zip",
    "programId": "65764",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jEni7WPgOUs&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65764",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65765,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Romans 12:9 Love must be sincere. Hate what is evil; cling to what is good.",
    "verse_th": "โรม 12:9 ให้​รัก​คน​อื่น​ด้วย​ความ​จริงใจ เกลียด​สิ่ง​ชั่วร้าย ยึด​มั่น​สิ่ง​ที่​ดี",
    "streamUrl": "fivefish.org/T65765",
    "trackDownloadUrl": "fivefish.org/T65765-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65765.zip",
    "programId": "65765",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wf2_-ZU8tRo&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65765",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 65766,
    "iso3": "ENG",
    "langId": "25",
    "languageEn": "English USA",
    "langTh": "อังกฤษ สหรัฐอเมริกา",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T65766",
    "trackDownloadUrl": "fivefish.org/T65766-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65766.zip",
    "programId": "65766",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OH61JzR3UN4&list=PLdMbuugYUIXWqV5GtDQD-0Rm7kyKxY2Jt",
    "shareUrl": "5fi.sh/T65766",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/English.USA.25.mp3",
    "stableKey": "English USA"
  },
  {
    "id": 3630,
    "iso3": "CDO",
    "langId": "113",
    "languageEn": "Foochow Colloquial Chinese",
    "langTh": "จีนฟูฉาว",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T3630",
    "trackDownloadUrl": "fivefish.org/T3630-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3630.zip",
    "programId": "3630",
    "languageVideoUrl": "https://www.youtube.com/watch?v=sGGUBNZsyEU&list=PLXcynA24_lTNF2eLmZIOcEkdwQFwGPioU",
    "shareUrl": "5fi.sh/T3630",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Foochow.Colloquial.Chinese.03630.mp3",
    "stableKey": "Foochow Colloquial Chinese"
  },
  {
    "id": 28330,
    "iso3": "CMN",
    "langId": "6039",
    "languageEn": "Guiliu",
    "langTh": "กุยเลียว",
    "title_en": "Becoming a Friend of God",
    "title_th": "กลายเป็นเพื่อนของพระเจ้า",
    "verse_en": "Romans 3:23 For all have sinned and fall short of the glory of God.",
    "verse_th": "โรม 3:23 เพราะ​ทุก​คน​ทำ​บาป​เหมือน​กัน​หมด และ​เสื่อม​จาก​พระบารมี​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T28330",
    "trackDownloadUrl": "fivefish.org/T28330-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/28330.zip",
    "programId": "28330",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PRaA43gmsQg&list=PLXcynA24_lTNpep2SUSg1Eh2QVnrAwbmz",
    "shareUrl": "5fi.sh/T28330",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Guiliu.6039.mp3",
    "stableKey": "Guiliu"
  },
  {
    "id": 80909,
    "iso3": "CMN",
    "langId": "6039",
    "languageEn": "Guiliu",
    "langTh": "กุยเลียว",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Romans 4:20-21 Yet he did not waver through unbelief regarding the promise of God, but was strengthened in his faith and gave glory to God, being fully persuaded that God had power to do what He had promised.",
    "verse_th": "โรม 4:20-21 แต่​อับราฮัม​ไม่​เคย​สงสัย​ใน​คำ​สัญญา​ของ​พระเจ้า​เลย กลับ​มี​ความ​ไว้วางใจ​มาก​ขึ้น ซึ่ง​เป็น​การ​ให้​เกียรติ​กับ​พระเจ้า 21 อับราฮัม​เชื่อ​อย่าง​แน่ว​แน่​ว่า พระเจ้า​สามารถ​ทำ​ใน​สิ่ง​ที่​พระองค์​ได้​สัญญา​ไว้",
    "streamUrl": "fivefish.org/T80909",
    "trackDownloadUrl": "fivefish.org/T80909-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80909.zip",
    "programId": "80909",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TnTVvAIRe1M&list=PLXcynA24_lTNpep2SUSg1Eh2QVnrAwbmz",
    "shareUrl": "5fi.sh/T80909",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Guiliu.80909.mp3",
    "stableKey": "Guiliu"
  },
  {
    "id": 30741,
    "iso3": "NAN",
    "langId": "366",
    "languageEn": "Hainanese",
    "langTh": "จีนไหหนาน",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Romans 5:5 And hope does not put us to shame, because God’s love has been poured out into our hearts through the Holy Spirit, Who has been given to us.",
    "verse_th": "โรม 5:5 ความหวัง​นั้น​ไม่​เคย​ทำ​ให้​เรา​ผิดหวัง​เลย เพราะ​พระเจ้า​ได้​เท​ความรัก​ของ​พระองค์​เข้า​มา​ใน​จิตใจ​ของ​เรา ผ่าน​ทาง​พระวิญญาณ​บริสุทธิ์​ที่​พระองค์​ได้​ให้​กับ​เรา​ไว้",
    "streamUrl": "fivefish.org/T30741",
    "trackDownloadUrl": "fivefish.org/T30741-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30741.zip",
    "programId": "30741",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Q4ed_DIb8SU&list=PLXcynA24_lTP21u8vGzcwi4_2GBP999OZ",
    "shareUrl": "5fi.sh/T30741",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hainanese.366.mp3",
    "stableKey": "Hainanese"
  },
  {
    "id": 30750,
    "iso3": "NAN",
    "langId": "366",
    "languageEn": "Hainanese",
    "langTh": "จีนไหหนาน",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "Romans 5:8 But God demonstrates His own love for us in this: While we were still sinners, Christ died for us.",
    "verse_th": "โรม 5:8 แต่​พระเจ้า​ได้​แสดง​ความรัก​ต่อ​เรา โดย​ยอม​ส่ง​พระคริสต์​มา​ตาย​เพื่อ​เรา ทั้งๆ​ที่​เรา​ยัง​เป็น​คน​บาป​อยู่",
    "streamUrl": "fivefish.org/T30750",
    "trackDownloadUrl": "fivefish.org/T30750-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30750.zip",
    "programId": "30750",
    "shareUrl": "5fi.sh/T30750",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hainanese.366.mp3",
    "stableKey": "Hainanese"
  },
  {
    "id": 3600,
    "iso3": "NAN",
    "langId": "366",
    "languageEn": "Hainanese",
    "langTh": "จีนไหหนาน",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Romans 6:23 For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
    "verse_th": "โรม 6:23 เพราะ​ค่าจ้าง​ที่​ความบาป​จ่าย​ให้​กับ​เรา​คือ​ความตาย แต่​ของขวัญ​ที่​พระเจ้า​ให้​กับ​เรา​นั้น​คือ​ชีวิต​ที่​อยู่​กับ​พระเจ้า​ตลอด​ไป ใน​พระเยซู​คริสต์เจ้า​ของ​เรา",
    "streamUrl": "fivefish.org/T3600",
    "trackDownloadUrl": "fivefish.org/T3600-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3600.zip",
    "programId": "3600",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1j2mCTiipnA&list=PLXcynA24_lTP21u8vGzcwi4_2GBP999OZ",
    "shareUrl": "5fi.sh/T3600",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hainanese.03600.mp3",
    "stableKey": "Hainanese"
  },
  {
    "id": 18870,
    "iso3": "NAN",
    "langId": "366",
    "languageEn": "Hainanese",
    "langTh": "จีนไหหนาน",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Romans 8:32 He who did not spare His own Son, but gave Him up for us all-how will He not also, along with Him, graciously give us all things?",
    "verse_th": "โรม 8:32 พระองค์​ไม่​หวง​แม้แต่​พระบุตร​ของ​พระองค์​เอง แต่​กลับ​มอบ​พระบุตร​นั้น​ให้​มา​ตาย​เพื่อ​เรา​ทุก​คน ถ้า​อย่าง​นั้น​พระองค์​จะ​ไม่​ยิ่ง​ให้​ทุก​สิ่ง​ทุก​อย่าง​กับ​เรา​พร้อม​กับ​พระบุตร​ด้วย​หรือ",
    "streamUrl": "fivefish.org/T18870",
    "trackDownloadUrl": "fivefish.org/T18870-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18870.zip",
    "programId": "18870",
    "languageVideoUrl": "https://www.youtube.com/watch?v=mUrJsJmbko4&list=PLXcynA24_lTP21u8vGzcwi4_2GBP999OZ",
    "shareUrl": "5fi.sh/T18870",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hainanese.366.mp3",
    "stableKey": "Hainanese"
  },
  {
    "id": 17390,
    "iso3": "HAK",
    "langId": "340",
    "languageEn": "Hakka",
    "langTh": "จีนแคะ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "1 Corinthians 14:33 For God is not a God of disorder but of peace - as in all the congregations of the Lord's people.",
    "verse_th": "1 โครินธ์ 14:33 เพราะ​พระเจ้า​ไม่​ได้​เป็น​พระเจ้า​แห่ง​ความ​วุ่นวาย แต่​เป็น​พระเจ้า​แห่ง​สันติสุข เหมือน​กับ​ที่​พระองค์​เป็น​ใน​ที่ประชุม​ทุก​แห่ง​ของ​คน​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T17390",
    "trackDownloadUrl": "fivefish.org/T17390-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/17390.zip",
    "programId": "17390",
    "languageVideoUrl": "https://www.youtube.com/watch?v=g50r7OY-LNs&list=PLXcynA24_lTMpwDLP6Ow39vX1qN2u_ejM",
    "shareUrl": "5fi.sh/T17390",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hakka.17390.mp3",
    "stableKey": "Hakka"
  },
  {
    "id": 2590,
    "iso3": "HAK",
    "langId": "340",
    "languageEn": "Hakka",
    "langTh": "จีนแคะ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "1 Corinthians 14:40 But everything should be done in a fitting and orderly way.",
    "verse_th": "1 โครินธ์ 14:40 แต่​ให้​ทำ​ทุก​อย่างนี้ อย่าง​เหมาะสม​และ​เป็น​ระเบียบ",
    "streamUrl": "fivefish.org/T2590",
    "trackDownloadUrl": "fivefish.org/T2590-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2590.zip",
    "programId": "2590",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4b0qtup6vwA&list=PLXcynA24_lTMpwDLP6Ow39vX1qN2u_ejM",
    "shareUrl": "5fi.sh/T2590",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hakka.340.mp3",
    "stableKey": "Hakka"
  },
  {
    "id": 37698,
    "iso3": "HNJ",
    "langId": "492",
    "languageEn": "Hmong Blue",
    "langTh": "ม้งเขียว",
    "title_en": "Creation to Christ",
    "title_th": "ตั้งแต่การสร้างจนถึงพระคริสต์",
    "verse_en": "1 Corinthians 15:58 Therefore, my dear brothers, stand firm. Let nothing move you. Always give yourselves fully to the work of the Lord, because you know that your labor in the Lord is not in vain.",
    "verse_th": "1 โครินธ์ 15:58 ดังนั้น พี่น้อง​ที่รัก ให้​มั่นคง อย่า​หวั่นไหว และ​ให้​ทุ่มเท​กับ​งาน​ของ​องค์​เจ้า​ชีวิต​ตลอด​เวลา เพราะ​คุณ​ก็​รู้​ว่า​จะ​ได้รับ​รางวัล​สำหรับ​งาน​หนัก​ที่​คุณ​ทำ​เพื่อ​องค์​เจ้า​ชีวิต​นั้น​แน่",
    "streamUrl": "fivefish.org/T37698",
    "trackDownloadUrl": "fivefish.org/T37698-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37698.zip",
    "programId": "37698",
    "languageVideoUrl": "https://www.youtube.com/watch?v=DYD-26yLaiQ&list=PLbQkUFqMy6wrIfwyHKuRt1SpvvWrKxcyW",
    "shareUrl": "5fi.sh/T37698",
    "duration": "51:52",
    "trackCount": "10.0",
    "sampleUrl": "/audio/Hmong.Blue.492.mp3",
    "stableKey": "Hmong Blue"
  },
  {
    "id": 62596,
    "iso3": "HNJ",
    "langId": "492",
    "languageEn": "Hmong Blue",
    "langTh": "ม้งเขียว",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "1 Corinthians 2:11 For who knows a person's thoughts except their own spirit within them? In the same way no one knows the thoughts of God except the Spirit of God.",
    "verse_th": "1 โครินธ์ 2:11 เพราะ​ไม่มี​ใคร​รู้​ความคิด​ของ​คนอื่น​ได้​นอกจาก​วิญญาณ​ที่​อยู่​ใน​ตัว​ของ​เขา​เอง เช่น​เดียว​กัน ไม่มี​ใคร​รู้​ความคิด​ของ​พระเจ้า​ได้​นอกจาก​พระวิญญาณ​ของ​พระองค์​เอง",
    "streamUrl": "fivefish.org/T62596",
    "trackDownloadUrl": "fivefish.org/T62596-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62596.zip",
    "programId": "62596",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XqROJ5YjDnI&list=PLbQkUFqMy6wrIfwyHKuRt1SpvvWrKxcyW",
    "shareUrl": "5fi.sh/T62596",
    "duration": "41:14",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Hmong.Blue.62596.mp3",
    "stableKey": "Hmong Blue"
  },
  {
    "id": 33020,
    "iso3": "HNJ",
    "langId": "492",
    "languageEn": "Hmong Blue",
    "langTh": "ม้งเขียว",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "1 Corinthians 2:12 We have not received the spirit of the world but the Spirit who is from God, that we may understand what God has freely given us.",
    "verse_th": "1 โครินธ์ 2:12 เรา​ไม่ได้​รับ​วิญญาณ​ของ​โลกนี้ แต่​รับ​พระวิญญาณ​ที่​มา​จาก​พระเจ้า เพื่อ​เรา​จะ​ได้​เข้าใจ​สิ่งต่างๆ​ที่​พระเจ้า​ให้​เรา และ​พระองค์​ก็​ให้​เรา​อย่าง​ใจกว้าง​จริงๆ",
    "streamUrl": "fivefish.org/T33020",
    "trackDownloadUrl": "fivefish.org/T33020-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33020.zip",
    "programId": "33020",
    "languageVideoUrl": "https://www.youtube.com/watch?v=7yWlIZ6K8k8&list=PLbQkUFqMy6wrIfwyHKuRt1SpvvWrKxcyW",
    "shareUrl": "5fi.sh/T33020",
    "duration": "102:10",
    "trackCount": "16.0",
    "sampleUrl": "/audio/Hmong.Blue.492.mp3",
    "stableKey": "Hmong Blue"
  },
  {
    "id": 33201,
    "iso3": "HNJ",
    "langId": "492",
    "languageEn": "Hmong Blue",
    "langTh": "ม้งเขียว",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "1 Corinthians 3:16 Don’t you know that you yourselves are God’s temple and that God’s Spirit lives in you?",
    "verse_th": "1 โครินธ์ 3:16 พวกคุณ​ไม่​รู้​หรือ​ว่า​พวกคุณ​เป็น​วิหาร​ของ​พระเจ้า และ​พระวิญญาณ​ของ​พระเจ้า​ก็​อยู่​ใน​หมู่​พวกคุณ",
    "streamUrl": "fivefish.org/T33201",
    "trackDownloadUrl": "fivefish.org/T33201-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33201.zip",
    "programId": "33201",
    "shareUrl": "5fi.sh/T33201",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.Blue.492.mp3",
    "stableKey": "Hmong Blue"
  },
  {
    "id": 27191,
    "iso3": "HNJ",
    "langId": "492",
    "languageEn": "Hmong Blue",
    "langTh": "ม้งเขียว",
    "title_en": "Songs",
    "title_th": "เพลง",
    "verse_en": "2 Corinthians 4:1 Therefore, since through God's mercy we have this ministry, we do not lose heart.",
    "verse_th": "2 โครินธ์ 4:1 เรา​ไม่​ย่อท้อ​ง่ายๆ​เพราะ​งานนี้​พระเจ้า​เอง​เป็น​ผู้​มอบ​ให้​เรา​ทำ",
    "streamUrl": "fivefish.org/T27191",
    "trackDownloadUrl": "fivefish.org/T27191-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27191.zip",
    "programId": "27191",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1d2ygZ2jXcY&list=PLbQkUFqMy6wrIfwyHKuRt1SpvvWrKxcyW",
    "shareUrl": "5fi.sh/T27191",
    "duration": "58:49",
    "trackCount": "29.0",
    "sampleUrl": "/audio/Hmong.Blue.492.mp3",
    "stableKey": "Hmong Blue"
  },
  {
    "id": 37600,
    "iso3": "MWW",
    "langId": "20040",
    "languageEn": "Hmong Shuad",
    "langTh": "ม้งชวด",
    "title_en": "Jesus Story 1 of 2",
    "title_th": "เรื่องราวของพระเยซู 1 of 2",
    "verse_en": "2 Corinthians 4:5 For we do not preach ourselves, but Jesus Christ our Lord, and ourselves as your servants for Jesus’ sake.",
    "verse_th": "2 โครินธ์ 4:5 เรา​ไม่ได้​ประกาศ​ตัว​เรา​เอง แต่​เรา​ประกาศ​ว่า​พระเยซู​คริสต์​เป็น​องค์​เจ้า​ชีวิต และ​ตัวเรา​เอง​เป็น​ทาส​ของ​พวกคุณ เพราะ​เห็น​แก่​พระเยซู",
    "streamUrl": "fivefish.org/T37600",
    "trackDownloadUrl": "fivefish.org/T37600-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37600.zip",
    "programId": "37600",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wVmLR9wwx-E&list=PLXcynA24_lTPzMB2PNaL9QkfSJUGXqqJV",
    "shareUrl": "5fi.sh/T37600",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.Shuad.37600.mp3",
    "stableKey": "Hmong Shuad"
  },
  {
    "id": 37601,
    "iso3": "MWW",
    "langId": "20040",
    "languageEn": "Hmong Shuad",
    "langTh": "ม้งชวด",
    "title_en": "Jesus Story 2 of 2",
    "title_th": "เรื่องราวของพระเยซู 2 of 2",
    "verse_en": "2 Corinthians 5:17 Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!",
    "verse_th": "2 โครินธ์ 5:17 ถ้า​ใคร​ก็ตาม​มีส่วน​ใน​พระคริสต์ คนนั้น​ได้​เข้า​สู่​โลกใหม่​ที่​พระเจ้า​ได้​สร้าง​ขึ้นมา​แล้ว สิ่ง​เก่าๆ​หายไป​หมดแล้ว ดูสิ สิ่ง​ใหม่ๆ​ก็​เกิดขึ้น",
    "streamUrl": "fivefish.org/T37601",
    "trackDownloadUrl": "fivefish.org/T37601-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37601.zip",
    "programId": "37601",
    "shareUrl": "5fi.sh/T37601",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.Shuad.20040.mp3",
    "stableKey": "Hmong Shuad"
  },
  {
    "id": 3181,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Ballads",
    "title_th": "เพลง",
    "verse_en": "2 Corinthians 5:21 God made Him who had no sin to be sin for us, so that in Him we might become the righteousness of God.",
    "verse_th": "2 โครินธ์ 5:21 พระเจ้า​ทำให้​พระคริสต์​ผู้​ที่​ไม่มี​บาป​กลายเป็น​คนบาป​เพื่อ​เรา เพื่อ​ว่า​ใน​พระคริสต์​นั้น ความ​ซื่อสัตย์​ของ​พระเจ้า จะ​ได้​เห็น​เด่นชัด​ใน​ตัวเรา",
    "streamUrl": "fivefish.org/T3181",
    "trackDownloadUrl": "fivefish.org/T3181-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3181.zip",
    "programId": "3181",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3c9S2Jl_vHM&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T3181",
    "duration": "49:43",
    "trackCount": "14.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37699,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Christian Life 1",
    "title_th": "ชีวิตคริสเตียน 1",
    "verse_en": "2 Corinthians 7:1 Therefore, since we have these promises, dear friends, let us purify ourselves from everything that contaminates body and spirit, perfecting holiness out of reverence for God.",
    "verse_th": "2 โครินธ์ 7:1 เพื่อน​ที่รัก ในเมื่อ​เรา​มี​คำ​สัญญา​พวกนี้ ก็​ขอให้​เรา​ชำระ​ตัวเอง​จาก​ทุกสิ่ง​ทุกอย่าง​ที่​ทำ​ให้​ร่างกาย​และ​จิตใจ​สกปรก ทำ​ตัว​ให้​บริสุทธิ์​ครบถ้วน​เพราะ​ยำเกรง​พระเจ้า",
    "streamUrl": "fivefish.org/T37699",
    "trackDownloadUrl": "fivefish.org/T37699-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37699.zip",
    "programId": "37699",
    "languageVideoUrl": "https://www.youtube.com/watch?v=LAYI14TGqbw&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T37699",
    "duration": "333:23",
    "trackCount": "27.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37758,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Christian Life 2",
    "title_th": "ชีวิตคริสเตียน 2",
    "verse_en": "2 Corinthians 9:6-7 Remember this: “Whoever sows sparingly will also reap sparingly, and whoever sows generously will also reap generously. Each man should give what he has decided in his heart to give, not reluctantly or under compulsion, for God loves a cheerful giver.”",
    "verse_th": "2 โครินธ์ 9:6-7 จำ​เอา​ไว้​ว่า “คน​ที่​หว่านน้อย​ก็​จะ​เก็บเกี่ยว​น้อย และ​คน​ที่​หว่านมาก​ก็​จะ​เก็บเกี่ยว​มากแต่ละ​คน​ควร​จะ​ให้​ตาม​ที่​ตั้งใจ​ไว้ ไม่ใช่​ให้​ด้วย​ความ​เสียดาย​หรือ​ถูก​บังคับ เพราะ​พระเจ้า​รัก​คน​ที่​ให้​ด้วย​ใจ​ที่​ชื่นชม​ยินดี”",
    "streamUrl": "fivefish.org/T37758",
    "trackDownloadUrl": "fivefish.org/T37758-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37758.zip",
    "programId": "37758",
    "shareUrl": "5fi.sh/T37758",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37759,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Christian Life 3 - Armor of GOD & Giving",
    "title_th": "ชีวิตคริสเตียน 3 – ยุทธภัณฑ์ของพระเจ้าและการถวาย",
    "verse_en": "Galatians 2:20 I have been crucified with Christ and I no longer live, but Christ lives in me. The life I live in the body, I live by faith in the Son of God, who loved me and gave Himself for me.",
    "verse_th": "กาลาเทีย 2:20 ผม​ได้​ถูก​ตรึง​บน​ไม้กางเขน​จน​ตาย​ไป​พร้อม​กับ​พระคริสต์ คน​ที่​มี​ชีวิต​อยู่​ตอนนี้​ไม่ใช่​ตัว​ผม​แล้ว​แต่​เป็น​พระคริสต์​ต่างหาก​ที่​อยู่​ใน​ตัว​ผม ชีวิต​ที่​มี​อยู่​เดี๋ยวนี้​ก็​เป็น​ชีวิต​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า ผู้​ที่รัก​ผม​และ​เสียสละ​ชีวิต​ให้​ผม",
    "streamUrl": "fivefish.org/T37759",
    "trackDownloadUrl": "fivefish.org/T37759-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37759.zip",
    "programId": "37759",
    "shareUrl": "5fi.sh/T37759",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37760,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Christian Life 4",
    "title_th": "ชีวิตคริสเตียน 4",
    "verse_en": "Galatians 4:4-5 But when the set time had fully come, God sent His Son, born of a woman, born under the law, to redeem those under the law, that we might receive adoption to sonship.",
    "verse_th": "กาลาเทีย 4:4-5 แต่​เมื่อ​ถึง​เวลา​ที่​เหมาะสม พระเจ้า​ก็​ได้​ส่ง​พระบุตร​ของ​พระองค์​โดย​คลอด​ออก​มา​จาก​ผู้หญิง และ​มีชีวิต​อยู่​ภายใต้​กฎ เพื่อ​มา​ปลดปล่อย​คน​ที่​อยู่​ภายใต้​กฎ​ให้​เป็น​อิสระ และ​เพื่อ​เรา​ทุกคน​จะ​ได้​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T37760",
    "trackDownloadUrl": "fivefish.org/T37760-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37760.zip",
    "programId": "37760",
    "shareUrl": "5fi.sh/T37760",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37761,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Christian Life 5",
    "title_th": "ชีวิตคริสเตียน 5",
    "verse_en": "Galatians 5:1 It is for freedom that Christ has set us free. Stand firm, then, and do not let yourselves be burdened again by a yoke of slavery.",
    "verse_th": "กาลาเทีย 5:1 เมื่อ​พระคริสต์​ได้​ปลดปล่อย​ให้​เรา​เป็น​อิสระ​แล้ว ก็​ให้​อยู่​อย่าง​คน​อิสระ​เถิด รักษา​มัน​ไว้​ให้ดี อย่า​กลับ​ไป​เป็น​ทาส​ของ​กฎ​อีก",
    "streamUrl": "fivefish.org/T37761",
    "trackDownloadUrl": "fivefish.org/T37761-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37761.zip",
    "programId": "37761",
    "shareUrl": "5fi.sh/T37761",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37700,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Creation to Christ",
    "title_th": "ตั้งแต่การสร้างจนถึงพระคริสต์",
    "verse_en": "Galatians 6:10 Therefore, as we have opportunity, let us do good to all people, especially to those who belong to the family of believers.",
    "verse_th": "กาลาเทีย 6:10 ดังนั้น เมื่อ​มี​โอกาส​ก็​ให้​ทำดี​กับ​ทุกคน โดย​เฉพาะ​อย่างยิ่ง​กับ​ครอบครัว​ที่​ไว้วางใจ​ใน​พระเจ้า",
    "streamUrl": "fivefish.org/T37700",
    "trackDownloadUrl": "fivefish.org/T37700-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37700.zip",
    "programId": "37700",
    "languageVideoUrl": "https://www.youtube.com/watch?v=mwnulEUUj5M&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T37700",
    "duration": "42:19",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Hmong.White.37700.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 62956,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "New Birth 1: Know God, Devil, Yourself",
    "title_th": "บังเกิดใหม่ 1 รู้จักพระเจ้า มารซาตานและตัวเอง",
    "verse_en": "Galatians 6:9 Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.",
    "verse_th": "กาลาเทีย 6:9 อย่า​เพิ่ง​ท้อแท้​ใน​การ​ทำดี เพราะ​เมื่อ​ถึง​เวลา​ที่​เหมาะ คุณ​ก็​จะ​ได้​เก็บเกี่ยว​ผล​จาก​การ​ทำดี​นั้น ถ้า​ไม่​เลิก​ไป​ซะก่อน​นะ",
    "streamUrl": "fivefish.org/T62956",
    "trackDownloadUrl": "fivefish.org/T62956-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62956.zip",
    "programId": "62956",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Nl5VclXXzXc&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T62956",
    "duration": "116:24",
    "trackCount": "6.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 37752,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "New Birth 2: Trust Jesus",
    "title_th": "บังเกิดใหม่ 2 วางใจในพระเยซู",
    "verse_en": "Ephesians 2:8-9 For it is by grace that you have been saved, through faith-and this not from yourselves, it is the gift of God-not by works, so that no one can boast.",
    "verse_th": "เอเฟซัส 2:8-9 ที่​พวกคุณ​รอด​นั้น​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระเจ้า ผ่าน​มา​ทาง​ความเชื่อ​ของ​คุณ ไม่ได้​มา​จาก​ตัว​ของ​คุณ​เอง แต่​เป็น​ของขวัญ​ที่​มา​จาก​พระเจ้ามัน​ไม่ได้​เป็น​ผล​มา​จาก​การ​กระทำ​ของ​ใคร เพื่อ​จะ​ได้​ไม่มี​ใคร​โอ้อวด​ได้",
    "streamUrl": "fivefish.org/T37752",
    "trackDownloadUrl": "fivefish.org/T37752-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37752.zip",
    "programId": "37752",
    "shareUrl": "5fi.sh/T37752",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 27261,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Songs 1",
    "title_th": "เพลง 1",
    "verse_en": "Ephesians 3:16-17 I pray that out of His glorious riches He may strengthen you with power through His Spirit in your inner being, so that Christ may dwell in your hearts through faith. And I pray that you, being rooted and established in love.",
    "verse_th": "เอเฟซัส 3:16-17 ขอให้​พระเจ้า​ที่​มั่งคั่ง​มหาศาล ช่วย​ให้​พวกคุณ​มี​พลังใจ​ที่​เข้มแข็ง​ผ่าน​ทาง​พระวิญญาณ​ของ​พระองค์ 17 ขอให้​พระคริสต์​ตั้ง​มั่นคง​อยู่​ในใจ​ของ​คุณ​เพราะ​คุณ​ไว้วางใจ​ใน​พระองค์ ขอให้​ลง​รากลึก​มั่นคง​ใน​ความรัก",
    "streamUrl": "fivefish.org/T27261",
    "trackDownloadUrl": "fivefish.org/T27261-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27261.zip",
    "programId": "27261",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WbrD_3lijOY&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T27261",
    "duration": "56:48",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 27181,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Songs 2",
    "title_th": "เพลง 2",
    "verse_en": "Ephesians 3:20-21 Now to Him who is able to do immeasurably more than all we ask or imagine, according to His power that is at work within us, to Him be glory in the church and in Christ Jesus throughout all generations, for ever and ever!",
    "verse_th": "เอเฟซัส 3:20-21 พระเจ้า​สามารถ​ทำได้​ทุกสิ่ง​มาก​ยิ่งกว่า​ที่​เรา​จะขอ​หรือ​คิด​ได้ ด้วย​ฤทธิ์​อำนาจ​ของ​พระองค์​ที่​กำลัง​ทำงาน​อยู่​ใน​ตัวเรา ขอให้​พระเจ้า​ได้รับ​เกียรติ​ทั้ง​จาก​หมู่ประชุม​ของ​พระองค์ และ​จาก​พระเยซู​คริสต์​ทุกยุค​ทุกสมัย​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T27181",
    "trackDownloadUrl": "fivefish.org/T27181-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27181.zip",
    "programId": "27181",
    "languageVideoUrl": "https://www.youtube.com/watch?v=uew-bQMS3fE&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T27181",
    "duration": "57:10",
    "trackCount": "28.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 27190,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Songs 3",
    "title_th": "เพลง 3",
    "verse_en": "Ephesians 5:3 But among you there must not be even a hint of sexual immorality, or of any kind of impurity, or of greed, because these are improper for God’s holy people.",
    "verse_th": "เอเฟซัส 5:3 เรื่อง​ความ​ผิดบาป​ทางเพศ เรื่อง​ลามก​ทุกอย่าง หรือ​ความ​มักมาก​ใน​กาม แม้แต่​จะ​พูดถึง​ก็​อย่าเลย เพราะ​มัน​ไม่เหมาะ​กับ​คน​ที่​เป็น​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T27190",
    "trackDownloadUrl": "fivefish.org/T27190-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27190.zip",
    "programId": "27190",
    "languageVideoUrl": "https://www.youtube.com/watch?v=7lJieYqrz3Q&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T27190",
    "duration": "59:07",
    "trackCount": "27.0",
    "sampleUrl": "/audio/Hmong.White.491.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 13240,
    "iso3": "MWW",
    "langId": "491",
    "languageEn": "Hmong White",
    "langTh": "ม้งขาว",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Philippians 2:3-4 Do nothing out of selfish ambition or vein conceit, but in humility consider others better than yourselves. Each of you should look not only to your own interests, but also the interests of others.",
    "verse_th": "ฟีลิปปี 2:3-4 อย่า​ทำ​อะไร​ที่​ชิงดี​ชิงเด่น​กัน หรือ​เพราะ​หลง​คิด​ว่า​ตัวเอง​เก่ง แต่​ให้​ถ่อมตัว​ลง และ​มอง​คน​อื่น​ว่า​สำคัญ​กว่า​ตัวเอง 4 อย่า​ให้​ใคร​คิด​เห็น​แต่​ประโยชน์​ส่วนตัว แต่​ให้​คิดถึง​ประโยชน์​ของ​คน​อื่น​ด้วย",
    "streamUrl": "fivefish.org/T13240",
    "trackDownloadUrl": "fivefish.org/T13240-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/13240.zip",
    "programId": "13240",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YpvQc6c61x8&list=PLho9cJoXqQC83xKHJsve41wYex5B0YXVt",
    "shareUrl": "5fi.sh/T13240",
    "duration": "61:28",
    "trackCount": "8.0",
    "sampleUrl": "/audio/Hmong.White.13240.mp3",
    "stableKey": "Hmong White"
  },
  {
    "id": 38079,
    "iso3": "CMN",
    "langId": "20057",
    "languageEn": "Hui",
    "langTh": "ฮุย",
    "title_en": "The Straight Path",
    "title_th": "เส้นทางตรง",
    "verse_en": "Philippians 4:12 I know what it is to be in need, and I know what it is to have plenty. I have learned the secret of being content in any and every situation, whether well fed or hungry, whether living in plenty or in want.",
    "verse_th": "ฟีลิปปี 4:12 ผม​รู้​ว่า​จะ​พอใจ​ได้​อย่างไร​ทั้ง​ตอน​ที่​ขัดสน และ​ตอน​ที่​มี​อย่าง​เหลือ​เฟือ ไม่​ว่า​จะ​อยู่​ใน​สภาพ​ไหน​ก็​ตาม ผม​ได้​เรียนรู้​เคล็ดลับ​ว่า​จะ​อยู่​อย่างไร ใน​เวลา​ที่​อิ่ม​ท้อง​หรือ​หิวโหย ใน​เวลา​ที่​มี​เหลือเฟือ​หรือ​ขาดแคลน",
    "streamUrl": "fivefish.org/T38079",
    "trackDownloadUrl": "fivefish.org/T38079-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/38079.zip",
    "programId": "38079",
    "shareUrl": "5fi.sh/T38079",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hui.38079.mp3",
    "stableKey": "Hui"
  },
  {
    "id": 37731,
    "iso3": "CMN",
    "langId": "20057",
    "languageEn": "Hui",
    "langTh": "ฮุย",
    "title_en": "The Straight Path 01 - 30",
    "title_th": "เส้นทางตรง 01 - 30",
    "verse_en": "Philippians 4:13 I can do everything through Him who gives me strength.",
    "verse_th": "ฟีลิปปี 4:13 พระคริสต์​ให้​ผม​มี​กำลัง​ที่​จะ​ทน​ได้​กับ​ทุก​สิ่ง",
    "streamUrl": "fivefish.org/T37731",
    "trackDownloadUrl": "fivefish.org/T37731-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37731.zip",
    "programId": "37731",
    "shareUrl": "5fi.sh/T37731",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Hui.20057.mp3",
    "stableKey": "Hui"
  },
  {
    "id": 33010,
    "iso3": "IUM",
    "langId": "417",
    "languageEn": "Iu Mien",
    "langTh": "อิ้วเมี่ยน",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Philippians 4:19 And my God will meet all your needs according to His glorious riches in Jesus Christ.",
    "verse_th": "ฟีลิปปี 4:19 พระเจ้า​ของ​ผม​จะ​ให้​ทุก​สิ่ง​ที่​จำเป็น​สำหรับ​คุณ จาก​ความ​มั่งคั่ง​อัน​มหาศาล​ของ​พระองค์​ที่​อยู่​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T33010",
    "trackDownloadUrl": "fivefish.org/T33010-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33010.zip",
    "programId": "33010",
    "languageVideoUrl": "https://www.youtube.com/watch?v=V9hV5I_y2_I&list=PLXcynA24_lTOERwQnmpfgPItFKIp1-ai7",
    "shareUrl": "5fi.sh/T33010",
    "duration": "94:32",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Iu.Mien.417.mp3",
    "stableKey": "Iu Mien"
  },
  {
    "id": 33011,
    "iso3": "IUM",
    "langId": "417",
    "languageEn": "Iu Mien",
    "langTh": "อิ้วเมี่ยน",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "Philippians 4:6 Do not be anxious about anything, but in everything, by prayer and petition, with thanksgiving, present your requests to God.",
    "verse_th": "ฟีลิปปี 4:6 เลิก​กังวล​ได้​แล้ว แต่​ให้​อธิษฐาน​ใน​ทุกๆ​ สถานการณ์ และ​ขอ​ใน​สิ่ง​ที่​คุณ​ต้องการ​จาก​พระเจ้า และ​เมื่อ​อธิษฐาน​ก็​ให้​ขอบคุณ​พระเจ้า​ด้วย",
    "streamUrl": "fivefish.org/T33011",
    "trackDownloadUrl": "fivefish.org/T33011-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33011.zip",
    "programId": "33011",
    "shareUrl": "5fi.sh/T33011",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Iu.Mien.417.mp3",
    "stableKey": "Iu Mien"
  },
  {
    "id": 38205,
    "iso3": "IUM",
    "langId": "417",
    "languageEn": "Iu Mien",
    "langTh": "อิ้วเมี่ยน",
    "title_en": "The Two Ways",
    "title_th": "สองทางเลือก",
    "verse_en": "Philippians 4:7 And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus.",
    "verse_th": "ฟีลิปปี 4:7 แล้ว​สันติสุข​ที่​มา​จาก​พระเจ้า ซึ่ง​ดี​กว่า​สันติสุข​ที่​มา​จาก​แผน​งาน​ต่างๆ​ของ​มนุษย์ จะ​ปกป้อง​รักษา​จิตใจ และ​ความคิด​ของ​คุณ​ไว้​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T38205",
    "trackDownloadUrl": "fivefish.org/T38205-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/38205.zip",
    "programId": "38205",
    "languageVideoUrl": "https://www.youtube.com/watch?v=QRqbH_qpzh8&list=PLXcynA24_lTOERwQnmpfgPItFKIp1-ai7",
    "shareUrl": "5fi.sh/T38205",
    "duration": "97:48",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Iu.Mien.417.mp3",
    "stableKey": "Iu Mien"
  },
  {
    "id": 5261,
    "iso3": "IUM",
    "langId": "417",
    "languageEn": "Iu Mien",
    "langTh": "อิ้วเมี่ยน",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Philippians 4:8 Finally, brothers and sisters, whatever is true, whatever is noble, whatever is right, whatever is pure, whatever is lovely, whatever is admirable—if anything is excellent or praiseworthy—think about such things.",
    "verse_th": "ฟีลิปปี 4:8 สุดท้าย​นี้ พี่น้อง​ครับ อะไร​ก็​ตาม​ที่​จริง ที่​น่านับถือ ที่​ถูกต้อง ที่​บริสุทธิ์ ที่​น่ารัก ที่​น่ายกย่อง นั่น​คือ​อะไรก็ตาม​ที่​ยอดเยี่ยม​และ​น่าสรรเสริญ ให้​เอาใจใส่​ใน​เรื่อง​เหล่า​นั้น",
    "streamUrl": "fivefish.org/T5261",
    "trackDownloadUrl": "fivefish.org/T5261-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/5261.zip",
    "programId": "5261",
    "languageVideoUrl": "https://www.youtube.com/watch?v=pQhjd9OU258&list=PLXcynA24_lTOERwQnmpfgPItFKIp1-ai7",
    "shareUrl": "5fi.sh/T5261",
    "duration": "43:28",
    "trackCount": "12.0",
    "sampleUrl": "/audio/Iu.Mien.417.mp3",
    "stableKey": "Iu Mien"
  },
  {
    "id": 63085,
    "iso3": "JPN",
    "langId": "96",
    "languageEn": "Japanese",
    "langTh": "ญี่ปุ่น",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Colossians 3:1-2 Since, then, you have been raised with Christ, set your hearts on things above, where Christ is, seated at the right hand of God. Set your minds on things above, not on earthly things.",
    "verse_th": "โคโลสี 3:1-2 พระเจ้า​ได้​ทำ​ให้​คุณ​ฟื้น​ขึ้น​จาก​ความตาย​กับ​พระคริสต์​แล้ว อย่าง​นั้น​ให้​แสวงหา​สิ่ง​ต่างๆ​ที่​อยู่​เบื้องบน ซึ่ง​เป็น​ที่​ที่​พระคริสต์​นั่ง​อยู่​ทาง​ขวา​มือ​ของ​พระเจ้า 2ให้​ใจ​ของ​คุณ​จดจ่อ​อยู่​กับ​สิ่ง​ที่​อยู่​เบื้องบน ไม่​ใช่​สิ่ง​ที่​อยู่​ใน​โลก",
    "streamUrl": "fivefish.org/T63085",
    "trackDownloadUrl": "fivefish.org/T63085-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63085.zip",
    "programId": "63085",
    "languageVideoUrl": "https://www.youtube.com/watch?v=iCWyGKh1CwY&list=PL35bS_eav2jX816bTdoeyciyvZG2qXWUI",
    "shareUrl": "5fi.sh/T63085",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Japanese.63085.mp3",
    "stableKey": "Japanese"
  },
  {
    "id": 32531,
    "iso3": "JPN",
    "langId": "96",
    "languageEn": "Japanese",
    "langTh": "ญี่ปุ่น",
    "title_en": "My Heart for You w/ English",
    "title_th": "สิ่งที่ใจฉันต้องการสำหรับคุณ",
    "verse_en": "Colossians 3:12 Therefore, as God's chosen people, holy and dearly loved, clothe yourselves with compassion, kindness, humility, gentleness and patience.",
    "verse_th": "โคโลสี 3:12 ดังนั้น​ใน​ฐานะ​ที่​เรา​เป็น​คน​ที่​พระเจ้า​ได้​เลือก เป็น​คน​ของ​พระเจ้า และ​เป็น​คน​ที่​พระองค์​รัก ก็​ให้​สวม​ใส่​ความ​เห็นอก​เห็นใจ ความ​มี​น้ำใจ ความ​ถ่อม​ตน ความ​สุภาพ​อ่อนโยน และ​ความอดทน",
    "streamUrl": "fivefish.org/T32531",
    "trackDownloadUrl": "fivefish.org/T32531-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32531.zip",
    "programId": "32531",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OENShpsljHw&list=PL35bS_eav2jX816bTdoeyciyvZG2qXWUI",
    "shareUrl": "5fi.sh/T32531",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Japanese.96.mp3",
    "stableKey": "Japanese"
  },
  {
    "id": 37280,
    "iso3": "JPN",
    "langId": "96",
    "languageEn": "Japanese",
    "langTh": "ญี่ปุ่น",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Colossians 3:15 Let the peace of Christ rule in your hearts, since as members of one body you were called to peace. And be thankful.",
    "verse_th": "โคโลสี 3:15 ขอให้​สันติสุข​จาก​พระคริสต์​มา​ครอบ​ครอง​จิตใจ​ของ​คุณ เพราะ​พระเจ้า​ได้​เรียก​คุณ​ให้​อยู่​กัน​อย่าง​สันติ​ใน​ร่างกาย​เดียว​กัน และ​ขอให้​เป็น​คน​ที่​รู้จัก​ขอบคุณ​พระเจ้า​อยู่​เสมอ",
    "streamUrl": "fivefish.org/T37280",
    "trackDownloadUrl": "fivefish.org/T37280-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37280.zip",
    "programId": "37280",
    "languageVideoUrl": "https://www.youtube.com/watch?v=apMopd_1w5I&list=PL35bS_eav2jX816bTdoeyciyvZG2qXWUI",
    "shareUrl": "5fi.sh/T37280",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Japanese.96.mp3",
    "stableKey": "Japanese"
  },
  {
    "id": 37281,
    "iso3": "JPN",
    "langId": "96",
    "languageEn": "Japanese",
    "langTh": "ญี่ปุ่น",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "1 Timothy 1:17 Now to the King eternal, immortal, invisible, the only God, be honor and glory for ever and ever. Amen.",
    "verse_th": "1 ทิโมธี 1:17 ขอให้​พระองค์​ผู้​เป็น​กษัตริย์​ของ​คน​ทุกยุค​ทุกสมัย ผู้​ไม่​มี​วัน​ตาย ผู้​ไม่​มี​ใคร​มอง​เห็น​ได้ และ​ผู้​เป็น​พระเจ้า​แต่​เพียง​องค์​เดียว ได้รับ​เกียรติ​และ​สง่าราศี อยู่​เสมอ​และ​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T37281",
    "trackDownloadUrl": "fivefish.org/T37281-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37281.zip",
    "programId": "37281",
    "shareUrl": "5fi.sh/T37281",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Japanese.96.mp3",
    "stableKey": "Japanese"
  },
  {
    "id": 80573,
    "iso3": "KAC",
    "langId": "175",
    "languageEn": "Kachin",
    "langTh": "คะฉิ่น",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "2 Timothy 2:22 Flee the evil desires of youth and pursue righteousness, faith, love and peace, along with those who call on the Lord out of a pure heart.",
    "verse_th": "2 ทิโมธี 2:22 ให้​วิ่งหนี​จาก​ราคะตัณหา​ของ​คน​หนุ่มสาว แต่​ไล่ตาม​สิ่ง​ที่​ถูกต้อง เช่น​ความเชื่อ ความรัก และ​สันติสุข ร่วมกับ​คน​เหล่านั้น​ที่​ร้องเรียก​องค์​เจ้า​ชีวิต​ด้วย​ใจ​ที่​สะอาด​บริสุทธิ์",
    "streamUrl": "fivefish.org/T80573",
    "trackDownloadUrl": "fivefish.org/T80573-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80573.zip",
    "programId": "80573",
    "languageVideoUrl": "https://www.youtube.com/watch?v=JB2Aip1opUc&list=PLbQkUFqMy6wpmNt3XZGcv1Egbu5tXx95B",
    "shareUrl": "5fi.sh/T80573",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kachin.175.mp3",
    "stableKey": "Kachin"
  },
  {
    "id": 66535,
    "iso3": "KAC",
    "langId": "175",
    "languageEn": "Kachin",
    "langTh": "คะฉิ่น",
    "title_en": "Jesus, the Refugee",
    "title_th": "พระเยซู ผู้ลี้ภัย",
    "verse_en": "2 Timothy 3:16 All Scripture is God-breathed and is useful for teaching, rebuking, correcting and training in righteousness.",
    "verse_th": "2 ทิโมธี 3:16 ทุกๆข้อ​ใน​พระคัมภีร์ พระเจ้า​เป็น​ผู้​ดลใจ​ให้​เขียน​ขึ้นมา เพื่อ​เป็น​ประโยชน์​ใน​การ​สั่งสอน​ความจริง ชี้​ให้​คน​เห็น​ถึง​ความบาป​ใน​ชีวิต ช่วย​ปรับปรุง​แก้ไข​ให้​คนดี​ขึ้น และ​ฝึก​คน​ให้​ทำ​ตามใจ​พระเจ้า",
    "streamUrl": "fivefish.org/T66535",
    "trackDownloadUrl": "fivefish.org/T66535-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/66535.zip",
    "programId": "66535",
    "languageVideoUrl": "https://www.youtube.com/watch?v=itnQc9neXF8&list=PLbQkUFqMy6wpmNt3XZGcv1Egbu5tXx95B",
    "shareUrl": "5fi.sh/T66535",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kachin.175.mp3",
    "stableKey": "Kachin"
  },
  {
    "id": 6100,
    "iso3": "KAC",
    "langId": "175",
    "languageEn": "Kachin",
    "langTh": "คะฉิ่น",
    "title_en": "Word of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Titus 3:5 He saved us, not because of righteous things we had done, but because of His mercy. He saved us through the washing of rebirth and renewal by the Holy Spirit.",
    "verse_th": "ทิตัส 3:5 พระองค์​ได้​ช่วย​ให้​เรา​รอด ไม่​ใช่​เพราะ​เรา​ทำดี แต่​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระองค์​ต่างหาก พระองค์​ได้​ชำระ​ล้าง​เรา ซึ่ง​ทำ​ให้​เรา​เกิด​ใหม่ และ​ถูก​สร้าง​ขึ้น​มา​ใหม่​ด้วย​ฤทธิ์เดช​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T6100",
    "trackDownloadUrl": "fivefish.org/T6100-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6100.zip",
    "programId": "6100",
    "languageVideoUrl": "https://www.youtube.com/watch?v=HQOOtxakl74&list=PLbQkUFqMy6wpmNt3XZGcv1Egbu5tXx95B",
    "shareUrl": "5fi.sh/T6100",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kachin.175.mp3",
    "stableKey": "Kachin"
  },
  {
    "id": 80870,
    "iso3": "BWE",
    "langId": "414",
    "languageEn": "Karen Bwe",
    "langTh": "กะเหรี่ยงบะเว",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Hebrews 10:24-25 And let us consider how we may spur one another on toward love and good deeds. Let us not give up meeting together as some are in the habit of doing, but let us encourage one another - and all the more as you see the Day approaching.",
    "verse_th": "ฮีบรู 10:24-25 ขอให้​เรา​ทุกคน​พิจารณา​กัน​และ​กัน เพื่อ​จะได้​กระตุ้น​กัน​ให้​มี​ความรัก​และ​ทำ​แต่​ความดีขอ​อย่าให้​เรา​ทิ้ง​การ​ประชุม​ไป​เหมือนกับ​ที่​บางคน​ทำ​อยู่ แต่​ให้​กำลังใจ​กัน​และ​กัน​มาก​ยิ่งขึ้น ยิ่ง​พวกคุณ​รู้​อยู่​แล้ว​ว่า​วันนั้น​กำลัง​ใกล้​มาถึง​แล้ว ก็​ยิ่ง​น่าจะ​ทำ​อย่างนี้",
    "streamUrl": "fivefish.org/T80870",
    "trackDownloadUrl": "fivefish.org/T80870-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80870.zip",
    "programId": "80870",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6KNkyfRLx7Y&list=PLbQkUFqMy6wpaQRqvSM8qqHCZLxJprboz",
    "shareUrl": "5fi.sh/T80870",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Bwe.414.mp3",
    "stableKey": "Karen Bwe"
  },
  {
    "id": 9310,
    "iso3": "BWE",
    "langId": "414",
    "languageEn": "Karen Bwe",
    "langTh": "กะเหรี่ยงบะเว",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Hebrews 11:6 And without faith it is impossible to please God, because anyone who comes to Him must believe that He exists and that He rewards those who earnestly seek Him.",
    "verse_th": "ฮีบรู 11:6 เขา​ได้รับ​การ​ยกย่อง​ว่า​เป็น​คนหนึ่ง​ที่​พระเจ้า​พอใจ แต่​ถ้า​ไม่มี​ความ​ไว้วางใจ​แล้ว ก็​เป็นไป​ไม่ได้​ที่​จะ​ทำให้​พระเจ้า​พอใจ เพราะ​คน​ที่​มา​เข้าเฝ้า​พระเจ้า​จะ​ต้อง​เชื่อ​ว่า​พระองค์​มี​จริง และ​ต้อง​เชื่อ​ว่า​พระองค์​จะ​ให้​รางวัล​กับ​ทุกคน​ที่​แสวงหา​พระองค์",
    "streamUrl": "fivefish.org/T9310",
    "trackDownloadUrl": "fivefish.org/T9310-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9310.zip",
    "programId": "9310",
    "languageVideoUrl": "https://www.youtube.com/watch?v=xn_qnuXY26o&list=PLbQkUFqMy6wpaQRqvSM8qqHCZLxJprboz",
    "shareUrl": "5fi.sh/T9310",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Bwe.414.mp3",
    "stableKey": "Karen Bwe"
  },
  {
    "id": 9340,
    "iso3": "BLK",
    "langId": "415",
    "languageEn": "Karen Pa'o Moulmein",
    "langTh": "กะเหรี่ยงปะโอ เมาะลำเลิง",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Hebrews 12:3 Consider Him who endured such opposition from sinful men, so that you will not grow weary and lose heart.",
    "verse_th": "ฮีบรู 12:3 ขอให้​ใคร่ครวญ​ถึง​พระองค์​ผู้ที่​ต้อง​ทน​ทุกข์ทรมาน​อย่าง​แสนสาหัส​จาก​คนบาป​ที่​ต่อต้าน​พระองค์ เพื่อ​พวกคุณ​จะ​ได้​ไม่ท้อใจ​หรือ​ยอมแพ้",
    "streamUrl": "fivefish.org/T9340",
    "trackDownloadUrl": "fivefish.org/T9340-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9340.zip",
    "programId": "9340",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IcAqC9bKNXw&list=PLbQkUFqMy6wr20TOVbK_tKPdxCV-N3g8t",
    "shareUrl": "5fi.sh/T9340",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pa'o.Moulmein.09340.mp3",
    "stableKey": "Karen Pa'o Moulmein"
  },
  {
    "id": 80827,
    "iso3": "BLK",
    "langId": "334",
    "languageEn": "Karen Pa'o Southern",
    "langTh": "กะเหรี่ยงปะโอ ใต้",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Hebrews 2:18 Because He Himself suffered when He was tempted, He is able to help those who are being tempted.",
    "verse_th": "ฮีบรู 2:18 เดี๋ยวนี้ พระองค์​สามารถ​ช่วย​คน​ที่​ถูก​ทดลอง​ได้แล้ว เพราะ​พระองค์​เอง​ได้รับ​ความ​ทรมาน​และ​ถูก​ทดลอง​มาก่อน",
    "streamUrl": "fivefish.org/T80827",
    "trackDownloadUrl": "fivefish.org/T80827-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80827.zip",
    "programId": "80827",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1gn0m3gpwDc&list=PLbQkUFqMy6wodsJ8c_wN5W6cT8i0EP7Kr",
    "shareUrl": "5fi.sh/T80827",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pa'o.Southern.80827.mp3",
    "stableKey": "Karen Pa'o Southern"
  },
  {
    "id": 6751,
    "iso3": "BLK",
    "langId": "334",
    "languageEn": "Karen Pa'o Southern",
    "langTh": "กะเหรี่ยงปะโอ ใต้",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Hebrews 4:15-16 For we do not have a high priest who is unable to empathize with our weaknesses, but we have One who has been tempted in every way, just as we are - yet He did not sin. Let us then approach God's throne of grace with confidence, so that we may receive mercy and find grace to help us in our time of need.",
    "verse_th": "ฮีบรู 4:15-16 เพราะ​หัวหน้า​นักบวช​สูงสุด​ของเรา​คนนี้​เข้าใจ​และ​เห็นใจ​ใน​จุดอ่อน​ทั้งหลาย​ของเรา เพราะ​พระองค์​ก็​เคย​ถูก​ทดลอง​เหมือนกับ​เรา​ทุกอย่าง แต่​ไม่ได้​ทำบาป​เลย 16 ดังนั้น​ขอให้​เรา​ทุกคน​เข้ามา​ยืน​ด้วย​ความ​มั่นใจ​ต่อหน้า​บัลลังก์​ของ​พระเจ้า​ผู้​มี​ความ​เมตตา​กรุณา เพื่อ​เรา​จะ​ได้รับ​ความปรานี และ​พบ​กับ​ความ​เมตตา​กรุณา​ที่​พระเจ้า​จะ​ช่วย​เรา​ใน​เวลา​ที่​เรา​ต้องการ​ความ​ช่วยเหลือ",
    "streamUrl": "fivefish.org/T6751",
    "trackDownloadUrl": "fivefish.org/T6751-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6751.zip",
    "programId": "6751",
    "languageVideoUrl": "https://www.youtube.com/watch?v=G4JTy-fgkJc&list=PLbQkUFqMy6wodsJ8c_wN5W6cT8i0EP7Kr",
    "shareUrl": "5fi.sh/T6751",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pao.Southern.334.mp3",
    "stableKey": "Karen Pa'o Southern"
  },
  {
    "id": 62599,
    "iso3": "KJP",
    "langId": "19467",
    "languageEn": "Karen Pwo Eastern",
    "langTh": "กะเหรี่ยงโป ตะวันออก",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Hebrews 9:27 Just as man is destined to die once, and after that to face judgment.",
    "verse_th": "ฮีบรู 9:27 มนุษย์​ตาย​แค่​ครั้งเดียว​แล้ว​เจอ​กับ​การ​พิพากษา",
    "streamUrl": "fivefish.org/T62599",
    "trackDownloadUrl": "fivefish.org/T62599-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62599.zip",
    "programId": "62599",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6HvS4gG93f0&list=PLbQkUFqMy6wqXNx7BgkheW-7he7RZc0cv",
    "shareUrl": "5fi.sh/T62599",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Eastern.62599.mp3",
    "stableKey": "Karen Pwo Eastern"
  },
  {
    "id": 9320,
    "iso3": "KJP",
    "langId": "2403",
    "languageEn": "Karen Pwo Eastern Kanjanaburi",
    "langTh": "กะเหรี่ยงโป ตะวันออก กาญจบุรี",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "James 4:14 Why, you do not even know what will happen tomorrow. What is your life? You are a mist that appears for a little while and then vanishes.",
    "verse_th": "ยากอบ 4:14 ตัว​คุณ​เอง​ก็​ยัง​ไม่​รู้​เลย​ว่า พรุ่งนี้​ชีวิต​ของ​คุณ​จะ​เป็น​อย่าง​ไร​บ้าง เพราะ​คุณ​เป็น​เพียง​แค่​หมอก ที่​เกิด​ขึ้น​ประ​เดี๋ยว​เดียว แล้ว​ก็​จาง​หาย​ไป",
    "streamUrl": "fivefish.org/T9320",
    "trackDownloadUrl": "fivefish.org/T9320-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9320.zip",
    "programId": "9320",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NjAOwR900DA&list=PLho9cJoXqQC_Mo9UQyMUxqu59a-ZqJrDX",
    "shareUrl": "5fi.sh/T9320",
    "duration": "56:04",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Karen.Pwo.Eastern.Kanjanaburi.2403.mp3",
    "stableKey": "Karen Pwo Eastern Kanjanaburi"
  },
  {
    "id": 27180,
    "iso3": "KJP",
    "langId": "2403",
    "languageEn": "Karen Pwo Eastern Kanjanaburi",
    "langTh": "กะเหรี่ยงโป ตะวันออก กาญจบุรี",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "1 Peter 2:11 Dear friends. I urge you as aliens and strangers in the world, to abstain from sinful desires, which war against your soul.",
    "verse_th": "1 เปโตร 2:11 เพื่อนรัก ให้​อยู่​อย่าง​คน​ต่างด้าว​และ​คน​แปลกถิ่น​ใน​สังคมนี้ ผม​ขอร้อง​ว่า​อย่า​ไป​ยอมแพ้​กับ​กิเลสตัณหา​ของ​สันดาน​ที่​ต่อสู้​กับ​ใจ​ของคุณ",
    "streamUrl": "fivefish.org/T27180",
    "trackDownloadUrl": "fivefish.org/T27180-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27180.zip",
    "programId": "27180",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8VeLyzfQATA&list=PLho9cJoXqQC_Mo9UQyMUxqu59a-ZqJrDX",
    "shareUrl": "5fi.sh/T27180",
    "duration": "61:35",
    "trackCount": "1.0",
    "sampleUrl": "/audio/Karen.Pwo.Eastern.Kanjanaburi.2403.mp3",
    "stableKey": "Karen Pwo Eastern Kanjanaburi"
  },
  {
    "id": 6690,
    "iso3": "PWW",
    "langId": "490",
    "languageEn": "Karen Pwo Hod",
    "langTh": "กะเหรี่ยงโป ฮอด",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "1 Peter 3:18 For Christ died for our sins once for all, the righteous for the unrighteous, to bring you to God. He was put to death in the body but made alive by the Spirit.",
    "verse_th": "1 ยอห์น 3:18 ลูก​เล็กๆ​ที่รัก อย่า​ให้​เรา​รัก​กัน​แค่​คำพูด​หรือ​รัก​แต่​ปาก​เท่านั้น แต่​ให้​เรา​รัก​กัน​ด้วย​การ​กระทำ​และ​ด้วย​ความ​จริงใจ",
    "streamUrl": "fivefish.org/T6690",
    "trackDownloadUrl": "fivefish.org/T6690-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6690.zip",
    "programId": "6690",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nwkPfFo0sJo&list=PLho9cJoXqQC-ZK27lmgctH_PaweYEnTws",
    "shareUrl": "5fi.sh/T6690",
    "duration": "32:31",
    "trackCount": "10.0",
    "sampleUrl": "/audio/Karen.Pwo.Hod.490.mp3",
    "stableKey": "Karen Pwo Hod"
  },
  {
    "id": 17200,
    "iso3": "KJT",
    "langId": "1182",
    "languageEn": "Karen Pwo Prae",
    "langTh": "กะเหรี่ยงโป แพร่",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "1 Peter 4:16 However, if you suffer as a Christian, do not be ashamed, but praise God that you bear that name.",
    "verse_th": "1 เปโตร 4:16 แต่​ถ้า​คุณ​ต้อง​ทนทุกข์​เพราะ​เป็น​คริสเตียน ก็​อย่า​อาย​เลย แต่​ให้​สรรเสริญ​พระเจ้า เพราะ​คุณ​ได้​ชื่อ​ว่า​คริสเตียน",
    "streamUrl": "fivefish.org/T17200",
    "trackDownloadUrl": "fivefish.org/T17200-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/17200.zip",
    "programId": "17200",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PzSvjB0hkCU&list=PLho9cJoXqQC8XVixZqbDfIAaNJZfTVPBp",
    "shareUrl": "5fi.sh/T17200",
    "duration": "21:19",
    "trackCount": "6.0",
    "sampleUrl": "/audio/Karen.Pwo.Prae.17200.mp3",
    "stableKey": "Karen Pwo Prae"
  },
  {
    "id": 80604,
    "iso3": "PWO",
    "langId": "416",
    "languageEn": "Karen Pwo Western",
    "langTh": "กะเหรี่ยงโป ตะวันตก",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "1 Peter 5:10 And the God of all grace, who called you to His eternal glory in Christ, after you have suffered a little while, will Himself restore you and make you strong, firm and steadfast.",
    "verse_th": "1 เปโตร 5:10 พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความ​เมตตา​ทุกอย่าง​ได้​เรียก​คุณ​ผ่านทาง​พระเยซู​คริสต์ ให้​คุณ​เข้ามา​มี​ส่วนร่วม​ใน​เกียรติ​ของ​พระองค์​ที่​ไม่มี​วัน​หมด คุณ​จะ​ต้อง​ทนทุกข์​อยู่​ประเดี๋ยวหนึ่ง แล้ว​หลังจากนั้น​พระเจ้า​ก็​จะ​ช่วยให้​คุณ​กลับคืน​สู่​สภาพ​สมบูรณ์แบบ จะ​ให้​คุณ​เข้มแข็ง มี​กำลัง​มากขึ้น​และ​มั่นคง",
    "streamUrl": "fivefish.org/T80604",
    "trackDownloadUrl": "fivefish.org/T80604-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80604.zip",
    "programId": "80604",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WPPU2ehuvsI&list=PLbQkUFqMy6wp4UmcPytwcv03p4ttlOz0l",
    "shareUrl": "5fi.sh/T80604",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Western.80604.mp3",
    "stableKey": "Karen Pwo Western"
  },
  {
    "id": 35850,
    "iso3": "PWO",
    "langId": "416",
    "languageEn": "Karen Pwo Western",
    "langTh": "กะเหรี่ยงโป ตะวันตก",
    "title_en": "Jesus Story 1 of 2",
    "title_th": "เรื่องราวของพระเยซู 1 of 2",
    "verse_en": "1 Peter 5:5-6 Young men, in the same way be submissive to those who are older. All of you, clothe yourselves with humility toward one another, because, God opposes the proud but gives grace to the humble. Humble yourselves, therefore, under God’s mighty hand, that He may lift you up in due time.",
    "verse_th": "1 เปโตร 5:5-6 ใน​ทำนอง​เดียวกัน คน​ที่มี​อายุ​น้อยกว่า ก็​ให้​เชื่อฟัง​พวก​ผู้นำ​อาวุโส แต่​ความจริง​แล้ว ทุกๆคน​ควร​จะ​อ่อนน้อม​ถ่อมตัว​รับใช้​ซึ่งกัน​และ​กัน​เหมือนกับ​ที่​พระคัมภีร์​เขียน​ไว้​ว่า พระเจ้า​ต่อต้าน​คน​ที่​เย่อหยิ่ง​จองหอง แต่​มี​ความ​เมตตา​กรุณา​ต่อ​คน​ที่​อ่อนน้อม​ถ่อมตน 6ถ้า​อย่างนั้น ให้​พวกคุณ​อ่อนน้อม​ถ่อมตัว​ลง​ใต้​อำนาจ​ที่​ยิ่งใหญ่​ของ​พระเจ้า เพื่อ​พระเจ้า​จะ​ได้​ยก​คุณ​ขึ้น​เมื่อ​ถึง​เวลาที่​เหมาะสม",
    "streamUrl": "fivefish.org/T35850",
    "trackDownloadUrl": "fivefish.org/T35850-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35850.zip",
    "programId": "35850",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FCFCH491kjI&list=PLbQkUFqMy6wp4UmcPytwcv03p4ttlOz0l",
    "shareUrl": "5fi.sh/T35850",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Western.416.mp3",
    "stableKey": "Karen Pwo Western"
  },
  {
    "id": 35851,
    "iso3": "PWO",
    "langId": "416",
    "languageEn": "Karen Pwo Western",
    "langTh": "กะเหรี่ยงโป ตะวันตก",
    "title_en": "Jesus Story 2 of 2",
    "title_th": "เรื่องราวของพระเยซู 2 of 2",
    "verse_en": "1 Peter 5:7 Cast all your anxiety on Him because He cares for you.",
    "verse_th": "1 เปโตร 5:7 ให้​เอา​ความ​กังวล​ทั้งหมด​ของ​คุณ​ฝากไว้​กับ​พระเจ้า เพราะ​พระองค์​ห่วงใย​คุณ",
    "streamUrl": "fivefish.org/T35851",
    "trackDownloadUrl": "fivefish.org/T35851-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35851.zip",
    "programId": "35851",
    "shareUrl": "5fi.sh/T35851",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Western.416.mp3",
    "stableKey": "Karen Pwo Western"
  },
  {
    "id": 9850,
    "iso3": "PWO",
    "langId": "416",
    "languageEn": "Karen Pwo Western",
    "langTh": "กะเหรี่ยงโป ตะวันตก",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "1 John 2:15 Do not love the world or anything in the world. If anyone loves the world, the love of the Father is not in him.",
    "verse_th": "1 ยอห์น 2:15 อย่า​รัก​โลก​หรือ​รัก​สิ่งของ​ใน​โลกนี้​อีก​ต่อไป ถ้า​คนไหน​รัก​โลกนี้ คนนั้น​ก็​ไม่ได้​รัก​พระบิดา",
    "streamUrl": "fivefish.org/T9850",
    "trackDownloadUrl": "fivefish.org/T9850-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9850.zip",
    "programId": "9850",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PYP5VUfm0kQ&list=PLbQkUFqMy6wp4UmcPytwcv03p4ttlOz0l",
    "shareUrl": "5fi.sh/T9850",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Western.416.mp3",
    "stableKey": "Karen Pwo Western"
  },
  {
    "id": 9851,
    "iso3": "PWO",
    "langId": "416",
    "languageEn": "Karen Pwo Western",
    "langTh": "กะเหรี่ยงโป ตะวันตก",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "1 John 2:16 For everything in the world - the lust of the flesh, the lust of the eyes, and the pride of life - comes not from the Father but from the world.",
    "verse_th": "1 ยอห์น 2:16 เพราะ​ทุกสิ่ง​ทุกอย่าง​ใน​โลกนี้ คือ​กิเลสตัณหา​ของ​สันดาน กิเลสตัณหา​ของ​ตา และ​การ​โอ้อวด​ใน​สิ่ง​ที่​ทำ​หรือ​มี สิ่ง​เหล่านี้​ไม่ได้​มา​จาก​พระบิดา แต่​มา​จาก​โลกนี้",
    "streamUrl": "fivefish.org/T9851",
    "trackDownloadUrl": "fivefish.org/T9851-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9851.zip",
    "programId": "9851",
    "languageVideoUrl": "https://www.youtube.com/watch?v=vCQXnm2m2n8&list=PLbQkUFqMy6wp4UmcPytwcv03p4ttlOz0l",
    "shareUrl": "5fi.sh/T9851",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Pwo.Western.416.mp3",
    "stableKey": "Karen Pwo Western"
  },
  {
    "id": 33121,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Following Jesus",
    "title_th": "ติดตามพระเยซู",
    "verse_en": "1 John 3:18 Dear children, let us not love with words or tongue but with actions and in truth.",
    "verse_th": "1 เปโตร 3:18 พระคริสต์​ทนทุกข์​เพื่อ​จัดการ​กับ​ความบาป​ครั้งเดียว​ก็​เพียงพอ​แล้ว พระองค์​ทำ​อย่างนี้​เพื่อ​นำ​คุณ​ไป​หา​พระเจ้า พระองค์​ถูก​ฆ่า​ทางกาย​แต่​มี​ชีวิต​ขึ้น​มา​ใหม่​โดย​ทาง​พระวิญญาณ",
    "streamUrl": "fivefish.org/T33121",
    "trackDownloadUrl": "fivefish.org/T33121-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33121.zip",
    "programId": "33121",
    "languageVideoUrl": "https://www.youtube.com/watch?v=2kk7Z2mJRGg&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T33121",
    "duration": "57:18",
    "trackCount": "16.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 27200,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Freedom in Jesus",
    "title_th": "อิสรภาพในพระเยซู",
    "verse_en": "1 John 5:13 I write these things to you who believe in the name of the Son of God so that you may know that you have eternal life.",
    "verse_th": "1 ยอห์น 5:13 ผม​ได้​เขียน​เรื่องนี้​ถึง​พวกคุณ​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า เพื่อ​พวกคุณ​จะ​ได้​รู้​ว่า คุณ​ยัง​มี​ชีวิต​ตลอดไป​กับ​พระเจ้า​อยู่",
    "streamUrl": "fivefish.org/T27200",
    "trackDownloadUrl": "fivefish.org/T27200-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27200.zip",
    "programId": "27200",
    "languageVideoUrl": "https://www.youtube.com/watch?v=QGz1r3cSeuw&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T27200",
    "duration": "58:53",
    "trackCount": "21.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 38334,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Revelation 1:8 I am the Alpha and the Omega, says the Lord God, Who is, and Who was, and Who is to come, the Almighty.",
    "verse_th": "วิวรณ์ 1:8 พระเจ้า​องค์​เจ้า​ชีวิต​พูดว่า “เรา​คือ​จุดเริ่มต้น​และ​จุดจบ พระเจ้า​ผู้ที่​เป็น​อยู่​ใน​ปัจจุบัน ใน​อดีต และ​กำลัง​จะ​มา​ใน​อนาคต พระเจ้า​ผู้​มี​ฤทธิ์​ทั้งสิ้น”",
    "streamUrl": "fivefish.org/T38334",
    "trackDownloadUrl": "fivefish.org/T38334-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/38334.zip",
    "programId": "38334",
    "languageVideoUrl": "https://www.youtube.com/watch?v=e2P4oUy1NaQ&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T38334",
    "duration": "59:14",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Karen.S'gaw.38334.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64523,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Revelation 3:20 Here I am! I stand at the door and knock. If anyone hears My voice and opens the door, I will come in and eat with him, and he with Me.",
    "verse_th": "วิวรณ์ 3:20 ฟัง​ไว้​ให้ดี เรา​ยืน​เคาะ​ประตู​อยู่ ถ้า​ใคร​ได้ยิน​เสียง​ของ​เรา​แล้ว​เปิด​ประตู เรา​จะ​เข้า​ไป​ข้างใน และ​กิน​อาหาร​ร่วมกับ​คนนั้น",
    "streamUrl": "fivefish.org/T64523",
    "trackDownloadUrl": "fivefish.org/T64523-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64523.zip",
    "programId": "64523",
    "languageVideoUrl": "https://www.youtube.com/watch?v=pWqq1zAPOtA&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64523",
    "duration": "44:25",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64524,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Genesis 1:1 In the beginning God created the heavens and the earth.",
    "verse_th": "ปฐมกาล 1:1 ใน​ปฐมกาล​นั้น เมื่อ​พระเจ้า​สร้าง​แผ่นดิน​และ​ท้องฟ้า",
    "streamUrl": "fivefish.org/T64524",
    "trackDownloadUrl": "fivefish.org/T64524-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64524.zip",
    "programId": "64524",
    "languageVideoUrl": "https://www.youtube.com/watch?v=5oYAygg1nrM&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64524",
    "duration": "44:48",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64525,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Exodus 23:25 Worship the LORD your God, and His blessing will be on your food and water. I will take away sickness from among you.",
    "verse_th": "อพยพ 23:25 ถ้า​พวกเจ้า​รับใช้​พระยาห์เวห์​พระเจ้า​ของเจ้า พระองค์​จะ​อวยพร​อาหาร​และ​น้ำ​ของเจ้า และ​เรา​จะ​เอา​เชื้อโรค​ออก​ไป​จากเจ้า",
    "streamUrl": "fivefish.org/T64525",
    "trackDownloadUrl": "fivefish.org/T64525-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64525.zip",
    "programId": "64525",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1SD7-rHuask&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64525",
    "duration": "45:55",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64526,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Leviticus 19:11 Do not steal. Do not lie. Do not deceive on another.",
    "verse_th": "เลวีนิติ 19:11 เจ้า​ต้อง​ไม่​ขโมย ไม่​โกง​หรือ​โกหก​ซึ่งกัน​และกัน",
    "streamUrl": "fivefish.org/T64526",
    "trackDownloadUrl": "fivefish.org/T64526-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64526.zip",
    "programId": "64526",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FU4htB95TzA&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64526",
    "duration": "43:57",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64527,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Numbers 23:19 God is not a man, that He should lie, nor a son of man, that He should change His mind. Does He speak and then not act? Does He promise and not fulfill?",
    "verse_th": "กันดารวิถี 23:19 พระเจ้า​ไม่​ใช่​มนุษย์​ที่​พูด​โกหก และ​ก็​ไม่​ใช่​มนุษย์​ที่​ชอบ​เปลี่ยนใจ มี​หรือ​ที่​พระองค์​พูด​แล้ว​ไม่​ทำ หรือ​สัญญา​แล้ว​ไม่​ทำ​ตาม​สัญญานั้น",
    "streamUrl": "fivefish.org/T64527",
    "trackDownloadUrl": "fivefish.org/T64527-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64527.zip",
    "programId": "64527",
    "languageVideoUrl": "https://www.youtube.com/watch?v=s-0A0eABF2I&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64527",
    "duration": "44:53",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64528,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Deuteronomy 31:6 Be strong and courageous. Do not be afraid or terrified because of them, for the LORD your God goes with you; He will never leave you nor forsake you.",
    "verse_th": "เฉลยธรรมบัญญัติ 31:6 ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ ไม่​ต้อง​กลัว​หรือ​ตื่นตกใจ​เพราะ​พวกนั้น เพราะ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน​คือ​ผู้ที่​จะ​ไป​กับ​ท่าน พระองค์​จะ​ไม่​ละ​ท่าน​ไป​หรือ​ทอดทิ้ง​ท่าน​หรอก”",
    "streamUrl": "fivefish.org/T64528",
    "trackDownloadUrl": "fivefish.org/T64528-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64528.zip",
    "programId": "64528",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IYR66PFyPaw&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64528",
    "duration": "43:44",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64529,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Deuteronomy 6:16 Do not put the LORD your God to the test as you did at Massah.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:16 พวกท่าน​ต้อง​ไม่​ลองดี​กับ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน เหมือน​กับ​ที่​พวกท่าน​เคย​ลองดี​กับ​พระองค์​มา​แล้ว​ที่​มัสสาห์",
    "streamUrl": "fivefish.org/T64529",
    "trackDownloadUrl": "fivefish.org/T64529-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64529.zip",
    "programId": "64529",
    "languageVideoUrl": "https://www.youtube.com/watch?v=k62rN2Mgfsg&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64529",
    "duration": "43:33",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64530,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Deuteronomy 6:5 Love the LORD your God with all your heart and with all your soul and with all your strength.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:5 ท่าน​ต้อง​รัก​พระยาห์เวห์​พระเจ้า​ของ​ท่าน ด้วย​การ​ทุ่ม​สุดใจ สุด​ชีวิต และ​สุด​ตัว ของ​ท่าน​ให้​กับ​พระองค์",
    "streamUrl": "fivefish.org/T64530",
    "trackDownloadUrl": "fivefish.org/T64530-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64530.zip",
    "programId": "64530",
    "languageVideoUrl": "https://www.youtube.com/watch?v=GOglfzXvCd8&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64530",
    "duration": "46:30",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 27210,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "The Works of Jesus",
    "title_th": "พระราชกิจของพระเยซู",
    "verse_en": "Deuteronomy 8:3 He humbled you, causing you to hunger and then feeding you with manna, which neither you nor your ancestors had known, to teach you that man does not live on bread alone but on every word that comes from the mouth of the LORD.",
    "verse_th": "เฉลยธรรมบัญญัติ 8:3 พระยาห์เวห์​ทำ​ให้​ท่าน​ต้อง​ทนทุกข์​จาก​ความหิว​แล้ว​พระองค์​ก็​เลี้ยง​พวกท่าน​ด้วย​มานา ที่​ทั้ง​ท่าน​และ​บรรพบุรุษ​ของ​ท่าน​ไม่​เคย​รู้จัก​มา​ก่อน เพื่อ​ที่​พระองค์​จะ​ได้​สอน​ท่าน​ว่า คน​เรา​ไม่​ได้​มี​ชีวิต​อยู่​ด้วย​อาหาร​เพียง​อย่าง​เดียว แต่​คน​เรา​จะ​มี​ชีวิต​อยู่​ได้​ด้วย​ทุกๆ​คำพูด​ที่​ออก​มา​จาก​ปาก​ของ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T27210",
    "trackDownloadUrl": "fivefish.org/T27210-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27210.zip",
    "programId": "27210",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Qs9M6Yo_2xQ&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T27210",
    "duration": "58:43",
    "trackCount": "18.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 9420,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Who Is Jesus?",
    "title_th": "พระเยซูคือใคร",
    "verse_en": "Joshua 1:8 Do not let this Book of the Law depart from your mouth; meditate on it day and night, so that you may be careful to do everything written in it. Then you will be prosperous and successful.",
    "verse_th": "โยชูวา 1:8 เจ้า​ต้อง​ไม่หยุด​พูด​ถึง​กฎ​ใน​หนังสือ​เล่มนี้ และ​เจ้า​ต้อง​ไตร่ตรอง​มัน​ทั้งวัน​ทั้งคืน เพื่อ​เจ้า​จะได้​ทำ​ตาม​สิ่ง​ที่​ได้​เขียน​ไว้​ใน​กฎ​นั้น​อย่าง​เคร่งครัด แล้ว​เจ้า​จะได้​เจริญ​รุ่งเรือง​และ​ประสบ​ความ​สำเร็จ",
    "streamUrl": "fivefish.org/T9420",
    "trackDownloadUrl": "fivefish.org/T9420-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9420.zip",
    "programId": "9420",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TVr8cRsU7ag&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T9420",
    "duration": "52:26",
    "trackCount": "15.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 27201,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Words of Life 4",
    "title_th": "พระคำแห่งชีวิต 4",
    "verse_en": "Joshua 1:9 Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the LORD your God will be with you wherever you go.",
    "verse_th": "โยชูวา 1:9 อย่าลืม​ว่า​เรา​ได้​สั่ง​เจ้า​ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ อย่า​ได้​หวาดกลัว​หรือ​ท้อถอย เพราะ​เรา ยาห์เวห์ พระเจ้า​ของเจ้า จะ​อยู่​กับเจ้า​ใน​ทุกที่​ที่​เจ้าไป”",
    "streamUrl": "fivefish.org/T27201",
    "trackDownloadUrl": "fivefish.org/T27201-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27201.zip",
    "programId": "27201",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ld5-wbtoYJ8&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T27201",
    "duration": "60:49",
    "trackCount": "15.0",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 64531,
    "iso3": "KSW",
    "langId": "238",
    "languageEn": "Karen S'gaw",
    "langTh": "กะเหรี่ยงสะกอ",
    "title_en": "Worship Songs CD 1",
    "title_th": "เพลงนมัสการ CD 1",
    "verse_en": "2 Chronicles 7:14 If My people, who are called by My name, will humble themselves and pray and seek My face and turn from their wicked ways, then I will hear from heaven, and I will forgive their sin and will heal their land.",
    "verse_th": "2 พงศาวดาร 7:14 ถ้า​ประชาชน​ของ​เรา​ผู้ที่​เรา​ได้​ประทับ​ชื่อ​เราไว้ ถ่อมตัว​ลง​และ​อธิษฐาน และ​เริ่ม​แสวงหา​ใบ​หน้า​ของเรา และ​หันเห​ออก​จาก​วิถีทาง​ชั่ว​ทั้งหลาย​ของ​พวกเขา เรา​ก็​จะ​รับฟัง​จาก​สวรรค์ และ​จะ​ยกโทษ​บาป​ของ​พวกเขา​และ​จะ​รักษา​แผ่นดิน​ของ​พวกเขา",
    "streamUrl": "fivefish.org/T64531",
    "trackDownloadUrl": "fivefish.org/T64531-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64531.zip",
    "programId": "64531",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4J1tO9WlWkQ&list=PLho9cJoXqQC-RWmaQeJEPzHhAcFMQUdrd",
    "shareUrl": "5fi.sh/T64531",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Karen.Sgaw.238.mp3",
    "stableKey": "Karen S'gaw"
  },
  {
    "id": 80842,
    "iso3": "EKY",
    "langId": "5169",
    "languageEn": "Kayah Eastern Presule",
    "langTh": "กะยาตะวันออก พรีซูลี",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Job 31:1 I made a covenant with my eyes not to look lustfully at a young woman.",
    "verse_th": "โยบ 31:1 ข้า​ทำ​ข้อตกลง​กับ​ดวงตา​ของ​ข้า​ว่า ข้า​จะ​ไม่​มอง​หญิงสาว​ด้วย​ความใคร่",
    "streamUrl": "fivefish.org/T80842",
    "trackDownloadUrl": "fivefish.org/T80842-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80842.zip",
    "programId": "80842",
    "languageVideoUrl": "https://www.youtube.com/watch?v=I-34H_ky6Dw&list=PLbQkUFqMy6wrpr3gZVsfhVMZb494x9UnS",
    "shareUrl": "5fi.sh/T80842",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kayah.Eastern.Presule.80842.mp3",
    "stableKey": "Kayah Eastern Presule"
  },
  {
    "id": 80838,
    "iso3": "KYU",
    "langId": "404",
    "languageEn": "Kayah Western",
    "langTh": "กะยาตะวันตก",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Psalms 103:1 Praise the LORD, my soul; all my inmost being, praise His holy name.",
    "verse_th": "สดุดี 103:1 จิตใจ​ของ​ข้าพเจ้า​เอ๋ย สรรเสริญ​พระยาห์เวห์เถิด หัวใจ​ทั้งดวง​ของข้าพเจ้า​เอ๋ย สรรเสริญ​ชื่อ​อันศักดิ์สิทธิ์​ของ​พระองค์เถิด",
    "streamUrl": "fivefish.org/T80838",
    "trackDownloadUrl": "fivefish.org/T80838-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80838.zip",
    "programId": "80838",
    "languageVideoUrl": "https://www.youtube.com/watch?v=SHWGcnKj_78&list=PLbQkUFqMy6wpA9PjyEKGnuGS2apTk19iT",
    "shareUrl": "5fi.sh/T80838",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kayah.Western.80838.mp3",
    "stableKey": "Kayah Western"
  },
  {
    "id": 62901,
    "iso3": "KYU",
    "langId": "404",
    "languageEn": "Kayah Western",
    "langTh": "กะยาตะวันตก",
    "title_en": "The Living Christ - Lessons 1 & 2",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 1 & 2",
    "verse_en": "Psalms 111:10 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สดุดี 111:10 การยำเกรง​พระยาห์เวห์​คือ​จุดเริ่มต้น​แห่งสติปัญญา ทุกคน​ที่​เชื่อฟัง​พระองค์​ก็​จะเป็น​คนที่​มีสติรอบคอบ พระองค์​จะได้รับ​การสรรเสริญ​ตลอดไป",
    "streamUrl": "fivefish.org/T62901",
    "trackDownloadUrl": "fivefish.org/T62901-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62901.zip",
    "programId": "62901",
    "languageVideoUrl": "https://www.youtube.com/watch?v=HR17QyJYlv4&list=PLbQkUFqMy6wpA9PjyEKGnuGS2apTk19iT",
    "shareUrl": "5fi.sh/T62901",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kayah.Western.404.mp3",
    "stableKey": "Kayah Western"
  },
  {
    "id": 63010,
    "iso3": "KYU",
    "langId": "404",
    "languageEn": "Kayah Western",
    "langTh": "กะยาตะวันตก",
    "title_en": "The Living Christ - Lessons 3 & 4",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 3 & 4",
    "verse_en": "Psalms 119: 9,11 How can a young man keep his way pure? By living according to Your Word. I have hidden Your Word in my heart that I might not sin against You.",
    "verse_th": "สดุดี 119:9,11 คนหนุ่มๆ​จะ​รักษาชีวิต​ของตน​ให้​บริสุทธิ์​ได้อย่างไร ก็​ด้วย​การรักษา​คำบัญชา​ของพระอง 11ข้าพเจ้า​เก็บรักษา​คำ​สัญญา​ของพระองค์​ไว้ในใจ เพื่อ​ข้าพเจ้า​จะได้​ไม่ทำบาป​ต่อพระองค์",
    "streamUrl": "fivefish.org/T63010",
    "trackDownloadUrl": "fivefish.org/T63010-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63010.zip",
    "programId": "63010",
    "languageVideoUrl": "https://www.youtube.com/watch?v=adQcVacxJ1M&list=PLbQkUFqMy6wpA9PjyEKGnuGS2apTk19iT",
    "shareUrl": "5fi.sh/T63010",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kayah.Western.404.mp3",
    "stableKey": "Kayah Western"
  },
  {
    "id": 6750,
    "iso3": "KYU",
    "langId": "404",
    "languageEn": "Kayah Western",
    "langTh": "กะยาตะวันตก",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 121:1-2 I lift up my eyes to the mountains— where does my help come from? My help comes from the LORD, the Maker of heaven and earth.",
    "verse_th": "สดุดี 121:1-2 ข้าพเจ้า​แหงนหน้า​มอง​ขึ้นไป​ยัง​ภูเขาทั้งหลาย ความช่วยเหลือ​ของข้าพเจ้า​จะมา​จาก​ที่ไหนกัน ความช่วยเหลือ​ของข้าพเจ้า​มาจาก​พระยาห์เวห์ ผู้สร้าง​สวรรค์​และ​แผ่นดินโลก",
    "streamUrl": "fivefish.org/T6750",
    "trackDownloadUrl": "fivefish.org/T6750-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6750.zip",
    "programId": "6750",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ZTb7QHLHNwk&list=PLbQkUFqMy6wpA9PjyEKGnuGS2apTk19iT",
    "shareUrl": "5fi.sh/T6750",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Kayah.Western.404.mp3",
    "stableKey": "Kayah Western"
  },
  {
    "id": 19141,
    "iso3": "BFG",
    "langId": "4229",
    "languageEn": "Kayan",
    "langTh": "กะยัน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Psalms 139:13-14 For You created my inmost being; You knit me together in my mother’s womb. I praise You because I am fearfully and wonderfully made; Your works are wonderful, I know that full well.",
    "verse_th": "สดุดี 139:13-14 พระองค์​สร้าง​ทั้งจิต​และใจ​ของข้าพเจ้า พระองค์​ทอ​ข้าพเจ้า​เข้าด้วยกัน​ใน​ท้องแม่ ข้าพเจ้า​จึง​ขอบคุณ​พระองค์​เพราะ​งาน​ของพระองค์นั้น​ช่างน่าเกรง​ขาม​และน่าทึ่ง พระองค์​รู้จัก​ข้าพเจ้า​อย่าง​ทะลุปรุโปร่ง",
    "streamUrl": "fivefish.org/T19141",
    "trackDownloadUrl": "fivefish.org/T19141-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/19141.zip",
    "programId": "19141",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lOev8EK0o1c&list=PLP0Y_cbvmX8o2kN3_8EfDRaGxPLCIvMEW",
    "shareUrl": "5fi.sh/T19141",
    "duration": "65:39",
    "trackCount": "44.0",
    "sampleUrl": "/audio/Kayan.19141.mp3",
    "stableKey": "Kayan"
  },
  {
    "id": 63793,
    "iso3": "BFG",
    "langId": "4229",
    "languageEn": "Kayan",
    "langTh": "กะยัน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Psalms 139:8 If I go up to the heavens, You are there; if I make my bed in the depths, You are there.",
    "verse_th": "สดุดี 139:8 ถ้า​ข้าพเจ้า​จะ​ขึ้นไป​บนสวรรค์​พระองค์​ก็อยู่ที่นั่น ถ้า​ข้าพเจ้า​นอนลง​ที่​แดน​คนตาย​พระองค์​ก็อยู่ที่นั่น",
    "streamUrl": "fivefish.org/T63793",
    "trackDownloadUrl": "fivefish.org/T63793-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63793.zip",
    "programId": "63793",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WHp0oWXVEZs&list=PLP0Y_cbvmX8o2kN3_8EfDRaGxPLCIvMEW",
    "shareUrl": "5fi.sh/T63793",
    "duration": "60:15",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Kayan.4229.mp3",
    "stableKey": "Kayan"
  },
  {
    "id": 75325,
    "iso3": "BFG",
    "langId": "4229",
    "languageEn": "Kayan",
    "langTh": "กะยัน",
    "title_en": "Words of Life for Women 1",
    "title_th": "พระคำแห่งชีวิต สำหรับผู้หญิง 1",
    "verse_en": "Psalms 23:1 The Lord is my Shepherd, I lack nothing.",
    "verse_th": "สดุดี 23:1 พระยาห์เวห์​เลี้ยงดู​ข้าพเจ้า​เหมือน​เลี้ยงแกะ ดังนั้น ข้าพเจ้า​ไม่ขาด​อะไรเลย",
    "streamUrl": "fivefish.org/T75325",
    "trackDownloadUrl": "fivefish.org/T75325-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/75325.zip",
    "programId": "75325",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4V9R7IpHqvc&list=PLP0Y_cbvmX8o2kN3_8EfDRaGxPLCIvMEW",
    "shareUrl": "5fi.sh/T75325",
    "duration": "66:20",
    "trackCount": "9.0",
    "sampleUrl": "/audio/Kayan.4229.mp3",
    "stableKey": "Kayan"
  },
  {
    "id": 75326,
    "iso3": "BFG",
    "langId": "4229",
    "languageEn": "Kayan",
    "langTh": "กะยัน",
    "title_en": "Words of Life for Women 2",
    "title_th": "พระคำแห่งชีวิต สำหรับผู้หญิง 2",
    "verse_en": "Psalms 27:14 Wait for the Lord; be strong and take heart and wait for the Lord.",
    "verse_th": "สดุดี 27:14 ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์ ให้​เข้มแข็ง​และ​กล้าหาญไว้ ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T75326",
    "trackDownloadUrl": "fivefish.org/T75326-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/75326.zip",
    "programId": "75326",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4Dz74b7ut8E&list=PLP0Y_cbvmX8o2kN3_8EfDRaGxPLCIvMEW",
    "shareUrl": "5fi.sh/T75326",
    "duration": "62:53",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Kayan.4229.mp3",
    "stableKey": "Kayan"
  },
  {
    "id": 11431,
    "iso3": "LBN",
    "langId": "487",
    "languageEn": "Khamet",
    "langTh": "ขะเม็ต",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 30:5 For His anger lasts only a moment, but His favor lasts a lifetime; weeping may stay for the night, but rejoicing comes in the morning.",
    "verse_th": "สดุดี 30:5 ความ​โกรธ​เกรี้ยว​ของ​พระองค์​อยู่​เพียง​ชั่วคราว แต่​ความปรานี​ของ​พระองค์​นำ​ชีวิต​มาให้ เรา​อาจจะ​ร้องไห้​ใน​ยามค่ำคืน แต่​ใน​วันรุ่งขึ้น เรา​จะ​ชื่นบาน",
    "streamUrl": "fivefish.org/T11431",
    "trackDownloadUrl": "fivefish.org/T11431-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/11431.zip",
    "programId": "11431",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jZ5_tx2jg38&list=PLXduqvGi62csJEaUKTgY3X25rqsNC4LXI",
    "shareUrl": "5fi.sh/T11431",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khamet.11431.mp3",
    "stableKey": "Khamet"
  },
  {
    "id": 16030,
    "iso3": "KJG",
    "langId": "1005",
    "languageEn": "Khamu",
    "langTh": "ขมุ",
    "title_en": "Creation to Christ",
    "title_th": "ตั้งแต่การสร้างจนถึงพระคริสต์",
    "verse_en": "Psalms 32:5 Then I acknowledged my sin to You and did not cover up my iniquity. I said, I will confess my transgressions to the LORD. And You forgave the guilt of my sin.",
    "verse_th": "สดุดี 32:5 ดังนั้น พระยาห์เวห์ ข้าพเจ้า​ขอสารภาพ​ความบาป​ต่อพระองค์ โดย​ไม่ได้​ซ่อน​ความผิดบาป​อะไร​ไว้เลย ข้าพเจ้า​พูดว่า “ข้าพเจ้า​จะ​สารภาพ​ต่อ​พระยาห์เวห์​ถึง​การกบฏ​ทั้งหลาย​ที่ทำไป” แล้ว​พระองค์​ก็​ได้​ยกโทษ​ให้​กับ​ความผิดบาป​ของ​ข้าพเจ้า เซลาห์",
    "streamUrl": "fivefish.org/T16030",
    "trackDownloadUrl": "fivefish.org/T16030-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/16030.zip",
    "programId": "16030",
    "languageVideoUrl": "https://www.youtube.com/watch?v=zSE0Th40Cko&list=PLXduqvGi62cviYk0NqZhMwsW6Ekbgh6-s",
    "shareUrl": "5fi.sh/T16030",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khamu.1005.mp3",
    "stableKey": "Khamu"
  },
  {
    "id": 16031,
    "iso3": "KJG",
    "langId": "1005",
    "languageEn": "Khamu",
    "langTh": "ขมุ",
    "title_en": "Growing in Jesus",
    "title_th": "เติบโตในพระเยซู",
    "verse_en": "Psalms 37:4 Take delight in the Lord, and He will give you the desires of your heart.",
    "verse_th": "สดุดี 37:4 ให้​มี​ความสุข​กับ​การรับใช้​พระยาห์เวห์ แล้ว​พระองค์​จะให้​สิ่งที่​ใจ​เจ้า​ต้องการ",
    "streamUrl": "fivefish.org/T16031",
    "trackDownloadUrl": "fivefish.org/T16031-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/16031.zip",
    "programId": "16031",
    "languageVideoUrl": "https://www.youtube.com/watch?v=UWDNMs8Pjsk&list=PLXduqvGi62cviYk0NqZhMwsW6Ekbgh6-s",
    "shareUrl": "5fi.sh/T16031",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khamu.1005.mp3",
    "stableKey": "Khamu"
  },
  {
    "id": 35880,
    "iso3": "KJG",
    "langId": "1005",
    "languageEn": "Khamu",
    "langTh": "ขมุ",
    "title_en": "Jesus Story 1 of 2",
    "title_th": "เรื่องราวของพระเยซู 1 of 2",
    "verse_en": "Psalms 4:3 Know that the LORD has set apart His faithful servant for Himself; the LORD hears when I call to Him.",
    "verse_th": "สดุดี 4:3 พวกเจ้า​ทั้งหลาย ให้​รู้​ไว้​เถอะ​ว่า พระยาห์เวห์​เอาใจใส่​คน​ที่​สัตย์ซื่อ​ต่อ​พระองค์​เป็นพิเศษ พระองค์​จะ​ฟัง​เสียง​ของเรา เมื่อ​เรา​ร้องขอ​ความช่วยเหลือ​จาก​พระองค์",
    "streamUrl": "fivefish.org/T35880",
    "trackDownloadUrl": "fivefish.org/T35880-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35880.zip",
    "programId": "35880",
    "languageVideoUrl": "https://www.youtube.com/watch?v=KN1xtfUYlBA&list=PLXduqvGi62cviYk0NqZhMwsW6Ekbgh6-s",
    "shareUrl": "5fi.sh/T35880",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khamu.35880.mp3",
    "stableKey": "Khamu"
  },
  {
    "id": 35881,
    "iso3": "KJG",
    "langId": "1005",
    "languageEn": "Khamu",
    "langTh": "ขมุ",
    "title_en": "Jesus Story 2 of 2",
    "title_th": "เรื่องราวของพระเยซู 2 of 2",
    "verse_en": "Psalms 4:8 In peace I will lie down and sleep, for You alone, LORD, make me dwell in safety.",
    "verse_th": "สดุดี 4:8 ดังนั้น ข้าพเจ้า​นอนลง​และ​หลับไป​อย่าง​สงบสุข​ยิ่งนัก เพราะ พระยาห์เวห์ พระองค์​แต่เพียงผู้เดียว​เป็น​ผู้ที่​ทำให้​ข้าพเจ้า​นอนลง​อย่างปลอดภัย",
    "streamUrl": "fivefish.org/T35881",
    "trackDownloadUrl": "fivefish.org/T35881-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35881.zip",
    "programId": "35881",
    "shareUrl": "5fi.sh/T35881",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khamu.1005.mp3",
    "stableKey": "Khamu"
  },
  {
    "id": 6700,
    "iso3": "KJG",
    "langId": "488",
    "languageEn": "Khamu Thailand",
    "langTh": "ขมุ ประเทศไทย",
    "title_en": "Power Over Fear",
    "title_th": "พลังเหนือความกลัว",
    "verse_en": "Psalms 94:11 The LORD knows all human plans; He knows that they are futile.",
    "verse_th": "สดุดี 94:11 พระยาห์เวห์​รู้จัก​ความคิด​ของ​มนุษย์ และ​พระองค์​รู้ว่า​มัน​ไร้สาระ",
    "streamUrl": "fivefish.org/T6700",
    "trackDownloadUrl": "fivefish.org/T6700-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6700.zip",
    "programId": "6700",
    "languageVideoUrl": "https://www.youtube.com/watch?v=MfefRsJgbmA&list=PLho9cJoXqQC8l3WbkugSmOqpIjTAOG2AA",
    "shareUrl": "5fi.sh/T6700",
    "duration": "13:00",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Khamu.Thailand.488.mp3",
    "stableKey": "Khamu Thailand"
  },
  {
    "id": 64394,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Proverbs 1:7 The fear of the LORD is the beginning of knowledge, but fools despise wisdom and instruction.",
    "verse_th": "สุภาษิต 1:7 การ​ยำเกรง​พระยาห์เวห์​คือ​จุด​เริ่มต้น​ของ​ความรู้ แต่​คน​โง่​เกลียดชัง​ปัญญา​และ​คำ​สั่งสอน",
    "streamUrl": "fivefish.org/T64394",
    "trackDownloadUrl": "fivefish.org/T64394-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64394.zip",
    "programId": "64394",
    "languageVideoUrl": "https://www.youtube.com/watch?v=v9lalr8K_X0&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T64394",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.64394.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74832,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Proverbs 1:8 Listen, my son, to your father's instruction and do not forsake your mother's teaching.",
    "verse_th": "สุภาษิต 1:8 ลูกเอ๋ย ให้​เชื่อฟัง​คำ​สั่งสอน​ของ​พ่อเจ้า และ​อย่า​ได้​ละทิ้ง​คำสอน​ของ​แม่เจ้า​ด้วย",
    "streamUrl": "fivefish.org/T74832",
    "trackDownloadUrl": "fivefish.org/T74832-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74832.zip",
    "programId": "74832",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jQqOuC1oHsw&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74832",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 80758,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 1 Beginning with GOD (B)",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า (B)",
    "verse_en": "Proverbs 10:12 Hatred stirs up conflict, but love covers over all wrongs.",
    "verse_th": "สุภาษิต 10:12 ความ​เกลียดชัง​ย่อม​เร่งเร้า​ให้​เกิด​การ​ทะเลาะ​วิวาท แต่​ความรัก​ปกปิด​ความผิด​ทั้งปวง",
    "streamUrl": "fivefish.org/T80758",
    "trackDownloadUrl": "fivefish.org/T80758-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80758.zip",
    "programId": "80758",
    "languageVideoUrl": "https://www.youtube.com/watch?v=P-poSf8wdH0&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T80758",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74833,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Proverbs 10:4 Lazy hands make for poverty, but diligent hands bring wealth.",
    "verse_th": "สุภาษิต 10:4 มือ​ที่​เกียจคร้าน​ทำให้​ยากจน แต่​มือ​ที่​ขยัน​ทำ​ให้​ร่ำรวย",
    "streamUrl": "fivefish.org/T74833",
    "trackDownloadUrl": "fivefish.org/T74833-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74833.zip",
    "programId": "74833",
    "languageVideoUrl": "https://www.youtube.com/watch?v=qp0JcCBjCw0&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74833",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74834,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Proverbs 10:9 Whoever walks in integrity walks securely, but whoever takes crooked paths will be found out.",
    "verse_th": "สุภาษิต 10:9 คน​ที่​ใช้​ชีวิต​อย่าง​ซื่อสัตย์​ไม่​ต้อง​ห่วง​อะไร แต่​คน​ที่​อยู่​ใน​ทาง​ไม่ซื่อสัตย์​ก็​จะ​ถูก​จับ​ได้",
    "streamUrl": "fivefish.org/T74834",
    "trackDownloadUrl": "fivefish.org/T74834-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74834.zip",
    "programId": "74834",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nrFC0Dr6PJI&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74834",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74835,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Proverbs 16:3 Commit to the LORD whatever you do, and He will establish your plans.",
    "verse_th": "สุภาษิต 16:3 ให้​มอบ​การ​งาน​ของ​เจ้า​ให้​กับ​พระยาห์เวห์ แล้ว​แผนการ​ของ​เจ้า​จะ​สำเร็จ",
    "streamUrl": "fivefish.org/T74835",
    "trackDownloadUrl": "fivefish.org/T74835-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74835.zip",
    "programId": "74835",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ySlJRksSZRY&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74835",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74836,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Proverbs 16:4 The Lord works out everything to its proper end— even the wicked for a day of disaster.",
    "verse_th": "สุภาษิต 16:4 พระยาห์เวห์​สร้าง​ทุกสิ่ง​ขึ้น​มา​อย่าง​มี​จุด​มุ่งหมาย แม้แต่​คนชั่ว พระองค์​ก็​สร้าง​ขึ้น​มา​เพื่อ​วัน​แห่ง​ความ​พินาศ",
    "streamUrl": "fivefish.org/T74836",
    "trackDownloadUrl": "fivefish.org/T74836-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74836.zip",
    "programId": "74836",
    "languageVideoUrl": "https://www.youtube.com/watch?v=QrB--c7rxKw&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74836",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 74837,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Proverbs 17:17 A friend loves at all times, and a brother is born for a time of adversity.",
    "verse_th": "สุภาษิต 17:17 เพื่อน​แท้​ก็​รักกัน​อยู่​เสมอ ส่วน​พี่น้องนั้น​ก็​เกิด​มา​เพื่อ​ช่วยเหลือกัน​ใน​ยาม​ทุกข์ยาก",
    "streamUrl": "fivefish.org/T74837",
    "trackDownloadUrl": "fivefish.org/T74837-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74837.zip",
    "programId": "74837",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IhIMNjRcrT0&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T74837",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 80108,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Proverbs 17:9 Whoever would foster love covers over an offense, but whoever repeats the matter separates close friends.",
    "verse_th": "สุภาษิต 17:9 คน​ที่​ปกปิด​ความผิด​ของ​คน​อื่น​ไว้​รักษา​มิตรภาพ ส่วน​คน​ที่​เล่า​ความผิด​ของ​เพื่อน​ให้​คนอื่น​ฟัง​ก็​ทำลาย​มิตรภาพ",
    "streamUrl": "fivefish.org/T80108",
    "trackDownloadUrl": "fivefish.org/T80108-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80108.zip",
    "programId": "80108",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jHD315mM1GY&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T80108",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 80109,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Proverbs 18:4 The words of the mouth are deep waters, but the fountain of wisdom is a rushing stream.",
    "verse_th": "สุภาษิต 18:4 คำพูด​จาก​ปาก เป็น​น้ำลึก​ที่​เกิน​กว่า​จะ​เข้าใจ​ได้ แต่​แหล่งน้ำ​แห่ง​ปัญญา​ทำ​ให้​สดชื่น​เสมอ เหมือน​กับ​ลำธาร​ที่​ไหล​เชี่ยว",
    "streamUrl": "fivefish.org/T80109",
    "trackDownloadUrl": "fivefish.org/T80109-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80109.zip",
    "programId": "80109",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yNYHQEcR1x4&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T80109",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 64395,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "Meeting the Creator God",
    "title_th": "พบพระเจ้าพระผู้สร้าง",
    "verse_en": "Proverbs 21:30 There is no wisdom, no insight, no plan that can succeed against the LORD.",
    "verse_th": "สุภาษิต 21:30 ถึง​จะ​มี​สติปัญญา ความเข้าใจ และ​คำปรึกษาดี​แค่ไหน​ก็ตาม ก็​ช่วย​ไม่​ได้​หรอก ถ้า​พระยาห์เวห์​ต่อต้าน​เจ้า",
    "streamUrl": "fivefish.org/T64395",
    "trackDownloadUrl": "fivefish.org/T64395-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64395.zip",
    "programId": "64395",
    "languageVideoUrl": "https://www.youtube.com/watch?v=RLfSwGIEdWc&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T64395",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 30080,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Proverbs 25:28 Like a city whose walls are broken through is a person who lacks self-control.",
    "verse_th": "สุภาษิต 25:28 คน​ที่​ควบคุม​อารมณ์​ตัวเอง​ไม่​ได้ ก็​เหมือน​เมือง​ที่​ไม่​มี​กำแพง​ป้องกัน",
    "streamUrl": "fivefish.org/T30080",
    "trackDownloadUrl": "fivefish.org/T30080-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30080.zip",
    "programId": "30080",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YRH0Pdkqgdg&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T30080",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 30081,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "Proverbs 27:17 As iron sharpens iron, so one person sharpens another.",
    "verse_th": "สุภาษิต 27:17 เหล็ก​ลับ​เหล็ก​ให้​คม​ได้ คน​ก็​ลับ​เพื่อน​ของ​เขา​ได้",
    "streamUrl": "fivefish.org/T30081",
    "trackDownloadUrl": "fivefish.org/T30081-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30081.zip",
    "programId": "30081",
    "shareUrl": "5fi.sh/T30081",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 3400,
    "iso3": "KHM",
    "langId": "365",
    "languageEn": "Khmer",
    "langTh": "เขมร",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 3:13-14 Blessed are those who find wisdom, those who gain understanding,for she is more profitable than silver and yields better returns than gold.",
    "verse_th": "สุภาษิต 3:13-14 คน​ที่​ค้นพบ​สติปัญญา มี​เกียรติ​จริงๆ คน​ที่​มี​ความ​เข้าใจ​ก็​มี​เกียรติ​จริงๆ 14 กำไร​ที่​เกิด​จาก​สติปัญญานั้น มี​ค่า​ยิ่งกว่า​เงิน รายได้​ที่​เกิด​จาก​เธอ มี​ค่า​ยิ่งกว่า​ทองคำ",
    "streamUrl": "fivefish.org/T3400",
    "trackDownloadUrl": "fivefish.org/T3400-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3400.zip",
    "programId": "3400",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jXlgt4hmHH8&list=PLd1Q7xMzP2jUf6fM8kO9_m0sbmv9nuOJm",
    "shareUrl": "5fi.sh/T3400",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Khmer.365.mp3",
    "stableKey": "Khmer"
  },
  {
    "id": 3590,
    "iso3": "KXM",
    "langId": "3450",
    "languageEn": "Khmer Thailand",
    "langTh": "เขมร ประเทศไทย",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 3:5-6 Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to Him, and He will make your paths straight.",
    "verse_th": "สุภาษิต 3:5-6 ให้​ไว้วางใจ​ใน​พระยาห์เวห์​ด้วย​สุดใจ​ของ​เจ้า และ​อย่า​ได้​พึ่ง​ความ​เข้าใจ​ของ​ตัว​เจ้า​เอง 6 ให้​เชื่อฟัง​พระองค์​ใน​ทุกหน​ทาง​ของ​เจ้า แล้ว​พระองค์​จะ​ทำ​ให้​เส้นทาง​ของ​เจ้า​ราบ​รื่น",
    "streamUrl": "fivefish.org/T3590",
    "trackDownloadUrl": "fivefish.org/T3590-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3590.zip",
    "programId": "3590",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WY8NMtZMkqs&list=PLho9cJoXqQC-sZPktvM_k5Z5YsqGiCqlM",
    "shareUrl": "5fi.sh/T3590",
    "duration": "29:30",
    "trackCount": "8.0",
    "sampleUrl": "/audio/Khmer.Thailand.3450.mp3",
    "stableKey": "Khmer Thailand"
  },
  {
    "id": 9371,
    "iso3": "KKH",
    "langId": "1152",
    "languageEn": "Khun",
    "langTh": "ขืน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 3:9-10 Honor the Lord with your wealth, with the first fruits of all your crops; then your barns will be filled to overflowing, and your vats will brim over with new wine.",
    "verse_th": "สุภาษิต 3:9-10 ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้ ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้แล้ว​ยุ้งฉาง​ของ​เจ้า​จะ​เต็มเปี่ยม​ไป​ด้วย​เมล็ดข้าว และ​ถัง​เหล้าองุ่น​ของ​เจ้า​ก็​จะ​เต็มล้น​ไปด้วย​เหล้าองุ่น​ใหม่",
    "streamUrl": "fivefish.org/T9371",
    "trackDownloadUrl": "fivefish.org/T9371-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9371.zip",
    "programId": "9371",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YaUfjNGkKhQ&list=PLbQkUFqMy6wqPL5FqJQMqjaWASqWYRc4q",
    "shareUrl": "5fi.sh/T9371",
    "duration": "21:03",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Khun.1152.mp3",
    "stableKey": "Khun"
  },
  {
    "id": 7581,
    "iso3": "KDT",
    "langId": "530",
    "languageEn": "Kuy",
    "langTh": "กูย",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 4:23 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สุภาษิต 4:23 ยิ่งกว่า​สิ่งใด ให้​เฝ้าระวัง​ใจ เพราะ​ใจ​เป็น​แหล่ง​ชีวิต",
    "streamUrl": "fivefish.org/T7581",
    "trackDownloadUrl": "fivefish.org/T7581-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/7581.zip",
    "programId": "7581",
    "languageVideoUrl": "https://www.youtube.com/watch?v=QCrR6Pdb2II&list=PLho9cJoXqQC_Uz3MRAoWz1Hjpgl6y-KWb",
    "shareUrl": "5fi.sh/T7581",
    "duration": "54:30",
    "trackCount": "16.0",
    "sampleUrl": "/audio/Kuy.530.mp3",
    "stableKey": "Kuy"
  },
  {
    "id": 32660,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "Christmas Readings & Songs",
    "title_th": "เรื่องราวคริสต์มาส & เพลง",
    "verse_en": "Isaiah 26:3 You will keep in perfect peace him whose mind is steadfast, because he trusts in You.",
    "verse_th": "อิสยาห์ 26:3 พระยาห์เวห์​เจ้าข้า พระองค์​ประทาน​สันติสุข​แท้จริง​ให้​กับ​ใจ​ที่พึ่งพิง​ในพระองค์นั้น เพราะ​พวกเขา​ไว้วางใจ​ในพระองค์",
    "streamUrl": "fivefish.org/T32660",
    "trackDownloadUrl": "fivefish.org/T32660-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32660.zip",
    "programId": "32660",
    "languageVideoUrl": "https://www.youtube.com/watch?v=X9GwPTHOiiA&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T32660",
    "duration": "43:01",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 63277,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Isaiah 40:31 But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.",
    "verse_th": "อิสยาห์ 40:31 แต่​คนเหล่านั้น​ที่​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์​จะ​มี​กำลัง​ขึ้นมาใหม่ และ​จะบิน​สูงขึ้นไป​เหมือน​ติดปีกนกอินทรี พวกเขา​จะ​วิ่ง​และ​จะ​ไม่หมดเรี่ยวแรง พวกเขา​จะ​เดิน​และ​จะ​ไม่เหนื่อย",
    "streamUrl": "fivefish.org/T63277",
    "trackDownloadUrl": "fivefish.org/T63277-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63277.zip",
    "programId": "63277",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nr7coCmPZAU&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T63277",
    "duration": "47:39",
    "trackCount": "43.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64244,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Isaiah 41:10 So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with My righteous hand.",
    "verse_th": "อิสยาห์ 41:10 ไม่ต้องกลัว เพราะ​เรา​อยู่​กับเจ้า อย่ากลัวเลย เพราะ​เรา​เป็น​พระเจ้า​ของเจ้า เรา​จะ​ทำให้​เจ้า​มีกำลัง ใช่แล้ว เรา​จะ​ช่วยเจ้า เรา​จะ​พยุงเจ้า​ด้วย​มือขวา​แห่ง​ชัยชนะ​ของเรา",
    "streamUrl": "fivefish.org/T64244",
    "trackDownloadUrl": "fivefish.org/T64244-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64244.zip",
    "programId": "64244",
    "languageVideoUrl": "https://www.youtube.com/watch?v=iElcSNuwG68&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64244",
    "duration": "37:32",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64245,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Isaiah 53:6 We all, like sheep, have gone astray, each of us has turned to his own way; and the Lord has laid on Him the iniquity of us all.",
    "verse_th": "อิสยาห์ 53:6 พวกเรา​ทุกคน​ได้​หลงหายไป​เหมือนแกะ พวกเรา​แต่ละคน​ต่าง​หลงไป​คนละทิศ​ละทาง แต่​พระยาห์เวห์​ปล่อย​ให้​ความผิด​ของ​พวกเรา​ทุกคน​โจมตีเขา",
    "streamUrl": "fivefish.org/T64245",
    "trackDownloadUrl": "fivefish.org/T64245-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64245.zip",
    "programId": "64245",
    "languageVideoUrl": "https://www.youtube.com/watch?v=oEM-ijoaz2E&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64245",
    "duration": "36:15",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64246,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Isaiah 6:8 Then I heard the voice of the Lord saying, Whom shall I send? And who will go for Us? And I said, Here am I. Send me!",
    "verse_th": "อิสยาห์ 6:8 และ​ผม​ก็​ได้ยิน​เสียง​ของ​องค์​เจ้า​ชีวิต​พูดว่า “เรา​จะ​ส่งใคร​ไปดี ใคร​จะไป​แทน​พวกเรา” แล้ว​ผม​ก็​ตอบว่า “ข้าพเจ้า​อยู่นี่ครับ ส่ง​ข้าพเจ้า​ไปเถิด”",
    "streamUrl": "fivefish.org/T64246",
    "trackDownloadUrl": "fivefish.org/T64246-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64246.zip",
    "programId": "64246",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Z3lmxq1SdhQ&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64246",
    "duration": "37:10",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64247,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Jeremiah 1:9 Then the LORD reached out His hand and touched my mouth and said to me, I have put My words in your mouth.",
    "verse_th": "เยเรมียาห์ 1:9 แล้ว​พระยาห์เวห์​ก็​ยื่น​มือ​ออกมา​แตะ​ปาก​ของผม และ​พระองค์​พูด​กับ​ผม​ว่า “เรา​ได้​ใส่​คำพูด​ของเรา​เข้าไป​ใน​ปาก​ของเจ้า​แล้ว",
    "streamUrl": "fivefish.org/T64247",
    "trackDownloadUrl": "fivefish.org/T64247-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64247.zip",
    "programId": "64247",
    "languageVideoUrl": "https://www.youtube.com/watch?v=y-eKZvumjd4&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64247",
    "duration": "35:42",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64248,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Jeremiah 29:13 You will seek Me and find Me when you seek Me with all your heart.",
    "verse_th": "เยเรมีย์ 29:13 เจ้า​จะ​แสวงหา​เรา แล้ว​เจ้า​ก็​จะ​พบ​เรา เมื่อ​เจ้า​แสวงหา​เรา​ด้วย​สิ้นสุดใจ​ของ​เจ้า",
    "streamUrl": "fivefish.org/T64248",
    "trackDownloadUrl": "fivefish.org/T64248-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64248.zip",
    "programId": "64248",
    "languageVideoUrl": "https://www.youtube.com/watch?v=GYb9wuT54lY&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64248",
    "duration": "36:59",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64249,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Lamentations 3:22-23 Because of the Lord’s great love, we are not consumed, for His compassions never fail. They are new every morning; great is Your faithfulness.",
    "verse_th": "บทเพลง​ร้องทุกข์ 3:22-23 แน่นอน ความรัก​ของ​พระยาห์เวห์​ไม่มี​วัน​สิ้นสุด แน่นอน ความเมตตา​ของ​พระองค์​ไม่มี​วัน​หมดสิ้น​ 23 ความรัก​และ​ความเมตตา​ของ​พระองค์​เริ่มต้นใหม่​ใน​ทุกๆ เช้า ความซื่อสัตย์​ของ​พระองค์​นั้น​ยิ่งใหญ่",
    "streamUrl": "fivefish.org/T64249",
    "trackDownloadUrl": "fivefish.org/T64249-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64249.zip",
    "programId": "64249",
    "languageVideoUrl": "https://www.youtube.com/watch?v=gujyOtpIhPc&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64249",
    "duration": "34:42",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64250,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Micah 6:8 He has shown you, O mortal, what is good. And what does the LORD require of you? To act justly and to love mercy and to walk humbly with your God.",
    "verse_th": "มีคาห์ 6:8 เจ้ามนุษย์ พระยาห์เวห์ บอก​เจ้า​แล้ว​ถึง​สิ่ง​ที่ดี และ​สิ่ง​ที่​พระองค์​ต้องการ​จาก​เจ้า คือ ให้​ทำ​สิ่ง​ที่​ยุติธรรม รัก​ความเมตตา และ​เดิน​กับ​พระเจ้า​ของ​เจ้า​ด้วย​ความถ่อมใจ",
    "streamUrl": "fivefish.org/T64250",
    "trackDownloadUrl": "fivefish.org/T64250-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64250.zip",
    "programId": "64250",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OG-oKfgVdxw&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64250",
    "duration": "36:26",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 64251,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Zechariah 7:9-10 “This is what the LORD Almighty said: ‘Administer true justice; show mercy and compassion to one another. Do not oppress the widow or the fatherless, the foreigner or the poor. Do not plot evil against each other.’",
    "verse_th": "เศคาริยาห์ 7:9-10 “นี่​คือ​สิ่ง​ที่​พระยาห์เวห์​ผู้มีฤทธิ์ทั้งสิ้น​พูด ‘ให้​ตัดสิน​อย่าง​ยุติธรรม ให้​มี​น้ำใจ​ต่อกัน​และ​เห็นอก​เห็นใจ​กัน อย่า​กดขี่​ข่มเหง​แม่หม้าย เด็ก​กำพร้า คนต่างชาติ หรือ​คนจน อย่า​วางแผนชั่ว​ในใจ​ต่อกัน’",
    "streamUrl": "fivefish.org/T64251",
    "trackDownloadUrl": "fivefish.org/T64251-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64251.zip",
    "programId": "64251",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XlqdX8gGi7E&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T64251",
    "duration": "33:55",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 6780,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Matthew 18:20 For where two or three come together in My name, there am I with them.",
    "verse_th": "มัทธิว 18:20 เพราะ​ที่​ไหน​ก็​ตาม ที่​มี​สอง​หรือ​สาม​คน​มา​อยู่​รวม​กัน​เพราะ​เป็น​ศิษย์​ของ​เรา เรา​ก็​จะ​อยู่​กับ​พวก​เขา​ที่​นั่น",
    "streamUrl": "fivefish.org/T6780",
    "trackDownloadUrl": "fivefish.org/T6780-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6780.zip",
    "programId": "6780",
    "languageVideoUrl": "https://www.youtube.com/watch?v=qNMmsuH3mjw&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T6780",
    "duration": "42:38",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 32651,
    "iso3": "LHU",
    "langId": "85",
    "languageEn": "Lahu Na",
    "langTh": "ลาหู่นา",
    "title_en": "Words of Life 3",
    "title_th": "พระคำแห่งชีวิต 3",
    "verse_en": "Matthew 19:26 Jesus looked at them and said, With man this is impossible, but with God all things are possible.",
    "verse_th": "มัทธิว 19:26 พระเยซู​มอง​พวก​ศิษย์​และ​พูด​ว่า “สำหรับ​มนุษย์ เป็น​ไป​ไม่​ได้​อยู่​แล้ว แต่​สำหรับ​พระเจ้า​ทุก​สิ่ง​ทุก​อย่าง​เป็น​ไป​ได้”",
    "streamUrl": "fivefish.org/T32651",
    "trackDownloadUrl": "fivefish.org/T32651-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32651.zip",
    "programId": "32651",
    "languageVideoUrl": "https://www.youtube.com/watch?v=aGetbjUA1fg&list=PLXcynA24_lTOrUEmUJQh7eG2Kjtv7p_3H",
    "shareUrl": "5fi.sh/T32651",
    "duration": "41:42",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lahu.Na.85.mp3",
    "stableKey": "Lahu Na"
  },
  {
    "id": 63278,
    "iso3": "LHU",
    "langId": "12683",
    "languageEn": "Lahu Shehleh",
    "langTh": "ลาหู่แซแล",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 28:19-20 Therefore, go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded you. And surely, I am with you always, to the very end of the age.",
    "verse_th": "มัทธิว 28:19-20 ดังนั้น​ให้​ออก​ไป​ทำ​ให้​คน​ทุก​ชาติ​มา​เป็น​ศิษย์​ของ​เรา ให้​เขา​เข้า​พิธี​จุ่มน้ำ เพื่อ​จะ​ได้​กลาย​เป็น​ของ​พระบิดา พระบุตร และ​พระวิญญาณ​บริสุทธิ์สอน​พวก​เขา​ให้​เชื่อฟัง​ทุก​สิ่ง​ที่​เรา​ได้​สั่ง​ไว้ จำ​ไว้​ว่า เรา​จะ​อยู่​กับ​พวก​คุณ​เสมอ จนกว่า​จะ​สิ้นยุค",
    "streamUrl": "fivefish.org/T63278",
    "trackDownloadUrl": "fivefish.org/T63278-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63278.zip",
    "programId": "63278",
    "languageVideoUrl": "https://www.youtube.com/watch?v=GvxRVipiuzI&list=PLXcynA24_lTNNaM66sfVG_aAqpQCyd0JO",
    "shareUrl": "5fi.sh/T63278",
    "duration": "56:45",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Lahu.Shehleh.12683.mp3",
    "stableKey": "Lahu Shehleh"
  },
  {
    "id": 62806,
    "iso3": "LHI",
    "langId": "20144",
    "languageEn": "Lahu Shi Barkeo",
    "langTh": "ลาหู่ชิ บาเกียว",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 4:19 “Come, follow Me,” Jesus said, “and I will make you fishers of men.”",
    "verse_th": "มัทธิว 4:19 พระองค์​พูด​กับ​เขา​ว่า “ตาม​เรา​มา​เถอะ เรา​จะ​สอน​ให้​จับ​คน​แทน​จับ​ปลา”",
    "streamUrl": "fivefish.org/T62806",
    "trackDownloadUrl": "fivefish.org/T62806-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62806.zip",
    "programId": "62806",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4Y5dGf9v_X4&list=PLXcynA24_lTMCs6JXmcZeE9WVLgE8SeSl",
    "shareUrl": "5fi.sh/T62806",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lahu.Shi.Barkeo.62806.mp3",
    "stableKey": "Lahu Shi Barkeo"
  },
  {
    "id": 6771,
    "iso3": "LHI",
    "langId": "565",
    "languageEn": "Lahu Yellow",
    "langTh": "ลาหู่เหลือง",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Matthew 4:4 Jesus answered, It is written: 'Man shall not live on bread alone, but on every word that comes from the mouth of God.'",
    "verse_th": "มัทธิว 4:4 พระเยซู​ตอบ​ว่า “พระคัมภีร์ เขียน​ไว้​ว่า ‘ชีวิต​ที่​เที่ยงแท้​ไม่​ได้​ขึ้น​อยู่​กับ​ขนมปัง​เพียง​อย่าง​เดียว แต่​อยู่​ได้​ด้วย​คำพูด​ทุก​คำ​ที่​มา​จาก​พระเจ้า’”",
    "streamUrl": "fivefish.org/T6771",
    "trackDownloadUrl": "fivefish.org/T6771-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6771.zip",
    "programId": "6771",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XsFwk8wtZL4&list=PLXcynA24_lTMZWwQke-RqftrmeT2-Kf8L",
    "shareUrl": "5fi.sh/T6771",
    "duration": "33:37",
    "trackCount": "10.0",
    "sampleUrl": "/audio/Lahu.Yellow.565.mp3",
    "stableKey": "Lahu Yellow"
  },
  {
    "id": 64576,
    "iso3": "LBN",
    "langId": "3120",
    "languageEn": "Lamet",
    "langTh": "ลาเม็ท",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 5:16 In the same way, let your light shine before men, that they may see your good deeds and praise your Father in heaven.",
    "verse_th": "มัทธิว 5:16 พวก​คุณ​ก็​เหมือน​กัน ให้​ส่อง​สว่าง​ออก​ไป​เพื่อ​คน​จะ​ได้​เห็น​ความ​ดี​ที่​คุณ​ทำ และ​จะ​ได้​สรรเสริญ​พระบิดา​ของ​คุณ​ที่​อยู่​บน​สวรรค์",
    "streamUrl": "fivefish.org/T64576",
    "trackDownloadUrl": "fivefish.org/T64576-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64576.zip",
    "programId": "64576",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WCuvjS_msdw&list=PLXduqvGi62csLUOP6OnHkofUHwWmR-K2y",
    "shareUrl": "5fi.sh/T64576",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lamet.64576.mp3",
    "stableKey": "Lamet"
  },
  {
    "id": 64623,
    "iso3": "LBN",
    "langId": "3120",
    "languageEn": "Lamet",
    "langTh": "ลาเม็ท",
    "title_en": "The Lost Son",
    "title_th": "บุตรน้อยหลงหาย",
    "verse_en": "Matthew 5:9 Blessed are the peacemakers, for they will be called children of God.",
    "verse_th": "มัทธิว 5:9 คน​ที่​สร้าง​สันติ มี​เกียรติ​จริงๆ เพราะ​พระเจ้า​จะ​เรียก​เขา​ว่า​เป็น​ลูก",
    "streamUrl": "fivefish.org/T64623",
    "trackDownloadUrl": "fivefish.org/T64623-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64623.zip",
    "programId": "64623",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lB4gYQ0Ul68&list=PLXduqvGi62csLUOP6OnHkofUHwWmR-K2y",
    "shareUrl": "5fi.sh/T64623",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lamet.3120.mp3",
    "stableKey": "Lamet"
  },
  {
    "id": 12600,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "Ballads",
    "title_th": "เพลง",
    "verse_en": "Matthew 6:33 But seek first His kingdom and His righteousness, and all these things will be given to you as well.",
    "verse_th": "มัทธิว 6:33 แต่​ให้​ดิ้นรน​หา​อาณาจักร​ของ​พระเจ้า​และ​ชีวิต​ที่​ทำ​ตามใจ​พระองค์​ก่อน แล้ว​พระองค์​จะ​ให้​สิ่ง​ที่​จำเป็น​ทั้งหมดนี้​กับ​พวก​คุณ​เอง",
    "streamUrl": "fivefish.org/T12600",
    "trackDownloadUrl": "fivefish.org/T12600-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/12600.zip",
    "programId": "12600",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4RsCGEvPst4&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T12600",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 14971,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "FEBC-Special 1",
    "title_th": "FEBC-พิเศษ 1",
    "verse_en": "Mark 10:45 For even the Son of Man did not come to be served, but to serve, and to give His life as ransom for many.",
    "verse_th": "มาระโก 10:45 เพราะ​แม้แต่​บุตร​มนุษย์ ก็​ยัง​ไม่​ได้​มา​เพื่อ​จะ​ให้​คน​อื่น​รับใช้ แต่​มา​เพื่อ​จะ​รับใช้​คน​อื่น และ​ยอม​สละ​ชีวิต​เพื่อ​ปลดปล่อย​ให้​คน​มากมาย​เป็น​อิสระ",
    "streamUrl": "fivefish.org/T14971",
    "trackDownloadUrl": "fivefish.org/T14971-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/14971.zip",
    "programId": "14971",
    "languageVideoUrl": "https://www.youtube.com/watch?v=i3hIQPlnzJA&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T14971",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 14960,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "FEBC-Special 2",
    "title_th": "FEBC-พิเศษ 2",
    "verse_en": "Mark 9:29 He replied, This kind can come out only by prayer.",
    "verse_th": "มาระโก 9:29 พระองค์​บอก​ว่า “มี​ทาง​เดียว​ที่​จะ​ไล่​ผี​ชั่ว​ชนิดนี้​ออก​ได้ คือ​ต้อง​อธิษฐาน”",
    "streamUrl": "fivefish.org/T14960",
    "trackDownloadUrl": "fivefish.org/T14960-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/14960.zip",
    "programId": "14960",
    "shareUrl": "5fi.sh/T14960",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 62857,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Luke 12:32 Do not be afraid, little flock, for your Father has been pleased to give you the kingdom.",
    "verse_th": "ลูกา 12:32 “ฝูง​แกะ​เล็กๆ​เอ๋ย ไม่​ต้อง​กลัว​นะ เพราะ​พระบิดา​ของ​คุณ​ยินดี​ที่​จะ​มอบ​อาณาจักร​ให้​กับ​คุณ",
    "streamUrl": "fivefish.org/T62857",
    "trackDownloadUrl": "fivefish.org/T62857-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62857.zip",
    "programId": "62857",
    "languageVideoUrl": "https://www.youtube.com/watch?v=dSwFRdQzlUs&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T62857",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 62858,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Luke 5:16 But Jesus often withdrew to lonely places and prayed.",
    "verse_th": "ลูกา 5:16 แต่​บ่อย​ครั้ง​ที่​พระเยซู​หลบ​ไป​ที่​สงบเงียบ​เพื่อ​อธิษฐาน",
    "streamUrl": "fivefish.org/T62858",
    "trackDownloadUrl": "fivefish.org/T62858-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62858.zip",
    "programId": "62858",
    "languageVideoUrl": "https://www.youtube.com/watch?v=AopLVAK3WEc&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T62858",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.62858.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 34010,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Luke 6:42 How can you say to your brother, 'Brother, let me take the speck out of your eye,' when you yourself fail to see the plank in your own eye? You hypocrite, first take the plank out of your eye, and then you will see clearly to remove the speck from your brother's eye.",
    "verse_th": "ลูกา 6:42 แล้ว​คุณ​พูด​กับ​พี่น้อง​ออก​มา​ได้​ยังไง​ว่า ‘เดี๋ยว​ผม​จะ​เขี่ย​ขี้ผง​ใน​ตา​ให้​นะ’ ทั้งๆที่​ซุง​ทั้ง​ท่อน​ใน​ตา​ตัวเอง​ก็​ยัง​มอง​ไม่​เห็น ไอ้​หน้าซื่อใจคด เอา​ท่อน​ซุง​ออก​จาก​ตา​ของ​ตัวเอง​ก่อน แล้ว​จะ​ได้​มอง​เห็น​ชัดๆ​ตอน​เขี่ย​ขี้ผง​ออก​จาก​ตา​ของ​พี่น้อง",
    "streamUrl": "fivefish.org/T34010",
    "trackDownloadUrl": "fivefish.org/T34010-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34010.zip",
    "programId": "34010",
    "languageVideoUrl": "https://www.youtube.com/watch?v=AHVEDXgxrqM&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T34010",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 34011,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "Luke 9:23 Then He said to them all, “If anyone would come after Me, he must deny himself and take up the cross daily and follow Me.”",
    "verse_th": "ลูกา 9:23 แล้ว​พระองค์​ก็​พูด​กับ​ทุก​คน​ว่า “ถ้า​ใคร​อยาก​จะ​ติดตาม​เรา ต้อง​เลิก​ตามใจ​ตัวเอง แล้ว​แบก​ไม้กางเขน​ของ​ตัวเอง​ตาม​เรา​ทุกๆ​วัน”",
    "streamUrl": "fivefish.org/T34011",
    "trackDownloadUrl": "fivefish.org/T34011-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34011.zip",
    "programId": "34011",
    "shareUrl": "5fi.sh/T34011",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 74991,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "Songs - Christian",
    "title_th": "เพลง – คริสเตียน",
    "verse_en": "John 1:12 Yet to all who received Him to those who believed in His name, He gave the right to become children of God.",
    "verse_th": "ยอห์น 1:12 แต่​ส่วน​คน​ที่​ยอมรับ​และ​ไว้วางใจ​พระองค์ พระองค์​ให้​สิทธิ์​พวก​เขา​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T74991",
    "trackDownloadUrl": "fivefish.org/T74991-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74991.zip",
    "programId": "74991",
    "languageVideoUrl": "https://www.youtube.com/watch?v=dUDKGFpC_vA&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T74991",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 2721,
    "iso3": "LAO",
    "langId": "999",
    "languageEn": "Lao",
    "langTh": "ลาว",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "John 10:14-15 I am the good shepherd; I know My sheep and My sheep know Me—just as the Father knows Me and I know the Father—and I lay down My life for the sheep.",
    "verse_th": "ยอห์น 10:14-15 เรา​เป็น​คน​เลี้ยง​แกะ​ที่​ดี เรา​รู้จัก​แกะ​ของ​เรา และ​แกะ​ก็​รู้จัก​เรา​ด้วย เหมือน​กับ​ที่​พระบิดา​รู้จัก​เรา​และ​เรา​ก็​รู้จัก​พระบิดา เรา​สละ​ชีวิต​ของ​เรา​เพื่อ​รักษา​แกะ​ของ​เรา​ให้​รอด",
    "streamUrl": "fivefish.org/T2721",
    "trackDownloadUrl": "fivefish.org/T2721-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2721.zip",
    "programId": "2721",
    "languageVideoUrl": "https://www.youtube.com/watch?v=JwOyjILT5hg&list=PLXduqvGi62cvaICxrXWem0TZ4w2tvR0F7",
    "shareUrl": "5fi.sh/T2721",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lao.999.mp3",
    "stableKey": "Lao"
  },
  {
    "id": 34271,
    "iso3": "SOA",
    "langId": "16824",
    "languageEn": "Lao Song Dam",
    "langTh": "ลาวโซ่งดำ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "John 10:27 My sheep listen to My voice; I know them, and they follow Me.",
    "verse_th": "ยอห์น 10:27 แกะ​ของ​เรา​จะ​ฟัง​เสียง​เรา และ​เรา​ก็​รู้จัก​แกะ​ของ​เรา และ​แกะ​ของ​เรา​จะ​ตาม​เรา​ไป",
    "streamUrl": "fivefish.org/T34271",
    "trackDownloadUrl": "fivefish.org/T34271-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34271.zip",
    "programId": "34271",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kaEhPdZzU2s&list=PLho9cJoXqQC831cwsY0kdD6Yu4RA8p1Ij",
    "shareUrl": "5fi.sh/T34271",
    "duration": "50:23",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Lao.Song.Dam.34271.mp3",
    "stableKey": "Lao Song Dam"
  },
  {
    "id": 34270,
    "iso3": "SOA",
    "langId": "16824",
    "languageEn": "Lao Song Dam",
    "langTh": "ลาวโซ่งดำ",
    "title_en": "Testimonies & Songs",
    "title_th": "คำพยาน & เพลง",
    "verse_en": "John 13:34 A new command I give you: Love one another. As I have loved you, so you must love one another.",
    "verse_th": "ยอห์น 13:34 เรา​จะ​ให้​คำสั่ง​ใหม่​กับ​พวก​คุณ คือ​ให้​รัก​ซึ่ง​กัน​และ​กัน พวก​คุณ​ต้อง​รัก​กัน​เหมือน​กับ​ที่​เรา​รัก​คุณ",
    "streamUrl": "fivefish.org/T34270",
    "trackDownloadUrl": "fivefish.org/T34270-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34270.zip",
    "programId": "34270",
    "languageVideoUrl": "https://www.youtube.com/watch?v=u1DJUXabDD8&list=PLho9cJoXqQC831cwsY0kdD6Yu4RA8p1Ij",
    "shareUrl": "5fi.sh/T34270",
    "duration": "38:45",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Lao.Song.Dam.16824.mp3",
    "stableKey": "Lao Song Dam"
  },
  {
    "id": 35532,
    "iso3": "SOA",
    "langId": "16824",
    "languageEn": "Lao Song Dam",
    "langTh": "ลาวโซ่งดำ",
    "title_en": "Words of Life & Story of Joseph",
    "title_th": "พระคำแห่งชีวิต & เรื่องราวของโยเซฟ",
    "verse_en": "John 13:35 By this everyone will know that you are My disciples, if you love one another.",
    "verse_th": "ยอห์น 13:35 ถ้า​พวก​คุณ​รัก​กัน ทุก​คน​ก็​จะ​รู้​ว่า​คุณ​เป็น​ศิษย์​ของ​เรา",
    "streamUrl": "fivefish.org/T35532",
    "trackDownloadUrl": "fivefish.org/T35532-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35532.zip",
    "programId": "35532",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OltoQYXTgyY&list=PLho9cJoXqQC831cwsY0kdD6Yu4RA8p1Ij",
    "shareUrl": "5fi.sh/T35532",
    "duration": "35:25",
    "trackCount": "9.0",
    "sampleUrl": "/audio/Lao.Song.Dam.16824.mp3",
    "stableKey": "Lao Song Dam"
  },
  {
    "id": 18020,
    "iso3": "LCP",
    "langId": "3124",
    "languageEn": "Lawa Ban Dong",
    "langTh": "ละว้าบ้านดง",
    "title_en": "Jesus, The Living Water",
    "title_th": "พระเยซูผู้ทรงเป็นน้ำแห่งชีวิต",
    "verse_en": "John 14:21 Whoever has My commands and obeys them, he is the one who loves Me. He who loves Me will be loved by My Father, and I too will love him and show Myself to him.",
    "verse_th": "ยอห์น 14:21 คน​ที่​รู้จัก​คำ​สั่งสอน​ของ​เรา​และ​ทำ​ตาม​ก็​เป็น​คน​ที่​รัก​เรา พระบิดา​จะ​รัก​คน​ที่​รัก​เรา​ด้วย เรา​ก็​จะ​รัก​พวก​เขา​และ​จะ​ปรากฏ​ตัว​ให้​พวก​เขา​เห็น",
    "streamUrl": "fivefish.org/T18020",
    "trackDownloadUrl": "fivefish.org/T18020-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18020.zip",
    "programId": "18020",
    "languageVideoUrl": "https://www.youtube.com/watch?v=VNEihlOpVWY&list=PLho9cJoXqQC8t0ZUiHcdgBr4YfAktbmBl",
    "shareUrl": "5fi.sh/T18020",
    "duration": "7:00",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.Ban.Dong.18020.mp3",
    "stableKey": "Lawa Ban Dong"
  },
  {
    "id": 18021,
    "iso3": "LCP",
    "langId": "3125",
    "languageEn": "Lawa Ban Sam",
    "langTh": "ละว้าบ้านสาม",
    "title_en": "Christ & His Resurrection",
    "title_th": "การฟื้นคืนพระชนม์ของพระเยซูคริสต์",
    "verse_en": "John 14:27 Peace I leave with you; My peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid.",
    "verse_th": "ยอห์น 14:27 เรา​ได้​ให้​สันติสุข​ไว้​กับ​คุณ สันติสุข​ที่​เรา​ให้​นี้​ไม่​เหมือน​กับ​ที่​โลก​ให้ ดังนั้น​คุณ​จึง​ไม่​ต้อง​ทุกข์ใจ หรือ​หวาดกลัว​เลย",
    "streamUrl": "fivefish.org/T18021",
    "trackDownloadUrl": "fivefish.org/T18021-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18021.zip",
    "programId": "18021",
    "languageVideoUrl": "https://www.youtube.com/watch?v=l5ZS05KHUyA&list=PLho9cJoXqQC9MFULrVZYOggft3tmJhH-u",
    "shareUrl": "5fi.sh/T18021",
    "duration": "6:47",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.Ban.Sam.18021.mp3",
    "stableKey": "Lawa Ban Sam"
  },
  {
    "id": 18030,
    "iso3": "LCP",
    "langId": "2187",
    "languageEn": "Lawa Chang Maw",
    "langTh": "ละว้าช่างหม้อ",
    "title_en": "Following Jesus",
    "title_th": "ติดตามพระเยซู",
    "verse_en": "John 14:6 Jesus answered, I am the way and the truth and the life. No one comes to the Father except through Me.",
    "verse_th": "ยอห์น 14:6 พระเยซู​บอก​ว่า เรา​เป็น​ทาง​นั้น เป็น​ความจริง​และ​เป็น​ชีวิต ไม่​มี​ใคร​ไป​ถึง​พระบิดา​ได้​นอก​จาก​มา​ทาง​เรา",
    "streamUrl": "fivefish.org/T18030",
    "trackDownloadUrl": "fivefish.org/T18030-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18030.zip",
    "programId": "18030",
    "languageVideoUrl": "https://www.youtube.com/watch?v=HQgbqjG5-s4&list=PLho9cJoXqQC-yMFxE9GvSFxr50navXAN6",
    "shareUrl": "5fi.sh/T18030",
    "duration": "13:01",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.Chang.Maw.18030.mp3",
    "stableKey": "Lawa Chang Maw"
  },
  {
    "id": 18031,
    "iso3": "LCP",
    "langId": "2404",
    "languageEn": "Lawa Kawng Lawi",
    "langTh": "ละว้ากองลอย",
    "title_en": "God Cares for You",
    "title_th": "พระเจ้าทรงห่วงใยคุณ",
    "verse_en": "John 15:7 If you remain in Me and My Words remain in you, ask whatever you wish, and it will be given you.",
    "verse_th": "ยอห์น 15:7 ถ้า​พวก​คุณ​ติด​สนิท​กับ​เรา และ​คำ​สั่งสอน​ของ​เรา​ติด​สนิท​กับ​คุณ ไม่ว่า​คุณ​จะ​ขอ​อะไร​มัน​ก็​จะ​เป็น​อย่าง​นั้น",
    "streamUrl": "fivefish.org/T18031",
    "trackDownloadUrl": "fivefish.org/T18031-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18031.zip",
    "programId": "18031",
    "languageVideoUrl": "https://www.youtube.com/watch?v=d_8iRXaatA8&list=PLho9cJoXqQC8lbbOjGetyNgZ7X5oHuOny",
    "shareUrl": "5fi.sh/T18031",
    "duration": "27:20",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.Kawng.Lawi.18031.mp3",
    "stableKey": "Lawa Kawng Lawi"
  },
  {
    "id": 17990,
    "iso3": "LCP",
    "langId": "1154",
    "languageEn": "Lawa La-oop",
    "langTh": "ละว้าละอุบ",
    "title_en": "What the Christian Believes",
    "title_th": "คริสเตียนเชื่ออะไร",
    "verse_en": "John 5:24 I tell you the truth, whoever hears My Word and believes Him who sent Me has eternal life and will not be condemned; he has crossed over from death to life.",
    "verse_th": "ยอห์น 5:24 เรา​จะ​บอก​ให้​รู้​ว่า คน​ที่​ฟัง​คำพูด​เรา​และ​ไว้วางใจ​พระองค์​ผู้​ส่ง​เรา​มา ก็​มี​ชีวิต​กับ​พระเจ้า​ตลอด​ไป และ​เขา​จะ​ไม่​ถูก​ตัดสินลงโทษ เขา​ได้​ผ่านพ้น​ความตาย​ไป​สู่​ชีวิต​แล้ว",
    "streamUrl": "fivefish.org/T17990",
    "trackDownloadUrl": "fivefish.org/T17990-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/17990.zip",
    "programId": "17990",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Ac6ag3uwsyQ&list=PLho9cJoXqQC9pq_AEx7xrCMmXH1mSpe7l",
    "shareUrl": "5fi.sh/T17990",
    "duration": "53:55",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.La-oop.17990.mp3",
    "stableKey": "Lawa La-oop"
  },
  {
    "id": 18010,
    "iso3": "LWL",
    "langId": "2188",
    "languageEn": "Lawa Northern",
    "langTh": "ละว้าเหนือ",
    "title_en": "Jesus, Stronger Than Satan",
    "title_th": "พระเยซูมีอำนาจเหนือซาตาน",
    "verse_en": "Acts 1:8 But you will receive power when the Holy Spirit comes on you; and you will be My witnesses in Jerusalem, and in all Judea and Samaria, and to the ends of the earth.",
    "verse_th": "กิจการ 1:8 เมื่อ​พระวิญญาณ​บริสุทธิ์​มา​อยู่​กับ​พวกคุณ พวก​คุณ​ก็​จะ​ได้รับ​ฤทธิ์เดช และ​จะ​เป็น​พยาน​เล่า​เรื่อง​ของ​เรา​ให้​คน​ฟัง ทั่ว​เมือง​เยรูซาเล็ม ใน​แคว้น​ยูเดีย ใน​แคว้น​สะมาเรีย และ​ทุก​หน​แห่ง​ใน​โลกนี้",
    "streamUrl": "fivefish.org/T18010",
    "trackDownloadUrl": "fivefish.org/T18010-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18010.zip",
    "programId": "18010",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YH-sQtfRYcI&list=PLho9cJoXqQC_zqvdvKVWpjIN_Rbt-xMnP",
    "shareUrl": "5fi.sh/T18010",
    "duration": "7:38",
    "trackCount": "1.0",
    "sampleUrl": "/audio/Lawa.Northern.18010.mp3",
    "stableKey": "Lawa Northern"
  },
  {
    "id": 18011,
    "iso3": "LWL",
    "langId": "3126",
    "languageEn": "Lawa Papae",
    "langTh": "ละว้าป่าแป๋",
    "title_en": "Freedom in Christ",
    "title_th": "เสรีภาพในพระคริสต์",
    "verse_en": "Acts 24:16 So I strive always to keep my conscience clear before God and man.",
    "verse_th": "กิจการ 24:16 ผม​จึง​พยายาม​ทำ​ดี​ที่สุด เพื่อ​จะ​ได้​มี​จิต​สำนึก​ที่​ถูกต้อง​ต่อหน้า​พระเจ้า​และ​มนุษย์​ทุก​คน",
    "streamUrl": "fivefish.org/T18011",
    "trackDownloadUrl": "fivefish.org/T18011-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18011.zip",
    "programId": "18011",
    "languageVideoUrl": "https://www.youtube.com/watch?v=HlECt9ilxYM&list=PLho9cJoXqQC9CSOnX0spnxqzRU-AljCLf",
    "shareUrl": "5fi.sh/T18011",
    "duration": "7:13",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lawa.Papae.18011.mp3",
    "stableKey": "Lawa Papae"
  },
  {
    "id": 32610,
    "iso3": "LIS",
    "langId": "13005",
    "languageEn": "Lisu Northern",
    "langTh": "ลีซูเหนือ",
    "title_en": "Songs & Messages",
    "title_th": "เพลงและคำสอน",
    "verse_en": "Acts 4:12 Salvation is found in no one else, for there is no other Name under heaven given to mankind by which we must be saved.",
    "verse_th": "กิจการ 4:12 นอกจาก​พระเยซู​แล้ว ไม่​มี​ใคร​ที่​จะ​ให้​ความ​รอด​กับ​เรา​ได้ ไม่​มี​ชื่อ​อื่น​ภายใต้​ฟ้านี้ ที่​จะ​ทำ​ให้​มนุษย์​รอด​ได้",
    "streamUrl": "fivefish.org/T32610",
    "trackDownloadUrl": "fivefish.org/T32610-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32610.zip",
    "programId": "32610",
    "languageVideoUrl": "https://www.youtube.com/watch?v=l07L3Tn92Uk&list=PLXcynA24_lTPtEdgCLnyyZC-Hz9-x4TNH",
    "shareUrl": "5fi.sh/T32610",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lisu.Northern.13005.mp3",
    "stableKey": "Lisu Northern"
  },
  {
    "id": 80711,
    "iso3": "LIS",
    "langId": "482",
    "languageEn": "Lisu Southern",
    "langTh": "ลีซูใต้",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Acts 4:13 When they saw the courage of Peter and John and realized that they were unschooled, ordinary men, they were astonished and they took note that these men had been with Jesus.",
    "verse_th": "กิจการ 4:13 เมื่อ​พวก​ผู้นำ​ชาว​ยิว​เห็น​ถึง​ความ​กล้าหาญ​ของ​เปโตร​กับ​ยอห์น และ​เห็น​ว่า​ทั้ง​สอง​เป็น​แค่​คน​ธรรมดาๆ​ที่​ไม่​ได้รับ​การ​ศึกษา​หรือ​ฝึกฝน​อะไร​มา​เป็น​พิเศษ พวก​เขา​ก็​ยิ่ง​แปลกใจ พวก​เขา​ต่าง​ก็​นึก​ขึ้น​มา​ได้​ว่า เปโตร​และ​ยอห์น​เคย​อยู่​กับ​พระเยซู​มา​ก่อน",
    "streamUrl": "fivefish.org/T80711",
    "trackDownloadUrl": "fivefish.org/T80711-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80711.zip",
    "programId": "80711",
    "languageVideoUrl": "https://www.youtube.com/watch?v=whB1GWczplU&list=PLXcynA24_lTNIdhVm2gflBgf6_FBFZvsE",
    "shareUrl": "5fi.sh/T80711",
    "duration": "56:02",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Lisu.Southern.80711.mp3",
    "stableKey": "Lisu Southern"
  },
  {
    "id": 80722,
    "iso3": "LIS",
    "langId": "482",
    "languageEn": "Lisu Southern",
    "langTh": "ลีซูใต้",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Romans 1:16 I am not ashamed of the Gospel, because it is the power of God for the salvation of everyone who believes: first for the Jew, then for the Gentile.",
    "verse_th": "โรม 1:16 ผม​ไม่​ละอาย​เกี่ยวกับ​ข่าวดีนี้​หรอก เพราะ​ข่าวดีนี้​เป็น​ฤทธิ์เดช​ของ​พระเจ้า​ที่​จะ​ช่วย​ชีวิต​ทุก​คน​ที่​ไว้วางใจ​ให้​รอด ช่วย​พวกยิว​ก่อน แล้ว​ต่อมา​ก็​ช่วย​คน​ที่​ไม่​ใช่​ยิว​ด้วย",
    "streamUrl": "fivefish.org/T80722",
    "trackDownloadUrl": "fivefish.org/T80722-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80722.zip",
    "programId": "80722",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1pL8Ax7glyI&list=PLXcynA24_lTNIdhVm2gflBgf6_FBFZvsE",
    "shareUrl": "5fi.sh/T80722",
    "duration": "54:29",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lisu.Southern.482.mp3",
    "stableKey": "Lisu Southern"
  },
  {
    "id": 80721,
    "iso3": "LIS",
    "langId": "482",
    "languageEn": "Lisu Southern",
    "langTh": "ลีซูใต้",
    "title_en": "Songs",
    "title_th": "เพลง",
    "verse_en": "Romans 12:1 Therefore, I urge you brothers, in view of God’s mercy, to offer your bodies as living sacrifices, holy and pleasing to God-this is your spiritual act of worship.",
    "verse_th": "โรม 12:1 ดังนั้น​พี่น้อง​ครับ พระเจ้า​ได้​เมตตากรุณา​ต่อ​เรา ผม​ก็​เลย​ขอ​ร้อง​ให้​คุณ​มอบ​ร่างกาย​ของ​คุณ​เป็น​เครื่อง​บูชา​ที่​มี​ชีวิต​อยู่ เป็น​เครื่อง​บูชา​ที่​บริสุทธิ์ และ​เป็น​ที่​พอใจ​ของ​พระเจ้า การ​",
    "streamUrl": "fivefish.org/T80721",
    "trackDownloadUrl": "fivefish.org/T80721-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80721.zip",
    "programId": "80721",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wqyysrFwojE&list=PLXcynA24_lTNIdhVm2gflBgf6_FBFZvsE",
    "shareUrl": "5fi.sh/T80721",
    "duration": "37:41",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lisu.Southern.482.mp3",
    "stableKey": "Lisu Southern"
  },
  {
    "id": 5820,
    "iso3": "LIS",
    "langId": "482",
    "languageEn": "Lisu Southern",
    "langTh": "ลีซูใต้",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Romans 12:2 Do not conform any longer to the pattern of this world but be transformed by the renewing of your mind. Then you will be able to test and approve what God’s will is - His good, pleasing and perfect will.",
    "verse_th": "โรม 12:2 อย่า​ทำ​ตาม​อย่าง​คน​ใน​โลกนี้ แต่​ขอ​ยอม​ให้​พระเจ้า​เปลี่ยน​แปลง​คุณ คือ​พระองค์​จะ​ให้​จิตใจ​ใหม่​กับ​คุณ​เพื่อ​จะ​ได้​รู้​ว่า​พระเจ้า​ต้อง​การ​อะไร สิ่ง​ไหน​ดี สิ่ง​ไหน​พระองค์​ชอบใจ และ​สิ่ง​ไหน​สมบูรณ์แบบ",
    "streamUrl": "fivefish.org/T5820",
    "trackDownloadUrl": "fivefish.org/T5820-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/5820.zip",
    "programId": "5820",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3AsedcKWkgY&list=PLXcynA24_lTNIdhVm2gflBgf6_FBFZvsE",
    "shareUrl": "5fi.sh/T5820",
    "duration": "50:55",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lisu.Southern.482.mp3",
    "stableKey": "Lisu Southern"
  },
  {
    "id": 27160,
    "iso3": "LIS",
    "langId": "482",
    "languageEn": "Lisu Southern",
    "langTh": "ลีซูใต้",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Romans 12:9 Love must be sincere. Hate what is evil; cling to what is good.",
    "verse_th": "โรม 12:9 ให้​รัก​คน​อื่น​ด้วย​ความ​จริงใจ เกลียด​สิ่ง​ชั่วร้าย ยึด​มั่น​สิ่ง​ที่​ดี",
    "streamUrl": "fivefish.org/T27160",
    "trackDownloadUrl": "fivefish.org/T27160-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27160.zip",
    "programId": "27160",
    "languageVideoUrl": "https://www.youtube.com/watch?v=_ysTDmqLK1k&list=PLXcynA24_lTNIdhVm2gflBgf6_FBFZvsE",
    "shareUrl": "5fi.sh/T27160",
    "duration": "62:17",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Lisu.Southern.482.mp3",
    "stableKey": "Lisu Southern"
  },
  {
    "id": 80831,
    "iso3": "LIS",
    "langId": "5143",
    "languageEn": "Lisu White",
    "langTh": "ลีซูขาว",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T80831",
    "trackDownloadUrl": "fivefish.org/T80831-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80831.zip",
    "programId": "80831",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PBkpEgWdJGQ&list=PLXcynA24_lTOj84v8HfhpjJIZE6fsNlm9",
    "shareUrl": "5fi.sh/T80831",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lisu.White.80831.mp3",
    "stableKey": "Lisu White"
  },
  {
    "id": 9311,
    "iso3": "KHB",
    "langId": "1147",
    "languageEn": "Lu",
    "langTh": "ลู",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T9311",
    "trackDownloadUrl": "fivefish.org/T9311-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9311.zip",
    "programId": "9311",
    "languageVideoUrl": "https://www.youtube.com/watch?v=M_H4YEdInAI&list=PLXcynA24_lTOQ_7_SHayl8SKVJ-awvMpE",
    "shareUrl": "5fi.sh/T9311",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Lu.1147.mp3",
    "stableKey": "Lu"
  },
  {
    "id": 3841,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Songs",
    "title_th": "เพลง",
    "verse_en": "Romans 3:23 For all have sinned and fall short of the glory of God.",
    "verse_th": "โรม 3:23 เพราะ​ทุก​คน​ทำ​บาป​เหมือน​กัน​หมด และ​เสื่อม​จาก​พระบารมี​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T3841",
    "trackDownloadUrl": "fivefish.org/T3841-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3841.zip",
    "programId": "3841",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NOdHMCYS9yw&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T3841",
    "duration": "58:53",
    "trackCount": "43.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 26111,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 01",
    "title_th": "พระคำแห่งชีวิต 01",
    "verse_en": "Romans 4:20-21 Yet he did not waver through unbelief regarding the promise of God, but was strengthened in his faith and gave glory to God, being fully persuaded that God had power to do what He had promised.",
    "verse_th": "โรม 4:20-21 แต่​อับราฮัม​ไม่​เคย​สงสัย​ใน​คำ​สัญญา​ของ​พระเจ้า​เลย กลับ​มี​ความ​ไว้วางใจ​มาก​ขึ้น ซึ่ง​เป็น​การ​ให้​เกียรติ​กับ​พระเจ้า 21 อับราฮัม​เชื่อ​อย่าง​แน่ว​แน่​ว่า พระเจ้า​สามารถ​ทำ​ใน​สิ่ง​ที่​พระองค์​ได้​สัญญา​ไว้",
    "streamUrl": "fivefish.org/T26111",
    "trackDownloadUrl": "fivefish.org/T26111-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/26111.zip",
    "programId": "26111",
    "languageVideoUrl": "https://www.youtube.com/watch?v=pBLtLkg54Ao&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T26111",
    "duration": "62:31",
    "trackCount": "1.0",
    "sampleUrl": "/audio/Malay.Pattani.26111.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27211,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 02",
    "title_th": "พระคำแห่งชีวิต 02",
    "verse_en": "Romans 5:5 And hope does not put us to shame, because God’s love has been poured out into our hearts through the Holy Spirit, Who has been given to us.",
    "verse_th": "โรม 5:5 ความหวัง​นั้น​ไม่​เคย​ทำ​ให้​เรา​ผิดหวัง​เลย เพราะ​พระเจ้า​ได้​เท​ความรัก​ของ​พระองค์​เข้า​มา​ใน​จิตใจ​ของ​เรา ผ่าน​ทาง​พระวิญญาณ​บริสุทธิ์​ที่​พระองค์​ได้​ให้​กับ​เรา​ไว้",
    "streamUrl": "fivefish.org/T27211",
    "trackDownloadUrl": "fivefish.org/T27211-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27211.zip",
    "programId": "27211",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3bmDD2gjKic&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27211",
    "duration": "57:35",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27220,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 03",
    "title_th": "พระคำแห่งชีวิต 03",
    "verse_en": "Romans 5:8 But God demonstrates His own love for us in this: While we were still sinners, Christ died for us.",
    "verse_th": "โรม 5:8 แต่​พระเจ้า​ได้​แสดง​ความรัก​ต่อ​เรา โดย​ยอม​ส่ง​พระคริสต์​มา​ตาย​เพื่อ​เรา ทั้งๆ​ที่​เรา​ยัง​เป็น​คน​บาป​อยู่",
    "streamUrl": "fivefish.org/T27220",
    "trackDownloadUrl": "fivefish.org/T27220-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27220.zip",
    "programId": "27220",
    "languageVideoUrl": "https://www.youtube.com/watch?v=9eJ7y5mo9JI&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27220",
    "duration": "57:32",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27221,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 04",
    "title_th": "พระคำแห่งชีวิต 04",
    "verse_en": "Romans 6:23 For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
    "verse_th": "โรม 6:23 เพราะ​ค่าจ้าง​ที่​ความบาป​จ่าย​ให้​กับ​เรา​คือ​ความตาย แต่​ของขวัญ​ที่​พระเจ้า​ให้​กับ​เรา​นั้น​คือ​ชีวิต​ที่​อยู่​กับ​พระเจ้า​ตลอด​ไป ใน​พระเยซู​คริสต์เจ้า​ของ​เรา",
    "streamUrl": "fivefish.org/T27221",
    "trackDownloadUrl": "fivefish.org/T27221-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27221.zip",
    "programId": "27221",
    "languageVideoUrl": "https://www.youtube.com/watch?v=fGSeouuU748&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27221",
    "duration": "60:03",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27230,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 05",
    "title_th": "พระคำแห่งชีวิต 05",
    "verse_en": "Romans 8:32 He who did not spare His own Son, but gave Him up for us all-how will He not also, along with Him, graciously give us all things?",
    "verse_th": "โรม 8:32 พระองค์​ไม่​หวง​แม้แต่​พระบุตร​ของ​พระองค์​เอง แต่​กลับ​มอบ​พระบุตร​นั้น​ให้​มา​ตาย​เพื่อ​เรา​ทุก​คน ถ้า​อย่าง​นั้น​พระองค์​จะ​ไม่​ยิ่ง​ให้​ทุก​สิ่ง​ทุก​อย่าง​กับ​เรา​พร้อม​กับ​พระบุตร​ด้วย​หรือ",
    "streamUrl": "fivefish.org/T27230",
    "trackDownloadUrl": "fivefish.org/T27230-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27230.zip",
    "programId": "27230",
    "languageVideoUrl": "https://www.youtube.com/watch?v=qoIiIXUxPMs&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27230",
    "duration": "58:28",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27231,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 06",
    "title_th": "พระคำแห่งชีวิต 06",
    "verse_en": "1 Corinthians 14:33 For God is not a God of disorder but of peace - as in all the congregations of the Lord's people.",
    "verse_th": "1 โครินธ์ 14:33 เพราะ​พระเจ้า​ไม่​ได้​เป็น​พระเจ้า​แห่ง​ความ​วุ่นวาย แต่​เป็น​พระเจ้า​แห่ง​สันติสุข เหมือน​กับ​ที่​พระองค์​เป็น​ใน​ที่ประชุม​ทุก​แห่ง​ของ​คน​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T27231",
    "trackDownloadUrl": "fivefish.org/T27231-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27231.zip",
    "programId": "27231",
    "languageVideoUrl": "https://www.youtube.com/watch?v=0GfQxpZHpVY&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27231",
    "duration": "60:00",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 27240,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 07",
    "title_th": "พระคำแห่งชีวิต 07",
    "verse_en": "1 Corinthians 14:40 But everything should be done in a fitting and orderly way.",
    "verse_th": "1 โครินธ์ 14:40 แต่​ให้​ทำ​ทุก​อย่างนี้ อย่าง​เหมาะสม​และ​เป็น​ระเบียบ",
    "streamUrl": "fivefish.org/T27240",
    "trackDownloadUrl": "fivefish.org/T27240-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27240.zip",
    "programId": "27240",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6CyITCG-8Cg&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T27240",
    "duration": "58:14",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78071,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 08 - Why Jesus Died",
    "title_th": "พระคำแห่งชีวิต 08 - ทำไมพระเยซูจึงต้องตาย",
    "verse_en": "1 Corinthians 15:58 Therefore, my dear brothers, stand firm. Let nothing move you. Always give yourselves fully to the work of the Lord, because you know that your labor in the Lord is not in vain.",
    "verse_th": "1 โครินธ์ 15:58 ดังนั้น พี่น้อง​ที่รัก ให้​มั่นคง อย่า​หวั่นไหว และ​ให้​ทุ่มเท​กับ​งาน​ของ​องค์​เจ้า​ชีวิต​ตลอด​เวลา เพราะ​คุณ​ก็​รู้​ว่า​จะ​ได้รับ​รางวัล​สำหรับ​งาน​หนัก​ที่​คุณ​ทำ​เพื่อ​องค์​เจ้า​ชีวิต​นั้น​แน่",
    "streamUrl": "fivefish.org/T78071",
    "trackDownloadUrl": "fivefish.org/T78071-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78071.zip",
    "programId": "78071",
    "languageVideoUrl": "https://www.youtube.com/watch?v=V2Dm9sFGDGQ&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78071",
    "duration": "60:54",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78072,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 09 - Fear of Evil Spirits",
    "title_th": "พระคำแห่งชีวิต 09 - กลัววิญญาณชั่ว",
    "verse_en": "1 Corinthians 2:11 For who knows a person's thoughts except their own spirit within them? In the same way no one knows the thoughts of God except the Spirit of God.",
    "verse_th": "1 โครินธ์ 2:11 เพราะ​ไม่มี​ใคร​รู้​ความคิด​ของ​คนอื่น​ได้​นอกจาก​วิญญาณ​ที่​อยู่​ใน​ตัว​ของ​เขา​เอง เช่น​เดียว​กัน ไม่มี​ใคร​รู้​ความคิด​ของ​พระเจ้า​ได้​นอกจาก​พระวิญญาณ​ของ​พระองค์​เอง",
    "streamUrl": "fivefish.org/T78072",
    "trackDownloadUrl": "fivefish.org/T78072-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78072.zip",
    "programId": "78072",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1CURBrKbQOU&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78072",
    "duration": "60:50",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78076,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 10 - Life After Death",
    "title_th": "พระคำแห่งชีวิต 10 - ชีวิตหลังความตาย",
    "verse_en": "1 Corinthians 2:12 We have not received the spirit of the world but the Spirit who is from God, that we may understand what God has freely given us.",
    "verse_th": "1 โครินธ์ 2:12 เรา​ไม่ได้​รับ​วิญญาณ​ของ​โลกนี้ แต่​รับ​พระวิญญาณ​ที่​มา​จาก​พระเจ้า เพื่อ​เรา​จะ​ได้​เข้าใจ​สิ่งต่างๆ​ที่​พระเจ้า​ให้​เรา และ​พระองค์​ก็​ให้​เรา​อย่าง​ใจกว้าง​จริงๆ",
    "streamUrl": "fivefish.org/T78076",
    "trackDownloadUrl": "fivefish.org/T78076-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78076.zip",
    "programId": "78076",
    "languageVideoUrl": "https://www.youtube.com/watch?v=xfqV5KSn94w&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78076",
    "duration": "60:52",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78073,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 11 - How Christians Live",
    "title_th": "พระคำแห่งชีวิต 11 - การดำเนินชีวิตคริสเตียน",
    "verse_en": "1 Corinthians 3:16 Don’t you know that you yourselves are God’s temple and that God’s Spirit lives in you?",
    "verse_th": "1 โครินธ์ 3:16 พวกคุณ​ไม่​รู้​หรือ​ว่า​พวกคุณ​เป็น​วิหาร​ของ​พระเจ้า และ​พระวิญญาณ​ของ​พระเจ้า​ก็​อยู่​ใน​หมู่​พวกคุณ",
    "streamUrl": "fivefish.org/T78073",
    "trackDownloadUrl": "fivefish.org/T78073-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78073.zip",
    "programId": "78073",
    "languageVideoUrl": "https://www.youtube.com/watch?v=iDvXfTyl5aA&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78073",
    "duration": "60:54",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78074,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 12 - Prayer",
    "title_th": "พระคำแห่งชีวิต 12 - การอธิษฐาน",
    "verse_en": "2 Corinthians 4:1 Therefore, since through God's mercy we have this ministry, we do not lose heart.",
    "verse_th": "2 โครินธ์ 4:1 เรา​ไม่​ย่อท้อ​ง่ายๆ​เพราะ​งานนี้​พระเจ้า​เอง​เป็น​ผู้​มอบ​ให้​เรา​ทำ",
    "streamUrl": "fivefish.org/T78074",
    "trackDownloadUrl": "fivefish.org/T78074-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78074.zip",
    "programId": "78074",
    "languageVideoUrl": "https://www.youtube.com/watch?v=_OM8bFJFPeA&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78074",
    "duration": "60:53",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 78075,
    "iso3": "MFA",
    "langId": "1958",
    "languageEn": "Malay Pattani",
    "langTh": "มาเลปัตตานี",
    "title_en": "Words of Life 13 - God, Jesus Christ",
    "title_th": "พระคำแห่งชีวิต 13 - พระเจ้า พระเยซูคริสต์",
    "verse_en": "2 Corinthians 4:5 For we do not preach ourselves, but Jesus Christ our Lord, and ourselves as your servants for Jesus’ sake.",
    "verse_th": "2 โครินธ์ 4:5 เรา​ไม่ได้​ประกาศ​ตัว​เรา​เอง แต่​เรา​ประกาศ​ว่า​พระเยซู​คริสต์​เป็น​องค์​เจ้า​ชีวิต และ​ตัวเรา​เอง​เป็น​ทาส​ของ​พวกคุณ เพราะ​เห็น​แก่​พระเยซู",
    "streamUrl": "fivefish.org/T78075",
    "trackDownloadUrl": "fivefish.org/T78075-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78075.zip",
    "programId": "78075",
    "languageVideoUrl": "https://www.youtube.com/watch?v=rAiEUU_UKIk&list=PLho9cJoXqQC_SdmSXjNQ9HkQBV1-pLWWs",
    "shareUrl": "5fi.sh/T78075",
    "duration": "60:53",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Malay.Pattani.1958.mp3",
    "stableKey": "Malay Pattani"
  },
  {
    "id": 2691,
    "iso3": "ZSM",
    "langId": "481",
    "languageEn": "Malay Standard",
    "langTh": "มลายูกลาง",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "2 Corinthians 5:17 Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!",
    "verse_th": "2 โครินธ์ 5:17 ถ้า​ใคร​ก็ตาม​มีส่วน​ใน​พระคริสต์ คนนั้น​ได้​เข้า​สู่​โลกใหม่​ที่​พระเจ้า​ได้​สร้าง​ขึ้นมา​แล้ว สิ่ง​เก่าๆ​หายไป​หมดแล้ว ดูสิ สิ่ง​ใหม่ๆ​ก็​เกิดขึ้น",
    "streamUrl": "fivefish.org/T2691",
    "trackDownloadUrl": "fivefish.org/T2691-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2691.zip",
    "programId": "2691",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3LxtpxerZDA&list=PLdcgUOeJ0XtGYiLR4i1IXBkitSJnykAmn",
    "shareUrl": "5fi.sh/T2691",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Malay.Standard.481.mp3",
    "stableKey": "Malay Standard"
  },
  {
    "id": 2591,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "2 Corinthians 5:21 God made Him who had no sin to be sin for us, so that in Him we might become the righteousness of God.",
    "verse_th": "2 โครินธ์ 5:21 พระเจ้า​ทำให้​พระคริสต์​ผู้​ที่​ไม่มี​บาป​กลายเป็น​คนบาป​เพื่อ​เรา เพื่อ​ว่า​ใน​พระคริสต์​นั้น ความ​ซื่อสัตย์​ของ​พระเจ้า จะ​ได้​เห็น​เด่นชัด​ใน​ตัวเรา",
    "streamUrl": "fivefish.org/T2591",
    "trackDownloadUrl": "fivefish.org/T2591-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2591.zip",
    "programId": "2591",
    "languageVideoUrl": "https://www.youtube.com/watch?v=P-9qnqc8zFc&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T2591",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80890,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "2 Corinthians 7:1 Therefore, since we have these promises, dear friends, let us purify ourselves from everything that contaminates body and spirit, perfecting holiness out of reverence for God.",
    "verse_th": "2 โครินธ์ 7:1 เพื่อน​ที่รัก ในเมื่อ​เรา​มี​คำ​สัญญา​พวกนี้ ก็​ขอให้​เรา​ชำระ​ตัวเอง​จาก​ทุกสิ่ง​ทุกอย่าง​ที่​ทำ​ให้​ร่างกาย​และ​จิตใจ​สกปรก ทำ​ตัว​ให้​บริสุทธิ์​ครบถ้วน​เพราะ​ยำเกรง​พระเจ้า",
    "streamUrl": "fivefish.org/T80890",
    "trackDownloadUrl": "fivefish.org/T80890-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80890.zip",
    "programId": "80890",
    "languageVideoUrl": "https://www.youtube.com/watch?v=pZG9PhrmzwU&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80890",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 64259,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Good News - Female",
    "title_th": "ข่าวประเสริฐ – ผู้หญิง",
    "verse_en": "2 Corinthians 9:6-7 Remember this: “Whoever sows sparingly will also reap sparingly, and whoever sows generously will also reap generously. Each man should give what he has decided in his heart to give, not reluctantly or under compulsion, for God loves a cheerful giver.”",
    "verse_th": "2 โครินธ์ 9:6-7 จำ​เอา​ไว้​ว่า “คน​ที่​หว่านน้อย​ก็​จะ​เก็บเกี่ยว​น้อย และ​คน​ที่​หว่านมาก​ก็​จะ​เก็บเกี่ยว​มากแต่ละ​คน​ควร​จะ​ให้​ตาม​ที่​ตั้งใจ​ไว้ ไม่ใช่​ให้​ด้วย​ความ​เสียดาย​หรือ​ถูก​บังคับ เพราะ​พระเจ้า​รัก​คน​ที่​ให้​ด้วย​ใจ​ที่​ชื่นชม​ยินดี”",
    "streamUrl": "fivefish.org/T64259",
    "trackDownloadUrl": "fivefish.org/T64259-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64259.zip",
    "programId": "64259",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wEolGcJ_7Vg&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T64259",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 62908,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Good News^ for university students",
    "title_th": "ข่าวประเสริฐ – สำหรับนักศึกษามหาวิทยาลัย",
    "verse_en": "Galatians 2:20 I have been crucified with Christ and I no longer live, but Christ lives in me. The life I live in the body, I live by faith in the Son of God, who loved me and gave Himself for me.",
    "verse_th": "กาลาเทีย 2:20 ผม​ได้​ถูก​ตรึง​บน​ไม้กางเขน​จน​ตาย​ไป​พร้อม​กับ​พระคริสต์ คน​ที่​มี​ชีวิต​อยู่​ตอนนี้​ไม่ใช่​ตัว​ผม​แล้ว​แต่​เป็น​พระคริสต์​ต่างหาก​ที่​อยู่​ใน​ตัว​ผม ชีวิต​ที่​มี​อยู่​เดี๋ยวนี้​ก็​เป็น​ชีวิต​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า ผู้​ที่รัก​ผม​และ​เสียสละ​ชีวิต​ให้​ผม",
    "streamUrl": "fivefish.org/T62908",
    "trackDownloadUrl": "fivefish.org/T62908-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62908.zip",
    "programId": "62908",
    "languageVideoUrl": "https://www.youtube.com/watch?v=mOGbecD5lx8&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T62908",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80921,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Galatians 4:4-5 But when the set time had fully come, God sent His Son, born of a woman, born under the law, to redeem those under the law, that we might receive adoption to sonship.",
    "verse_th": "กาลาเทีย 4:4-5 แต่​เมื่อ​ถึง​เวลา​ที่​เหมาะสม พระเจ้า​ก็​ได้​ส่ง​พระบุตร​ของ​พระองค์​โดย​คลอด​ออก​มา​จาก​ผู้หญิง และ​มีชีวิต​อยู่​ภายใต้​กฎ เพื่อ​มา​ปลดปล่อย​คน​ที่​อยู่​ภายใต้​กฎ​ให้​เป็น​อิสระ และ​เพื่อ​เรา​ทุกคน​จะ​ได้​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T80921",
    "trackDownloadUrl": "fivefish.org/T80921-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80921.zip",
    "programId": "80921",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XH9BiHstPjw&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80921",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.80921.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80922,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Galatians 5:1 It is for freedom that Christ has set us free. Stand firm, then, and do not let yourselves be burdened again by a yoke of slavery.",
    "verse_th": "กาลาเทีย 5:1 เมื่อ​พระคริสต์​ได้​ปลดปล่อย​ให้​เรา​เป็น​อิสระ​แล้ว ก็​ให้​อยู่​อย่าง​คน​อิสระ​เถิด รักษา​มัน​ไว้​ให้ดี อย่า​กลับ​ไป​เป็น​ทาส​ของ​กฎ​อีก",
    "streamUrl": "fivefish.org/T80922",
    "trackDownloadUrl": "fivefish.org/T80922-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80922.zip",
    "programId": "80922",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Ju5iPbSFL9Y&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80922",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80901,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Galatians 6:10 Therefore, as we have opportunity, let us do good to all people, especially to those who belong to the family of believers.",
    "verse_th": "กาลาเทีย 6:10 ดังนั้น เมื่อ​มี​โอกาส​ก็​ให้​ทำดี​กับ​ทุกคน โดย​เฉพาะ​อย่างยิ่ง​กับ​ครอบครัว​ที่​ไว้วางใจ​ใน​พระเจ้า",
    "streamUrl": "fivefish.org/T80901",
    "trackDownloadUrl": "fivefish.org/T80901-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80901.zip",
    "programId": "80901",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1TreYXPKTK4&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80901",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80892,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Galatians 6:9 Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.",
    "verse_th": "กาลาเทีย 6:9 อย่า​เพิ่ง​ท้อแท้​ใน​การ​ทำดี เพราะ​เมื่อ​ถึง​เวลา​ที่​เหมาะ คุณ​ก็​จะ​ได้​เก็บเกี่ยว​ผล​จาก​การ​ทำดี​นั้น ถ้า​ไม่​เลิก​ไป​ซะก่อน​นะ",
    "streamUrl": "fivefish.org/T80892",
    "trackDownloadUrl": "fivefish.org/T80892-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80892.zip",
    "programId": "80892",
    "languageVideoUrl": "https://www.youtube.com/watch?v=hB11UblRtOU&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80892",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80893,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Ephesians 2:8-9 For it is by grace that you have been saved, through faith-and this not from yourselves, it is the gift of God-not by works, so that no one can boast.",
    "verse_th": "เอเฟซัส 2:8-9 ที่​พวกคุณ​รอด​นั้น​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระเจ้า ผ่าน​มา​ทาง​ความเชื่อ​ของ​คุณ ไม่ได้​มา​จาก​ตัว​ของ​คุณ​เอง แต่​เป็น​ของขวัญ​ที่​มา​จาก​พระเจ้ามัน​ไม่ได้​เป็น​ผล​มา​จาก​การ​กระทำ​ของ​ใคร เพื่อ​จะ​ได้​ไม่มี​ใคร​โอ้อวด​ได้",
    "streamUrl": "fivefish.org/T80893",
    "trackDownloadUrl": "fivefish.org/T80893-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80893.zip",
    "programId": "80893",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6GnX3aJU0To&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80893",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80923,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Ephesians 3:16-17 I pray that out of His glorious riches He may strengthen you with power through His Spirit in your inner being, so that Christ may dwell in your hearts through faith. And I pray that you, being rooted and established in love.",
    "verse_th": "เอเฟซัส 3:16-17 ขอให้​พระเจ้า​ที่​มั่งคั่ง​มหาศาล ช่วย​ให้​พวกคุณ​มี​พลังใจ​ที่​เข้มแข็ง​ผ่าน​ทาง​พระวิญญาณ​ของ​พระองค์ 17 ขอให้​พระคริสต์​ตั้ง​มั่นคง​อยู่​ในใจ​ของ​คุณ​เพราะ​คุณ​ไว้วางใจ​ใน​พระองค์ ขอให้​ลง​รากลึก​มั่นคง​ใน​ความรัก",
    "streamUrl": "fivefish.org/T80923",
    "trackDownloadUrl": "fivefish.org/T80923-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80923.zip",
    "programId": "80923",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kvA_h4PRFLo&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80923",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80924,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Ephesians 3:20-21 Now to Him who is able to do immeasurably more than all we ask or imagine, according to His power that is at work within us, to Him be glory in the church and in Christ Jesus throughout all generations, for ever and ever!",
    "verse_th": "เอเฟซัส 3:20-21 พระเจ้า​สามารถ​ทำได้​ทุกสิ่ง​มาก​ยิ่งกว่า​ที่​เรา​จะขอ​หรือ​คิด​ได้ ด้วย​ฤทธิ์​อำนาจ​ของ​พระองค์​ที่​กำลัง​ทำงาน​อยู่​ใน​ตัวเรา ขอให้​พระเจ้า​ได้รับ​เกียรติ​ทั้ง​จาก​หมู่ประชุม​ของ​พระองค์ และ​จาก​พระเยซู​คริสต์​ทุกยุค​ทุกสมัย​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T80924",
    "trackDownloadUrl": "fivefish.org/T80924-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80924.zip",
    "programId": "80924",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ExQN2ZBF1_I&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80924",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 80925,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Ephesians 5:3 But among you there must not be even a hint of sexual immorality, or of any kind of impurity, or of greed, because these are improper for God’s holy people.",
    "verse_th": "เอเฟซัส 5:3 เรื่อง​ความ​ผิดบาป​ทางเพศ เรื่อง​ลามก​ทุกอย่าง หรือ​ความ​มักมาก​ใน​กาม แม้แต่​จะ​พูดถึง​ก็​อย่าเลย เพราะ​มัน​ไม่เหมาะ​กับ​คน​ที่​เป็น​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T80925",
    "trackDownloadUrl": "fivefish.org/T80925-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80925.zip",
    "programId": "80925",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kRzUrr6WZt0&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T80925",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 30090,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Portrait of Jesus (Modern)",
    "title_th": "ชีวิตของพระเยซู (Modern)",
    "verse_en": "Philippians 2:3-4 Do nothing out of selfish ambition or vein conceit, but in humility consider others better than yourselves. Each of you should look not only to your own interests, but also the interests of others.",
    "verse_th": "ฟีลิปปี 2:3-4 อย่า​ทำ​อะไร​ที่​ชิงดี​ชิงเด่น​กัน หรือ​เพราะ​หลง​คิด​ว่า​ตัวเอง​เก่ง แต่​ให้​ถ่อมตัว​ลง และ​มอง​คน​อื่น​ว่า​สำคัญ​กว่า​ตัวเอง 4 อย่า​ให้​ใคร​คิด​เห็น​แต่​ประโยชน์​ส่วนตัว แต่​ให้​คิดถึง​ประโยชน์​ของ​คน​อื่น​ด้วย",
    "streamUrl": "fivefish.org/T30090",
    "trackDownloadUrl": "fivefish.org/T30090-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30090.zip",
    "programId": "30090",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PnDdEwM2BxQ&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T30090",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 30091,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Portrait of Jesus (Union)",
    "title_th": "ชีวิตของพระเยซู (Union)",
    "verse_en": "Philippians 4:12 I know what it is to be in need, and I know what it is to have plenty. I have learned the secret of being content in any and every situation, whether well fed or hungry, whether living in plenty or in want.",
    "verse_th": "ฟีลิปปี 4:12 ผม​รู้​ว่า​จะ​พอใจ​ได้​อย่างไร​ทั้ง​ตอน​ที่​ขัดสน และ​ตอน​ที่​มี​อย่าง​เหลือ​เฟือ ไม่​ว่า​จะ​อยู่​ใน​สภาพ​ไหน​ก็​ตาม ผม​ได้​เรียนรู้​เคล็ดลับ​ว่า​จะ​อยู่​อย่างไร ใน​เวลา​ที่​อิ่ม​ท้อง​หรือ​หิวโหย ใน​เวลา​ที่​มี​เหลือเฟือ​หรือ​ขาดแคลน",
    "streamUrl": "fivefish.org/T30091",
    "trackDownloadUrl": "fivefish.org/T30091-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30091.zip",
    "programId": "30091",
    "languageVideoUrl": "https://www.youtube.com/watch?v=A55MMMKRNmM&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T30091",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 62646,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "The Living Christ 1-63",
    "title_th": "ชีวิตของพระคริสต์ 1-63",
    "verse_en": "Philippians 4:13 I can do everything through Him who gives me strength.",
    "verse_th": "ฟีลิปปี 4:13 พระคริสต์​ให้​ผม​มี​กำลัง​ที่​จะ​ทน​ได้​กับ​ทุก​สิ่ง",
    "streamUrl": "fivefish.org/T62646",
    "trackDownloadUrl": "fivefish.org/T62646-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62646.zip",
    "programId": "62646",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OhhDjx2KTD4&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T62646",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 62647,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "The Living Christ 64-120",
    "title_th": "ชีวิตของพระคริสต์ 64-120",
    "verse_en": "Philippians 4:19 And my God will meet all your needs according to His glorious riches in Jesus Christ.",
    "verse_th": "ฟีลิปปี 4:19 พระเจ้า​ของ​ผม​จะ​ให้​ทุก​สิ่ง​ที่​จำเป็น​สำหรับ​คุณ จาก​ความ​มั่งคั่ง​อัน​มหาศาล​ของ​พระองค์​ที่​อยู่​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T62647",
    "trackDownloadUrl": "fivefish.org/T62647-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62647.zip",
    "programId": "62647",
    "shareUrl": "5fi.sh/T62647",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 29260,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Philippians 4:6 Do not be anxious about anything, but in everything, by prayer and petition, with thanksgiving, present your requests to God.",
    "verse_th": "ฟีลิปปี 4:6 เลิก​กังวล​ได้​แล้ว แต่​ให้​อธิษฐาน​ใน​ทุกๆ​ สถานการณ์ และ​ขอ​ใน​สิ่ง​ที่​คุณ​ต้องการ​จาก​พระเจ้า และ​เมื่อ​อธิษฐาน​ก็​ให้​ขอบคุณ​พระเจ้า​ด้วย",
    "streamUrl": "fivefish.org/T29260",
    "trackDownloadUrl": "fivefish.org/T29260-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29260.zip",
    "programId": "29260",
    "languageVideoUrl": "https://www.youtube.com/watch?v=qJKTybtx2qs&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T29260",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 29261,
    "iso3": "CMN",
    "langId": "37",
    "languageEn": "Mandarin",
    "langTh": "จีนกลาง",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Philippians 4:7 And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus.",
    "verse_th": "ฟีลิปปี 4:7 แล้ว​สันติสุข​ที่​มา​จาก​พระเจ้า ซึ่ง​ดี​กว่า​สันติสุข​ที่​มา​จาก​แผน​งาน​ต่างๆ​ของ​มนุษย์ จะ​ปกป้อง​รักษา​จิตใจ และ​ความคิด​ของ​คุณ​ไว้​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T29261",
    "trackDownloadUrl": "fivefish.org/T29261-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/29261.zip",
    "programId": "29261",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wW1DQ7EbYpk&list=PLdcgUOeJ0XtEVe11dLip3rNOl7Al--hlT",
    "shareUrl": "5fi.sh/T29261",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mandarin.37.mp3",
    "stableKey": "Mandarin"
  },
  {
    "id": 37926,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Philippians 4:8 Finally, brothers and sisters, whatever is true, whatever is noble, whatever is right, whatever is pure, whatever is lovely, whatever is admirable—if anything is excellent or praiseworthy—think about such things.",
    "verse_th": "ฟีลิปปี 4:8 สุดท้าย​นี้ พี่น้อง​ครับ อะไร​ก็​ตาม​ที่​จริง ที่​น่านับถือ ที่​ถูกต้อง ที่​บริสุทธิ์ ที่​น่ารัก ที่​น่ายกย่อง นั่น​คือ​อะไรก็ตาม​ที่​ยอดเยี่ยม​และ​น่าสรรเสริญ ให้​เอาใจใส่​ใน​เรื่อง​เหล่า​นั้น",
    "streamUrl": "fivefish.org/T37926",
    "trackDownloadUrl": "fivefish.org/T37926-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37926.zip",
    "programId": "37926",
    "languageVideoUrl": "https://www.youtube.com/watch?v=h5cXv7Wuv0k&list=PLbQkUFqMy6wq0hjjcgZtJBfdllwusgDLo",
    "shareUrl": "5fi.sh/T37926",
    "duration": "40:57",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Moken.37926.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 64535,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Gospel of Luke Ch 01-06",
    "title_th": "พระกิตติคุณลูกา บทที่ 01-06",
    "verse_en": "Colossians 3:1-2 Since, then, you have been raised with Christ, set your hearts on things above, where Christ is, seated at the right hand of God. Set your minds on things above, not on earthly things.",
    "verse_th": "โคโลสี 3:1-2 พระเจ้า​ได้​ทำ​ให้​คุณ​ฟื้น​ขึ้น​จาก​ความตาย​กับ​พระคริสต์​แล้ว อย่าง​นั้น​ให้​แสวงหา​สิ่ง​ต่างๆ​ที่​อยู่​เบื้องบน ซึ่ง​เป็น​ที่​ที่​พระคริสต์​นั่ง​อยู่​ทาง​ขวา​มือ​ของ​พระเจ้า 2ให้​ใจ​ของ​คุณ​จดจ่อ​อยู่​กับ​สิ่ง​ที่​อยู่​เบื้องบน ไม่​ใช่​สิ่ง​ที่​อยู่​ใน​โลก",
    "streamUrl": "fivefish.org/T64535",
    "trackDownloadUrl": "fivefish.org/T64535-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64535.zip",
    "programId": "64535",
    "languageVideoUrl": "https://www.youtube.com/watch?v=YLzAtT9QgtY&list=PLbQkUFqMy6wq0hjjcgZtJBfdllwusgDLo",
    "shareUrl": "5fi.sh/T64535",
    "duration": "260:59",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 64536,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Gospel of Luke Ch 07-11",
    "title_th": "พระกิตติคุณลูกา บทที่ 07-11",
    "verse_en": "Colossians 3:12 Therefore, as God's chosen people, holy and dearly loved, clothe yourselves with compassion, kindness, humility, gentleness and patience.",
    "verse_th": "โคโลสี 3:12 ดังนั้น​ใน​ฐานะ​ที่​เรา​เป็น​คน​ที่​พระเจ้า​ได้​เลือก เป็น​คน​ของ​พระเจ้า และ​เป็น​คน​ที่​พระองค์​รัก ก็​ให้​สวม​ใส่​ความ​เห็นอก​เห็นใจ ความ​มี​น้ำใจ ความ​ถ่อม​ตน ความ​สุภาพ​อ่อนโยน และ​ความอดทน",
    "streamUrl": "fivefish.org/T64536",
    "trackDownloadUrl": "fivefish.org/T64536-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64536.zip",
    "programId": "64536",
    "shareUrl": "5fi.sh/T64536",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 64537,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Gospel of Luke Ch 12-18",
    "title_th": "พระกิตติคุณลูกา บทที่ 12-18",
    "verse_en": "Colossians 3:15 Let the peace of Christ rule in your hearts, since as members of one body you were called to peace. And be thankful.",
    "verse_th": "โคโลสี 3:15 ขอให้​สันติสุข​จาก​พระคริสต์​มา​ครอบ​ครอง​จิตใจ​ของ​คุณ เพราะ​พระเจ้า​ได้​เรียก​คุณ​ให้​อยู่​กัน​อย่าง​สันติ​ใน​ร่างกาย​เดียว​กัน และ​ขอให้​เป็น​คน​ที่​รู้จัก​ขอบคุณ​พระเจ้า​อยู่​เสมอ",
    "streamUrl": "fivefish.org/T64537",
    "trackDownloadUrl": "fivefish.org/T64537-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64537.zip",
    "programId": "64537",
    "shareUrl": "5fi.sh/T64537",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 64538,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Gospel of Luke Ch 19-24",
    "title_th": "พระกิตติคุณลูกา บทที่ 19-24",
    "verse_en": "1 Timothy 1:17 Now to the King eternal, immortal, invisible, the only God, be honor and glory for ever and ever. Amen.",
    "verse_th": "1 ทิโมธี 1:17 ขอให้​พระองค์​ผู้​เป็น​กษัตริย์​ของ​คน​ทุกยุค​ทุกสมัย ผู้​ไม่​มี​วัน​ตาย ผู้​ไม่​มี​ใคร​มอง​เห็น​ได้ และ​ผู้​เป็น​พระเจ้า​แต่​เพียง​องค์​เดียว ได้รับ​เกียรติ​และ​สง่าราศี อยู่​เสมอ​และ​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T64538",
    "trackDownloadUrl": "fivefish.org/T64538-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64538.zip",
    "programId": "64538",
    "shareUrl": "5fi.sh/T64538",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 4871,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "2 Timothy 2:22 Flee the evil desires of youth and pursue righteousness, faith, love and peace, along with those who call on the Lord out of a pure heart.",
    "verse_th": "2 ทิโมธี 2:22 ให้​วิ่งหนี​จาก​ราคะตัณหา​ของ​คน​หนุ่มสาว แต่​ไล่ตาม​สิ่ง​ที่​ถูกต้อง เช่น​ความเชื่อ ความรัก และ​สันติสุข ร่วมกับ​คน​เหล่านั้น​ที่​ร้องเรียก​องค์​เจ้า​ชีวิต​ด้วย​ใจ​ที่​สะอาด​บริสุทธิ์",
    "streamUrl": "fivefish.org/T4871",
    "trackDownloadUrl": "fivefish.org/T4871-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/4871.zip",
    "programId": "4871",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IVtO05zaGz0&list=PLbQkUFqMy6wq0hjjcgZtJBfdllwusgDLo",
    "shareUrl": "5fi.sh/T4871",
    "duration": "39:22",
    "trackCount": "12.0",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 9791,
    "iso3": "MWT",
    "langId": "1136",
    "languageEn": "Moken",
    "langTh": "มอแกน",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "2 Timothy 3:16 All Scripture is God-breathed and is useful for teaching, rebuking, correcting and training in righteousness.",
    "verse_th": "2 ทิโมธี 3:16 ทุกๆข้อ​ใน​พระคัมภีร์ พระเจ้า​เป็น​ผู้​ดลใจ​ให้​เขียน​ขึ้นมา เพื่อ​เป็น​ประโยชน์​ใน​การ​สั่งสอน​ความจริง ชี้​ให้​คน​เห็น​ถึง​ความบาป​ใน​ชีวิต ช่วย​ปรับปรุง​แก้ไข​ให้​คนดี​ขึ้น และ​ฝึก​คน​ให้​ทำ​ตามใจ​พระเจ้า",
    "streamUrl": "fivefish.org/T9791",
    "trackDownloadUrl": "fivefish.org/T9791-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9791.zip",
    "programId": "9791",
    "languageVideoUrl": "https://www.youtube.com/watch?v=fUWZVXpYENI&list=PLbQkUFqMy6wq0hjjcgZtJBfdllwusgDLo",
    "shareUrl": "5fi.sh/T9791",
    "duration": "20:14",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Moken.1136.mp3",
    "stableKey": "Moken"
  },
  {
    "id": 80865,
    "iso3": "MNW",
    "langId": "399",
    "languageEn": "Mon",
    "langTh": "มอญ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Titus 3:5 He saved us, not because of righteous things we had done, but because of His mercy. He saved us through the washing of rebirth and renewal by the Holy Spirit.",
    "verse_th": "ทิตัส 3:5 พระองค์​ได้​ช่วย​ให้​เรา​รอด ไม่​ใช่​เพราะ​เรา​ทำดี แต่​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระองค์​ต่างหาก พระองค์​ได้​ชำระ​ล้าง​เรา ซึ่ง​ทำ​ให้​เรา​เกิด​ใหม่ และ​ถูก​สร้าง​ขึ้น​มา​ใหม่​ด้วย​ฤทธิ์เดช​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T80865",
    "trackDownloadUrl": "fivefish.org/T80865-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80865.zip",
    "programId": "80865",
    "languageVideoUrl": "https://www.youtube.com/watch?v=0KGDJlgORjI&list=PLbQkUFqMy6wp3A1WsZC5B-AtDjwAY3gMK",
    "shareUrl": "5fi.sh/T80865",
    "duration": "57:20",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Mon.80865.mp3",
    "stableKey": "Mon"
  },
  {
    "id": 7821,
    "iso3": "MNW",
    "langId": "399",
    "languageEn": "Mon",
    "langTh": "มอญ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Hebrews 10:24-25 And let us consider how we may spur one another on toward love and good deeds. Let us not give up meeting together as some are in the habit of doing, but let us encourage one another - and all the more as you see the Day approaching.",
    "verse_th": "ฮีบรู 10:24-25 ขอให้​เรา​ทุกคน​พิจารณา​กัน​และ​กัน เพื่อ​จะได้​กระตุ้น​กัน​ให้​มี​ความรัก​และ​ทำ​แต่​ความดีขอ​อย่าให้​เรา​ทิ้ง​การ​ประชุม​ไป​เหมือนกับ​ที่​บางคน​ทำ​อยู่ แต่​ให้​กำลังใจ​กัน​และ​กัน​มาก​ยิ่งขึ้น ยิ่ง​พวกคุณ​รู้​อยู่​แล้ว​ว่า​วันนั้น​กำลัง​ใกล้​มาถึง​แล้ว ก็​ยิ่ง​น่าจะ​ทำ​อย่างนี้",
    "streamUrl": "fivefish.org/T7821",
    "trackDownloadUrl": "fivefish.org/T7821-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/7821.zip",
    "programId": "7821",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-1rMnz-pZpo&list=PLbQkUFqMy6wp3A1WsZC5B-AtDjwAY3gMK",
    "shareUrl": "5fi.sh/T7821",
    "duration": "34:28",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Mon.399.mp3",
    "stableKey": "Mon"
  },
  {
    "id": 9321,
    "iso3": "MNW",
    "langId": "2405",
    "languageEn": "Mon Takanoon",
    "langTh": "มอญ ทาคานูน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Hebrews 11:6 And without faith it is impossible to please God, because anyone who comes to Him must believe that He exists and that He rewards those who earnestly seek Him.",
    "verse_th": "ฮีบรู 11:6 เขา​ได้รับ​การ​ยกย่อง​ว่า​เป็น​คนหนึ่ง​ที่​พระเจ้า​พอใจ แต่​ถ้า​ไม่มี​ความ​ไว้วางใจ​แล้ว ก็​เป็นไป​ไม่ได้​ที่​จะ​ทำให้​พระเจ้า​พอใจ เพราะ​คน​ที่​มา​เข้าเฝ้า​พระเจ้า​จะ​ต้อง​เชื่อ​ว่า​พระองค์​มี​จริง และ​ต้อง​เชื่อ​ว่า​พระองค์​จะ​ให้​รางวัล​กับ​ทุกคน​ที่​แสวงหา​พระองค์",
    "streamUrl": "fivefish.org/T9321",
    "trackDownloadUrl": "fivefish.org/T9321-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9321.zip",
    "programId": "9321",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nGeDmXqyfus&list=PLbQkUFqMy6wru0P7L08vVsVHoAhFhCw8g",
    "shareUrl": "5fi.sh/T9321",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Mon.Takanoon.09321.mp3",
    "stableKey": "Mon Takanoon"
  },
  {
    "id": 64238,
    "iso3": "NPI",
    "langId": "6428",
    "languageEn": "Nepali",
    "langTh": "เนปาล",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Hebrews 12:3 Consider Him who endured such opposition from sinful men, so that you will not grow weary and lose heart.",
    "verse_th": "ฮีบรู 12:3 ขอให้​ใคร่ครวญ​ถึง​พระองค์​ผู้ที่​ต้อง​ทน​ทุกข์ทรมาน​อย่าง​แสนสาหัส​จาก​คนบาป​ที่​ต่อต้าน​พระองค์ เพื่อ​พวกคุณ​จะ​ได้​ไม่ท้อใจ​หรือ​ยอมแพ้",
    "streamUrl": "fivefish.org/T64238",
    "trackDownloadUrl": "fivefish.org/T64238-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64238.zip",
    "programId": "64238",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WQNI7NKGLfc&list=PL-5yEg0Ecc2gxmgq9DuJ0HguT6ukSzlcW",
    "shareUrl": "5fi.sh/T64238",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.64238.mp3",
    "stableKey": "Nepali"
  },
  {
    "id": 64085,
    "iso3": "NPI",
    "langId": "6428",
    "languageEn": "Nepali",
    "langTh": "เนปาล",
    "title_en": "Promises of God",
    "title_th": "พระสัญญาของพระเจ้า",
    "verse_en": "Hebrews 2:18 Because He Himself suffered when He was tempted, He is able to help those who are being tempted.",
    "verse_th": "ฮีบรู 2:18 เดี๋ยวนี้ พระองค์​สามารถ​ช่วย​คน​ที่​ถูก​ทดลอง​ได้แล้ว เพราะ​พระองค์​เอง​ได้รับ​ความ​ทรมาน​และ​ถูก​ทดลอง​มาก่อน",
    "streamUrl": "fivefish.org/T64085",
    "trackDownloadUrl": "fivefish.org/T64085-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64085.zip",
    "programId": "64085",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TIPS517nOlY&list=PL-5yEg0Ecc2gxmgq9DuJ0HguT6ukSzlcW",
    "shareUrl": "5fi.sh/T64085",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.6428.mp3",
    "stableKey": "Nepali"
  },
  {
    "id": 62307,
    "iso3": "NPI",
    "langId": "6428",
    "languageEn": "Nepali",
    "langTh": "เนปาล",
    "title_en": "Testimony",
    "title_th": "คำพยาน",
    "verse_en": "Hebrews 4:15-16 For we do not have a high priest who is unable to empathize with our weaknesses, but we have One who has been tempted in every way, just as we are - yet He did not sin. Let us then approach God's throne of grace with confidence, so that we may receive mercy and find grace to help us in our time of need.",
    "verse_th": "ฮีบรู 4:15-16 เพราะ​หัวหน้า​นักบวช​สูงสุด​ของเรา​คนนี้​เข้าใจ​และ​เห็นใจ​ใน​จุดอ่อน​ทั้งหลาย​ของเรา เพราะ​พระองค์​ก็​เคย​ถูก​ทดลอง​เหมือนกับ​เรา​ทุกอย่าง แต่​ไม่ได้​ทำบาป​เลย 16 ดังนั้น​ขอให้​เรา​ทุกคน​เข้ามา​ยืน​ด้วย​ความ​มั่นใจ​ต่อหน้า​บัลลังก์​ของ​พระเจ้า​ผู้​มี​ความ​เมตตา​กรุณา เพื่อ​เรา​จะ​ได้รับ​ความปรานี และ​พบ​กับ​ความ​เมตตา​กรุณา​ที่​พระเจ้า​จะ​ช่วย​เรา​ใน​เวลา​ที่​เรา​ต้องการ​ความ​ช่วยเหลือ",
    "streamUrl": "fivefish.org/T62307",
    "trackDownloadUrl": "fivefish.org/T62307-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62307.zip",
    "programId": "62307",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6sa7sWumW_Y&list=PL-5yEg0Ecc2gxmgq9DuJ0HguT6ukSzlcW",
    "shareUrl": "5fi.sh/T62307",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.6428.mp3",
    "stableKey": "Nepali"
  },
  {
    "id": 80350,
    "iso3": "NPI",
    "langId": "5115",
    "languageEn": "Nepali Bhutan",
    "langTh": "เนปาล ภูฏาน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Hebrews 9:27 Just as man is destined to die once, and after that to face judgment.",
    "verse_th": "ฮีบรู 9:27 มนุษย์​ตาย​แค่​ครั้งเดียว​แล้ว​เจอ​กับ​การ​พิพากษา",
    "streamUrl": "fivefish.org/T80350",
    "trackDownloadUrl": "fivefish.org/T80350-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80350.zip",
    "programId": "80350",
    "languageVideoUrl": "https://www.youtube.com/watch?v=AbwZ0GfF5sY&list=PLrcs3EjrK1vwsm5dPZwBNU-w65n7vEUxh",
    "shareUrl": "5fi.sh/T80350",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Bhutan.80350.mp3",
    "stableKey": "Nepali Bhutan"
  },
  {
    "id": 65455,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "After the Earthquake",
    "title_th": "หลังเกิดแผ่นดินไหว",
    "verse_en": "James 4:14 Why, you do not even know what will happen tomorrow. What is your life? You are a mist that appears for a little while and then vanishes.",
    "verse_th": "ยากอบ 4:14 ตัว​คุณ​เอง​ก็​ยัง​ไม่​รู้​เลย​ว่า พรุ่งนี้​ชีวิต​ของ​คุณ​จะ​เป็น​อย่าง​ไร​บ้าง เพราะ​คุณ​เป็น​เพียง​แค่​หมอก ที่​เกิด​ขึ้น​ประ​เดี๋ยว​เดียว แล้ว​ก็​จาง​หาย​ไป",
    "streamUrl": "fivefish.org/T65455",
    "trackDownloadUrl": "fivefish.org/T65455-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65455.zip",
    "programId": "65455",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ZqgUqu1T9KE&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T65455",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 27110,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Are You Happy?",
    "title_th": "คุณมีความสุขไหม?",
    "verse_en": "1 Peter 2:11 Dear friends. I urge you as aliens and strangers in the world, to abstain from sinful desires, which war against your soul.",
    "verse_th": "1 เปโตร 2:11 เพื่อนรัก ให้​อยู่​อย่าง​คน​ต่างด้าว​และ​คน​แปลกถิ่น​ใน​สังคมนี้ ผม​ขอร้อง​ว่า​อย่า​ไป​ยอมแพ้​กับ​กิเลสตัณหา​ของ​สันดาน​ที่​ต่อสู้​กับ​ใจ​ของคุณ",
    "streamUrl": "fivefish.org/T27110",
    "trackDownloadUrl": "fivefish.org/T27110-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27110.zip",
    "programId": "27110",
    "languageVideoUrl": "https://www.youtube.com/watch?v=uXu6nXdiRGc&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T27110",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 37696,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Christmas & Easter",
    "title_th": "คริสต์มาสและอีสเตอร์",
    "verse_en": "1 Peter 3:18 For Christ died for our sins once for all, the righteous for the unrighteous, to bring you to God. He was put to death in the body but made alive by the Spirit.",
    "verse_th": "1 ยอห์น 3:18 ลูก​เล็กๆ​ที่รัก อย่า​ให้​เรา​รัก​กัน​แค่​คำพูด​หรือ​รัก​แต่​ปาก​เท่านั้น แต่​ให้​เรา​รัก​กัน​ด้วย​การ​กระทำ​และ​ด้วย​ความ​จริงใจ",
    "streamUrl": "fivefish.org/T37696",
    "trackDownloadUrl": "fivefish.org/T37696-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37696.zip",
    "programId": "37696",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1l7RuinQiNY&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T37696",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 37694,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Follow Up",
    "title_th": "ติดตาม",
    "verse_en": "1 Peter 4:16 However, if you suffer as a Christian, do not be ashamed, but praise God that you bear that name.",
    "verse_th": "1 เปโตร 4:16 แต่​ถ้า​คุณ​ต้อง​ทนทุกข์​เพราะ​เป็น​คริสเตียน ก็​อย่า​อาย​เลย แต่​ให้​สรรเสริญ​พระเจ้า เพราะ​คุณ​ได้​ชื่อ​ว่า​คริสเตียน",
    "streamUrl": "fivefish.org/T37694",
    "trackDownloadUrl": "fivefish.org/T37694-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37694.zip",
    "programId": "37694",
    "languageVideoUrl": "https://www.youtube.com/watch?v=KRIySvdyqGI&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T37694",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 75099,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Follow Up Messages",
    "title_th": "ติดตามข้อความ",
    "verse_en": "1 Peter 5:10 And the God of all grace, who called you to His eternal glory in Christ, after you have suffered a little while, will Himself restore you and make you strong, firm and steadfast.",
    "verse_th": "1 เปโตร 5:10 พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความ​เมตตา​ทุกอย่าง​ได้​เรียก​คุณ​ผ่านทาง​พระเยซู​คริสต์ ให้​คุณ​เข้ามา​มี​ส่วนร่วม​ใน​เกียรติ​ของ​พระองค์​ที่​ไม่มี​วัน​หมด คุณ​จะ​ต้อง​ทนทุกข์​อยู่​ประเดี๋ยวหนึ่ง แล้ว​หลังจากนั้น​พระเจ้า​ก็​จะ​ช่วยให้​คุณ​กลับคืน​สู่​สภาพ​สมบูรณ์แบบ จะ​ให้​คุณ​เข้มแข็ง มี​กำลัง​มากขึ้น​และ​มั่นคง",
    "streamUrl": "fivefish.org/T75099",
    "trackDownloadUrl": "fivefish.org/T75099-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/75099.zip",
    "programId": "75099",
    "languageVideoUrl": "https://www.youtube.com/watch?v=mGlUEP684Co&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T75099",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 32951,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "1 Peter 5:5-6 Young men, in the same way be submissive to those who are older. All of you, clothe yourselves with humility toward one another, because, God opposes the proud but gives grace to the humble. Humble yourselves, therefore, under God’s mighty hand, that He may lift you up in due time.",
    "verse_th": "1 เปโตร 5:5-6 ใน​ทำนอง​เดียวกัน คน​ที่มี​อายุ​น้อยกว่า ก็​ให้​เชื่อฟัง​พวก​ผู้นำ​อาวุโส แต่​ความจริง​แล้ว ทุกๆคน​ควร​จะ​อ่อนน้อม​ถ่อมตัว​รับใช้​ซึ่งกัน​และ​กัน​เหมือนกับ​ที่​พระคัมภีร์​เขียน​ไว้​ว่า พระเจ้า​ต่อต้าน​คน​ที่​เย่อหยิ่ง​จองหอง แต่​มี​ความ​เมตตา​กรุณา​ต่อ​คน​ที่​อ่อนน้อม​ถ่อมตน 6ถ้า​อย่างนั้น ให้​พวกคุณ​อ่อนน้อม​ถ่อมตัว​ลง​ใต้​อำนาจ​ที่​ยิ่งใหญ่​ของ​พระเจ้า เพื่อ​พระเจ้า​จะ​ได้​ยก​คุณ​ขึ้น​เมื่อ​ถึง​เวลาที่​เหมาะสม",
    "streamUrl": "fivefish.org/T32951",
    "trackDownloadUrl": "fivefish.org/T32951-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32951.zip",
    "programId": "32951",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ZpVv_NXhohM&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T32951",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 37693,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Gospel",
    "title_th": "พระกิตติคุณ",
    "verse_en": "1 Peter 5:7 Cast all your anxiety on Him because He cares for you.",
    "verse_th": "1 เปโตร 5:7 ให้​เอา​ความ​กังวล​ทั้งหมด​ของ​คุณ​ฝากไว้​กับ​พระเจ้า เพราะ​พระองค์​ห่วงใย​คุณ",
    "streamUrl": "fivefish.org/T37693",
    "trackDownloadUrl": "fivefish.org/T37693-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37693.zip",
    "programId": "37693",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Fam-GZre3vI&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T37693",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 79174,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "1 John 2:15 Do not love the world or anything in the world. If anyone loves the world, the love of the Father is not in him.",
    "verse_th": "1 ยอห์น 2:15 อย่า​รัก​โลก​หรือ​รัก​สิ่งของ​ใน​โลกนี้​อีก​ต่อไป ถ้า​คนไหน​รัก​โลกนี้ คนนั้น​ก็​ไม่ได้​รัก​พระบิดา",
    "streamUrl": "fivefish.org/T79174",
    "trackDownloadUrl": "fivefish.org/T79174-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/79174.zip",
    "programId": "79174",
    "languageVideoUrl": "https://www.youtube.com/watch?v=czzcAQjiDOM&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T79174",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.79174.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 79180,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "1 John 2:16 For everything in the world - the lust of the flesh, the lust of the eyes, and the pride of life - comes not from the Father but from the world.",
    "verse_th": "1 ยอห์น 2:16 เพราะ​ทุกสิ่ง​ทุกอย่าง​ใน​โลกนี้ คือ​กิเลสตัณหา​ของ​สันดาน กิเลสตัณหา​ของ​ตา และ​การ​โอ้อวด​ใน​สิ่ง​ที่​ทำ​หรือ​มี สิ่ง​เหล่านี้​ไม่ได้​มา​จาก​พระบิดา แต่​มา​จาก​โลกนี้",
    "streamUrl": "fivefish.org/T79180",
    "trackDownloadUrl": "fivefish.org/T79180-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/79180.zip",
    "programId": "79180",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8lOBhBx2NfE&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T79180",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 31200,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Songs",
    "title_th": "เพลง",
    "verse_en": "1 John 3:18 Dear children, let us not love with words or tongue but with actions and in truth.",
    "verse_th": "1 เปโตร 3:18 พระคริสต์​ทนทุกข์​เพื่อ​จัดการ​กับ​ความบาป​ครั้งเดียว​ก็​เพียงพอ​แล้ว พระองค์​ทำ​อย่างนี้​เพื่อ​นำ​คุณ​ไป​หา​พระเจ้า พระองค์​ถูก​ฆ่า​ทางกาย​แต่​มี​ชีวิต​ขึ้น​มา​ใหม่​โดย​ทาง​พระวิญญาณ",
    "streamUrl": "fivefish.org/T31200",
    "trackDownloadUrl": "fivefish.org/T31200-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31200.zip",
    "programId": "31200",
    "languageVideoUrl": "https://www.youtube.com/watch?v=k9HvEBRGfvY&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T31200",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 37695,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Student",
    "title_th": "นักศึกษา",
    "verse_en": "1 John 5:13 I write these things to you who believe in the name of the Son of God so that you may know that you have eternal life.",
    "verse_th": "1 ยอห์น 5:13 ผม​ได้​เขียน​เรื่องนี้​ถึง​พวกคุณ​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า เพื่อ​พวกคุณ​จะ​ได้​รู้​ว่า คุณ​ยัง​มี​ชีวิต​ตลอดไป​กับ​พระเจ้า​อยู่",
    "streamUrl": "fivefish.org/T37695",
    "trackDownloadUrl": "fivefish.org/T37695-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37695.zip",
    "programId": "37695",
    "languageVideoUrl": "https://www.youtube.com/watch?v=MeGSDNLSoRY&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T37695",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 3080,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Revelation 1:8 I am the Alpha and the Omega, says the Lord God, Who is, and Who was, and Who is to come, the Almighty.",
    "verse_th": "วิวรณ์ 1:8 พระเจ้า​องค์​เจ้า​ชีวิต​พูดว่า “เรา​คือ​จุดเริ่มต้น​และ​จุดจบ พระเจ้า​ผู้ที่​เป็น​อยู่​ใน​ปัจจุบัน ใน​อดีต และ​กำลัง​จะ​มา​ใน​อนาคต พระเจ้า​ผู้​มี​ฤทธิ์​ทั้งสิ้น”",
    "streamUrl": "fivefish.org/T3080",
    "trackDownloadUrl": "fivefish.org/T3080-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3080.zip",
    "programId": "3080",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OHNBFUqYSqY&list=PL0wFOj5X3S9gld2X3CbnyBZ_0y0VA6iGv",
    "shareUrl": "5fi.sh/T3080",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 3090,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Revelation 3:20 Here I am! I stand at the door and knock. If anyone hears My voice and opens the door, I will come in and eat with him, and he with Me.",
    "verse_th": "วิวรณ์ 3:20 ฟัง​ไว้​ให้ดี เรา​ยืน​เคาะ​ประตู​อยู่ ถ้า​ใคร​ได้ยิน​เสียง​ของ​เรา​แล้ว​เปิด​ประตู เรา​จะ​เข้า​ไป​ข้างใน และ​กิน​อาหาร​ร่วมกับ​คนนั้น",
    "streamUrl": "fivefish.org/T3090",
    "trackDownloadUrl": "fivefish.org/T3090-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3090.zip",
    "programId": "3090",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ZF9eFEefFE8&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T3090",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 20731,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Genesis 1:1 In the beginning God created the heavens and the earth.",
    "verse_th": "ปฐมกาล 1:1 ใน​ปฐมกาล​นั้น เมื่อ​พระเจ้า​สร้าง​แผ่นดิน​และ​ท้องฟ้า",
    "streamUrl": "fivefish.org/T20731",
    "trackDownloadUrl": "fivefish.org/T20731-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/20731.zip",
    "programId": "20731",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yW53OkQnx6g&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T20731",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 20700,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Words of Life 3",
    "title_th": "พระคำแห่งชีวิต 3",
    "verse_en": "Exodus 23:25 Worship the LORD your God, and His blessing will be on your food and water. I will take away sickness from among you.",
    "verse_th": "อพยพ 23:25 ถ้า​พวกเจ้า​รับใช้​พระยาห์เวห์​พระเจ้า​ของเจ้า พระองค์​จะ​อวยพร​อาหาร​และ​น้ำ​ของเจ้า และ​เรา​จะ​เอา​เชื้อโรค​ออก​ไป​จากเจ้า",
    "streamUrl": "fivefish.org/T20700",
    "trackDownloadUrl": "fivefish.org/T20700-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/20700.zip",
    "programId": "20700",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IZt6y5Bh1-k&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T20700",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 20781,
    "iso3": "NPI",
    "langId": "2522",
    "languageEn": "Nepali Kathmandu",
    "langTh": "เนปาล กาฐมาณฑุ",
    "title_en": "Words of Life 4",
    "title_th": "พระคำแห่งชีวิต 4",
    "verse_en": "Leviticus 19:11 Do not steal. Do not lie. Do not deceive on another.",
    "verse_th": "เลวีนิติ 19:11 เจ้า​ต้อง​ไม่​ขโมย ไม่​โกง​หรือ​โกหก​ซึ่งกัน​และกัน",
    "streamUrl": "fivefish.org/T20781",
    "trackDownloadUrl": "fivefish.org/T20781-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/20781.zip",
    "programId": "20781",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-RndUjL1AzE&list=PL-5yEg0Ecc2jz1tvZzoR6spZHT4ODuVKr",
    "shareUrl": "5fi.sh/T20781",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nepali.Kathmandu.2522.mp3",
    "stableKey": "Nepali Kathmandu"
  },
  {
    "id": 22510,
    "iso3": "ACN",
    "langId": "4370",
    "languageEn": "Ngochang",
    "langTh": "งอชาง",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Numbers 23:19 God is not a man, that He should lie, nor a son of man, that He should change His mind. Does He speak and then not act? Does He promise and not fulfill?",
    "verse_th": "กันดารวิถี 23:19 พระเจ้า​ไม่​ใช่​มนุษย์​ที่​พูด​โกหก และ​ก็​ไม่​ใช่​มนุษย์​ที่​ชอบ​เปลี่ยนใจ มี​หรือ​ที่​พระองค์​พูด​แล้ว​ไม่​ทำ หรือ​สัญญา​แล้ว​ไม่​ทำ​ตาม​สัญญานั้น",
    "streamUrl": "fivefish.org/T22510",
    "trackDownloadUrl": "fivefish.org/T22510-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/22510.zip",
    "programId": "22510",
    "languageVideoUrl": "https://www.youtube.com/watch?v=aDS6fc3b6V0&list=PLXcynA24_lTMW01O9o6uETg_FySNfRlHW",
    "shareUrl": "5fi.sh/T22510",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Ngochang.22510.mp3",
    "stableKey": "Ngochang"
  },
  {
    "id": 22511,
    "iso3": "ACN",
    "langId": "4370",
    "languageEn": "Ngochang",
    "langTh": "งอชาง",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Deuteronomy 31:6 Be strong and courageous. Do not be afraid or terrified because of them, for the LORD your God goes with you; He will never leave you nor forsake you.",
    "verse_th": "เฉลยธรรมบัญญัติ 31:6 ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ ไม่​ต้อง​กลัว​หรือ​ตื่นตกใจ​เพราะ​พวกนั้น เพราะ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน​คือ​ผู้ที่​จะ​ไป​กับ​ท่าน พระองค์​จะ​ไม่​ละ​ท่าน​ไป​หรือ​ทอดทิ้ง​ท่าน​หรอก”",
    "streamUrl": "fivefish.org/T22511",
    "trackDownloadUrl": "fivefish.org/T22511-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/22511.zip",
    "programId": "22511",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Z3MTk5ygs-g&list=PLXcynA24_lTMW01O9o6uETg_FySNfRlHW",
    "shareUrl": "5fi.sh/T22511",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Ngochang.4370.mp3",
    "stableKey": "Ngochang"
  },
  {
    "id": 64992,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "Creation Songs",
    "title_th": "เพลงการทรงสร้าง",
    "verse_en": "Deuteronomy 6:16 Do not put the LORD your God to the test as you did at Massah.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:16 พวกท่าน​ต้อง​ไม่​ลองดี​กับ​พระยาห์เวห์​พระเจ้า​ของ​ท่าน เหมือน​กับ​ที่​พวกท่าน​เคย​ลองดี​กับ​พระองค์​มา​แล้ว​ที่​มัสสาห์",
    "streamUrl": "fivefish.org/T64992",
    "trackDownloadUrl": "fivefish.org/T64992-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64992.zip",
    "programId": "64992",
    "languageVideoUrl": "https://www.youtube.com/watch?v=02iXMszFs_8&list=PLho9cJoXqQC-69ZY7bPfmL9Oi8bbGeP1y",
    "shareUrl": "5fi.sh/T64992",
    "duration": "40:26",
    "trackCount": "20.0",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 64993,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "Good News 1",
    "title_th": "ข่าวประเสริฐ 1",
    "verse_en": "Deuteronomy 6:5 Love the LORD your God with all your heart and with all your soul and with all your strength.",
    "verse_th": "เฉลยธรรมบัญญัติ 6:5 ท่าน​ต้อง​รัก​พระยาห์เวห์​พระเจ้า​ของ​ท่าน ด้วย​การ​ทุ่ม​สุดใจ สุด​ชีวิต และ​สุด​ตัว ของ​ท่าน​ให้​กับ​พระองค์",
    "streamUrl": "fivefish.org/T64993",
    "trackDownloadUrl": "fivefish.org/T64993-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64993.zip",
    "programId": "64993",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TICQ2qelCj8&list=PLho9cJoXqQC-69ZY7bPfmL9Oi8bbGeP1y",
    "shareUrl": "5fi.sh/T64993",
    "duration": "49:07",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Nyah.Kur.64993.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 64994,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "Good News 2",
    "title_th": "ข่าวประเสริฐ 2",
    "verse_en": "Deuteronomy 8:3 He humbled you, causing you to hunger and then feeding you with manna, which neither you nor your ancestors had known, to teach you that man does not live on bread alone but on every word that comes from the mouth of the LORD.",
    "verse_th": "เฉลยธรรมบัญญัติ 8:3 พระยาห์เวห์​ทำ​ให้​ท่าน​ต้อง​ทนทุกข์​จาก​ความหิว​แล้ว​พระองค์​ก็​เลี้ยง​พวกท่าน​ด้วย​มานา ที่​ทั้ง​ท่าน​และ​บรรพบุรุษ​ของ​ท่าน​ไม่​เคย​รู้จัก​มา​ก่อน เพื่อ​ที่​พระองค์​จะ​ได้​สอน​ท่าน​ว่า คน​เรา​ไม่​ได้​มี​ชีวิต​อยู่​ด้วย​อาหาร​เพียง​อย่าง​เดียว แต่​คน​เรา​จะ​มี​ชีวิต​อยู่​ได้​ด้วย​ทุกๆ​คำพูด​ที่​ออก​มา​จาก​ปาก​ของ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T64994",
    "trackDownloadUrl": "fivefish.org/T64994-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64994.zip",
    "programId": "64994",
    "shareUrl": "5fi.sh/T64994",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 65333,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Joshua 1:8 Do not let this Book of the Law depart from your mouth; meditate on it day and night, so that you may be careful to do everything written in it. Then you will be prosperous and successful.",
    "verse_th": "โยชูวา 1:8 เจ้า​ต้อง​ไม่หยุด​พูด​ถึง​กฎ​ใน​หนังสือ​เล่มนี้ และ​เจ้า​ต้อง​ไตร่ตรอง​มัน​ทั้งวัน​ทั้งคืน เพื่อ​เจ้า​จะได้​ทำ​ตาม​สิ่ง​ที่​ได้​เขียน​ไว้​ใน​กฎ​นั้น​อย่าง​เคร่งครัด แล้ว​เจ้า​จะได้​เจริญ​รุ่งเรือง​และ​ประสบ​ความ​สำเร็จ",
    "streamUrl": "fivefish.org/T65333",
    "trackDownloadUrl": "fivefish.org/T65333-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65333.zip",
    "programId": "65333",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NwNRJ7tyTwk&list=PLho9cJoXqQC-69ZY7bPfmL9Oi8bbGeP1y",
    "shareUrl": "5fi.sh/T65333",
    "duration": "35:14",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 65334,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Joshua 1:9 Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the LORD your God will be with you wherever you go.",
    "verse_th": "โยชูวา 1:9 อย่าลืม​ว่า​เรา​ได้​สั่ง​เจ้า​ให้​เข้มแข็ง​และ​กล้าหาญ​ไว้ อย่า​ได้​หวาดกลัว​หรือ​ท้อถอย เพราะ​เรา ยาห์เวห์ พระเจ้า​ของเจ้า จะ​อยู่​กับเจ้า​ใน​ทุกที่​ที่​เจ้าไป”",
    "streamUrl": "fivefish.org/T65334",
    "trackDownloadUrl": "fivefish.org/T65334-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65334.zip",
    "programId": "65334",
    "languageVideoUrl": "https://www.youtube.com/watch?v=QNY0EIgoAHs&list=PLho9cJoXqQC-69ZY7bPfmL9Oi8bbGeP1y",
    "shareUrl": "5fi.sh/T65334",
    "duration": "37:16",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 65655,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "2 Chronicles 7:14 If My people, who are called by My name, will humble themselves and pray and seek My face and turn from their wicked ways, then I will hear from heaven, and I will forgive their sin and will heal their land.",
    "verse_th": "2 พงศาวดาร ถ้า​ประชาชน​ของ​เรา​ผู้ที่​เรา​ได้​ประทับ​ชื่อ​เราไว้ ถ่อมตัว​ลง​และ​อธิษฐาน และ​เริ่ม​แสวงหา​ใบ​หน้า​ของเรา และ​หันเห​ออก​จาก​วิถีทาง​ชั่ว​ทั้งหลาย​ของ​พวกเขา เรา​ก็​จะ​รับฟัง​จาก​สวรรค์ และ​จะ​ยกโทษ​บาป​ของ​พวกเขา​และ​จะ​รักษา​แผ่นดิน​ของ​พวกเขา",
    "streamUrl": "",
    "trackDownloadUrl": "",
    "zipDownloadUrl": "",
    "programId": "",
    "shareUrl": "",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 64995,
    "iso3": "CBN",
    "langId": "15143",
    "languageEn": "Nyah Kur",
    "langTh": "ญัฮกุร",
    "title_en": "Prodigal Son",
    "title_th": "บุตรน้อยหลงหาย",
    "verse_en": "Job 31:1 I made a covenant with my eyes not to look lustfully at a young woman.",
    "verse_th": "โยบ 31:1 ข้า​ทำ​ข้อตกลง​กับ​ดวงตา​ของ​ข้า​ว่า ข้า​จะ​ไม่​มอง​หญิงสาว​ด้วย​ความใคร่",
    "streamUrl": "fivefish.org/T64995",
    "trackDownloadUrl": "fivefish.org/T64995-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64995.zip",
    "programId": "64995",
    "languageVideoUrl": "https://www.youtube.com/watch?v=WxqRwfrupfY&list=PLho9cJoXqQC-69ZY7bPfmL9Oi8bbGeP1y",
    "shareUrl": "5fi.sh/T64995",
    "duration": "5:29",
    "trackCount": "1.0",
    "sampleUrl": "/audio/Nyah.Kur.15143.mp3",
    "stableKey": "Nyah Kur"
  },
  {
    "id": 65961,
    "iso3": "NYW",
    "langId": "15183",
    "languageEn": "Nyaw",
    "langTh": "ญ้อ",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "Psalms 103:1 Praise the LORD, my soul; all my inmost being, praise His holy name.",
    "verse_th": "สดุดี 103:1 จิตใจ​ของ​ข้าพเจ้า​เอ๋ย สรรเสริญ​พระยาห์เวห์เถิด หัวใจ​ทั้งดวง​ของข้าพเจ้า​เอ๋ย สรรเสริญ​ชื่อ​อันศักดิ์สิทธิ์​ของ​พระองค์เถิด",
    "streamUrl": "",
    "trackDownloadUrl": "",
    "zipDownloadUrl": "",
    "programId": "",
    "shareUrl": "",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Nyaw.65961.mp3",
    "stableKey": "Nyaw"
  },
  {
    "id": 2951,
    "iso3": "RYN",
    "langId": "1944",
    "languageEn": "Okinawan",
    "langTh": "โอกินา",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 111:10 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สดุดี 111:10 การยำเกรง​พระยาห์เวห์​คือ​จุดเริ่มต้น​แห่งสติปัญญา ทุกคน​ที่​เชื่อฟัง​พระองค์​ก็​จะเป็น​คนที่​มีสติรอบคอบ พระองค์​จะได้รับ​การสรรเสริญ​ตลอดไป",
    "streamUrl": "fivefish.org/T2951",
    "trackDownloadUrl": "fivefish.org/T2951-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2951.zip",
    "programId": "2951",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6HoBOjJidFA&list=PL35bS_eav2jUqU38yMXoESEdiI-bQy1Gq",
    "shareUrl": "5fi.sh/T2951",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Okinawan.02951.mp3",
    "stableKey": "Okinawan"
  },
  {
    "id": 11340,
    "iso3": "PRT",
    "langId": "3118",
    "languageEn": "Phai Central",
    "langTh": "ไปรกลาง",
    "title_en": "Words of Life w/ PHAI: Southern",
    "title_th": "พระคำแห่งชีวิต ไปร: ใต้",
    "verse_en": "Psalms 119: 9,11 How can a young man keep his way pure? By living according to Your Word. I have hidden Your Word in my heart that I might not sin against You.",
    "verse_th": "สดุดี 119:9,11 คนหนุ่มๆ​จะ​รักษาชีวิต​ของตน​ให้​บริสุทธิ์​ได้อย่างไร ก็​ด้วย​การรักษา​คำบัญชา​ของพระอง 11ข้าพเจ้า​เก็บรักษา​คำ​สัญญา​ของพระองค์​ไว้ในใจ เพื่อ​ข้าพเจ้า​จะได้​ไม่ทำบาป​ต่อพระองค์",
    "streamUrl": "fivefish.org/T11340",
    "trackDownloadUrl": "fivefish.org/T11340-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/11340.zip",
    "programId": "11340",
    "languageVideoUrl": "https://www.youtube.com/watch?v=BnD-V14zLVU&list=PLho9cJoXqQC_O72LS9NhLksauIDXFPQUN",
    "shareUrl": "5fi.sh/T11340",
    "duration": "13:34",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Phai.Central.11340.mp3",
    "stableKey": "Phai Central"
  },
  {
    "id": 11341,
    "iso3": "MLF",
    "langId": "2041",
    "languageEn": "Phai Northern",
    "langTh": "ไปรเหนือ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 121:1-2 I lift up my eyes to the mountains— where does my help come from? My help comes from the LORD, the Maker of heaven and earth.",
    "verse_th": "สดุดี 121:1-2 ข้าพเจ้า​แหงนหน้า​มอง​ขึ้นไป​ยัง​ภูเขาทั้งหลาย ความช่วยเหลือ​ของข้าพเจ้า​จะมา​จาก​ที่ไหนกัน ความช่วยเหลือ​ของข้าพเจ้า​มาจาก​พระยาห์เวห์ ผู้สร้าง​สวรรค์​และ​แผ่นดินโลก",
    "streamUrl": "fivefish.org/T11341",
    "trackDownloadUrl": "fivefish.org/T11341-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/11341.zip",
    "programId": "11341",
    "languageVideoUrl": "https://www.youtube.com/watch?v=KEpJ7G3T4YY&list=PLXduqvGi62ctL-4SC_AOvyJtgO-l5vWOw",
    "shareUrl": "5fi.sh/T11341",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Phai.Northern.11341.mp3",
    "stableKey": "Phai Northern"
  },
  {
    "id": 11330,
    "iso3": "PRT",
    "langId": "3119",
    "languageEn": "Phai Southern",
    "langTh": "ไปรใต้",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 139:13-14 For You created my inmost being; You knit me together in my mother’s womb. I praise You because I am fearfully and wonderfully made; Your works are wonderful, I know that full well.",
    "verse_th": "สดุดี 139:13-14 พระองค์​สร้าง​ทั้งจิต​และใจ​ของข้าพเจ้า พระองค์​ทอ​ข้าพเจ้า​เข้าด้วยกัน​ใน​ท้องแม่ ข้าพเจ้า​จึง​ขอบคุณ​พระองค์​เพราะ​งาน​ของพระองค์นั้น​ช่างน่าเกรง​ขาม​และน่าทึ่ง พระองค์​รู้จัก​ข้าพเจ้า​อย่าง​ทะลุปรุโปร่ง",
    "streamUrl": "fivefish.org/T11330",
    "trackDownloadUrl": "fivefish.org/T11330-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/11330.zip",
    "programId": "11330",
    "languageVideoUrl": "https://www.youtube.com/watch?v=tKbVA8uOi_Q&list=PLho9cJoXqQC8GoZlFP4eI2ncvdEOY3FVk",
    "shareUrl": "5fi.sh/T11330",
    "duration": "14:02",
    "trackCount": "4.0",
    "sampleUrl": "/audio/Phai.Southern.11330.mp3",
    "stableKey": "Phai Southern"
  },
  {
    "id": 18081,
    "iso3": "PHT",
    "langId": "1711",
    "languageEn": "Phu Thai",
    "langTh": "ภูไท",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Psalms 139:8 If I go up to the heavens, You are there; if I make my bed in the depths, You are there.",
    "verse_th": "สดุดี 139:8 ถ้า​ข้าพเจ้า​จะ​ขึ้นไป​บนสวรรค์​พระองค์​ก็อยู่ที่นั่น ถ้า​ข้าพเจ้า​นอนลง​ที่​แดน​คนตาย​พระองค์​ก็อยู่ที่นั่น",
    "streamUrl": "fivefish.org/T18081",
    "trackDownloadUrl": "fivefish.org/T18081-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18081.zip",
    "programId": "18081",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Lfdl9Vh3J90&list=PLho9cJoXqQC-K83MVq6E13pkg6kiqbJ92",
    "shareUrl": "5fi.sh/T18081",
    "duration": "19:45",
    "trackCount": "6.0",
    "sampleUrl": "/audio/Phu.Thai.18081.mp3",
    "stableKey": "Phu Thai"
  },
  {
    "id": 63894,
    "iso3": "PHT",
    "langId": "22139",
    "languageEn": "Phu Thai Na Kae",
    "langTh": "ภูไท นาแก",
    "title_en": "Good News 1-22 and Testimony",
    "title_th": "ข่าวประเสริฐ 1-22 และคำพยาน",
    "verse_en": "Psalms 23:1 The Lord is my Shepherd, I lack nothing.",
    "verse_th": "สดุดี 23:1 พระยาห์เวห์​เลี้ยงดู​ข้าพเจ้า​เหมือน​เลี้ยงแกะ ดังนั้น ข้าพเจ้า​ไม่ขาด​อะไรเลย",
    "streamUrl": "fivefish.org/T63894",
    "trackDownloadUrl": "fivefish.org/T63894-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63894.zip",
    "programId": "63894",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3akP3pf6fF0&list=PLho9cJoXqQC_OjXcxY9oBmbUEVdNHXkh-",
    "shareUrl": "5fi.sh/T63894",
    "duration": "55:35",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Phu.Thai.Na.Kae.63894.mp3",
    "stableKey": "Phu Thai Na Kae"
  },
  {
    "id": 63895,
    "iso3": "PHT",
    "langId": "22139",
    "languageEn": "Phu Thai Na Kae",
    "langTh": "ภูไท นาแก",
    "title_en": "Good News 23-40",
    "title_th": "ข่าวประเสริฐ 23-40",
    "verse_en": "Psalms 27:14 Wait for the Lord; be strong and take heart and wait for the Lord.",
    "verse_th": "สดุดี 27:14 ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์ ให้​เข้มแข็ง​และ​กล้าหาญไว้ ให้​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์",
    "streamUrl": "fivefish.org/T63895",
    "trackDownloadUrl": "fivefish.org/T63895-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63895.zip",
    "programId": "63895",
    "shareUrl": "5fi.sh/T63895",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Phu.Thai.Na.Kae.22139.mp3",
    "stableKey": "Phu Thai Na Kae"
  },
  {
    "id": 63892,
    "iso3": "PHT",
    "langId": "22140",
    "languageEn": "Phu Thai Renu",
    "langTh": "ภูไท เรณู",
    "title_en": "Good News 1-22 and Testimony",
    "title_th": "ข่าวประเสริฐ 1-22 และคำพยาน",
    "verse_en": "Psalms 30:5 For His anger lasts only a moment, but His favor lasts a lifetime; weeping may stay for the night, but rejoicing comes in the morning.",
    "verse_th": "สดุดี 30:5 ความ​โกรธ​เกรี้ยว​ของ​พระองค์​อยู่​เพียง​ชั่วคราว แต่​ความปรานี​ของ​พระองค์​นำ​ชีวิต​มาให้ เรา​อาจจะ​ร้องไห้​ใน​ยามค่ำคืน แต่​ใน​วันรุ่งขึ้น เรา​จะ​ชื่นบาน",
    "streamUrl": "fivefish.org/T63892",
    "trackDownloadUrl": "fivefish.org/T63892-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63892.zip",
    "programId": "63892",
    "languageVideoUrl": "https://www.youtube.com/watch?v=48qe9EoIvzo&list=PLho9cJoXqQC92uLzLCZmh5bQgpfsWuTUq",
    "shareUrl": "5fi.sh/T63892",
    "duration": "69:06",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Phu.Thai.Renu.22140.mp3",
    "stableKey": "Phu Thai Renu"
  },
  {
    "id": 63893,
    "iso3": "PHT",
    "langId": "22140",
    "languageEn": "Phu Thai Renu",
    "langTh": "ภูไท เรณู",
    "title_en": "Good News 23-40",
    "title_th": "ข่าวประเสริฐ 23-40",
    "verse_en": "Psalms 32:5 Then I acknowledged my sin to You and did not cover up my iniquity. I said, I will confess my transgressions to the LORD. And You forgave the guilt of my sin.",
    "verse_th": "สดุดี 32:5 ดังนั้น พระยาห์เวห์ ข้าพเจ้า​ขอสารภาพ​ความบาป​ต่อพระองค์ โดย​ไม่ได้​ซ่อน​ความผิดบาป​อะไร​ไว้เลย ข้าพเจ้า​พูดว่า “ข้าพเจ้า​จะ​สารภาพ​ต่อ​พระยาห์เวห์​ถึง​การกบฏ​ทั้งหลาย​ที่ทำไป” แล้ว​พระองค์​ก็​ได้​ยกโทษ​ให้​กับ​ความผิดบาป​ของ​ข้าพเจ้า เซลาห์",
    "streamUrl": "fivefish.org/T63893",
    "trackDownloadUrl": "fivefish.org/T63893-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63893.zip",
    "programId": "63893",
    "shareUrl": "5fi.sh/T63893",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Phu.Thai.Renu.22140.mp3",
    "stableKey": "Phu Thai Renu"
  },
  {
    "id": 65751,
    "iso3": "PHT",
    "langId": "22140",
    "languageEn": "Phu Thai Renu",
    "langTh": "ภูไท เรณู",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Psalms 37:4 Take delight in the Lord, and He will give you the desires of your heart.",
    "verse_th": "สดุดี 37:4 ให้​มี​ความสุข​กับ​การรับใช้​พระยาห์เวห์ แล้ว​พระองค์​จะให้​สิ่งที่​ใจ​เจ้า​ต้องการ",
    "streamUrl": "fivefish.org/T65751",
    "trackDownloadUrl": "fivefish.org/T65751-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65751.zip",
    "programId": "65751",
    "languageVideoUrl": "https://www.youtube.com/watch?v=2Y2LFs3ANGM&list=PLho9cJoXqQC92uLzLCZmh5bQgpfsWuTUq",
    "shareUrl": "5fi.sh/T65751",
    "duration": "42:40",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Phu.Thai.Renu.65751.mp3",
    "stableKey": "Phu Thai Renu"
  },
  {
    "id": 65752,
    "iso3": "PHT",
    "langId": "22140",
    "languageEn": "Phu Thai Renu",
    "langTh": "ภูไท เรณู",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Psalms 4:3 Know that the LORD has set apart His faithful servant for Himself; the LORD hears when I call to Him.",
    "verse_th": "สดุดี 4:3 พวกเจ้า​ทั้งหลาย ให้​รู้​ไว้​เถอะ​ว่า พระยาห์เวห์​เอาใจใส่​คน​ที่​สัตย์ซื่อ​ต่อ​พระองค์​เป็นพิเศษ พระองค์​จะ​ฟัง​เสียง​ของเรา เมื่อ​เรา​ร้องขอ​ความช่วยเหลือ​จาก​พระองค์",
    "streamUrl": "fivefish.org/T65752",
    "trackDownloadUrl": "fivefish.org/T65752-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65752.zip",
    "programId": "65752",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kRZQrUzisrs&list=PLho9cJoXqQC92uLzLCZmh5bQgpfsWuTUq",
    "shareUrl": "5fi.sh/T65752",
    "duration": "44:30",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Phu.Thai.Renu.22140.mp3",
    "stableKey": "Phu Thai Renu"
  },
  {
    "id": 66545,
    "iso3": "PHT",
    "langId": "22140",
    "languageEn": "Phu Thai Renu",
    "langTh": "ภูไท เรณู",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Psalms 4:8 In peace I will lie down and sleep, for You alone, LORD, make me dwell in safety.",
    "verse_th": "สดุดี 4:8 ดังนั้น ข้าพเจ้า​นอนลง​และ​หลับไป​อย่าง​สงบสุข​ยิ่งนัก เพราะ พระยาห์เวห์ พระองค์​แต่เพียงผู้เดียว​เป็น​ผู้ที่​ทำให้​ข้าพเจ้า​นอนลง​อย่างปลอดภัย",
    "streamUrl": "fivefish.org/T66545",
    "trackDownloadUrl": "fivefish.org/T66545-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/66545.zip",
    "programId": "66545",
    "languageVideoUrl": "https://www.youtube.com/watch?v=K5HqRcLnu9E&list=PLho9cJoXqQC92uLzLCZmh5bQgpfsWuTUq",
    "shareUrl": "5fi.sh/T66545",
    "duration": "48:49",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Phu.Thai.Renu.22140.mp3",
    "stableKey": "Phu Thai Renu"
  },
  {
    "id": 32211,
    "iso3": "CMN",
    "langId": "6331",
    "languageEn": "Pinghua Guangxi Nanning",
    "langTh": "จีนกวางสี หนานหนิง",
    "title_en": "Becoming a Friend of God",
    "title_th": "เป็นเพื่อนของพระเจ้า",
    "verse_en": "Psalms 94:11 The LORD knows all human plans; He knows that they are futile.",
    "verse_th": "สดุดี 94:11 พระยาห์เวห์​รู้จัก​ความคิด​ของ​มนุษย์ และ​พระองค์​รู้ว่า​มัน​ไร้สาระ",
    "streamUrl": "fivefish.org/T32211",
    "trackDownloadUrl": "fivefish.org/T32211-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32211.zip",
    "programId": "32211",
    "languageVideoUrl": "https://www.youtube.com/watch?v=zYa2-jf27DI&list=PLXcynA24_lTNxrsVrrqGAP9EpzKIuPox_",
    "shareUrl": "5fi.sh/T32211",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Pinghua.Guangxi.Nanning.32211.mp3",
    "stableKey": "Pinghua Guangxi Nanning"
  },
  {
    "id": 24620,
    "iso3": "SKB",
    "langId": "3112",
    "languageEn": "Saek",
    "langTh": "แสก",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Proverbs 1:7 The fear of the LORD is the beginning of knowledge, but fools despise wisdom and instruction.",
    "verse_th": "สุภาษิต 1:7 การ​ยำเกรง​พระยาห์เวห์​คือ​จุด​เริ่มต้น​ของ​ความรู้ แต่​คน​โง่​เกลียดชัง​ปัญญา​และ​คำ​สั่งสอน",
    "streamUrl": "fivefish.org/T24620",
    "trackDownloadUrl": "fivefish.org/T24620-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/24620.zip",
    "programId": "24620",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Tlzi3Z-evcM&list=PLXduqvGi62csTzN7RkATYUMfPexp9uYBY",
    "shareUrl": "5fi.sh/T24620",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Saek.24620.mp3",
    "stableKey": "Saek"
  },
  {
    "id": 80859,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Proverbs 1:8 Listen, my son, to your father's instruction and do not forsake your mother's teaching.",
    "verse_th": "สุภาษิต 1:8 ลูกเอ๋ย ให้​เชื่อฟัง​คำ​สั่งสอน​ของ​พ่อเจ้า และ​อย่า​ได้​ละทิ้ง​คำสอน​ของ​แม่เจ้า​ด้วย",
    "streamUrl": "fivefish.org/T80859",
    "trackDownloadUrl": "fivefish.org/T80859-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80859.zip",
    "programId": "80859",
    "languageVideoUrl": "https://www.youtube.com/watch?v=EXmQx9vtDIU&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T80859",
    "duration": "58:01",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Shan.80859.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 62897,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Proverbs 10:12 Hatred stirs up conflict, but love covers over all wrongs.",
    "verse_th": "สุภาษิต 10:12 ความ​เกลียดชัง​ย่อม​เร่งเร้า​ให้​เกิด​การ​ทะเลาะ​วิวาท แต่​ความรัก​ปกปิด​ความผิด​ทั้งปวง",
    "streamUrl": "fivefish.org/T62897",
    "trackDownloadUrl": "fivefish.org/T62897-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62897.zip",
    "programId": "62897",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kDl4yFnd59E&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T62897",
    "duration": "44:47",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 62898,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Proverbs 10:4 Lazy hands make for poverty, but diligent hands bring wealth.",
    "verse_th": "สุภาษิต 10:4 มือ​ที่​เกียจคร้าน​ทำให้​ยากจน แต่​มือ​ที่​ขยัน​ทำ​ให้​ร่ำรวย",
    "streamUrl": "fivefish.org/T62898",
    "trackDownloadUrl": "fivefish.org/T62898-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62898.zip",
    "programId": "62898",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TG_WDXbYRTM&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T62898",
    "duration": "46:22",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 62899,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Proverbs 10:9 Whoever walks in integrity walks securely, but whoever takes crooked paths will be found out.",
    "verse_th": "สุภาษิต 10:9 คน​ที่​ใช้​ชีวิต​อย่าง​ซื่อสัตย์​ไม่​ต้อง​ห่วง​อะไร แต่​คน​ที่​อยู่​ใน​ทาง​ไม่ซื่อสัตย์​ก็​จะ​ถูก​จับ​ได้",
    "streamUrl": "fivefish.org/T62899",
    "trackDownloadUrl": "fivefish.org/T62899-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62899.zip",
    "programId": "62899",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kfWtkM5_osA&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T62899",
    "duration": "50:36",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 62900,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Proverbs 16:3 Commit to the LORD whatever you do, and He will establish your plans.",
    "verse_th": "สุภาษิต 16:3 ให้​มอบ​การ​งาน​ของ​เจ้า​ให้​กับ​พระยาห์เวห์ แล้ว​แผนการ​ของ​เจ้า​จะ​สำเร็จ",
    "streamUrl": "fivefish.org/T62900",
    "trackDownloadUrl": "fivefish.org/T62900-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62900.zip",
    "programId": "62900",
    "languageVideoUrl": "https://www.youtube.com/watch?v=vaCpzb1Ihe0&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T62900",
    "duration": "49:26",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 63416,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Proverbs 16:4 The Lord works out everything to its proper end— even the wicked for a day of disaster.",
    "verse_th": "สุภาษิต 16:4 พระยาห์เวห์​สร้าง​ทุกสิ่ง​ขึ้น​มา​อย่าง​มี​จุด​มุ่งหมาย แม้แต่​คนชั่ว พระองค์​ก็​สร้าง​ขึ้น​มา​เพื่อ​วัน​แห่ง​ความ​พินาศ",
    "streamUrl": "fivefish.org/T63416",
    "trackDownloadUrl": "fivefish.org/T63416-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63416.zip",
    "programId": "63416",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wMjqVeE5aoA&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T63416",
    "duration": "48:18",
    "trackCount": "26.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 63417,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Proverbs 17:17 A friend loves at all times, and a brother is born for a time of adversity.",
    "verse_th": "สุภาษิต 17:17 เพื่อน​แท้​ก็​รักกัน​อยู่​เสมอ ส่วน​พี่น้องนั้น​ก็​เกิด​มา​เพื่อ​ช่วยเหลือกัน​ใน​ยาม​ทุกข์ยาก",
    "streamUrl": "fivefish.org/T63417",
    "trackDownloadUrl": "fivefish.org/T63417-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63417.zip",
    "programId": "63417",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-pdx_GM95l4&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T63417",
    "duration": "42:08",
    "trackCount": "26.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 63878,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Proverbs 17:9 Whoever would foster love covers over an offense, but whoever repeats the matter separates close friends.",
    "verse_th": "สุภาษิต 17:9 คน​ที่​ปกปิด​ความผิด​ของ​คน​อื่น​ไว้​รักษา​มิตรภาพ ส่วน​คน​ที่​เล่า​ความผิด​ของ​เพื่อน​ให้​คนอื่น​ฟัง​ก็​ทำลาย​มิตรภาพ",
    "streamUrl": "fivefish.org/T63878",
    "trackDownloadUrl": "fivefish.org/T63878-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63878.zip",
    "programId": "63878",
    "languageVideoUrl": "https://www.youtube.com/watch?v=PP4LWFWSjJY&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T63878",
    "duration": "54:54",
    "trackCount": "27.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 63879,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Proverbs 18:4 The words of the mouth are deep waters, but the fountain of wisdom is a rushing stream.",
    "verse_th": "สุภาษิต 18:4 คำพูด​จาก​ปาก เป็น​น้ำลึก​ที่​เกิน​กว่า​จะ​เข้าใจ​ได้ แต่​แหล่งน้ำ​แห่ง​ปัญญา​ทำ​ให้​สดชื่น​เสมอ เหมือน​กับ​ลำธาร​ที่​ไหล​เชี่ยว",
    "streamUrl": "fivefish.org/T63879",
    "trackDownloadUrl": "fivefish.org/T63879-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63879.zip",
    "programId": "63879",
    "languageVideoUrl": "https://www.youtube.com/watch?v=b9UQZkLYlws&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T63879",
    "duration": "51:51",
    "trackCount": "27.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 80866,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "The Living Christ - Lessons 1 & 2",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 1 & 2",
    "verse_en": "Proverbs 21:30 There is no wisdom, no insight, no plan that can succeed against the LORD.",
    "verse_th": "สุภาษิต 21:30 ถึง​จะ​มี​สติปัญญา ความเข้าใจ และ​คำปรึกษาดี​แค่ไหน​ก็ตาม ก็​ช่วย​ไม่​ได้​หรอก ถ้า​พระยาห์เวห์​ต่อต้าน​เจ้า",
    "streamUrl": "fivefish.org/T80866",
    "trackDownloadUrl": "fivefish.org/T80866-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80866.zip",
    "programId": "80866",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OXERDOPlL3Q&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T80866",
    "duration": "42:31",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 62783,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "The Living Christ - Lessons 3 & 4",
    "title_th": "ชีวิตของพระคริสต์ - บทที่ 3 & 4",
    "verse_en": "Proverbs 25:28 Like a city whose walls are broken through is a person who lacks self-control.",
    "verse_th": "สุภาษิต 25:28 คน​ที่​ควบคุม​อารมณ์​ตัวเอง​ไม่​ได้ ก็​เหมือน​เมือง​ที่​ไม่​มี​กำแพง​ป้องกัน",
    "streamUrl": "fivefish.org/T62783",
    "trackDownloadUrl": "fivefish.org/T62783-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/62783.zip",
    "programId": "62783",
    "languageVideoUrl": "https://www.youtube.com/watch?v=OLwaxQLoziQ&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T62783",
    "duration": "39:41",
    "trackCount": "21.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 6821,
    "iso3": "SHN",
    "langId": "83",
    "languageEn": "Shan",
    "langTh": "ไทใหญ่",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Proverbs 27:17 As iron sharpens iron, so one person sharpens another.",
    "verse_th": "สุภาษิต 27:17 เหล็ก​ลับ​เหล็ก​ให้​คม​ได้ คน​ก็​ลับ​เพื่อน​ของ​เขา​ได้",
    "streamUrl": "fivefish.org/T6821",
    "trackDownloadUrl": "fivefish.org/T6821-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6821.zip",
    "programId": "6821",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yFmxCKgi-7w&list=PLbQkUFqMy6wp5OUZiU-li1Ud7PJR3BX8w",
    "shareUrl": "5fi.sh/T6821",
    "duration": "61:15",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Shan.83.mp3",
    "stableKey": "Shan"
  },
  {
    "id": 64970,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Proverbs 3:13-14 Blessed are those who find wisdom, those who gain understanding,for she is more profitable than silver and yields better returns than gold.",
    "verse_th": "สุภาษิต 3:13-14 คน​ที่​ค้นพบ​สติปัญญา มี​เกียรติ​จริงๆ คน​ที่​มี​ความ​เข้าใจ​ก็​มี​เกียรติ​จริงๆ 14 กำไร​ที่​เกิด​จาก​สติปัญญานั้น มี​ค่า​ยิ่งกว่า​เงิน รายได้​ที่​เกิด​จาก​เธอ มี​ค่า​ยิ่งกว่า​ทองคำ",
    "streamUrl": "fivefish.org/T64970",
    "trackDownloadUrl": "fivefish.org/T64970-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64970.zip",
    "programId": "64970",
    "languageVideoUrl": "https://www.youtube.com/watch?v=irEdB7ainec&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T64970",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80926,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Proverbs 3:5-6 Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to Him, and He will make your paths straight.",
    "verse_th": "สุภาษิต 3:5-6 ให้​ไว้วางใจ​ใน​พระยาห์เวห์​ด้วย​สุดใจ​ของ​เจ้า และ​อย่า​ได้​พึ่ง​ความ​เข้าใจ​ของ​ตัว​เจ้า​เอง 6 ให้​เชื่อฟัง​พระองค์​ใน​ทุกหน​ทาง​ของ​เจ้า แล้ว​พระองค์​จะ​ทำ​ให้​เส้นทาง​ของ​เจ้า​ราบ​รื่น",
    "streamUrl": "fivefish.org/T80926",
    "trackDownloadUrl": "fivefish.org/T80926-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80926.zip",
    "programId": "80926",
    "shareUrl": "5fi.sh/T80926",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80656,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Proverbs 3:9-10 Honor the Lord with your wealth, with the first fruits of all your crops; then your barns will be filled to overflowing, and your vats will brim over with new wine.",
    "verse_th": "สุภาษิต 3:9-10 ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้ ให้​ถวาย​เกียรติ​กับ​พระยาห์เวห์​ด้วย​ทรัพย์​สมบัติ​ของ​เจ้า และ​ด้วย​ผลผลิต​แรก​จาก​พืชผล​ทุกชนิด​ที่​เจ้า​ปลูกไว้แล้ว​ยุ้งฉาง​ของ​เจ้า​จะ​เต็มเปี่ยม​ไป​ด้วย​เมล็ดข้าว และ​ถัง​เหล้าองุ่น​ของ​เจ้า​ก็​จะ​เต็มล้น​ไปด้วย​เหล้าองุ่น​ใหม่",
    "streamUrl": "fivefish.org/T80656",
    "trackDownloadUrl": "fivefish.org/T80656-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80656.zip",
    "programId": "80656",
    "languageVideoUrl": "https://www.youtube.com/watch?v=fNbS43R3DwE&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80656",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80602,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Proverbs 4:23 The fear of the LORD is the beginning of wisdom; all who follow His precepts have good understanding. To Him belongs eternal praise.",
    "verse_th": "สุภาษิต 4:23 ยิ่งกว่า​สิ่งใด ให้​เฝ้าระวัง​ใจ เพราะ​ใจ​เป็น​แหล่ง​ชีวิต",
    "streamUrl": "fivefish.org/T80602",
    "trackDownloadUrl": "fivefish.org/T80602-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80602.zip",
    "programId": "80602",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NigzEJg367g&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80602",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80603,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Isaiah 26:3 You will keep in perfect peace him whose mind is steadfast, because he trusts in You.",
    "verse_th": "อิสยาห์ 26:3 พระยาห์เวห์​เจ้าข้า พระองค์​ประทาน​สันติสุข​แท้จริง​ให้​กับ​ใจ​ที่พึ่งพิง​ในพระองค์นั้น เพราะ​พวกเขา​ไว้วางใจ​ในพระองค์",
    "streamUrl": "fivefish.org/T80603",
    "trackDownloadUrl": "fivefish.org/T80603-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80603.zip",
    "programId": "80603",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kLHYu_UMcVM&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80603",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80607,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Isaiah 40:31 But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.",
    "verse_th": "อิสยาห์ 40:31 แต่​คนเหล่านั้น​ที่​ฝาก​ความหวัง​ไว้​กับ​พระยาห์เวห์​จะ​มี​กำลัง​ขึ้นมาใหม่ และ​จะบิน​สูงขึ้นไป​เหมือน​ติดปีกนกอินทรี พวกเขา​จะ​วิ่ง​และ​จะ​ไม่หมดเรี่ยวแรง พวกเขา​จะ​เดิน​และ​จะ​ไม่เหนื่อย",
    "streamUrl": "fivefish.org/T80607",
    "trackDownloadUrl": "fivefish.org/T80607-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80607.zip",
    "programId": "80607",
    "languageVideoUrl": "https://www.youtube.com/watch?v=A3iA6U6cCQQ&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80607",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80628,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Isaiah 41:10 So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with My righteous hand.",
    "verse_th": "อิสยาห์ 41:10 ไม่ต้องกลัว เพราะ​เรา​อยู่​กับเจ้า อย่ากลัวเลย เพราะ​เรา​เป็น​พระเจ้า​ของเจ้า เรา​จะ​ทำให้​เจ้า​มีกำลัง ใช่แล้ว เรา​จะ​ช่วยเจ้า เรา​จะ​พยุงเจ้า​ด้วย​มือขวา​แห่ง​ชัยชนะ​ของเรา",
    "streamUrl": "fivefish.org/T80628",
    "trackDownloadUrl": "fivefish.org/T80628-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80628.zip",
    "programId": "80628",
    "languageVideoUrl": "https://www.youtube.com/watch?v=bB-C8_av6Co&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80628",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 80633,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Isaiah 53:6 We all, like sheep, have gone astray, each of us has turned to his own way; and the Lord has laid on Him the iniquity of us all.",
    "verse_th": "อิสยาห์ 53:6 พวกเรา​ทุกคน​ได้​หลงหายไป​เหมือนแกะ พวกเรา​แต่ละคน​ต่าง​หลงไป​คนละทิศ​ละทาง แต่​พระยาห์เวห์​ปล่อย​ให้​ความผิด​ของ​พวกเรา​ทุกคน​โจมตีเขา",
    "streamUrl": "fivefish.org/T80633",
    "trackDownloadUrl": "fivefish.org/T80633-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80633.zip",
    "programId": "80633",
    "languageVideoUrl": "https://www.youtube.com/watch?v=uDcii3QjRyA&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T80633",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.80633.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 3211,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Isaiah 6:8 Then I heard the voice of the Lord saying, Whom shall I send? And who will go for Us? And I said, Here am I. Send me!",
    "verse_th": "อิสยาห์ 6:8 และ​ผม​ก็​ได้ยิน​เสียง​ของ​องค์​เจ้า​ชีวิต​พูดว่า “เรา​จะ​ส่งใคร​ไปดี ใคร​จะไป​แทน​พวกเรา” แล้ว​ผม​ก็​ตอบว่า “ข้าพเจ้า​อยู่นี่ครับ ส่ง​ข้าพเจ้า​ไปเถิด”",
    "streamUrl": "fivefish.org/T3211",
    "trackDownloadUrl": "fivefish.org/T3211-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3211.zip",
    "programId": "3211",
    "shareUrl": "5fi.sh/T3211",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 18931,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Jeremiah 1:9 Then the LORD reached out His hand and touched my mouth and said to me, I have put My words in your mouth.",
    "verse_th": "เยเรมียาห์ 1:9 แล้ว​พระยาห์เวห์​ก็​ยื่น​มือ​ออกมา​แตะ​ปาก​ของผม และ​พระองค์​พูด​กับ​ผม​ว่า “เรา​ได้​ใส่​คำพูด​ของเรา​เข้าไป​ใน​ปาก​ของเจ้า​แล้ว",
    "streamUrl": "fivefish.org/T18931",
    "trackDownloadUrl": "fivefish.org/T18931-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18931.zip",
    "programId": "18931",
    "languageVideoUrl": "https://www.youtube.com/watch?v=g4FAQzdrF-g&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T18931",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 30361,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Words of Life 3",
    "title_th": "พระคำแห่งชีวิต 3",
    "verse_en": "Jeremiah 29:13 You will seek Me and find Me when you seek Me with all your heart.",
    "verse_th": "เยเรมีย์ 29:13 เจ้า​จะ​แสวงหา​เรา แล้ว​เจ้า​ก็​จะ​พบ​เรา เมื่อ​เจ้า​แสวงหา​เรา​ด้วย​สิ้นสุดใจ​ของ​เจ้า",
    "streamUrl": "fivefish.org/T30361",
    "trackDownloadUrl": "fivefish.org/T30361-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30361.zip",
    "programId": "30361",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3_bofNDuliQ&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T30361",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 30370,
    "iso3": "SIN",
    "langId": "345",
    "languageEn": "Sinhala",
    "langTh": "สิงหล",
    "title_en": "Words of Life 4",
    "title_th": "พระคำแห่งชีวิต 4",
    "verse_en": "Lamentations 3:22-23 Because of the Lord’s great love, we are not consumed, for His compassions never fail. They are new every morning; great is Your faithfulness.",
    "verse_th": "บทเพลง​ร้องทุกข์ 3:22-23 แน่นอน ความรัก​ของ​พระยาห์เวห์​ไม่มี​วัน​สิ้นสุด แน่นอน ความเมตตา​ของ​พระองค์​ไม่มี​วัน​หมดสิ้น​ 23 ความรัก​และ​ความเมตตา​ของ​พระองค์​เริ่มต้นใหม่​ใน​ทุกๆ เช้า ความซื่อสัตย์​ของ​พระองค์​นั้น​ยิ่งใหญ่",
    "streamUrl": "fivefish.org/T30370",
    "trackDownloadUrl": "fivefish.org/T30370-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30370.zip",
    "programId": "30370",
    "languageVideoUrl": "https://www.youtube.com/watch?v=n-q0CDqmpG0&list=PLdcgUOeJ0XtEZXoubYxtcfi5erBySLYgj",
    "shareUrl": "5fi.sh/T30370",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sinhala.345.mp3",
    "stableKey": "Sinhala"
  },
  {
    "id": 65653,
    "iso3": "THM",
    "langId": "6765",
    "languageEn": "So Thavung",
    "langTh": "โซ่ทะวืง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Micah 6:8 He has shown you, O mortal, what is good. And what does the LORD require of you? To act justly and to love mercy and to walk humbly with your God.",
    "verse_th": "มีคาห์ 6:8 เจ้ามนุษย์ พระยาห์เวห์ บอก​เจ้า​แล้ว​ถึง​สิ่ง​ที่ดี และ​สิ่ง​ที่​พระองค์​ต้องการ​จาก​เจ้า คือ ให้​ทำ​สิ่ง​ที่​ยุติธรรม รัก​ความเมตตา และ​เดิน​กับ​พระเจ้า​ของ​เจ้า​ด้วย​ความถ่อมใจ",
    "streamUrl": "fivefish.org/T65653",
    "trackDownloadUrl": "fivefish.org/T65653-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65653.zip",
    "programId": "65653",
    "languageVideoUrl": "https://www.youtube.com/watch?v=9MTES1GFBSk&list=PLho9cJoXqQC864kXEoVI-Rj3elRR8HFdC",
    "shareUrl": "5fi.sh/T65653",
    "duration": "45:06",
    "trackCount": "40.0",
    "sampleUrl": "/audio/So.Thavung.65653.mp3",
    "stableKey": "So Thavung"
  },
  {
    "id": 19561,
    "iso3": "KDT",
    "langId": "1003",
    "languageEn": "Sui South",
    "langTh": "สุ่ยใต้",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Zechariah 7:9-10 “This is what the LORD Almighty said: ‘Administer true justice; show mercy and compassion to one another. Do not oppress the widow or the fatherless, the foreigner or the poor. Do not plot evil against each other.’",
    "verse_th": "เศคาริยาห์ 7:9-10 “นี่​คือ​สิ่ง​ที่​พระยาห์เวห์​ผู้มีฤทธิ์ทั้งสิ้น​พูด ‘ให้​ตัดสิน​อย่าง​ยุติธรรม ให้​มี​น้ำใจ​ต่อกัน​และ​เห็นอก​เห็นใจ​กัน อย่า​กดขี่​ข่มเหง​แม่หม้าย เด็ก​กำพร้า คนต่างชาติ หรือ​คนจน อย่า​วางแผนชั่ว​ในใจ​ต่อกัน’",
    "streamUrl": "fivefish.org/T19561",
    "trackDownloadUrl": "fivefish.org/T19561-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/19561.zip",
    "programId": "19561",
    "languageVideoUrl": "https://www.youtube.com/watch?v=whnKXrLiNL0&list=PLXduqvGi62cvrpnZzQVveCWZc0LA9zT5g",
    "shareUrl": "5fi.sh/T19561",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Sui.South.19561.mp3",
    "stableKey": "Sui South"
  },
  {
    "id": 22900,
    "iso3": "BLT",
    "langId": "794",
    "languageEn": "Tai Black",
    "langTh": "ไทดำ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 18:20 For where two or three come together in My name, there am I with them.",
    "verse_th": "มัทธิว 18:20 เพราะ​ที่​ไหน​ก็​ตาม ที่​มี​สอง​หรือ​สาม​คน​มา​อยู่​รวม​กัน​เพราะ​เป็น​ศิษย์​ของ​เรา เรา​ก็​จะ​อยู่​กับ​พวก​เขา​ที่​นั่น",
    "streamUrl": "fivefish.org/T22900",
    "trackDownloadUrl": "fivefish.org/T22900-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/22900.zip",
    "programId": "22900",
    "languageVideoUrl": "https://www.youtube.com/watch?v=BRxMllUlmzQ&list=PLbVWnwtj_2QF9TLrN6iEs_4mf5yvZwKxY",
    "shareUrl": "5fi.sh/T22900",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tai.Black.22900.mp3",
    "stableKey": "Tai Black"
  },
  {
    "id": 22901,
    "iso3": "BLT",
    "langId": "794",
    "languageEn": "Tai Black",
    "langTh": "ไทดำ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Matthew 19:26 Jesus looked at them and said, With man this is impossible, but with God all things are possible.",
    "verse_th": "มัทธิว 19:26 พระเยซู​มอง​พวก​ศิษย์​และ​พูด​ว่า “สำหรับ​มนุษย์ เป็น​ไป​ไม่​ได้​อยู่​แล้ว แต่​สำหรับ​พระเจ้า​ทุก​สิ่ง​ทุก​อย่าง​เป็น​ไป​ได้”",
    "streamUrl": "fivefish.org/T22901",
    "trackDownloadUrl": "fivefish.org/T22901-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/22901.zip",
    "programId": "22901",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4qduia0kYG0&list=PLbVWnwtj_2QF9TLrN6iEs_4mf5yvZwKxY",
    "shareUrl": "5fi.sh/T22901",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tai.Black.794.mp3",
    "stableKey": "Tai Black"
  },
  {
    "id": 6701,
    "iso3": "TDD",
    "langId": "508",
    "languageEn": "Tai Ya",
    "langTh": "ไทหย่า",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Matthew 28:19-20 Therefore, go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded you. And surely, I am with you always, to the very end of the age.",
    "verse_th": "มัทธิว 28:19-20 ดังนั้น​ให้​ออก​ไป​ทำ​ให้​คน​ทุก​ชาติ​มา​เป็น​ศิษย์​ของ​เรา ให้​เขา​เข้า​พิธี​จุ่มน้ำ เพื่อ​จะ​ได้​กลาย​เป็น​ของ​พระบิดา พระบุตร และ​พระวิญญาณ​บริสุทธิ์สอน​พวก​เขา​ให้​เชื่อฟัง​ทุก​สิ่ง​ที่​เรา​ได้​สั่ง​ไว้ จำ​ไว้​ว่า เรา​จะ​อยู่​กับ​พวก​คุณ​เสมอ จนกว่า​จะ​สิ้นยุค",
    "streamUrl": "fivefish.org/T6701",
    "trackDownloadUrl": "fivefish.org/T6701-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6701.zip",
    "programId": "6701",
    "languageVideoUrl": "https://www.youtube.com/watch?v=e01y7nH7nc4&list=PLXcynA24_lTN2WxWQAZFlVgRw53w9anxy",
    "shareUrl": "5fi.sh/T6701",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tai.Ya.06701.mp3",
    "stableKey": "Tai Ya"
  },
  {
    "id": 64971,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 4:19 “Come, follow Me,” Jesus said, “and I will make you fishers of men.”",
    "verse_th": "มัทธิว 4:19 พระองค์​พูด​กับ​เขา​ว่า “ตาม​เรา​มา​เถอะ เรา​จะ​สอน​ให้​จับ​คน​แทน​จับ​ปลา”",
    "streamUrl": "fivefish.org/T64971",
    "trackDownloadUrl": "fivefish.org/T64971-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64971.zip",
    "programId": "64971",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NOjtdq6SVrg&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T64971",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 74792,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Matthew 4:4 Jesus answered, It is written: 'Man shall not live on bread alone, but on every word that comes from the mouth of God.'",
    "verse_th": "มัทธิว 4:4 พระเยซู​ตอบ​ว่า “พระคัมภีร์ เขียน​ไว้​ว่า ‘ชีวิต​ที่​เที่ยงแท้​ไม่​ได้​ขึ้น​อยู่​กับ​ขนมปัง​เพียง​อย่าง​เดียว แต่​อยู่​ได้​ด้วย​คำพูด​ทุก​คำ​ที่​มา​จาก​พระเจ้า’”",
    "streamUrl": "fivefish.org/T74792",
    "trackDownloadUrl": "fivefish.org/T74792-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74792.zip",
    "programId": "74792",
    "shareUrl": "5fi.sh/T74792",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80579,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Matthew 5:16 In the same way, let your light shine before men, that they may see your good deeds and praise your Father in heaven.",
    "verse_th": "มัทธิว 5:16 พวก​คุณ​ก็​เหมือน​กัน ให้​ส่อง​สว่าง​ออก​ไป​เพื่อ​คน​จะ​ได้​เห็น​ความ​ดี​ที่​คุณ​ทำ และ​จะ​ได้​สรรเสริญ​พระบิดา​ของ​คุณ​ที่​อยู่​บน​สวรรค์",
    "streamUrl": "fivefish.org/T80579",
    "trackDownloadUrl": "fivefish.org/T80579-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80579.zip",
    "programId": "80579",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3afuqfGpFWE&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80579",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80580,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Matthew 5:9 Blessed are the peacemakers, for they will be called children of God.",
    "verse_th": "มัทธิว 5:9 คน​ที่​สร้าง​สันติ มี​เกียรติ​จริงๆ เพราะ​พระเจ้า​จะ​เรียก​เขา​ว่า​เป็น​ลูก",
    "streamUrl": "fivefish.org/T80580",
    "trackDownloadUrl": "fivefish.org/T80580-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80580.zip",
    "programId": "80580",
    "languageVideoUrl": "https://www.youtube.com/watch?v=MijvK19s9Ng&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80580",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.80580.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80581,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Matthew 6:33 But seek first His kingdom and His righteousness, and all these things will be given to you as well.",
    "verse_th": "มัทธิว 6:33 แต่​ให้​ดิ้นรน​หา​อาณาจักร​ของ​พระเจ้า​และ​ชีวิต​ที่​ทำ​ตามใจ​พระองค์​ก่อน แล้ว​พระองค์​จะ​ให้​สิ่ง​ที่​จำเป็น​ทั้งหมดนี้​กับ​พวก​คุณ​เอง",
    "streamUrl": "fivefish.org/T80581",
    "trackDownloadUrl": "fivefish.org/T80581-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80581.zip",
    "programId": "80581",
    "languageVideoUrl": "https://www.youtube.com/watch?v=98dTSXPLEOE&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80581",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80582,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Mark 10:45 For even the Son of Man did not come to be served, but to serve, and to give His life as ransom for many.",
    "verse_th": "มาระโก 10:45 เพราะ​แม้แต่​บุตร​มนุษย์ ก็​ยัง​ไม่​ได้​มา​เพื่อ​จะ​ให้​คน​อื่น​รับใช้ แต่​มา​เพื่อ​จะ​รับใช้​คน​อื่น และ​ยอม​สละ​ชีวิต​เพื่อ​ปลดปล่อย​ให้​คน​มากมาย​เป็น​อิสระ",
    "streamUrl": "fivefish.org/T80582",
    "trackDownloadUrl": "fivefish.org/T80582-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80582.zip",
    "programId": "80582",
    "languageVideoUrl": "https://www.youtube.com/watch?v=hWfD6-htPhs&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80582",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80583,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Mark 9:29 He replied, This kind can come out only by prayer.",
    "verse_th": "มาระโก 9:29 พระองค์​บอก​ว่า “มี​ทาง​เดียว​ที่​จะ​ไล่​ผี​ชั่ว​ชนิดนี้​ออก​ได้ คือ​ต้อง​อธิษฐาน”",
    "streamUrl": "fivefish.org/T80583",
    "trackDownloadUrl": "fivefish.org/T80583-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80583.zip",
    "programId": "80583",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1ZF2GLl8BiQ&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80583",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80584,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Luke 12:32 Do not be afraid, little flock, for your Father has been pleased to give you the kingdom.",
    "verse_th": "ลูกา 12:32 “ฝูง​แกะ​เล็กๆ​เอ๋ย ไม่​ต้อง​กลัว​นะ เพราะ​พระบิดา​ของ​คุณ​ยินดี​ที่​จะ​มอบ​อาณาจักร​ให้​กับ​คุณ",
    "streamUrl": "fivefish.org/T80584",
    "trackDownloadUrl": "fivefish.org/T80584-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80584.zip",
    "programId": "80584",
    "languageVideoUrl": "https://www.youtube.com/watch?v=pz3hJzFb5IA&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80584",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80585,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Luke 5:16 But Jesus often withdrew to lonely places and prayed.",
    "verse_th": "ลูกา 5:16 แต่​บ่อย​ครั้ง​ที่​พระเยซู​หลบ​ไป​ที่​สงบเงียบ​เพื่อ​อธิษฐาน",
    "streamUrl": "fivefish.org/T80585",
    "trackDownloadUrl": "fivefish.org/T80585-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80585.zip",
    "programId": "80585",
    "languageVideoUrl": "https://www.youtube.com/watch?v=RN8O8O-X704&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80585",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 80586,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Luke 6:42 How can you say to your brother, 'Brother, let me take the speck out of your eye,' when you yourself fail to see the plank in your own eye? You hypocrite, first take the plank out of your eye, and then you will see clearly to remove the speck from your brother's eye.",
    "verse_th": "ลูกา 6:42 แล้ว​คุณ​พูด​กับ​พี่น้อง​ออก​มา​ได้​ยังไง​ว่า ‘เดี๋ยว​ผม​จะ​เขี่ย​ขี้ผง​ใน​ตา​ให้​นะ’ ทั้งๆที่​ซุง​ทั้ง​ท่อน​ใน​ตา​ตัวเอง​ก็​ยัง​มอง​ไม่​เห็น ไอ้​หน้าซื่อใจคด เอา​ท่อน​ซุง​ออก​จาก​ตา​ของ​ตัวเอง​ก่อน แล้ว​จะ​ได้​มอง​เห็น​ชัดๆ​ตอน​เขี่ย​ขี้ผง​ออก​จาก​ตา​ของ​พี่น้อง",
    "streamUrl": "fivefish.org/T80586",
    "trackDownloadUrl": "fivefish.org/T80586-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80586.zip",
    "programId": "80586",
    "languageVideoUrl": "https://www.youtube.com/watch?v=R4iFzqSxjyA&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T80586",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 34070,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Luke 9:23 Then He said to them all, “If anyone would come after Me, he must deny himself and take up the cross daily and follow Me.”",
    "verse_th": "ลูกา 9:23 แล้ว​พระองค์​ก็​พูด​กับ​ทุก​คน​ว่า “ถ้า​ใคร​อยาก​จะ​ติดตาม​เรา ต้อง​เลิก​ตามใจ​ตัวเอง แล้ว​แบก​ไม้กางเขน​ของ​ตัวเอง​ตาม​เรา​ทุกๆ​วัน”",
    "streamUrl": "fivefish.org/T34070",
    "trackDownloadUrl": "fivefish.org/T34070-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34070.zip",
    "programId": "34070",
    "languageVideoUrl": "https://www.youtube.com/watch?v=yUdkgAxo0jQ&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T34070",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 34071,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "John 1:12 Yet to all who received Him to those who believed in His name, He gave the right to become children of God.",
    "verse_th": "ยอห์น 1:12 แต่​ส่วน​คน​ที่​ยอมรับ​และ​ไว้วางใจ​พระองค์ พระองค์​ให้​สิทธิ์​พวก​เขา​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T34071",
    "trackDownloadUrl": "fivefish.org/T34071-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34071.zip",
    "programId": "34071",
    "shareUrl": "5fi.sh/T34071",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 2790,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "John 10:14-15 I am the good shepherd; I know My sheep and My sheep know Me—just as the Father knows Me and I know the Father—and I lay down My life for the sheep.",
    "verse_th": "ยอห์น 10:14-15 เรา​เป็น​คน​เลี้ยง​แกะ​ที่​ดี เรา​รู้จัก​แกะ​ของ​เรา และ​แกะ​ก็​รู้จัก​เรา​ด้วย เหมือน​กับ​ที่​พระบิดา​รู้จัก​เรา​และ​เรา​ก็​รู้จัก​พระบิดา เรา​สละ​ชีวิต​ของ​เรา​เพื่อ​รักษา​แกะ​ของ​เรา​ให้​รอด",
    "streamUrl": "fivefish.org/T2790",
    "trackDownloadUrl": "fivefish.org/T2790-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2790.zip",
    "programId": "2790",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4PsCMX4MXqA&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T2790",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 2791,
    "iso3": "TAM",
    "langId": "174",
    "languageEn": "Tamil",
    "langTh": "ทมิฬ",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "John 10:27 My sheep listen to My voice; I know them, and they follow Me.",
    "verse_th": "ยอห์น 10:27 แกะ​ของ​เรา​จะ​ฟัง​เสียง​เรา และ​เรา​ก็​รู้จัก​แกะ​ของ​เรา และ​แกะ​ของ​เรา​จะ​ตาม​เรา​ไป",
    "streamUrl": "fivefish.org/T2791",
    "trackDownloadUrl": "fivefish.org/T2791-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2791.zip",
    "programId": "2791",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Dyo6zVQ4Z-g&list=PL-5yEg0Ecc2j5MQAo1kgm3sJfikYGJI4Q",
    "shareUrl": "5fi.sh/T2791",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tamil.174.mp3",
    "stableKey": "Tamil"
  },
  {
    "id": 3411,
    "iso3": "NAN",
    "langId": "186",
    "languageEn": "Teochew",
    "langTh": "จีนแต้จิ๋ว",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "John 13:34 A new command I give you: Love one another. As I have loved you, so you must love one another.",
    "verse_th": "ยอห์น 13:34 เรา​จะ​ให้​คำสั่ง​ใหม่​กับ​พวก​คุณ คือ​ให้​รัก​ซึ่ง​กัน​และ​กัน พวก​คุณ​ต้อง​รัก​กัน​เหมือน​กับ​ที่​เรา​รัก​คุณ",
    "streamUrl": "fivefish.org/T3411",
    "trackDownloadUrl": "fivefish.org/T3411-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3411.zip",
    "programId": "3411",
    "shareUrl": "5fi.sh/T3411",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Teochew.186.mp3",
    "stableKey": "Teochew"
  },
  {
    "id": 18871,
    "iso3": "NAN",
    "langId": "186",
    "languageEn": "Teochew",
    "langTh": "จีนแต้จิ๋ว",
    "title_en": "Believe in Jesus",
    "title_th": "เชื่อในพระเยซู",
    "verse_en": "John 13:35 By this everyone will know that you are My disciples, if you love one another.",
    "verse_th": "ยอห์น 13:35 ถ้า​พวก​คุณ​รัก​กัน ทุก​คน​ก็​จะ​รู้​ว่า​คุณ​เป็น​ศิษย์​ของ​เรา",
    "streamUrl": "fivefish.org/T18871",
    "trackDownloadUrl": "fivefish.org/T18871-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/18871.zip",
    "programId": "18871",
    "languageVideoUrl": "https://www.youtube.com/watch?v=FE1jwMnVB1o&list=PLXcynA24_lTMxSvunkEOT71hqsehLhVWf",
    "shareUrl": "5fi.sh/T18871",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Teochew.18871.mp3",
    "stableKey": "Teochew"
  },
  {
    "id": 3670,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Everybody Ought to Know",
    "title_th": "เรื่องที่ทุกคนควรรู้",
    "verse_en": "John 14:21 Whoever has My commands and obeys them, he is the one who loves Me. He who loves Me will be loved by My Father, and I too will love him and show Myself to him.",
    "verse_th": "ยอห์น 14:21 คน​ที่​รู้จัก​คำ​สั่งสอน​ของ​เรา​และ​ทำ​ตาม​ก็​เป็น​คน​ที่​รัก​เรา พระบิดา​จะ​รัก​คน​ที่​รัก​เรา​ด้วย เรา​ก็​จะ​รัก​พวก​เขา​และ​จะ​ปรากฏ​ตัว​ให้​พวก​เขา​เห็น",
    "streamUrl": "fivefish.org/T3670",
    "trackDownloadUrl": "fivefish.org/T3670-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3670.zip",
    "programId": "3670",
    "languageVideoUrl": "https://www.youtube.com/watch?v=ArsKdRdvL6I&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T3670",
    "duration": "28:43",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 74673,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Good News (Short)",
    "title_th": "ข่าวประเสริฐ (Short)",
    "verse_en": "John 14:27 Peace I leave with you; My peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid.",
    "verse_th": "ยอห์น 14:27 เรา​ได้​ให้​สันติสุข​ไว้​กับ​คุณ สันติสุข​ที่​เรา​ให้​นี้​ไม่​เหมือน​กับ​ที่​โลก​ให้ ดังนั้น​คุณ​จึง​ไม่​ต้อง​ทุกข์ใจ หรือ​หวาดกลัว​เลย",
    "streamUrl": "fivefish.org/T74673",
    "trackDownloadUrl": "fivefish.org/T74673-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74673.zip",
    "programId": "74673",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lhE4eu_1nSM&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T74673",
    "duration": "22:29",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Thai.Central.74673.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 63629,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Good News for Children",
    "title_th": "ข่าวประเสริฐ สำหรับเด็ก",
    "verse_en": "John 14:6 Jesus answered, I am the way and the truth and the life. No one comes to the Father except through Me.",
    "verse_th": "ยอห์น 14:6 พระเยซู​บอก​ว่า เรา​เป็น​ทาง​นั้น เป็น​ความจริง​และ​เป็น​ชีวิต ไม่​มี​ใคร​ไป​ถึง​พระบิดา​ได้​นอก​จาก​มา​ทาง​เรา",
    "streamUrl": "fivefish.org/T63629",
    "trackDownloadUrl": "fivefish.org/T63629-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63629.zip",
    "programId": "63629",
    "languageVideoUrl": "https://www.youtube.com/watch?v=I2QSn9DJKo8&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T63629",
    "duration": "78:24",
    "trackCount": "14.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80501,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "John 15:7 If you remain in Me and My Words remain in you, ask whatever you wish, and it will be given you.",
    "verse_th": "ยอห์น 15:7 ถ้า​พวก​คุณ​ติด​สนิท​กับ​เรา และ​คำ​สั่งสอน​ของ​เรา​ติด​สนิท​กับ​คุณ ไม่ว่า​คุณ​จะ​ขอ​อะไร​มัน​ก็​จะ​เป็น​อย่าง​นั้น",
    "streamUrl": "fivefish.org/T80501",
    "trackDownloadUrl": "fivefish.org/T80501-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80501.zip",
    "programId": "80501",
    "languageVideoUrl": "https://www.youtube.com/watch?v=k1xeC1Sbz-Q&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80501",
    "duration": "32:32",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80502,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "John 5:24 I tell you the truth, whoever hears My Word and believes Him who sent Me has eternal life and will not be condemned; he has crossed over from death to life.",
    "verse_th": "ยอห์น 5:24 เรา​จะ​บอก​ให้​รู้​ว่า คน​ที่​ฟัง​คำพูด​เรา​และ​ไว้วางใจ​พระองค์​ผู้​ส่ง​เรา​มา ก็​มี​ชีวิต​กับ​พระเจ้า​ตลอด​ไป และ​เขา​จะ​ไม่​ถูก​ตัดสินลงโทษ เขา​ได้​ผ่านพ้น​ความตาย​ไป​สู่​ชีวิต​แล้ว",
    "streamUrl": "fivefish.org/T80502",
    "trackDownloadUrl": "fivefish.org/T80502-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80502.zip",
    "programId": "80502",
    "languageVideoUrl": "https://www.youtube.com/watch?v=hu3o3slCPNU&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80502",
    "duration": "35:08",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80503,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Acts 1:8 But you will receive power when the Holy Spirit comes on you; and you will be My witnesses in Jerusalem, and in all Judea and Samaria, and to the ends of the earth.",
    "verse_th": "กิจการ 1:8 เมื่อ​พระวิญญาณ​บริสุทธิ์​มา​อยู่​กับ​พวกคุณ พวก​คุณ​ก็​จะ​ได้รับ​ฤทธิ์เดช และ​จะ​เป็น​พยาน​เล่า​เรื่อง​ของ​เรา​ให้​คน​ฟัง ทั่ว​เมือง​เยรูซาเล็ม ใน​แคว้น​ยูเดีย ใน​แคว้น​สะมาเรีย และ​ทุก​หน​แห่ง​ใน​โลกนี้",
    "streamUrl": "fivefish.org/T80503",
    "trackDownloadUrl": "fivefish.org/T80503-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80503.zip",
    "programId": "80503",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Ipq1gY9BaBM&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80503",
    "duration": "34:55",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80504,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Acts 24:16 So I strive always to keep my conscience clear before God and man.",
    "verse_th": "กิจการ 24:16 ผม​จึง​พยายาม​ทำ​ดี​ที่สุด เพื่อ​จะ​ได้​มี​จิต​สำนึก​ที่​ถูกต้อง​ต่อหน้า​พระเจ้า​และ​มนุษย์​ทุก​คน",
    "streamUrl": "fivefish.org/T80504",
    "trackDownloadUrl": "fivefish.org/T80504-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80504.zip",
    "programId": "80504",
    "languageVideoUrl": "https://www.youtube.com/watch?v=LK8nAIWVkQ0&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80504",
    "duration": "37:00",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80505,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Acts 4:12 Salvation is found in no one else, for there is no other Name under heaven given to mankind by which we must be saved.",
    "verse_th": "กิจการ 4:12 นอกจาก​พระเยซู​แล้ว ไม่​มี​ใคร​ที่​จะ​ให้​ความ​รอด​กับ​เรา​ได้ ไม่​มี​ชื่อ​อื่น​ภายใต้​ฟ้านี้ ที่​จะ​ทำ​ให้​มนุษย์​รอด​ได้",
    "streamUrl": "fivefish.org/T80505",
    "trackDownloadUrl": "fivefish.org/T80505-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80505.zip",
    "programId": "80505",
    "languageVideoUrl": "https://www.youtube.com/watch?v=d5Hm_XEQLzM&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80505",
    "duration": "34:28",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80506,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Acts 4:13 When they saw the courage of Peter and John and realized that they were unschooled, ordinary men, they were astonished and they took note that these men had been with Jesus.",
    "verse_th": "กิจการ 4:13 เมื่อ​พวก​ผู้นำ​ชาว​ยิว​เห็น​ถึง​ความ​กล้าหาญ​ของ​เปโตร​กับ​ยอห์น และ​เห็น​ว่า​ทั้ง​สอง​เป็น​แค่​คน​ธรรมดาๆ​ที่​ไม่​ได้รับ​การ​ศึกษา​หรือ​ฝึกฝน​อะไร​มา​เป็น​พิเศษ พวก​เขา​ก็​ยิ่ง​แปลกใจ พวก​เขา​ต่าง​ก็​นึก​ขึ้น​มา​ได้​ว่า เปโตร​และ​ยอห์น​เคย​อยู่​กับ​พระเยซู​มา​ก่อน",
    "streamUrl": "fivefish.org/T80506",
    "trackDownloadUrl": "fivefish.org/T80506-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80506.zip",
    "programId": "80506",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NWIeKZ6KCQ8&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80506",
    "duration": "32:17",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80507,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Romans 1:16 I am not ashamed of the Gospel, because it is the power of God for the salvation of everyone who believes: first for the Jew, then for the Gentile.",
    "verse_th": "โรม 1:16 ผม​ไม่​ละอาย​เกี่ยวกับ​ข่าวดีนี้​หรอก เพราะ​ข่าวดีนี้​เป็น​ฤทธิ์เดช​ของ​พระเจ้า​ที่​จะ​ช่วย​ชีวิต​ทุก​คน​ที่​ไว้วางใจ​ให้​รอด ช่วย​พวกยิว​ก่อน แล้ว​ต่อมา​ก็​ช่วย​คน​ที่​ไม่​ใช่​ยิว​ด้วย",
    "streamUrl": "fivefish.org/T80507",
    "trackDownloadUrl": "fivefish.org/T80507-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80507.zip",
    "programId": "80507",
    "shareUrl": "5fi.sh/T80507",
    "duration": "33:56",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 80508,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Romans 12:1 Therefore, I urge you brothers, in view of God’s mercy, to offer your bodies as living sacrifices, holy and pleasing to God-this is your spiritual act of worship.",
    "verse_th": "โรม 12:1 ดังนั้น​พี่น้อง​ครับ พระเจ้า​ได้​เมตตากรุณา​ต่อ​เรา ผม​ก็​เลย​ขอ​ร้อง​ให้​คุณ​มอบ​ร่างกาย​ของ​คุณ​เป็น​เครื่อง​บูชา​ที่​มี​ชีวิต​อยู่ เป็น​เครื่อง​บูชา​ที่​บริสุทธิ์ และ​เป็น​ที่​พอใจ​ของ​พระเจ้า การ​",
    "streamUrl": "fivefish.org/T80508",
    "trackDownloadUrl": "fivefish.org/T80508-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80508.zip",
    "programId": "80508",
    "languageVideoUrl": "https://www.youtube.com/watch?v=tGKH3qIYjEc&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T80508",
    "duration": "34:22",
    "trackCount": "25.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 30120,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Portrait of Jesus 1",
    "title_th": "ชีวิตของพระเยซู 1",
    "verse_en": "Romans 12:2 Do not conform any longer to the pattern of this world but be transformed by the renewing of your mind. Then you will be able to test and approve what God’s will is - His good, pleasing and perfect will.",
    "verse_th": "โรม 12:2 อย่า​ทำ​ตาม​อย่าง​คน​ใน​โลกนี้ แต่​ขอ​ยอม​ให้​พระเจ้า​เปลี่ยน​แปลง​คุณ คือ​พระองค์​จะ​ให้​จิตใจ​ใหม่​กับ​คุณ​เพื่อ​จะ​ได้​รู้​ว่า​พระเจ้า​ต้อง​การ​อะไร สิ่ง​ไหน​ดี สิ่ง​ไหน​พระองค์​ชอบใจ และ​สิ่ง​ไหน​สมบูรณ์แบบ",
    "streamUrl": "fivefish.org/T30120",
    "trackDownloadUrl": "fivefish.org/T30120-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30120.zip",
    "programId": "30120",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Jnl8T2wEDko&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T30120",
    "duration": "104:32",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 30121,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Portrait of Jesus 2",
    "title_th": "ชีวิตของพระเยซู 2",
    "verse_en": "Romans 12:9 Love must be sincere. Hate what is evil; cling to what is good.",
    "verse_th": "โรม 12:9 ให้​รัก​คน​อื่น​ด้วย​ความ​จริงใจ เกลียด​สิ่ง​ชั่วร้าย ยึด​มั่น​สิ่ง​ที่​ดี",
    "streamUrl": "fivefish.org/T30121",
    "trackDownloadUrl": "fivefish.org/T30121-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30121.zip",
    "programId": "30121",
    "shareUrl": "5fi.sh/T30121",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 32420,
    "iso3": "THA",
    "langId": "1124",
    "languageEn": "Thai Central",
    "langTh": "ไทยกลาง",
    "title_en": "Testimonies & Songs",
    "title_th": "คำพยาน & เพลง",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T32420",
    "trackDownloadUrl": "fivefish.org/T32420-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/32420.zip",
    "programId": "32420",
    "languageVideoUrl": "https://www.youtube.com/watch?v=AOwTf5y6H70&list=PLho9cJoXqQC-5MCH9vL7G3u5F11qYmoq9",
    "shareUrl": "5fi.sh/T32420",
    "duration": "41:50",
    "trackCount": "6.0",
    "sampleUrl": "/audio/Thai.Central.1124.mp3",
    "stableKey": "Thai Central"
  },
  {
    "id": 6851,
    "iso3": "KHB",
    "langId": "2286",
    "languageEn": "Thai Lu",
    "langTh": "ไทลื้อ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Romans 15:13 May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.",
    "verse_th": "โรม 15:13 ขอ​ให้​พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความหวัง ช่วย​เติม​ให้​คุณ​เต็มเปี่ยม​บริบูรณ์​ไป​ด้วย​ความ​ชื่นชม​ยินดี​และ​สันติสุข ตาม​ความ​ไว้วางใจ​ที่​คุณ​มี​ใน​พระองค์ เพื่อ​คุณ​จะ​ได้​มี​ความหวัง​อย่าง​เหลือล้น ด้วย​อำนาจ​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T6851",
    "trackDownloadUrl": "fivefish.org/T6851-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6851.zip",
    "programId": "6851",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Tqhh3g7DK3c&list=PLXcynA24_lTOQ_7_SHayl8SKVJ-awvMpE",
    "shareUrl": "5fi.sh/T6851",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Tai.Lu.06851.mp3",
    "stableKey": "Thai Lu"
  },
  {
    "id": 33831,
    "iso3": "TTS",
    "langId": "311",
    "languageEn": "Thai Northeastern",
    "langTh": "ไทยอีสาน",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Romans 3:23 For all have sinned and fall short of the glory of God.",
    "verse_th": "โรม 3:23 เพราะ​ทุก​คน​ทำ​บาป​เหมือน​กัน​หมด และ​เสื่อม​จาก​พระบารมี​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T33831",
    "trackDownloadUrl": "fivefish.org/T33831-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/33831.zip",
    "programId": "33831",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8aKxEoldeCE&list=PLho9cJoXqQC89BSsB4Vs0F8pmgfa4zMjQ",
    "shareUrl": "5fi.sh/T33831",
    "duration": "50:08",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Thai.Northeastern.33831.mp3",
    "stableKey": "Thai Northeastern"
  },
  {
    "id": 2810,
    "iso3": "TTS",
    "langId": "311",
    "languageEn": "Thai Northeastern",
    "langTh": "ไทยอีสาน",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Romans 4:20-21 Yet he did not waver through unbelief regarding the promise of God, but was strengthened in his faith and gave glory to God, being fully persuaded that God had power to do what He had promised.",
    "verse_th": "โรม 4:20-21 แต่​อับราฮัม​ไม่​เคย​สงสัย​ใน​คำ​สัญญา​ของ​พระเจ้า​เลย กลับ​มี​ความ​ไว้วางใจ​มาก​ขึ้น ซึ่ง​เป็น​การ​ให้​เกียรติ​กับ​พระเจ้า 21 อับราฮัม​เชื่อ​อย่าง​แน่ว​แน่​ว่า พระเจ้า​สามารถ​ทำ​ใน​สิ่ง​ที่​พระองค์​ได้​สัญญา​ไว้",
    "streamUrl": "fivefish.org/T2810",
    "trackDownloadUrl": "fivefish.org/T2810-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2810.zip",
    "programId": "2810",
    "languageVideoUrl": "https://www.youtube.com/watch?v=7xjjxn9fNBo&list=PLho9cJoXqQC89BSsB4Vs0F8pmgfa4zMjQ",
    "shareUrl": "5fi.sh/T2810",
    "duration": "38:48",
    "trackCount": "12.0",
    "sampleUrl": "/audio/Thai.Northeastern.311.mp3",
    "stableKey": "Thai Northeastern"
  },
  {
    "id": 2811,
    "iso3": "TTS",
    "langId": "311",
    "languageEn": "Thai Northeastern",
    "langTh": "ไทยอีสาน",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Romans 5:5 And hope does not put us to shame, because God’s love has been poured out into our hearts through the Holy Spirit, Who has been given to us.",
    "verse_th": "โรม 5:5 ความหวัง​นั้น​ไม่​เคย​ทำ​ให้​เรา​ผิดหวัง​เลย เพราะ​พระเจ้า​ได้​เท​ความรัก​ของ​พระองค์​เข้า​มา​ใน​จิตใจ​ของ​เรา ผ่าน​ทาง​พระวิญญาณ​บริสุทธิ์​ที่​พระองค์​ได้​ให้​กับ​เรา​ไว้",
    "streamUrl": "fivefish.org/T2811",
    "trackDownloadUrl": "fivefish.org/T2811-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2811.zip",
    "programId": "2811",
    "languageVideoUrl": "https://www.youtube.com/watch?v=RayhK6MYUXo&list=PLho9cJoXqQC89BSsB4Vs0F8pmgfa4zMjQ",
    "shareUrl": "5fi.sh/T2811",
    "duration": "36:18",
    "trackCount": "10.0",
    "sampleUrl": "/audio/Thai.Northeastern.311.mp3",
    "stableKey": "Thai Northeastern"
  },
  {
    "id": 3031,
    "iso3": "NOD",
    "langId": "101",
    "languageEn": "Thai Northern",
    "langTh": "ไทยเหนือ-กำเมือง",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Romans 5:8 But God demonstrates His own love for us in this: While we were still sinners, Christ died for us.",
    "verse_th": "โรม 5:8 แต่​พระเจ้า​ได้​แสดง​ความรัก​ต่อ​เรา โดย​ยอม​ส่ง​พระคริสต์​มา​ตาย​เพื่อ​เรา ทั้งๆ​ที่​เรา​ยัง​เป็น​คน​บาป​อยู่",
    "streamUrl": "fivefish.org/T3031",
    "trackDownloadUrl": "fivefish.org/T3031-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3031.zip",
    "programId": "3031",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lc11rdbiKLo&list=PLho9cJoXqQC8tw2cmPt3V14oe-CG-Jj8i",
    "shareUrl": "5fi.sh/T3031",
    "duration": "39:51",
    "trackCount": "12.0",
    "sampleUrl": "/audio/Thai.Northern.101.mp3",
    "stableKey": "Thai Northern"
  },
  {
    "id": 78070,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "The Book of James; Epistle to Ephesians",
    "title_th": "พระธรรมยากอบ และพระธรรมเอเฟซัส",
    "verse_en": "Romans 6:23 For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.",
    "verse_th": "โรม 6:23 เพราะ​ค่าจ้าง​ที่​ความบาป​จ่าย​ให้​กับ​เรา​คือ​ความตาย แต่​ของขวัญ​ที่​พระเจ้า​ให้​กับ​เรา​นั้น​คือ​ชีวิต​ที่​อยู่​กับ​พระเจ้า​ตลอด​ไป ใน​พระเยซู​คริสต์เจ้า​ของ​เรา",
    "streamUrl": "fivefish.org/T78070",
    "trackDownloadUrl": "fivefish.org/T78070-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78070.zip",
    "programId": "78070",
    "languageVideoUrl": "https://www.youtube.com/watch?v=9agxVoYBKDM&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78070",
    "duration": "59:22",
    "trackCount": "35.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 10920,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 1",
    "title_th": "พระคำแห่งชีวิต 1",
    "verse_en": "Romans 8:32 He who did not spare His own Son, but gave Him up for us all-how will He not also, along with Him, graciously give us all things?",
    "verse_th": "โรม 8:32 พระองค์​ไม่​หวง​แม้แต่​พระบุตร​ของ​พระองค์​เอง แต่​กลับ​มอบ​พระบุตร​นั้น​ให้​มา​ตาย​เพื่อ​เรา​ทุก​คน ถ้า​อย่าง​นั้น​พระองค์​จะ​ไม่​ยิ่ง​ให้​ทุก​สิ่ง​ทุก​อย่าง​กับ​เรา​พร้อม​กับ​พระบุตร​ด้วย​หรือ",
    "streamUrl": "fivefish.org/T10920",
    "trackDownloadUrl": "fivefish.org/T10920-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/10920.zip",
    "programId": "10920",
    "languageVideoUrl": "https://www.youtube.com/watch?v=9hQnXr7V0PY&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T10920",
    "duration": "35:04",
    "trackCount": "10.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 27241,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 2, Believing in God",
    "title_th": "พระคำแห่งชีวิต 2, เชื่อในพระเจ้า",
    "verse_en": "1 Corinthians 14:33 For God is not a God of disorder but of peace - as in all the congregations of the Lord's people.",
    "verse_th": "1 โครินธ์ 14:33 เพราะ​พระเจ้า​ไม่​ได้​เป็น​พระเจ้า​แห่ง​ความ​วุ่นวาย แต่​เป็น​พระเจ้า​แห่ง​สันติสุข เหมือน​กับ​ที่​พระองค์​เป็น​ใน​ที่ประชุม​ทุก​แห่ง​ของ​คน​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T27241",
    "trackDownloadUrl": "fivefish.org/T27241-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/27241.zip",
    "programId": "27241",
    "languageVideoUrl": "https://www.youtube.com/watch?v=nI-CigRUjjA&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T27241",
    "duration": "59:53",
    "trackCount": "16.0",
    "sampleUrl": "/audio/Thai.Southern.27241.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 25790,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 3, Questions and Answers",
    "title_th": "พระคำแห่งชีวิต 3, คำถามและคำตอบ",
    "verse_en": "1 Corinthians 14:40 But everything should be done in a fitting and orderly way.",
    "verse_th": "1 โครินธ์ 14:40 แต่​ให้​ทำ​ทุก​อย่างนี้ อย่าง​เหมาะสม​และ​เป็น​ระเบียบ",
    "streamUrl": "fivefish.org/T25790",
    "trackDownloadUrl": "fivefish.org/T25790-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/25790.zip",
    "programId": "25790",
    "languageVideoUrl": "https://www.youtube.com/watch?v=TstGA7M85ok&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T25790",
    "duration": "59:54",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 25791,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 4, Jesus Died for Us",
    "title_th": "พระคำแห่งชีวิต 4, พระเยซูสิ้นพระชนม์เพื่อเรา",
    "verse_en": "1 Corinthians 15:58 Therefore, my dear brothers, stand firm. Let nothing move you. Always give yourselves fully to the work of the Lord, because you know that your labor in the Lord is not in vain.",
    "verse_th": "1 โครินธ์ 15:58 ดังนั้น พี่น้อง​ที่รัก ให้​มั่นคง อย่า​หวั่นไหว และ​ให้​ทุ่มเท​กับ​งาน​ของ​องค์​เจ้า​ชีวิต​ตลอด​เวลา เพราะ​คุณ​ก็​รู้​ว่า​จะ​ได้รับ​รางวัล​สำหรับ​งาน​หนัก​ที่​คุณ​ทำ​เพื่อ​องค์​เจ้า​ชีวิต​นั้น​แน่",
    "streamUrl": "fivefish.org/T25791",
    "trackDownloadUrl": "fivefish.org/T25791-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/25791.zip",
    "programId": "25791",
    "languageVideoUrl": "https://www.youtube.com/watch?v=J_MTzwrzuzU&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T25791",
    "duration": "61:13",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 78065,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 5, Creation to Christ",
    "title_th": "พระคำแห่งชีวิต 5, ตั้งแต่การสร้างจนถึงพระคริสต์",
    "verse_en": "1 Corinthians 2:11 For who knows a person's thoughts except their own spirit within them? In the same way no one knows the thoughts of God except the Spirit of God.",
    "verse_th": "1 โครินธ์ 2:11 เพราะ​ไม่มี​ใคร​รู้​ความคิด​ของ​คนอื่น​ได้​นอกจาก​วิญญาณ​ที่​อยู่​ใน​ตัว​ของ​เขา​เอง เช่น​เดียว​กัน ไม่มี​ใคร​รู้​ความคิด​ของ​พระเจ้า​ได้​นอกจาก​พระวิญญาณ​ของ​พระองค์​เอง",
    "streamUrl": "fivefish.org/T78065",
    "trackDownloadUrl": "fivefish.org/T78065-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78065.zip",
    "programId": "78065",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Uqgg-V5gJ9A&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78065",
    "duration": "59:13",
    "trackCount": "31.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 78066,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 6, Why Did Jesus Die?",
    "title_th": "พระคำแห่งชีวิต 6, ทำไมพระเยซูถึงสิ้นพระชนม์",
    "verse_en": "1 Corinthians 2:12 We have not received the spirit of the world but the Spirit who is from God, that we may understand what God has freely given us.",
    "verse_th": "1 โครินธ์ 2:12 เรา​ไม่ได้​รับ​วิญญาณ​ของ​โลกนี้ แต่​รับ​พระวิญญาณ​ที่​มา​จาก​พระเจ้า เพื่อ​เรา​จะ​ได้​เข้าใจ​สิ่งต่างๆ​ที่​พระเจ้า​ให้​เรา และ​พระองค์​ก็​ให้​เรา​อย่าง​ใจกว้าง​จริงๆ",
    "streamUrl": "fivefish.org/T78066",
    "trackDownloadUrl": "fivefish.org/T78066-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78066.zip",
    "programId": "78066",
    "languageVideoUrl": "https://www.youtube.com/watch?v=aZ5SqYTIp-0&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78066",
    "duration": "59:18",
    "trackCount": "42.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 78067,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 7, Fear of Evil Spirits",
    "title_th": "พระคำแห่งชีวิต 7, กลัววิญญาณชั่ว",
    "verse_en": "1 Corinthians 3:16 Don’t you know that you yourselves are God’s temple and that God’s Spirit lives in you?",
    "verse_th": "1 โครินธ์ 3:16 พวกคุณ​ไม่​รู้​หรือ​ว่า​พวกคุณ​เป็น​วิหาร​ของ​พระเจ้า และ​พระวิญญาณ​ของ​พระเจ้า​ก็​อยู่​ใน​หมู่​พวกคุณ",
    "streamUrl": "fivefish.org/T78067",
    "trackDownloadUrl": "fivefish.org/T78067-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78067.zip",
    "programId": "78067",
    "languageVideoUrl": "https://www.youtube.com/watch?v=rR6HnXi3Viw&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78067",
    "duration": "58:33",
    "trackCount": "44.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 78068,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 8, Life of Christ 1",
    "title_th": "พระคำแห่งชีวิต 8, ชีวิตของพระคริสต์ 1",
    "verse_en": "2 Corinthians 4:1 Therefore, since through God's mercy we have this ministry, we do not lose heart.",
    "verse_th": "2 โครินธ์ 4:1 เรา​ไม่​ย่อท้อ​ง่ายๆ​เพราะ​งานนี้​พระเจ้า​เอง​เป็น​ผู้​มอบ​ให้​เรา​ทำ",
    "streamUrl": "fivefish.org/T78068",
    "trackDownloadUrl": "fivefish.org/T78068-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78068.zip",
    "programId": "78068",
    "languageVideoUrl": "https://www.youtube.com/watch?v=1w_5l52j_8k&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78068",
    "duration": "58:42",
    "trackCount": "41.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 78069,
    "iso3": "SOU",
    "langId": "1167",
    "languageEn": "Thai Southern",
    "langTh": "ไทยใต้",
    "title_en": "Words of Life 9, Life of Christ 2",
    "title_th": "พระคำแห่งชีวิต 9, ชีวิตของพระคริสต์ 2",
    "verse_en": "2 Corinthians 4:5 For we do not preach ourselves, but Jesus Christ our Lord, and ourselves as your servants for Jesus’ sake.",
    "verse_th": "2 โครินธ์ 4:5 เรา​ไม่ได้​ประกาศ​ตัว​เรา​เอง แต่​เรา​ประกาศ​ว่า​พระเยซู​คริสต์​เป็น​องค์​เจ้า​ชีวิต และ​ตัวเรา​เอง​เป็น​ทาส​ของ​พวกคุณ เพราะ​เห็น​แก่​พระเยซู",
    "streamUrl": "fivefish.org/T78069",
    "trackDownloadUrl": "fivefish.org/T78069-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/78069.zip",
    "programId": "78069",
    "languageVideoUrl": "https://www.youtube.com/watch?v=06BFPQa-HaE&list=PLho9cJoXqQC-o2dQL2end3qtclCP7ow6O",
    "shareUrl": "5fi.sh/T78069",
    "duration": "58:36",
    "trackCount": "37.0",
    "sampleUrl": "/audio/Thai.Southern.1167.mp3",
    "stableKey": "Thai Southern"
  },
  {
    "id": 6841,
    "iso3": "PRT",
    "langId": "2289",
    "languageEn": "Tin Eastern",
    "langTh": "ลัวะ ตะวันออก",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "2 Corinthians 5:17 Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!",
    "verse_th": "2 โครินธ์ 5:17 ถ้า​ใคร​ก็ตาม​มีส่วน​ใน​พระคริสต์ คนนั้น​ได้​เข้า​สู่​โลกใหม่​ที่​พระเจ้า​ได้​สร้าง​ขึ้นมา​แล้ว สิ่ง​เก่าๆ​หายไป​หมดแล้ว ดูสิ สิ่ง​ใหม่ๆ​ก็​เกิดขึ้น",
    "streamUrl": "fivefish.org/T6841",
    "trackDownloadUrl": "fivefish.org/T6841-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/6841.zip",
    "programId": "6841",
    "languageVideoUrl": "https://www.youtube.com/watch?v=UjtOfQuBkeQ&list=PLho9cJoXqQC_W3xPCuUSfSvqRQCxDGTXn",
    "shareUrl": "5fi.sh/T6841",
    "duration": "15:36",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Tin.Eastern.2289.mp3",
    "stableKey": "Tin Eastern"
  },
  {
    "id": 10841,
    "iso3": "MLF",
    "langId": "2290",
    "languageEn": "Tin Western",
    "langTh": "ลัวะ ตะวันตก",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "2 Corinthians 5:21 God made Him who had no sin to be sin for us, so that in Him we might become the righteousness of God.",
    "verse_th": "2 โครินธ์ 5:21 พระเจ้า​ทำให้​พระคริสต์​ผู้​ที่​ไม่มี​บาป​กลายเป็น​คนบาป​เพื่อ​เรา เพื่อ​ว่า​ใน​พระคริสต์​นั้น ความ​ซื่อสัตย์​ของ​พระเจ้า จะ​ได้​เห็น​เด่นชัด​ใน​ตัวเรา",
    "streamUrl": "fivefish.org/T10841",
    "trackDownloadUrl": "fivefish.org/T10841-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/10841.zip",
    "programId": "10841",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jPtllR2WQXk&list=PLXduqvGi62cvlLnlTz225KctR-CR3Qz2l",
    "shareUrl": "5fi.sh/T10841",
    "duration": "26:46",
    "trackCount": "8.0",
    "sampleUrl": "/audio/Tin.Western.10841.mp3",
    "stableKey": "Tin Western"
  },
  {
    "id": 37634,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "5 loaves, 2 fishes & good diet",
    "title_th": "ขนมปังห้าก้อน ปลาสองตัวและอาหาร",
    "verse_en": "2 Corinthians 7:1 Therefore, since we have these promises, dear friends, let us purify ourselves from everything that contaminates body and spirit, perfecting holiness out of reverence for God.",
    "verse_th": "2 โครินธ์ 7:1 เพื่อน​ที่รัก ในเมื่อ​เรา​มี​คำ​สัญญา​พวกนี้ ก็​ขอให้​เรา​ชำระ​ตัวเอง​จาก​ทุกสิ่ง​ทุกอย่าง​ที่​ทำ​ให้​ร่างกาย​และ​จิตใจ​สกปรก ทำ​ตัว​ให้​บริสุทธิ์​ครบถ้วน​เพราะ​ยำเกรง​พระเจ้า",
    "streamUrl": "fivefish.org/T37634",
    "trackDownloadUrl": "fivefish.org/T37634-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37634.zip",
    "programId": "37634",
    "languageVideoUrl": "https://www.youtube.com/watch?v=A5yg3k2mTfk&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37634",
    "duration": "36:02",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37629,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Festivals & Prayer",
    "title_th": "เทศกาลและคำอธิษฐาน",
    "verse_en": "2 Corinthians 9:6-7 Remember this: “Whoever sows sparingly will also reap sparingly, and whoever sows generously will also reap generously. Each man should give what he has decided in his heart to give, not reluctantly or under compulsion, for God loves a cheerful giver.”",
    "verse_th": "2 โครินธ์ 9:6-7 จำ​เอา​ไว้​ว่า “คน​ที่​หว่านน้อย​ก็​จะ​เก็บเกี่ยว​น้อย และ​คน​ที่​หว่านมาก​ก็​จะ​เก็บเกี่ยว​มากแต่ละ​คน​ควร​จะ​ให้​ตาม​ที่​ตั้งใจ​ไว้ ไม่ใช่​ให้​ด้วย​ความ​เสียดาย​หรือ​ถูก​บังคับ เพราะ​พระเจ้า​รัก​คน​ที่​ให้​ด้วย​ใจ​ที่​ชื่นชม​ยินดี”",
    "streamUrl": "fivefish.org/T37629",
    "trackDownloadUrl": "fivefish.org/T37629-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37629.zip",
    "programId": "37629",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-i9IAwQpvv8&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37629",
    "duration": "46:27",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37626,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Freedom from Fear",
    "title_th": "อิสรภาพจากความกลัว",
    "verse_en": "Galatians 2:20 I have been crucified with Christ and I no longer live, but Christ lives in me. The life I live in the body, I live by faith in the Son of God, who loved me and gave Himself for me.",
    "verse_th": "กาลาเทีย 2:20 ผม​ได้​ถูก​ตรึง​บน​ไม้กางเขน​จน​ตาย​ไป​พร้อม​กับ​พระคริสต์ คน​ที่​มี​ชีวิต​อยู่​ตอนนี้​ไม่ใช่​ตัว​ผม​แล้ว​แต่​เป็น​พระคริสต์​ต่างหาก​ที่​อยู่​ใน​ตัว​ผม ชีวิต​ที่​มี​อยู่​เดี๋ยวนี้​ก็​เป็น​ชีวิต​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า ผู้​ที่รัก​ผม​และ​เสียสละ​ชีวิต​ให้​ผม",
    "streamUrl": "fivefish.org/T37626",
    "trackDownloadUrl": "fivefish.org/T37626-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37626.zip",
    "programId": "37626",
    "languageVideoUrl": "https://www.youtube.com/watch?v=BuJQOTdCbd8&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37626",
    "duration": "36:29",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37635,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Good Neighbour & Forgiveness",
    "title_th": "เพื่อนบ้านที่ดีและการให้อภัย",
    "verse_en": "Galatians 4:4-5 But when the set time had fully come, God sent His Son, born of a woman, born under the law, to redeem those under the law, that we might receive adoption to sonship.",
    "verse_th": "กาลาเทีย 4:4-5 แต่​เมื่อ​ถึง​เวลา​ที่​เหมาะสม พระเจ้า​ก็​ได้​ส่ง​พระบุตร​ของ​พระองค์​โดย​คลอด​ออก​มา​จาก​ผู้หญิง และ​มีชีวิต​อยู่​ภายใต้​กฎ เพื่อ​มา​ปลดปล่อย​คน​ที่​อยู่​ภายใต้​กฎ​ให้​เป็น​อิสระ และ​เพื่อ​เรา​ทุกคน​จะ​ได้​เป็น​ลูก​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T37635",
    "trackDownloadUrl": "fivefish.org/T37635-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37635.zip",
    "programId": "37635",
    "languageVideoUrl": "https://www.youtube.com/watch?v=EkkSdl-zANk&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37635",
    "duration": "44:44",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 35660,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Galatians 5:1 It is for freedom that Christ has set us free. Stand firm, then, and do not let yourselves be burdened again by a yoke of slavery.",
    "verse_th": "กาลาเทีย 5:1 เมื่อ​พระคริสต์​ได้​ปลดปล่อย​ให้​เรา​เป็น​อิสระ​แล้ว ก็​ให้​อยู่​อย่าง​คน​อิสระ​เถิด รักษา​มัน​ไว้​ให้ดี อย่า​กลับ​ไป​เป็น​ทาส​ของ​กฎ​อีก",
    "streamUrl": "fivefish.org/T35660",
    "trackDownloadUrl": "fivefish.org/T35660-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/35660.zip",
    "programId": "35660",
    "languageVideoUrl": "https://www.youtube.com/watch?v=awDeo6T_NgY&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T35660",
    "duration": "74:02",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Urak.Lawoi.35660.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37628,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Sea people & Value of Women",
    "title_th": "ชาวทะเลและคุณค่าของผู้หญิง",
    "verse_en": "Galatians 6:10 Therefore, as we have opportunity, let us do good to all people, especially to those who belong to the family of believers.",
    "verse_th": "กาลาเทีย 6:10 ดังนั้น เมื่อ​มี​โอกาส​ก็​ให้​ทำดี​กับ​ทุกคน โดย​เฉพาะ​อย่างยิ่ง​กับ​ครอบครัว​ที่​ไว้วางใจ​ใน​พระเจ้า",
    "streamUrl": "fivefish.org/T37628",
    "trackDownloadUrl": "fivefish.org/T37628-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37628.zip",
    "programId": "37628",
    "languageVideoUrl": "https://www.youtube.com/watch?v=9kV0Qf-2_eQ&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37628",
    "duration": "59:28",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37636,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Songs",
    "title_th": "เพลง",
    "verse_en": "Galatians 6:9 Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.",
    "verse_th": "กาลาเทีย 6:9 อย่า​เพิ่ง​ท้อแท้​ใน​การ​ทำดี เพราะ​เมื่อ​ถึง​เวลา​ที่​เหมาะ คุณ​ก็​จะ​ได้​เก็บเกี่ยว​ผล​จาก​การ​ทำดี​นั้น ถ้า​ไม่​เลิก​ไป​ซะก่อน​นะ",
    "streamUrl": "fivefish.org/T37636",
    "trackDownloadUrl": "fivefish.org/T37636-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37636.zip",
    "programId": "37636",
    "languageVideoUrl": "https://www.youtube.com/watch?v=J2ucQzDiB94&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37636",
    "duration": "74:38",
    "trackCount": "26.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 34990,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Testimonies & Songs",
    "title_th": "คำพยาน & เพลง",
    "verse_en": "Ephesians 2:8-9 For it is by grace that you have been saved, through faith-and this not from yourselves, it is the gift of God-not by works, so that no one can boast.",
    "verse_th": "เอเฟซัส 2:8-9 ที่​พวกคุณ​รอด​นั้น​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระเจ้า ผ่าน​มา​ทาง​ความเชื่อ​ของ​คุณ ไม่ได้​มา​จาก​ตัว​ของ​คุณ​เอง แต่​เป็น​ของขวัญ​ที่​มา​จาก​พระเจ้ามัน​ไม่ได้​เป็น​ผล​มา​จาก​การ​กระทำ​ของ​ใคร เพื่อ​จะ​ได้​ไม่มี​ใคร​โอ้อวด​ได้",
    "streamUrl": "fivefish.org/T34990",
    "trackDownloadUrl": "fivefish.org/T34990-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/34990.zip",
    "programId": "34990",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Iid8YTvCNqw&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T34990",
    "duration": "88:54",
    "trackCount": "7.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 37627,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Victory over sin & Power of Unity",
    "title_th": "ชัยชนะเหนือบาปและพลังแห่งความสามัคคี",
    "verse_en": "Ephesians 3:16-17 I pray that out of His glorious riches He may strengthen you with power through His Spirit in your inner being, so that Christ may dwell in your hearts through faith. And I pray that you, being rooted and established in love.",
    "verse_th": "เอเฟซัส 3:16-17 ขอให้​พระเจ้า​ที่​มั่งคั่ง​มหาศาล ช่วย​ให้​พวกคุณ​มี​พลังใจ​ที่​เข้มแข็ง​ผ่าน​ทาง​พระวิญญาณ​ของ​พระองค์ 17 ขอให้​พระคริสต์​ตั้ง​มั่นคง​อยู่​ในใจ​ของ​คุณ​เพราะ​คุณ​ไว้วางใจ​ใน​พระองค์ ขอให้​ลง​รากลึก​มั่นคง​ใน​ความรัก",
    "streamUrl": "fivefish.org/T37627",
    "trackDownloadUrl": "fivefish.org/T37627-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37627.zip",
    "programId": "37627",
    "languageVideoUrl": "https://www.youtube.com/watch?v=-U73kMCaW6I&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T37627",
    "duration": "37:37",
    "trackCount": "2.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 9410,
    "iso3": "URK",
    "langId": "1135",
    "languageEn": "Urak Lawoi",
    "langTh": "อูรักลาโวจ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Ephesians 3:20-21 Now to Him who is able to do immeasurably more than all we ask or imagine, according to His power that is at work within us, to Him be glory in the church and in Christ Jesus throughout all generations, for ever and ever!",
    "verse_th": "เอเฟซัส 3:20-21 พระเจ้า​สามารถ​ทำได้​ทุกสิ่ง​มาก​ยิ่งกว่า​ที่​เรา​จะขอ​หรือ​คิด​ได้ ด้วย​ฤทธิ์​อำนาจ​ของ​พระองค์​ที่​กำลัง​ทำงาน​อยู่​ใน​ตัวเรา ขอให้​พระเจ้า​ได้รับ​เกียรติ​ทั้ง​จาก​หมู่ประชุม​ของ​พระองค์ และ​จาก​พระเยซู​คริสต์​ทุกยุค​ทุกสมัย​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T9410",
    "trackDownloadUrl": "fivefish.org/T9410-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/9410.zip",
    "programId": "9410",
    "languageVideoUrl": "https://www.youtube.com/watch?v=lyrRG1GwSkY&list=PLho9cJoXqQC91RD1sU2tA2vvLGXdnxqEk",
    "shareUrl": "5fi.sh/T9410",
    "duration": "18:41",
    "trackCount": "6.0",
    "sampleUrl": "/audio/Urak.Lawoi.1135.mp3",
    "stableKey": "Urak Lawoi"
  },
  {
    "id": 64433,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Ephesians 5:3 But among you there must not be even a hint of sexual immorality, or of any kind of impurity, or of greed, because these are improper for God’s holy people.",
    "verse_th": "เอเฟซัส 5:3 เรื่อง​ความ​ผิดบาป​ทางเพศ เรื่อง​ลามก​ทุกอย่าง หรือ​ความ​มักมาก​ใน​กาม แม้แต่​จะ​พูดถึง​ก็​อย่าเลย เพราะ​มัน​ไม่เหมาะ​กับ​คน​ที่​เป็น​ของ​พระเจ้า",
    "streamUrl": "fivefish.org/T64433",
    "trackDownloadUrl": "fivefish.org/T64433-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64433.zip",
    "programId": "64433",
    "languageVideoUrl": "https://www.youtube.com/watch?v=n0T145EzxNo&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T64433",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 74723,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Philippians 2:3-4 Do nothing out of selfish ambition or vein conceit, but in humility consider others better than yourselves. Each of you should look not only to your own interests, but also the interests of others.",
    "verse_th": "ฟีลิปปี 2:3-4 อย่า​ทำ​อะไร​ที่​ชิงดี​ชิงเด่น​กัน หรือ​เพราะ​หลง​คิด​ว่า​ตัวเอง​เก่ง แต่​ให้​ถ่อมตัว​ลง และ​มอง​คน​อื่น​ว่า​สำคัญ​กว่า​ตัวเอง 4 อย่า​ให้​ใคร​คิด​เห็น​แต่​ประโยชน์​ส่วนตัว แต่​ให้​คิดถึง​ประโยชน์​ของ​คน​อื่น​ด้วย",
    "streamUrl": "fivefish.org/T74723",
    "trackDownloadUrl": "fivefish.org/T74723-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74723.zip",
    "programId": "74723",
    "languageVideoUrl": "https://www.youtube.com/watch?v=vcTOG5CU-Ms&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T74723",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 74724,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Philippians 4:12 I know what it is to be in need, and I know what it is to have plenty. I have learned the secret of being content in any and every situation, whether well fed or hungry, whether living in plenty or in want.",
    "verse_th": "ฟีลิปปี 4:12 ผม​รู้​ว่า​จะ​พอใจ​ได้​อย่างไร​ทั้ง​ตอน​ที่​ขัดสน และ​ตอน​ที่​มี​อย่าง​เหลือ​เฟือ ไม่​ว่า​จะ​อยู่​ใน​สภาพ​ไหน​ก็​ตาม ผม​ได้​เรียนรู้​เคล็ดลับ​ว่า​จะ​อยู่​อย่างไร ใน​เวลา​ที่​อิ่ม​ท้อง​หรือ​หิวโหย ใน​เวลา​ที่​มี​เหลือเฟือ​หรือ​ขาดแคลน",
    "streamUrl": "fivefish.org/T74724",
    "trackDownloadUrl": "fivefish.org/T74724-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74724.zip",
    "programId": "74724",
    "languageVideoUrl": "https://www.youtube.com/watch?v=_oYNg1wIurU&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T74724",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 74725,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "Philippians 4:13 I can do everything through Him who gives me strength.",
    "verse_th": "ฟีลิปปี 4:13 พระคริสต์​ให้​ผม​มี​กำลัง​ที่​จะ​ทน​ได้​กับ​ทุก​สิ่ง",
    "streamUrl": "fivefish.org/T74725",
    "trackDownloadUrl": "fivefish.org/T74725-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74725.zip",
    "programId": "74725",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8RfVQngT5cY&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T74725",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 74726,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Philippians 4:19 And my God will meet all your needs according to His glorious riches in Jesus Christ.",
    "verse_th": "ฟีลิปปี 4:19 พระเจ้า​ของ​ผม​จะ​ให้​ทุก​สิ่ง​ที่​จำเป็น​สำหรับ​คุณ จาก​ความ​มั่งคั่ง​อัน​มหาศาล​ของ​พระองค์​ที่​อยู่​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T74726",
    "trackDownloadUrl": "fivefish.org/T74726-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74726.zip",
    "programId": "74726",
    "languageVideoUrl": "https://www.youtube.com/watch?v=zHUfU-8nJgM&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T74726",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 74727,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "Philippians 4:6 Do not be anxious about anything, but in everything, by prayer and petition, with thanksgiving, present your requests to God.",
    "verse_th": "ฟีลิปปี 4:6 เลิก​กังวล​ได้​แล้ว แต่​ให้​อธิษฐาน​ใน​ทุกๆ​ สถานการณ์ และ​ขอ​ใน​สิ่ง​ที่​คุณ​ต้องการ​จาก​พระเจ้า และ​เมื่อ​อธิษฐาน​ก็​ให้​ขอบคุณ​พระเจ้า​ด้วย",
    "streamUrl": "fivefish.org/T74727",
    "trackDownloadUrl": "fivefish.org/T74727-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74727.zip",
    "programId": "74727",
    "languageVideoUrl": "https://www.youtube.com/watch?v=gSmsG6z9jNk&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T74727",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 77480,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Philippians 4:7 And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus.",
    "verse_th": "ฟีลิปปี 4:7 แล้ว​สันติสุข​ที่​มา​จาก​พระเจ้า ซึ่ง​ดี​กว่า​สันติสุข​ที่​มา​จาก​แผน​งาน​ต่างๆ​ของ​มนุษย์ จะ​ปกป้อง​รักษา​จิตใจ และ​ความคิด​ของ​คุณ​ไว้​ใน​พระเยซู​คริสต์",
    "streamUrl": "fivefish.org/T77480",
    "trackDownloadUrl": "fivefish.org/T77480-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/77480.zip",
    "programId": "77480",
    "languageVideoUrl": "https://www.youtube.com/watch?v=DbqM3XzaRT8&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T77480",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.77480.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 77490,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "Philippians 4:8 Finally, brothers and sisters, whatever is true, whatever is noble, whatever is right, whatever is pure, whatever is lovely, whatever is admirable—if anything is excellent or praiseworthy—think about such things.",
    "verse_th": "ฟีลิปปี 4:8 สุดท้าย​นี้ พี่น้อง​ครับ อะไร​ก็​ตาม​ที่​จริง ที่​น่านับถือ ที่​ถูกต้อง ที่​บริสุทธิ์ ที่​น่ารัก ที่​น่ายกย่อง นั่น​คือ​อะไรก็ตาม​ที่​ยอดเยี่ยม​และ​น่าสรรเสริญ ให้​เอาใจใส่​ใน​เรื่อง​เหล่า​นั้น",
    "streamUrl": "fivefish.org/T77490",
    "trackDownloadUrl": "fivefish.org/T77490-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/77490.zip",
    "programId": "77490",
    "languageVideoUrl": "https://www.youtube.com/watch?v=o6npc9pDSAg&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T77490",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 77500,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "Colossians 3:1-2 Since, then, you have been raised with Christ, set your hearts on things above, where Christ is, seated at the right hand of God. Set your minds on things above, not on earthly things.",
    "verse_th": "โคโลสี 3:1-2 พระเจ้า​ได้​ทำ​ให้​คุณ​ฟื้น​ขึ้น​จาก​ความตาย​กับ​พระคริสต์​แล้ว อย่าง​นั้น​ให้​แสวงหา​สิ่ง​ต่างๆ​ที่​อยู่​เบื้องบน ซึ่ง​เป็น​ที่​ที่​พระคริสต์​นั่ง​อยู่​ทาง​ขวา​มือ​ของ​พระเจ้า 2ให้​ใจ​ของ​คุณ​จดจ่อ​อยู่​กับ​สิ่ง​ที่​อยู่​เบื้องบน ไม่​ใช่​สิ่ง​ที่​อยู่​ใน​โลก",
    "streamUrl": "fivefish.org/T77500",
    "trackDownloadUrl": "fivefish.org/T77500-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/77500.zip",
    "programId": "77500",
    "languageVideoUrl": "https://www.youtube.com/watch?v=s4GHFOdiR7U&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T77500",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 64434,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Lord Your Name Be Lifted High",
    "title_th": "ยกพระนามของพระเจ้าสูงสุด",
    "verse_en": "Colossians 3:12 Therefore, as God's chosen people, holy and dearly loved, clothe yourselves with compassion, kindness, humility, gentleness and patience.",
    "verse_th": "โคโลสี 3:12 ดังนั้น​ใน​ฐานะ​ที่​เรา​เป็น​คน​ที่​พระเจ้า​ได้​เลือก เป็น​คน​ของ​พระเจ้า และ​เป็น​คน​ที่​พระองค์​รัก ก็​ให้​สวม​ใส่​ความ​เห็นอก​เห็นใจ ความ​มี​น้ำใจ ความ​ถ่อม​ตน ความ​สุภาพ​อ่อนโยน และ​ความอดทน",
    "streamUrl": "fivefish.org/T64434",
    "trackDownloadUrl": "fivefish.org/T64434-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64434.zip",
    "programId": "64434",
    "languageVideoUrl": "https://www.youtube.com/watch?v=jQ213Icz61U&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T64434",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 31590,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Portrait of Jesus",
    "title_th": "ชีวิตของพระเยซู",
    "verse_en": "Colossians 3:15 Let the peace of Christ rule in your hearts, since as members of one body you were called to peace. And be thankful.",
    "verse_th": "โคโลสี 3:15 ขอให้​สันติสุข​จาก​พระคริสต์​มา​ครอบ​ครอง​จิตใจ​ของ​คุณ เพราะ​พระเจ้า​ได้​เรียก​คุณ​ให้​อยู่​กัน​อย่าง​สันติ​ใน​ร่างกาย​เดียว​กัน และ​ขอให้​เป็น​คน​ที่​รู้จัก​ขอบคุณ​พระเจ้า​อยู่​เสมอ",
    "streamUrl": "fivefish.org/T31590",
    "trackDownloadUrl": "fivefish.org/T31590-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31590.zip",
    "programId": "31590",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Tm_HCC5pwQg&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T31590",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 2781,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Words of Life (H)",
    "title_th": "พระคำแห่งชีวิต (H)",
    "verse_en": "1 Timothy 1:17 Now to the King eternal, immortal, invisible, the only God, be honor and glory for ever and ever. Amen.",
    "verse_th": "1 ทิโมธี 1:17 ขอให้​พระองค์​ผู้​เป็น​กษัตริย์​ของ​คน​ทุกยุค​ทุกสมัย ผู้​ไม่​มี​วัน​ตาย ผู้​ไม่​มี​ใคร​มอง​เห็น​ได้ และ​ผู้​เป็น​พระเจ้า​แต่​เพียง​องค์​เดียว ได้รับ​เกียรติ​และ​สง่าราศี อยู่​เสมอ​และ​ตลอดไป อาเมน",
    "streamUrl": "fivefish.org/T2781",
    "trackDownloadUrl": "fivefish.org/T2781-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2781.zip",
    "programId": "2781",
    "languageVideoUrl": "https://www.youtube.com/watch?v=uyI_0xGtoW0&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T2781",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 2740,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Words of Life (M) 1",
    "title_th": "พระคำแห่งชีวิต (M) 1",
    "verse_en": "2 Timothy 2:22 Flee the evil desires of youth and pursue righteousness, faith, love and peace, along with those who call on the Lord out of a pure heart.",
    "verse_th": "2 ทิโมธี 2:22 ให้​วิ่งหนี​จาก​ราคะตัณหา​ของ​คน​หนุ่มสาว แต่​ไล่ตาม​สิ่ง​ที่​ถูกต้อง เช่น​ความเชื่อ ความรัก และ​สันติสุข ร่วมกับ​คน​เหล่านั้น​ที่​ร้องเรียก​องค์​เจ้า​ชีวิต​ด้วย​ใจ​ที่​สะอาด​บริสุทธิ์",
    "streamUrl": "fivefish.org/T2740",
    "trackDownloadUrl": "fivefish.org/T2740-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2740.zip",
    "programId": "2740",
    "languageVideoUrl": "https://www.youtube.com/watch?v=51secNp_kxc&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T2740",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 2741,
    "iso3": "URD",
    "langId": "61",
    "languageEn": "Urdu",
    "langTh": "อูรดู",
    "title_en": "Words of Life (M) 2",
    "title_th": "พระคำแห่งชีวิต (M) 2",
    "verse_en": "2 Timothy 3:16 All Scripture is God-breathed and is useful for teaching, rebuking, correcting and training in righteousness.",
    "verse_th": "2 ทิโมธี 3:16 ทุกๆข้อ​ใน​พระคัมภีร์ พระเจ้า​เป็น​ผู้​ดลใจ​ให้​เขียน​ขึ้นมา เพื่อ​เป็น​ประโยชน์​ใน​การ​สั่งสอน​ความจริง ชี้​ให้​คน​เห็น​ถึง​ความบาป​ใน​ชีวิต ช่วย​ปรับปรุง​แก้ไข​ให้​คนดี​ขึ้น และ​ฝึก​คน​ให้​ทำ​ตามใจ​พระเจ้า",
    "streamUrl": "fivefish.org/T2741",
    "trackDownloadUrl": "fivefish.org/T2741-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/2741.zip",
    "programId": "2741",
    "languageVideoUrl": "https://www.youtube.com/watch?v=gArJljjAYjo&list=PL-5yEg0Ecc2i3vxNkS1ZKzLfKH13FlHnW",
    "shareUrl": "5fi.sh/T2741",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Urdu.61.mp3",
    "stableKey": "Urdu"
  },
  {
    "id": 12741,
    "iso3": "VIE",
    "langId": "4568",
    "languageEn": "Vietnamese",
    "langTh": "เวียดนาม",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "Titus 3:5 He saved us, not because of righteous things we had done, but because of His mercy. He saved us through the washing of rebirth and renewal by the Holy Spirit.",
    "verse_th": "ทิตัส 3:5 พระองค์​ได้​ช่วย​ให้​เรา​รอด ไม่​ใช่​เพราะ​เรา​ทำดี แต่​เป็น​เพราะ​ความ​เมตตา​กรุณา​ของ​พระองค์​ต่างหาก พระองค์​ได้​ชำระ​ล้าง​เรา ซึ่ง​ทำ​ให้​เรา​เกิด​ใหม่ และ​ถูก​สร้าง​ขึ้น​มา​ใหม่​ด้วย​ฤทธิ์เดช​ของ​พระวิญญาณ​บริสุทธิ์",
    "streamUrl": "fivefish.org/T12741",
    "trackDownloadUrl": "fivefish.org/T12741-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/12741.zip",
    "programId": "12741",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NxTIL36Oea8&list=PLbVWnwtj_2QH7jBxbdUf-gIAXlqc8RWsD",
    "shareUrl": "5fi.sh/T12741",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.12741.mp3",
    "stableKey": "Vietnamese"
  },
  {
    "id": 37560,
    "iso3": "VIE",
    "langId": "4568",
    "languageEn": "Vietnamese",
    "langTh": "เวียดนาม",
    "title_en": "Jesus Story 1 of 2",
    "title_th": "เรื่องราวของพระเยซู 1 of 2",
    "verse_en": "Hebrews 10:24-25 And let us consider how we may spur one another on toward love and good deeds. Let us not give up meeting together as some are in the habit of doing, but let us encourage one another - and all the more as you see the Day approaching.",
    "verse_th": "ฮีบรู 10:24-25 ขอให้​เรา​ทุกคน​พิจารณา​กัน​และ​กัน เพื่อ​จะได้​กระตุ้น​กัน​ให้​มี​ความรัก​และ​ทำ​แต่​ความดีขอ​อย่าให้​เรา​ทิ้ง​การ​ประชุม​ไป​เหมือนกับ​ที่​บางคน​ทำ​อยู่ แต่​ให้​กำลังใจ​กัน​และ​กัน​มาก​ยิ่งขึ้น ยิ่ง​พวกคุณ​รู้​อยู่​แล้ว​ว่า​วันนั้น​กำลัง​ใกล้​มาถึง​แล้ว ก็​ยิ่ง​น่าจะ​ทำ​อย่างนี้",
    "streamUrl": "fivefish.org/T37560",
    "trackDownloadUrl": "fivefish.org/T37560-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37560.zip",
    "programId": "37560",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4aLZnEk3lTs&list=PLbVWnwtj_2QH7jBxbdUf-gIAXlqc8RWsD",
    "shareUrl": "5fi.sh/T37560",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.4568.mp3",
    "stableKey": "Vietnamese"
  },
  {
    "id": 37561,
    "iso3": "VIE",
    "langId": "4568",
    "languageEn": "Vietnamese",
    "langTh": "เวียดนาม",
    "title_en": "Jesus Story 2 of 2",
    "title_th": "เรื่องราวของพระเยซู 2 of 2",
    "verse_en": "Hebrews 11:6 And without faith it is impossible to please God, because anyone who comes to Him must believe that He exists and that He rewards those who earnestly seek Him.",
    "verse_th": "ฮีบรู 11:6 เขา​ได้รับ​การ​ยกย่อง​ว่า​เป็น​คนหนึ่ง​ที่​พระเจ้า​พอใจ แต่​ถ้า​ไม่มี​ความ​ไว้วางใจ​แล้ว ก็​เป็นไป​ไม่ได้​ที่​จะ​ทำให้​พระเจ้า​พอใจ เพราะ​คน​ที่​มา​เข้าเฝ้า​พระเจ้า​จะ​ต้อง​เชื่อ​ว่า​พระองค์​มี​จริง และ​ต้อง​เชื่อ​ว่า​พระองค์​จะ​ให้​รางวัล​กับ​ทุกคน​ที่​แสวงหา​พระองค์",
    "streamUrl": "fivefish.org/T37561",
    "trackDownloadUrl": "fivefish.org/T37561-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37561.zip",
    "programId": "37561",
    "shareUrl": "5fi.sh/T37561",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.4568.mp3",
    "stableKey": "Vietnamese"
  },
  {
    "id": 30131,
    "iso3": "VIE",
    "langId": "4568",
    "languageEn": "Vietnamese",
    "langTh": "เวียดนาม",
    "title_en": "Portrait of Jesus",
    "title_th": "ชีวิตของพระเยซู",
    "verse_en": "Hebrews 12:3 Consider Him who endured such opposition from sinful men, so that you will not grow weary and lose heart.",
    "verse_th": "ฮีบรู 12:3 ขอให้​ใคร่ครวญ​ถึง​พระองค์​ผู้ที่​ต้อง​ทน​ทุกข์ทรมาน​อย่าง​แสนสาหัส​จาก​คนบาป​ที่​ต่อต้าน​พระองค์ เพื่อ​พวกคุณ​จะ​ได้​ไม่ท้อใจ​หรือ​ยอมแพ้",
    "streamUrl": "fivefish.org/T30131",
    "trackDownloadUrl": "fivefish.org/T30131-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/30131.zip",
    "programId": "30131",
    "languageVideoUrl": "https://www.youtube.com/watch?v=6tsASuh25Zw&list=PLbVWnwtj_2QH7jBxbdUf-gIAXlqc8RWsD",
    "shareUrl": "5fi.sh/T30131",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.4568.mp3",
    "stableKey": "Vietnamese"
  },
  {
    "id": 74687,
    "iso3": "VIE",
    "langId": "4568",
    "languageEn": "Vietnamese",
    "langTh": "เวียดนาม",
    "title_en": "Words of Life 2",
    "title_th": "พระคำแห่งชีวิต 2",
    "verse_en": "Hebrews 2:18 Because He Himself suffered when He was tempted, He is able to help those who are being tempted.",
    "verse_th": "ฮีบรู 2:18 เดี๋ยวนี้ พระองค์​สามารถ​ช่วย​คน​ที่​ถูก​ทดลอง​ได้แล้ว เพราะ​พระองค์​เอง​ได้รับ​ความ​ทรมาน​และ​ถูก​ทดลอง​มาก่อน",
    "streamUrl": "fivefish.org/T74687",
    "trackDownloadUrl": "fivefish.org/T74687-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/74687.zip",
    "programId": "74687",
    "languageVideoUrl": "https://www.youtube.com/watch?v=fiQG3lMJvMQ&list=PLbVWnwtj_2QH7jBxbdUf-gIAXlqc8RWsD",
    "shareUrl": "5fi.sh/T74687",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.4568.mp3",
    "stableKey": "Vietnamese"
  },
  {
    "id": 80424,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "Hebrews 4:15-16 For we do not have a high priest who is unable to empathize with our weaknesses, but we have One who has been tempted in every way, just as we are - yet He did not sin. Let us then approach God's throne of grace with confidence, so that we may receive mercy and find grace to help us in our time of need.",
    "verse_th": "ฮีบรู 4:15-16 เพราะ​หัวหน้า​นักบวช​สูงสุด​ของเรา​คนนี้​เข้าใจ​และ​เห็นใจ​ใน​จุดอ่อน​ทั้งหลาย​ของเรา เพราะ​พระองค์​ก็​เคย​ถูก​ทดลอง​เหมือนกับ​เรา​ทุกอย่าง แต่​ไม่ได้​ทำบาป​เลย 16 ดังนั้น​ขอให้​เรา​ทุกคน​เข้ามา​ยืน​ด้วย​ความ​มั่นใจ​ต่อหน้า​บัลลังก์​ของ​พระเจ้า​ผู้​มี​ความ​เมตตา​กรุณา เพื่อ​เรา​จะ​ได้รับ​ความปรานี และ​พบ​กับ​ความ​เมตตา​กรุณา​ที่​พระเจ้า​จะ​ช่วย​เรา​ใน​เวลา​ที่​เรา​ต้องการ​ความ​ช่วยเหลือ",
    "streamUrl": "fivefish.org/T80424",
    "trackDownloadUrl": "fivefish.org/T80424-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80424.zip",
    "programId": "80424",
    "languageVideoUrl": "https://www.youtube.com/watch?v=rWkXMfcJtrM&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80424",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80417,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "Hebrews 9:27 Just as man is destined to die once, and after that to face judgment.",
    "verse_th": "ฮีบรู 9:27 มนุษย์​ตาย​แค่​ครั้งเดียว​แล้ว​เจอ​กับ​การ​พิพากษา",
    "streamUrl": "fivefish.org/T80417",
    "trackDownloadUrl": "fivefish.org/T80417-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80417.zip",
    "programId": "80417",
    "languageVideoUrl": "https://www.youtube.com/watch?v=a_sa1qgTES0&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80417",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80423,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 3 Victory through GOD",
    "title_th": "LLL 3 ชัยชนะโดยพระเจ้า",
    "verse_en": "James 4:14 Why, you do not even know what will happen tomorrow. What is your life? You are a mist that appears for a little while and then vanishes.",
    "verse_th": "ยากอบ 4:14 ตัว​คุณ​เอง​ก็​ยัง​ไม่​รู้​เลย​ว่า พรุ่งนี้​ชีวิต​ของ​คุณ​จะ​เป็น​อย่าง​ไร​บ้าง เพราะ​คุณ​เป็น​เพียง​แค่​หมอก ที่​เกิด​ขึ้น​ประ​เดี๋ยว​เดียว แล้ว​ก็​จาง​หาย​ไป",
    "streamUrl": "fivefish.org/T80423",
    "trackDownloadUrl": "fivefish.org/T80423-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80423.zip",
    "programId": "80423",
    "languageVideoUrl": "https://www.youtube.com/watch?v=msmkOqNztK0&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80423",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80418,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "1 Peter 2:11 Dear friends. I urge you as aliens and strangers in the world, to abstain from sinful desires, which war against your soul.",
    "verse_th": "1 เปโตร 2:11 เพื่อนรัก ให้​อยู่​อย่าง​คน​ต่างด้าว​และ​คน​แปลกถิ่น​ใน​สังคมนี้ ผม​ขอร้อง​ว่า​อย่า​ไป​ยอมแพ้​กับ​กิเลสตัณหา​ของ​สันดาน​ที่​ต่อสู้​กับ​ใจ​ของคุณ",
    "streamUrl": "fivefish.org/T80418",
    "trackDownloadUrl": "fivefish.org/T80418-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80418.zip",
    "programId": "80418",
    "languageVideoUrl": "https://www.youtube.com/watch?v=3ljiM9K0N4k&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80418",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80419,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 5 On Trial for GOD",
    "title_th": "LLL 5 การทดสอบเพื่อพระเจ้า",
    "verse_en": "1 Peter 3:18 For Christ died for our sins once for all, the righteous for the unrighteous, to bring you to God. He was put to death in the body but made alive by the Spirit.",
    "verse_th": "1 ยอห์น 3:18 ลูก​เล็กๆ​ที่รัก อย่า​ให้​เรา​รัก​กัน​แค่​คำพูด​หรือ​รัก​แต่​ปาก​เท่านั้น แต่​ให้​เรา​รัก​กัน​ด้วย​การ​กระทำ​และ​ด้วย​ความ​จริงใจ",
    "streamUrl": "fivefish.org/T80419",
    "trackDownloadUrl": "fivefish.org/T80419-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80419.zip",
    "programId": "80419",
    "languageVideoUrl": "https://www.youtube.com/watch?v=4X6uVXW6N2Q&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80419",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80420,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "1 Peter 4:16 However, if you suffer as a Christian, do not be ashamed, but praise God that you bear that name.",
    "verse_th": "1 เปโตร 4:16 แต่​ถ้า​คุณ​ต้อง​ทนทุกข์​เพราะ​เป็น​คริสเตียน ก็​อย่า​อาย​เลย แต่​ให้​สรรเสริญ​พระเจ้า เพราะ​คุณ​ได้​ชื่อ​ว่า​คริสเตียน",
    "streamUrl": "fivefish.org/T80420",
    "trackDownloadUrl": "fivefish.org/T80420-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80420.zip",
    "programId": "80420",
    "languageVideoUrl": "https://www.youtube.com/watch?v=8DaBs7drng8&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80420",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.80420.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80421,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 7 JESUS - Lord & Saviour",
    "title_th": "LLL 7 พระเยซูเป็นพระเจ้าและพระผู้ช่วยให้รอด",
    "verse_en": "1 Peter 5:10 And the God of all grace, who called you to His eternal glory in Christ, after you have suffered a little while, will Himself restore you and make you strong, firm and steadfast.",
    "verse_th": "1 เปโตร 5:10 พระเจ้า​ผู้​เป็น​แหล่ง​ของ​ความ​เมตตา​ทุกอย่าง​ได้​เรียก​คุณ​ผ่านทาง​พระเยซู​คริสต์ ให้​คุณ​เข้ามา​มี​ส่วนร่วม​ใน​เกียรติ​ของ​พระองค์​ที่​ไม่มี​วัน​หมด คุณ​จะ​ต้อง​ทนทุกข์​อยู่​ประเดี๋ยวหนึ่ง แล้ว​หลังจากนั้น​พระเจ้า​ก็​จะ​ช่วยให้​คุณ​กลับคืน​สู่​สภาพ​สมบูรณ์แบบ จะ​ให้​คุณ​เข้มแข็ง มี​กำลัง​มากขึ้น​และ​มั่นคง",
    "streamUrl": "fivefish.org/T80421",
    "trackDownloadUrl": "fivefish.org/T80421-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80421.zip",
    "programId": "80421",
    "languageVideoUrl": "https://www.youtube.com/watch?v=LMIQkXhi6vo&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80421",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 80422,
    "iso3": "VIE",
    "langId": "2",
    "languageEn": "Vietnamese South",
    "langTh": "เวียดนามใต้",
    "title_en": "LLL 8 Acts of the HOLY SPIRIT",
    "title_th": "LLL 8 การงานของพระวิญญาณบริสุทธิ์",
    "verse_en": "1 Peter 5:5-6 Young men, in the same way be submissive to those who are older. All of you, clothe yourselves with humility toward one another, because, God opposes the proud but gives grace to the humble. Humble yourselves, therefore, under God’s mighty hand, that He may lift you up in due time.",
    "verse_th": "1 เปโตร 5:5-6 ใน​ทำนอง​เดียวกัน คน​ที่มี​อายุ​น้อยกว่า ก็​ให้​เชื่อฟัง​พวก​ผู้นำ​อาวุโส แต่​ความจริง​แล้ว ทุกๆคน​ควร​จะ​อ่อนน้อม​ถ่อมตัว​รับใช้​ซึ่งกัน​และ​กัน​เหมือนกับ​ที่​พระคัมภีร์​เขียน​ไว้​ว่า พระเจ้า​ต่อต้าน​คน​ที่​เย่อหยิ่ง​จองหอง แต่​มี​ความ​เมตตา​กรุณา​ต่อ​คน​ที่​อ่อนน้อม​ถ่อมตน 6ถ้า​อย่างนั้น ให้​พวกคุณ​อ่อนน้อม​ถ่อมตัว​ลง​ใต้​อำนาจ​ที่​ยิ่งใหญ่​ของ​พระเจ้า เพื่อ​พระเจ้า​จะ​ได้​ยก​คุณ​ขึ้น​เมื่อ​ถึง​เวลาที่​เหมาะสม",
    "streamUrl": "fivefish.org/T80422",
    "trackDownloadUrl": "fivefish.org/T80422-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/80422.zip",
    "programId": "80422",
    "languageVideoUrl": "https://www.youtube.com/watch?v=cvrmnTW7OTI&list=PLbVWnwtj_2QEzkyxxKfG32pPzLFUQJdoc",
    "shareUrl": "5fi.sh/T80422",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Vietnamese.South.2.mp3",
    "stableKey": "Vietnamese South"
  },
  {
    "id": 28831,
    "iso3": "BLR",
    "langId": "6074",
    "languageEn": "Yi Pula in Mengzi",
    "langTh": "ยี ปูลา เม่งจื๊อ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "1 Peter 5:7 Cast all your anxiety on Him because He cares for you.",
    "verse_th": "1 เปโตร 5:7 ให้​เอา​ความ​กังวล​ทั้งหมด​ของ​คุณ​ฝากไว้​กับ​พระเจ้า เพราะ​พระองค์​ห่วงใย​คุณ",
    "streamUrl": "fivefish.org/T28831",
    "trackDownloadUrl": "fivefish.org/T28831-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/28831.zip",
    "programId": "28831",
    "languageVideoUrl": "https://www.youtube.com/watch?v=UDpiFCbxo60&list=PLXcynA24_lTMpylHmOfG211wEntI7XEtN",
    "shareUrl": "5fi.sh/T28831",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Yi.Pula.in.Mengzi.28831.mp3",
    "stableKey": "Yi Pula in Mengzi"
  },
  {
    "id": 28840,
    "iso3": "BLR",
    "langId": "6084",
    "languageEn": "Yi Pula in Yuanyang",
    "langTh": "ยี ปูลา หยวนหยาง",
    "title_en": "Words of Life (Eval)",
    "title_th": "พระคำแห่งชีวิต (Eval)",
    "verse_en": "1 John 2:15 Do not love the world or anything in the world. If anyone loves the world, the love of the Father is not in him.",
    "verse_th": "1 ยอห์น 2:15 อย่า​รัก​โลก​หรือ​รัก​สิ่งของ​ใน​โลกนี้​อีก​ต่อไป ถ้า​คนไหน​รัก​โลกนี้ คนนั้น​ก็​ไม่ได้​รัก​พระบิดา",
    "streamUrl": "fivefish.org/T28840",
    "trackDownloadUrl": "fivefish.org/T28840-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/28840.zip",
    "programId": "28840",
    "languageVideoUrl": "https://www.youtube.com/watch?v=kiTTaoxEmV0&list=PLXcynA24_lTOj7-irxVD7tNVceQMXZrpQ",
    "shareUrl": "5fi.sh/T28840",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Yi.Pula.in.Yuanyang.28840.mp3",
    "stableKey": "Yi Pula in Yuanyang"
  },
  {
    "id": 65100,
    "iso3": "YNO",
    "langId": "18600",
    "languageEn": "Yong",
    "langTh": "ยอง",
    "title_en": "Good News",
    "title_th": "ข่าวประเสริฐ",
    "verse_en": "1 John 2:16 For everything in the world - the lust of the flesh, the lust of the eyes, and the pride of life - comes not from the Father but from the world.",
    "verse_th": "1 ยอห์น 2:16 เพราะ​ทุกสิ่ง​ทุกอย่าง​ใน​โลกนี้ คือ​กิเลสตัณหา​ของ​สันดาน กิเลสตัณหา​ของ​ตา และ​การ​โอ้อวด​ใน​สิ่ง​ที่​ทำ​หรือ​มี สิ่ง​เหล่านี้​ไม่ได้​มา​จาก​พระบิดา แต่​มา​จาก​โลกนี้",
    "streamUrl": "fivefish.org/T65100",
    "trackDownloadUrl": "fivefish.org/T65100-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/65100.zip",
    "programId": "65100",
    "languageVideoUrl": "https://www.youtube.com/watch?v=doE5yqsP364&list=PLho9cJoXqQC-pJAeHUkVGsxWkf6f5bqiN",
    "shareUrl": "5fi.sh/T65100",
    "duration": "58:19",
    "trackCount": "40.0",
    "sampleUrl": "/audio/Yong.65100.mp3",
    "stableKey": "Yong"
  },
  {
    "id": 63896,
    "iso3": "YOY",
    "langId": "18626",
    "languageEn": "Yoy",
    "langTh": "โย้ย",
    "title_en": "LLL 1 Beginning with GOD",
    "title_th": "LLL 1 เริ่มต้นกับพระเจ้า",
    "verse_en": "1 John 3:18 Dear children, let us not love with words or tongue but with actions and in truth.",
    "verse_th": "1 เปโตร 3:18 พระคริสต์​ทนทุกข์​เพื่อ​จัดการ​กับ​ความบาป​ครั้งเดียว​ก็​เพียงพอ​แล้ว พระองค์​ทำ​อย่างนี้​เพื่อ​นำ​คุณ​ไป​หา​พระเจ้า พระองค์​ถูก​ฆ่า​ทางกาย​แต่​มี​ชีวิต​ขึ้น​มา​ใหม่​โดย​ทาง​พระวิญญาณ",
    "streamUrl": "fivefish.org/T63896",
    "trackDownloadUrl": "fivefish.org/T63896-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63896.zip",
    "programId": "63896",
    "languageVideoUrl": "https://www.youtube.com/watch?v=0ohXTFA5ia0&list=PLho9cJoXqQC9i16HiRaH8OQ2sk159NBc8",
    "shareUrl": "5fi.sh/T63896",
    "duration": "43:03",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Yoy.18626.mp3",
    "stableKey": "Yoy"
  },
  {
    "id": 64996,
    "iso3": "YOY",
    "langId": "18626",
    "languageEn": "Yoy",
    "langTh": "โย้ย",
    "title_en": "LLL 2 Mighty Men of GOD",
    "title_th": "LLL 2 ผู้ได้รับอำนาจจากพระเจ้า",
    "verse_en": "1 John 5:13 I write these things to you who believe in the name of the Son of God so that you may know that you have eternal life.",
    "verse_th": "1 ยอห์น 5:13 ผม​ได้​เขียน​เรื่องนี้​ถึง​พวกคุณ​ที่​ไว้วางใจ​ใน​พระบุตร​ของ​พระเจ้า เพื่อ​พวกคุณ​จะ​ได้​รู้​ว่า คุณ​ยัง​มี​ชีวิต​ตลอดไป​กับ​พระเจ้า​อยู่",
    "streamUrl": "fivefish.org/T64996",
    "trackDownloadUrl": "fivefish.org/T64996-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/64996.zip",
    "programId": "64996",
    "languageVideoUrl": "https://www.youtube.com/watch?v=thyxW-Wac6A&list=PLho9cJoXqQC9i16HiRaH8OQ2sk159NBc8",
    "shareUrl": "5fi.sh/T64996",
    "duration": "40:59",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Yoy.18626.mp3",
    "stableKey": "Yoy"
  },
  {
    "id": 63897,
    "iso3": "YOY",
    "langId": "18626",
    "languageEn": "Yoy",
    "langTh": "โย้ย",
    "title_en": "LLL 4 Servants of GOD",
    "title_th": "LLL 4 ผู้รับใช้ของพระเจ้า",
    "verse_en": "Revelation 1:8 I am the Alpha and the Omega, says the Lord God, Who is, and Who was, and Who is to come, the Almighty.",
    "verse_th": "วิวรณ์ 1:8 พระเจ้า​องค์​เจ้า​ชีวิต​พูดว่า “เรา​คือ​จุดเริ่มต้น​และ​จุดจบ พระเจ้า​ผู้ที่​เป็น​อยู่​ใน​ปัจจุบัน ใน​อดีต และ​กำลัง​จะ​มา​ใน​อนาคต พระเจ้า​ผู้​มี​ฤทธิ์​ทั้งสิ้น”",
    "streamUrl": "fivefish.org/T63897",
    "trackDownloadUrl": "fivefish.org/T63897-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63897.zip",
    "programId": "63897",
    "languageVideoUrl": "https://www.youtube.com/watch?v=IPH1f51vvck&list=PLho9cJoXqQC9i16HiRaH8OQ2sk159NBc8",
    "shareUrl": "5fi.sh/T63897",
    "duration": "47:10",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Yoy.18626.mp3",
    "stableKey": "Yoy"
  },
  {
    "id": 63898,
    "iso3": "YOY",
    "langId": "18626",
    "languageEn": "Yoy",
    "langTh": "โย้ย",
    "title_en": "LLL 6 JESUS - Teacher & Healer",
    "title_th": "LLL 6 พระเยซูเป็นผู้สอนและผู้รักษา",
    "verse_en": "Revelation 3:20 Here I am! I stand at the door and knock. If anyone hears My voice and opens the door, I will come in and eat with him, and he with Me.",
    "verse_th": "วิวรณ์ 3:20 ฟัง​ไว้​ให้ดี เรา​ยืน​เคาะ​ประตู​อยู่ ถ้า​ใคร​ได้ยิน​เสียง​ของ​เรา​แล้ว​เปิด​ประตู เรา​จะ​เข้า​ไป​ข้างใน และ​กิน​อาหาร​ร่วมกับ​คนนั้น",
    "streamUrl": "fivefish.org/T63898",
    "trackDownloadUrl": "fivefish.org/T63898-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/63898.zip",
    "programId": "63898",
    "languageVideoUrl": "https://www.youtube.com/watch?v=NttVNVlL_CI&list=PLho9cJoXqQC9i16HiRaH8OQ2sk159NBc8",
    "shareUrl": "5fi.sh/T63898",
    "duration": "47:14",
    "trackCount": "24.0",
    "sampleUrl": "/audio/Yoy.63898.mp3",
    "stableKey": "Yoy"
  },
  {
    "id": 3241,
    "iso3": "CMN",
    "langId": "241",
    "languageEn": "Yunnanese",
    "langTh": "จีนยูนนาน",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "Genesis 1:1 In the beginning God created the heavens and the earth.",
    "verse_th": "ปฐมกาล 1:1 ใน​ปฐมกาล​นั้น เมื่อ​พระเจ้า​สร้าง​แผ่นดิน​และ​ท้องฟ้า",
    "streamUrl": "fivefish.org/T3241",
    "trackDownloadUrl": "fivefish.org/T3241-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/3241.zip",
    "programId": "3241",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Bk6bpWqRTNk&list=PLXcynA24_lTPMMHQhbc9GKxdIqh7zWLKu",
    "shareUrl": "5fi.sh/T3241",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Yunnanese.03241.mp3",
    "stableKey": "Yunnanese"
  },
  {
    "id": 37400,
    "iso3": "AEU",
    "langId": "1148",
    "languageEn": "Akeu",
    "langTh": "อาเคอะ",
    "title_en": "Words of Life",
    "title_th": "พระคำแห่งชีวิต",
    "verse_en": "",
    "verse_th": "",
    "streamUrl": "fivefish.org/T37400",
    "trackDownloadUrl": "fivefish.org/T37400-001.mp3",
    "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/37400.zip",
    "programId": "37400",
    "languageVideoUrl": "https://www.youtube.com/watch?v=wgk8G6K7cN0&list=PLXcynA24_lTMfK40uNECYzwFBmcvoXB2D",
    "shareUrl": "5fi.sh/T37400",
    "duration": "",
    "trackCount": "",
    "sampleUrl": "/audio/Akeu.1148.mp3",
    "stableKey": "Akeu"
  }
,
{
  "id": 70900,
  "iso3": "ENG",
  "langId": "1234",
  "languageEn": "English Australia",
  "langTh": "อังกฤษ ออสเตรเลีย",
  "title_en": "LLL",
  "title_th": "พระคำแห่งชีวิต",
  "verse_en": "",
  "verse_th": "",
  "streamUrl": "fivefish.org/T70900",
  "trackDownloadUrl": "fivefish.org/T70900-001.mp3",
  "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/70900.zip",
  "programId": "70900",
    "languageVideoUrl": "https://www.youtube.com/watch?v=rRdhePT9nI0&list=PL-Y0D9PLpdLAlV8MeGOk5xjfM0ZI0NsKK",
  "shareUrl": "5fi.sh/T70900",
  "duration": "",
  "trackCount": "",
  "sampleUrl": "/audio/English.Australia.70900.mp3",
  "stableKey": "English Australia"
}
,
{
  "id": 31874,
  "iso3": "KAC",
  "langId": "348",
  "languageEn": "Kachin",
  "langTh": "คะฉิ่น",
  "title_en": "Good News",
  "title_th": "พระคำแห่งชีวิต",
  "verse_en": "",
  "verse_th": "",
  "streamUrl": "fivefish.org/T31874",
  "trackDownloadUrl": "fivefish.org/T31874-001.mp3",
  "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/31874.zip",
  "programId": "31874",
    "languageVideoUrl": "https://www.youtube.com/watch?v=XU6ATkwa8mc&list=PL-5yEg0Ecc2jt-yJ3CZjPToMfbg__RjwA",
  "shareUrl": "5fi.sh/T31874",
  "duration": "",
  "trackCount": "",
  "sampleUrl": "/audio/Kachin.Singpho.31874.mp3",
  "stableKey": "Kachin"
}
,
{
  "id": 22750,
  "iso3": "CTG",
  "langId": "3259",
  "languageEn": "Bangla Chittagonian",
  "langTh": "บังกลา ชิตตาโกเนียน",
  "title_en": "Good News",
  "title_th": "พระคำแห่งชีวิต",
  "verse_en": "",
  "verse_th": "",
  "streamUrl": "fivefish.org/T22750",
  "trackDownloadUrl": "fivefish.org/T22750-001.mp3",
  "zipDownloadUrl": "https://files.globalrecordings.net/files/set/mp3-low/22750.zip",
  "programId": "22750",
    "languageVideoUrl": "https://www.youtube.com/watch?v=Rp5weIHbp00&list=PLHKb-Ty4Yl_ONI6GnqlcRZhKJx9nO7Crz",
  "shareUrl": "5fi.sh/T22750",
  "duration": "",
  "trackCount": "",
  "sampleUrl": "/audio/Bangla.Chittagonian.22750.mp3",
  "stableKey": "Bangla Chittagonian"
}
]